!function(e,t){var i=function(r){t(e.lazySizes,r),e.removeEventListener("lazyunveilread",i,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0)}(window,function(e,t,i,r){"use strict";function a(e){var t=getComputedStyle(e,null)||{},i=t.fontFamily||"",r=i.match(u)||"",a=r&&i.match(c)||"";return a&&(a=a[1]),{fit:r&&r[1]||"",position:y[a]||a||"center"}}function n(e,t){var r,a,n=i.cfg,s=e.cloneNode(!1),o=s.style,l=function(){var t=e.currentSrc||e.src;t&&a!==t&&(a=t,o.backgroundImage="url("+(f.test(t)?JSON.stringify(t):t)+")",r||(r=!0,i.rC(s,n.loadingClass),i.aC(s,n.loadedClass)))},u=function(){i.rAF(l)};e._lazysizesParentFit=t.fit,e.addEventListener("lazyloaded",u,!0),e.addEventListener("load",u,!0),s.addEventListener("load",function(){var e=s.currentSrc||s.src;e&&e!=d&&(s.src=d,s.srcset="")}),i.rAF(function(){var r=e,a=e.parentNode;"PICTURE"==a.nodeName.toUpperCase()&&(r=a,a=a.parentNode),i.rC(s,n.loadedClass),i.rC(s,n.lazyClass),i.aC(s,n.loadingClass),i.aC(s,n.objectFitClass||"lazysizes-display-clone"),s.getAttribute(n.srcsetAttr)&&s.setAttribute(n.srcsetAttr,""),s.getAttribute(n.srcAttr)&&s.setAttribute(n.srcAttr,""),s.src=d,s.srcset="",o.backgroundRepeat="no-repeat",o.backgroundPosition=t.position,o.backgroundSize=t.fit,r.style.display="none",e.setAttribute("data-parent-fit",t.fit),e.setAttribute("data-parent-container","prev"),a.insertBefore(s,r),e._lazysizesParentFit&&delete e._lazysizesParentFit,e.complete&&l()})}var s=t.createElement("a").style,o="objectFit"in s,l=o&&"objectPosition"in s,u=/object-fit["']*\s*:\s*["']*(contain|cover)/,c=/object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,d="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",f=/\(|\)|'/,y={center:"center","50% 50%":"center"};if(!o||!l){var p=function(e){if(e.detail.instance==i){var t=e.target,r=a(t);!r.fit||o&&"center"==r.position||n(t,r)}};e.addEventListener("lazyunveilread",p,!0),r&&r.detail&&p(r)}}),!function(e,t){var i=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",i,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes"),require("../fix-ios-sizes/fix-ios-sizes")):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0)}(window,function(e,t,i){"use strict";var r,a=i&&i.cfg||e.lazySizesConfig,n=t.createElement("img"),s="sizes"in n&&"srcset"in n,o=/\s+\d+h/g,l=function(){var e=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,i=Array.prototype.forEach;return function(){var r=t.createElement("img"),a=function(t){var i,r,a=t.getAttribute(lazySizesConfig.srcsetAttr);a&&((r=a.match(e))&&(i="w"==r[2]?r[1]/r[3]:r[3]/r[1])&&t.setAttribute("data-aspectratio",i),t.setAttribute(lazySizesConfig.srcsetAttr,a.replace(o,"")))},n=function(e){var t=e.target.parentNode;t&&"PICTURE"==t.nodeName&&i.call(t.getElementsByTagName("source"),a),a(e.target)},s=function(){r.currentSrc&&t.removeEventListener("lazybeforeunveil",n)};t.addEventListener("lazybeforeunveil",n),r.onload=s,r.onerror=s,r.srcset="data:,a 1w 1h",r.complete&&s()}}();if(a||(a={},e.lazySizesConfig=a),a.supportsType||(a.supportsType=function(e){return!e}),!e.picturefill&&!a.pf){if(e.HTMLPictureElement&&s)return t.msElementsFromPoint&&l(navigator.userAgent.match(/Edge\/(\d+)/)),void(a.pf=function(){});a.pf=function(t){var i,a;if(!e.picturefill)for(i=0,a=t.elements.length;i<a;i++)r(t.elements[i])},r=function(){var n=function(e,t){return e.w-t.w},l=/^\s*\d+\.*\d*px\s*$/,u=function(e){var t,i,r=e.length,a=e[r-1],n=0;for(n;n<r;n++)if(a=e[n],a.d=a.w/e.w,a.d>=e.d){!a.cached&&(t=e[n-1])&&t.d>e.d-.13*Math.pow(e.d,2.2)&&(i=Math.pow(t.d-.6,1.6),t.cached&&(t.d+=.15*i),t.d+(a.d-e.d)*i>e.d&&(a=t));break}return a},c=function(){var e,t=/(([^,\s].[^\s]+)\s+(\d+)w)/g,i=/\s/,r=function(t,i,r,a){e.push({c:i,u:r,w:1*a})};return function(a){return e=[],a=a.trim(),a.replace(o,"").replace(t,r),e.length||!a||i.test(a)||e.push({c:a,u:a,w:99}),e}}(),d=function(){d.init||(d.init=!0,addEventListener("resize",function(){var e,i=t.getElementsByClassName("lazymatchmedia"),a=function(){var e,t;for(e=0,t=i.length;e<t;e++)r(i[e])};return function(){clearTimeout(e),e=setTimeout(a,66)}}()))},f=function(t,r){var n,s=t.getAttribute("srcset")||t.getAttribute(a.srcsetAttr);!s&&r&&(s=t._lazypolyfill?t._lazypolyfill._set:t.getAttribute(a.srcAttr)||t.getAttribute("src")),t._lazypolyfill&&t._lazypolyfill._set==s||(n=c(s||""),r&&t.parentNode&&(n.isPicture="PICTURE"==t.parentNode.nodeName.toUpperCase(),n.isPicture&&e.matchMedia&&(i.aC(t,"lazymatchmedia"),d())),n._set=s,Object.defineProperty(t,"_lazypolyfill",{value:n,writable:!0}))},y=function(t){var r=e.devicePixelRatio||1,a=i.getX&&i.getX(t);return Math.min(a||r,2.5,r)},p=function(t){return e.matchMedia?(p=function(e){return!e||(matchMedia(e)||{}).matches})(t):!t},z=function(e){var t,r,s,o,c,d,z;if(o=e,f(o,!0),c=o._lazypolyfill,c.isPicture)for(r=0,t=e.parentNode.getElementsByTagName("source"),s=t.length;r<s;r++)if(a.supportsType(t[r].getAttribute("type"),e)&&p(t[r].getAttribute("media"))){o=t[r],f(o),c=o._lazypolyfill;break}return c.length>1?(z=o.getAttribute("sizes")||"",z=l.test(z)&&parseInt(z,10)||i.gW(e,e.parentNode),c.d=y(e),!c.src||!c.w||c.w<z?(c.w=z,d=u(c.sort(n)),c.src=d):d=c.src):d=c[0],d},v=function(e){if(!s||!e.parentNode||"PICTURE"==e.parentNode.nodeName.toUpperCase()){var t=z(e);t&&t.u&&e._lazypolyfill.cur!=t.u&&(e._lazypolyfill.cur=t.u,t.cached=!0,e.setAttribute(a.srcAttr,t.u),e.setAttribute("src",t.u))}};return v.parse=c,v}(),a.loadedClass&&a.loadingClass&&function(){var e=[];['img[sizes$="px"][srcset].',"picture > img:not([srcset])."].forEach(function(t){e.push(t+a.loadedClass),e.push(t+a.loadingClass)}),a.pf({elements:t.querySelectorAll(e.join(", "))})}()}}),function(e,t){var i=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",i,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0)}(window,function(e,t,i){"use strict";if(e.addEventListener){var r=/\s+/g,a=/\s*\|\s+|\s+\|\s*/g,n=/^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,s=/^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,o=/\(|\)|'/,l={contain:1,cover:1},u=function(e){var t=i.gW(e,e.parentNode);return(!e._lazysizesWidth||t>e._lazysizesWidth)&&(e._lazysizesWidth=t),e._lazysizesWidth},c=function(e){var t;return t=(getComputedStyle(e)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!l[t]&&l[e.style.backgroundSize]&&(t=e.style.backgroundSize),t},d=function(e,t){if(t){var i=t.match(s);i&&i[1]?e.setAttribute("type",i[1]):e.setAttribute("media",lazySizesConfig.customMedia[t]||t)}},f=function(e,i,s){var o=t.createElement("picture"),l=i.getAttribute(lazySizesConfig.sizesAttr),u=i.getAttribute("data-ratio"),c=i.getAttribute("data-optimumx");i._lazybgset&&i._lazybgset.parentNode==i&&i.removeChild(i._lazybgset),Object.defineProperty(s,"_lazybgset",{value:i,writable:!0}),Object.defineProperty(i,"_lazybgset",{value:o,writable:!0}),e=e.replace(r," ").split(a),o.style.display="none",s.className=lazySizesConfig.lazyClass,1!=e.length||l||(l="auto"),e.forEach(function(e){var i,r=t.createElement("source");l&&"auto"!=l&&r.setAttribute("sizes",l),(i=e.match(n))?(r.setAttribute(lazySizesConfig.srcsetAttr,i[1]),d(r,i[2]),d(r,i[3])):r.setAttribute(lazySizesConfig.srcsetAttr,e),o.appendChild(r)}),l&&(s.setAttribute(lazySizesConfig.sizesAttr,l),i.removeAttribute(lazySizesConfig.sizesAttr),i.removeAttribute("sizes")),c&&s.setAttribute("data-optimumx",c),u&&s.setAttribute("data-ratio",u),o.appendChild(s),i.appendChild(o)},y=function(e){if(e.target._lazybgset){var t=e.target,r=t._lazybgset,a=t.currentSrc||t.src;if(a){var n=i.fire(r,"bgsetproxy",{src:a,useSrc:o.test(a)?JSON.stringify(a):a});n.defaultPrevented||(r.style.backgroundImage="url("+n.detail.useSrc+")")}t._lazybgsetLoading&&(i.fire(r,"_lazyloaded",{},!1,!0),delete t._lazybgsetLoading)}};addEventListener("lazybeforeunveil",function(e){var r,a,n;!e.defaultPrevented&&(r=e.target.getAttribute("data-bgset"))&&(n=e.target,a=t.createElement("img"),a.alt="",a._lazybgsetLoading=!0,e.detail.firesLoad=!0,f(r,n,a),setTimeout(function(){i.loader.unveil(a),i.rAF(function(){i.fire(a,"_lazyloaded",{},!0,!0),a.complete&&y({target:a})})}))}),t.addEventListener("load",y,!0),e.addEventListener("lazybeforesizes",function(e){if(e.detail.instance==i&&e.target._lazybgset&&e.detail.dataAttr){var t=e.target._lazybgset,r=c(t);l[r]&&(e.target._lazysizesParentFit=r,i.rAF(function(){e.target.setAttribute("data-parent-fit",r),e.target._lazysizesParentFit&&delete e.target._lazysizesParentFit}))}},!0),t.documentElement.addEventListener("lazybeforesizes",function(e){!e.defaultPrevented&&e.target._lazybgset&&e.detail.instance==i&&(e.detail.width=u(e.target._lazybgset))})}}),!function(e,t){var i=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",i,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0)}(window,function(e,t,i){"use strict";if(e.addEventListener){var r=e.requestAnimationFrame||setTimeout,a=function(){var n,s,o,l,u=i.cfg,c={"data-bgset":1,"data-include":1,"data-poster":1,"data-bg":1,"data-script":1},d="(\\s|^)("+u.loadedClass,f=t.documentElement,y=function(e){r(function(){i.rC(e,u.loadedClass),u.unloadedClass&&i.rC(e,u.unloadedClass),i.aC(e,u.lazyClass),("none"==e.style.display||e.parentNode&&"none"==e.parentNode.style.display)&&setTimeout(function(){i.loader.unveil(e)},0)})},p=function(e){var t,i,r,a;for(t=0,i=e.length;t<i;t++)r=e[t],a=r.target,a.getAttribute(r.attributeName)&&("source"==a.localName&&a.parentNode&&(a=a.parentNode.querySelector("img")),a&&d.test(a.className)&&y(a))};u.unloadedClass&&(d+="|"+u.unloadedClass),d+="|"+u.loadingClass+")(\\s|$)",d=new RegExp(d),c[u.srcAttr]=1,c[u.srcsetAttr]=1,e.MutationObserver?(o=new MutationObserver(p),n=function(){l||(l=!0,o.observe(f,{subtree:!0,attributes:!0,attributeFilter:Object.keys(c)}))},s=function(){l&&(l=!1,o.disconnect())}):(f.addEventListener("DOMAttrModified",function(){var e,t=[],i=function(){p(t),t=[],e=!1};return function(r){l&&c[r.attrName]&&r.newValue&&(t.push({target:r.target,attributeName:r.attrName}),e||(setTimeout(i),e=!0))}}(),!0),n=function(){l=!0},s=function(){l=!1}),addEventListener("lazybeforeunveil",s,!0),addEventListener("lazybeforeunveil",n),addEventListener("lazybeforesizes",s,!0),addEventListener("lazybeforesizes",n),n(),removeEventListener("lazybeforeunveil",a)};addEventListener("lazybeforeunveil",a)}}),!function(e,t){var i=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",i,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0)}(window,function(e,t,i){"use strict";if(e.addEventListener){var r=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,a=/parent-fit["']*\s*:\s*["']*(contain|cover|width)/,n=/parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,s=/^picture$/i,o=function(e){return getComputedStyle(e,null)||{}},l={getParent:function(t,i){var r=t,a=t.parentNode;return i&&"prev"!=i||!a||!s.test(a.nodeName||"")||(a=a.parentNode),"self"!=i&&(r="prev"==i?t.previousElementSibling:i&&(a.closest||e.jQuery)?(a.closest?a.closest(i):jQuery(a).closest(i)[0])||a:a),r},getFit:function(e){var t,i,r=o(e),s=r.content||r.fontFamily,u={fit:e._lazysizesParentFit||e.getAttribute("data-parent-fit")};return!u.fit&&s&&(t=s.match(a))&&(u.fit=t[1]),u.fit?(i=e._lazysizesParentContainer||e.getAttribute("data-parent-container"),!i&&s&&(t=s.match(n))&&(i=t[1]),u.parent=l.getParent(e,i)):u.fit=r.objectFit,u},getImageRatio:function(t){var i,a,n,o,l,u=t.parentNode,c=u&&s.test(u.nodeName||"")?u.querySelectorAll("source, img"):[t];for(i=0;i<c.length;i++)if(t=c[i],a=t.getAttribute(lazySizesConfig.srcsetAttr)||t.getAttribute("srcset")||t.getAttribute("data-pfsrcset")||t.getAttribute("data-risrcset")||"",n=t._lsMedia||t.getAttribute("media"),n=lazySizesConfig.customMedia[t.getAttribute("data-media")||n]||n,a&&(!n||(e.matchMedia&&matchMedia(n)||{}).matches)){o=parseFloat(t.getAttribute("data-aspectratio")),!o&&(l=a.match(r))&&(o="w"==l[2]?l[1]/l[3]:l[3]/l[1]);break}return o},calculateSize:function(e,t){var i,r,a,n,s=this.getFit(e),o=s.fit,l=s.parent;return"width"==o||("contain"==o||"cover"==o)&&(a=this.getImageRatio(e))?(l?t=l.clientWidth:l=e,n=t,"width"==o?n=t:(r=l.clientHeight)>40&&(i=t/r)&&("cover"==o&&i<a||"contain"==o&&i>a)&&(n=t*(a/i)),n):t}};i.parentFit=l,t.addEventListener("lazybeforesizes",function(e){if(!e.defaultPrevented&&e.detail.instance==i){var t=e.target;e.detail.width=l.calculateSize(t,e.detail.width)}})}}),!function(e,t){var i=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",i,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0)}(window,function(e,t,i){"use strict";function r(t,i){var r,a,n,s,o=e.getComputedStyle(t);a=t.parentNode,s={isPicture:!(!a||!f.test(a.nodeName||""))},n=function(e,i){var r=t.getAttribute("data-"+e);if(!r){var a=o.getPropertyValue("--ls-"+e);a&&(r=a.trim())}if(r){if("true"==r)r=!0;else if("false"==r)r=!1;else if(d.test(r))r=parseFloat(r);else if("function"==typeof u[e])r=u[e](t,r);else if(v.test(r))try{r=JSON.parse(r)}catch(e){}s[e]=r}else e in u&&"function"!=typeof u[e]?s[e]=u[e]:i&&"function"==typeof u[e]&&(s[e]=u[e](t,r))};for(r in u)n(r);return i.replace(z,function(e,t){t in s||n(t,!0)}),s}function a(e,t){var i=[],r=function(e,i){return c[typeof t[i]]?t[i]:e};return i.srcset=[],t.absUrl&&(g.setAttribute("href",e),e=g.href),e=((t.prefix||"")+e+(t.postfix||"")).replace(z,r),t.widths.forEach(function(r){var a=t.widthmap[r]||r,n=t.aspectratio||t.ratio,s=!t.aspectratio&&u.traditionalRatio,o={u:e.replace(y,a).replace(p,n?s?Math.round(r*n):Math.round(r/n):""),w:r};i.push(o),i.srcset.push(o.c=o.u+" "+r+"w")}),i}function n(e,i,r){var n=0,s=0,o=r;if(e){if("container"===i.ratio){for(n=o.scrollWidth,s=o.scrollHeight;!(n&&s||o===t);)o=o.parentNode,n=o.scrollWidth,s=o.scrollHeight;n&&s&&(i.ratio=s/n)}e=a(e,i),e.isPicture=i.isPicture,h&&"IMG"==r.nodeName.toUpperCase()?r.removeAttribute(l.srcsetAttr):r.setAttribute(l.srcsetAttr,e.srcset.join(", ")),Object.defineProperty(r,"_lazyrias",{value:e,writable:!0})}}function s(e,t){var a=r(e,t);return u.modifyOptions.call(e,{target:e,details:a,detail:a}),i.fire(e,"lazyriasmodifyoptions",a),a}function o(e){return e.getAttribute(e.getAttribute("data-srcattr")||u.srcAttr)||e.getAttribute(l.srcsetAttr)||e.getAttribute(l.srcAttr)||e.getAttribute("data-pfsrcset")||""}var l,u,c={string:1,number:1},d=/^\-*\+*\d+\.*\d*$/,f=/^picture$/i,y=/\s*\{\s*width\s*\}\s*/i,p=/\s*\{\s*height\s*\}\s*/i,z=/\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,v=/^\[.*\]|\{.*\}$/,m=/^(?:auto|\d+(px)?)$/,g=t.createElement("a"),b=t.createElement("img"),h="srcset"in b&&!("sizes"in b),A=!!e.HTMLPictureElement&&!h;!function(){var t,r=function(){},a={prefix:"",postfix:"",srcAttr:"data-src",absUrl:!1,modifyOptions:r,widthmap:{},ratio:!1,traditionalRatio:!1,aspectratio:!1};l=i&&i.cfg||e.lazySizesConfig,l||(l={},e.lazySizesConfig=l),l.supportsType||(l.supportsType=function(e){return!e}),l.rias||(l.rias={}),"widths"in(u=l.rias)||(u.widths=[],function(e){for(var t,i=0;!t||t<3e3;)i+=5,i>30&&(i+=1),t=36*i,e.push(t)}(u.widths));for(t in a)t in u||(u[t]=a[t])}(),addEventListener("lazybeforesizes",function(e){if(e.detail.instance==i){var t,r,a,c,d,f,p,z,v,g,b,h,E;if(t=e.target,e.detail.dataAttr&&!e.defaultPrevented&&!u.disabled&&(v=t.getAttribute(l.sizesAttr)||t.getAttribute("sizes"))&&m.test(v)){if(r=o(t),a=s(t,r),b=y.test(a.prefix)||y.test(a.postfix),a.isPicture&&(c=t.parentNode))for(d=c.getElementsByTagName("source"),f=0,p=d.length;f<p;f++)(b||y.test(z=o(d[f])))&&(n(z,a,d[f]),h=!0);b||y.test(r)?(n(r,a,t),h=!0):h&&(E=[],E.srcset=[],E.isPicture=!0,Object.defineProperty(t,"_lazyrias",{value:E,writable:!0})),h&&(A?t.removeAttribute(l.srcAttr):"auto"!=v&&(g={width:parseInt(v,10)},C({target:t,detail:g})))}}},!0);var C=function(){var r=function(e,t){return e.w-t.w},a=function(e){var t,i,r=e.length,a=e[r-1],n=0;for(n;n<r;n++)if(a=e[n],a.d=a.w/e.w,a.d>=e.d){!a.cached&&(t=e[n-1])&&t.d>e.d-.13*Math.pow(e.d,2.2)&&(i=Math.pow(t.d-.6,1.6),t.cached&&(t.d+=.15*i),t.d+(a.d-e.d)*i>e.d&&(a=t));break}return a},n=function(e,t){var r;return!e._lazyrias&&i.pWS&&(r=i.pWS(e.getAttribute(l.srcsetAttr||""))).length&&(Object.defineProperty(e,"_lazyrias",{value:r,writable:!0}),t&&e.parentNode&&(r.isPicture="PICTURE"==e.parentNode.nodeName.toUpperCase())),e._lazyrias},s=function(t){var r=e.devicePixelRatio||1,a=i.getX&&i.getX(t);return Math.min(a||r,2.4,r)},o=function(t,i){var o,l,u,c,d,f;if(d=t._lazyrias,d.isPicture&&e.matchMedia)for(l=0,o=t.parentNode.getElementsByTagName("source"),u=o.length;l<u;l++)if(n(o[l])&&!o[l].getAttribute("type")&&(!(c=o[l].getAttribute("media"))||(matchMedia(c)||{}).matches)){d=o[l]._lazyrias;break}return(!d.w||d.w<i)&&(d.w=i,d.d=s(t),f=a(d.sort(r))),f},u=function(r){if(r.detail.instance==i){var a,s=r.target;if(!h&&(e.respimage||e.picturefill||lazySizesConfig.pf))return void t.removeEventListener("lazybeforesizes",u);("_lazyrias"in s||r.detail.dataAttr&&n(s,!0))&&(a=o(s,r.detail.width))&&a.u&&s._lazyrias.cur!=a.u&&(s._lazyrias.cur=a.u,a.cached=!0,i.rAF(function(){s.setAttribute(l.srcAttr,a.u),s.setAttribute("src",a.u)}))}};return A?u=function(){}:addEventListener("lazybeforesizes",u),u}()}),!function(e,t){var i=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",i,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?i():e.addEventListener("lazyunveilread",i,!0)}(window,function(e,t,i){"use strict";function r(i,r){var a="vimeoCallback"+u,n=t.createElement("script");i+="&callback="+a,u++,e[a]=function(t){n.parentNode.removeChild(n),delete e[a],r(t)},n.src=i,t.head.appendChild(n)}function a(e,t){r(p.replace(c,e),function(e){e&&e.thumbnail_url&&(t.style.backgroundImage="url("+e.thumbnail_url+")")}),t.addEventListener("click",n)}function n(e){var t=e.currentTarget,i=t.getAttribute("data-vimeo"),r=t.getAttribute("data-vimeoparams")||"";r&&!d.test(r)&&(r="&"+r),e.preventDefault(),t.innerHTML='<iframe src="'+z.replace(c,i)+r+'" frameborder="0" allowfullscreen="" width="640" height="390"></iframe>',t.removeEventListener("click",n)}function s(e,t){t.style.backgroundImage="url("+f.replace(c,e)+")",t.addEventListener("click",o)}function o(e){var t=e.currentTarget,i=t.getAttribute("data-youtube"),r=t.getAttribute("data-ytparams")||"";r&&!d.test(r)&&(r="&"+r),e.preventDefault(),t.innerHTML='<iframe src="'+y.replace(c,i)+r+'" frameborder="0" allowfullscreen="" width="640" height="390"></iframe>',t.removeEventListener("click",o)}if(t.getElementsByClassName){var l="https:"==location.protocol?"https:":"http:",u=Date.now(),c=/\{\{id}}/,d=/^&/,f=l+"//img.youtube.com/vi//sddefault.jpg",y=l+"//www.youtube.com/embed/?autoplay=1",p=l+"//vimeo.com/api/oembed.json?url=https%3A//vimeo.com/",z=l+"//player.vimeo.com/video/?autoplay=1";t.addEventListener("lazybeforeunveil",function(e){if(e.detail.instance==i){var t=e.target,r=t.getAttribute("data-youtube"),n=t.getAttribute("data-vimeo");r&&t&&s(r,t),n&&t&&a(n,t)}})}}),function(e,t){var i=t(e,e.document);e.lazySizes=i,"object"==typeof module&&module.exports&&(module.exports=i)}(window,function(e,t){"use strict";if(t.getElementsByClassName){var i,r,a=t.documentElement,n=e.Date,s=e.HTMLPictureElement,o="addEventListener",l="getAttribute",u=e[o],c=e.setTimeout,d=e.requestAnimationFrame||c,f=e.requestIdleCallback,y=/^picture$/i,p=["load","error","lazyincluded","_lazyloaded"],z={},v=Array.prototype.forEach,m=function(e,t){return z[t]||(z[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")),z[t].test(e[l]("class")||"")&&z[t]},g=function(e,t){m(e,t)||e.setAttribute("class",(e[l]("class")||"").trim()+" "+t)},b=function(e,t){var i;(i=m(e,t))&&e.setAttribute("class",(e[l]("class")||"").replace(i," "))},h=function(e,t,i){var r=i?o:"removeEventListener";i&&h(e,t),p.forEach(function(i){e[r](i,t)})},A=function(e,r,a,n,s){var o=t.createEvent("Event");return a||(a={}),a.instance=i,o.initEvent(r,!n,!s),o.detail=a,e.dispatchEvent(o),o},C=function(t,i){var a;!s&&(a=e.picturefill||r.pf)?(i&&i.src&&!t[l]("srcset")&&t.setAttribute("srcset",i.src),a({reevaluate:!0,elements:[t]})):i&&i.src&&(t.src=i.src)},E=function(e,t){return(getComputedStyle(e,null)||{})[t]},w=function(e,t,i){for(i=i||e.offsetWidth;i<r.minSize&&t&&!e._lazysizesWidth;)i=t.offsetWidth,t=t.parentNode;return i},_=function(){var e,i,r=[],a=[],n=r,s=function(){var t=n;for(n=r.length?a:r,e=!0,i=!1;t.length;)t.shift()();e=!1},o=function(r,a){e&&!a?r.apply(this,arguments):(n.push(r),i||(i=!0,(t.hidden?c:d)(s)))};return o._lsFlush=s,o}(),N=function(e,t){return t?function(){_(e)}:function(){var t=this,i=arguments;_(function(){e.apply(t,i)})}},S=function(e){var t,i=0,a=r.throttleDelay,s=r.ricTimeout,o=function(){t=!1,i=n.now(),e()},l=f&&s>49?function(){f(o,{timeout:s}),s!==r.ricTimeout&&(s=r.ricTimeout)}:N(function(){c(o)},!0);return function(e){var r;(e=e===!0)&&(s=33),t||(t=!0,r=a-(n.now()-i),r<0&&(r=0),e||r<9?l():c(l,r))}},L=function(e){var t,i,r=99,a=function(){t=null,e()},s=function(){var e=n.now()-i;e<r?c(s,r-e):(f||a)(a)};return function(){i=n.now(),t||(t=c(s,r))}};!function(){var t,i={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:0,throttleDelay:125};r=e.lazySizesConfig||e.lazysizesConfig||{};for(t in i)t in r||(r[t]=i[t]);e.lazySizesConfig=r,c(function(){r.init&&T()})}();var P=function(){var s,d,f,p,z,w,P,T,x,F,k,j,O=/^img$/i,W=/^iframe$/i,R="onscroll"in e&&!/(gle|ing)bot/.test(navigator.userAgent),B=0,I=0,$=0,q=-1,H=function(e){$--,(!e||$<0||!e.target)&&($=0)},U=function(e){return null==j&&(j="hidden"==E(t.body,"visibility")),j||"hidden"!=E(e.parentNode,"visibility")&&"hidden"!=E(e,"visibility")},D=function(e,i){var r,n=e,s=U(e);for(T-=i,k+=i,x-=i,F+=i;s&&(n=n.offsetParent)&&n!=t.body&&n!=a;)s=(E(n,"opacity")||1)>0,s&&"visible"!=E(n,"overflow")&&(r=n.getBoundingClientRect(),s=F>r.left&&x<r.right&&k>r.top-1&&T<r.bottom+1);return s},V=function(){var e,n,o,u,c,f,y,z,v,m,g,b,h=i.elements;if((p=r.loadMode)&&$<8&&(e=h.length)){for(n=0,q++,m=!r.expand||r.expand<1?a.clientHeight>500&&a.clientWidth>500?500:370:r.expand,i._defEx=m,g=m*r.expFactor,b=r.hFac,j=null,I<g&&$<1&&q>2&&p>2&&!t.hidden?(I=g,q=0):I=p>1&&q>1&&$<6?m:B;n<e;n++)if(h[n]&&!h[n]._lazyRace)if(R)if((z=h[n][l]("data-expand"))&&(f=1*z)||(f=I),v!==f&&(w=innerWidth+f*b,P=innerHeight+f,y=f*-1,v=f),o=h[n].getBoundingClientRect(),(k=o.bottom)>=y&&(T=o.top)<=P&&(F=o.right)>=y*b&&(x=o.left)<=w&&(k||F||x||T)&&(r.loadHidden||U(h[n]))&&(d&&$<3&&!z&&(p<3||q<4)||D(h[n],f))){if(ee(h[n]),c=!0,$>9)break}else!c&&d&&!u&&$<4&&q<4&&p>2&&(s[0]||r.preloadAfterLoad)&&(s[0]||!z&&(k||F||x||T||"auto"!=h[n][l](r.sizesAttr)))&&(u=s[0]||h[n]);else ee(h[n]);u&&!c&&ee(u)}},X=S(V),J=function(e){var t=e.target;return t._lazyCache?void delete t._lazyCache:(H(e),g(t,r.loadedClass),b(t,r.loadingClass),h(t,G),void A(t,"lazyloaded"))},Q=N(J),G=function(e){Q({target:e.target})},K=function(e,t){try{e.contentWindow.location.replace(t)}catch(i){e.src=t}},Y=function(e){var t,i=e[l](r.srcsetAttr);(t=r.customMedia[e[l]("data-media")||e[l]("media")])&&e.setAttribute("media",t),i&&e.setAttribute("srcset",i)},Z=N(function(e,t,i,a,n){var s,o,u,d,p,z;(p=A(e,"lazybeforeunveil",t)).defaultPrevented||(a&&(i?g(e,r.autosizesClass):e.setAttribute("sizes",a)),o=e[l](r.srcsetAttr),s=e[l](r.srcAttr),n&&(u=e.parentNode,d=u&&y.test(u.nodeName||"")),z=t.firesLoad||"src"in e&&(o||s||d),p={target:e},g(e,r.loadingClass),z&&(clearTimeout(f),f=c(H,2500),h(e,G,!0)),d&&v.call(u.getElementsByTagName("source"),Y),o?e.setAttribute("srcset",o):s&&!d&&(W.test(e.nodeName)?K(e,s):e.src=s),n&&(o||d)&&C(e,{src:s})),e._lazyRace&&delete e._lazyRace,b(e,r.lazyClass),_(function(){(!z||e.complete&&e.naturalWidth>1)&&(J(p),e._lazyCache=!0,c(function(){"_lazyCache"in e&&delete e._lazyCache},9))},!0)}),ee=function(e){var t,i=O.test(e.nodeName),a=i&&(e[l](r.sizesAttr)||e[l]("sizes")),n="auto"==a;(!n&&d||!i||!e[l]("src")&&!e.srcset||e.complete||m(e,r.errorClass)||!m(e,r.lazyClass))&&(t=A(e,"lazyunveilread").detail,n&&M.updateElem(e,!0,e.offsetWidth),e._lazyRace=!0,$++,Z(e,t,n,a,i))},te=function(){if(!d){if(n.now()-z<999)return void c(te,999);var e=L(function(){r.loadMode=3,X()});d=!0,r.loadMode=3,X(),u("scroll",function(){3==r.loadMode&&(r.loadMode=2),e()},!0)}};return{_:function(){z=n.now(),i.elements=t.getElementsByClassName(r.lazyClass),s=t.getElementsByClassName(r.lazyClass+" "+r.preloadClass),u("scroll",X,!0),u("resize",X,!0),e.MutationObserver?new MutationObserver(X).observe(a,{childList:!0,subtree:!0,attributes:!0}):(a[o]("DOMNodeInserted",X,!0),a[o]("DOMAttrModified",X,!0),setInterval(X,999)),u("hashchange",X,!0),["focus","mouseover","click","load","transitionend","animationend","webkitAnimationEnd"].forEach(function(e){t[o](e,X,!0)}),/d$|^c/.test(t.readyState)?te():(u("load",te),t[o]("DOMContentLoaded",X),c(te,2e4)),i.elements.length?(V(),_._lsFlush()):X()},checkElems:X,unveil:ee}}(),M=function(){var e,i=N(function(e,t,i,r){var a,n,s;if(e._lazysizesWidth=r,r+="px",e.setAttribute("sizes",r),y.test(t.nodeName||""))for(a=t.getElementsByTagName("source"),n=0,s=a.length;n<s;n++)a[n].setAttribute("sizes",r);i.detail.dataAttr||C(e,i.detail)}),a=function(e,t,r){var a,n=e.parentNode;n&&(r=w(e,n,r),a=A(e,"lazybeforesizes",{width:r,dataAttr:!!t}),a.defaultPrevented||(r=a.detail.width,r&&r!==e._lazysizesWidth&&i(e,n,a,r)))},n=function(){var t,i=e.length;if(i)for(t=0;t<i;t++)a(e[t])},s=L(n);return{_:function(){e=t.getElementsByClassName(r.autosizesClass),u("resize",s)},checkElems:s,updateElem:a}}(),T=function(){T.i||(T.i=!0,M._(),P._())};return i={cfg:r,autoSizer:M,loader:P,init:T,uP:C,aC:g,rC:b,hC:m,fire:A,gW:w,rAF:_}}});
/*!
 * modernizr.min.js
 */
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-objectfit-touchevents-setclasses !*/
/*!
 * stylehatch-standards.js
 */
function replaceUrlParam(e,t,n){var i=new RegExp("("+t+"=).*?(&|$)"),r=e;return r=e.search(i)>=0?e.replace(i,"$1"+n+"$2"):r+(r.indexOf("?")>0?"&":"?")+t+"="+n}function removeDataAttributes(e){var t,n=$(e);if(n.length>0){var i=[],r=n.get(0).attributes,o=r.length;for(t=0;t<o;t++)"data-"===r[t].name.substring(0,5)&&i.push(r[t].name);$.each(i,function(e,t){n.removeAttr(t)})}}function wordWrapper(e,t,n){if(e.length>t){for(var i=t;i>0&&" "!=e[i];i--);if(i>0){var r=e.substring(0,i),o=e.substring(i+1);return r+n+wordWrapper(o,t,n)}}return e}!function(e,t,n){function i(e,t){return typeof e===t}function r(){var e,t,n,r,o,s,a;for(var l in b)if(b.hasOwnProperty(l)){if(e=[],t=b[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(r=i(t.fn,"function")?t.fn():t.fn,o=0;o<e.length;o++)s=e[o],a=s.split("."),1===a.length?x[a[0]]=r:(!x[a[0]]||x[a[0]]instanceof Boolean||(x[a[0]]=new Boolean(x[a[0]])),x[a[0]][a[1]]=r),y.push((r?"":"no-")+a.join("-"))}}function o(e){var t=C.className,n=x._config.classPrefix||"";if(_&&(t=t.baseVal),x._config.enableJSClass){var i=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(i,"$1"+n+"js$2")}x._config.enableClasses&&(t+=" "+n+e.join(" "+n),_?C.className.baseVal=t:C.className=t)}function s(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function a(e,t){return!!~(""+e).indexOf(t)}function l(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):_?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function u(e,t){return function(){return e.apply(t,arguments)}}function c(e,t,n){var r;for(var o in e)if(e[o]in t)return n===!1?e[o]:(r=t[e[o]],i(r,"function")?u(r,n||t):r);return!1}function d(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function f(t,n,i){var r;if("getComputedStyle"in e){r=getComputedStyle.call(e,t,n);var o=e.console;if(null!==r)i&&(r=r.getPropertyValue(i));else if(o){var s=o.error?"error":"log";o[s].call(o,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else r=!n&&t.currentStyle&&t.currentStyle[i];return r}function h(){var e=t.body;return e||(e=l(_?"svg":"body"),e.fake=!0),e}function p(e,n,i,r){var o,s,a,u,c="modernizr",d=l("div"),f=h();if(parseInt(i,10))for(;i--;)a=l("div"),a.id=r?r[i]:c+(i+1),d.appendChild(a);return o=l("style"),o.type="text/css",o.id="s"+c,(f.fake?f:d).appendChild(o),f.appendChild(d),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(t.createTextNode(e)),d.id=c,f.fake&&(f.style.background="",f.style.overflow="hidden",u=C.style.overflow,C.style.overflow="hidden",C.appendChild(f)),s=n(d,e),f.fake?(f.parentNode.removeChild(f),C.style.overflow=u,C.offsetHeight):d.parentNode.removeChild(d),!!s}function m(t,i){var r=t.length;if("CSS"in e&&"supports"in e.CSS){for(;r--;)if(e.CSS.supports(d(t[r]),i))return!0;return!1}if("CSSSupportsRule"in e){for(var o=[];r--;)o.push("("+d(t[r])+":"+i+")");return o=o.join(" or "),p("@supports ("+o+") { #modernizr { position: absolute; } }",function(e){return"absolute"==f(e,null,"position")})}return n}function g(e,t,r,o){function u(){d&&(delete I.style,delete I.modElem)}if(o=!i(o,"undefined")&&o,!i(r,"undefined")){var c=m(e,r);if(!i(c,"undefined"))return c}for(var d,f,h,p,g,v=["modernizr","tspan","samp"];!I.style&&v.length;)d=!0,I.modElem=l(v.shift()),I.style=I.modElem.style;for(h=e.length,f=0;h>f;f++)if(p=e[f],g=I.style[p],a(p,"-")&&(p=s(p)),I.style[p]!==n){if(o||i(r,"undefined"))return u(),"pfx"!=t||p;try{I.style[p]=r}catch(e){}if(I.style[p]!=g)return u(),"pfx"!=t||p}return u(),!1}function v(e,t,n,r,o){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+E.join(s+" ")+s).split(" ");return i(t,"string")||i(t,"undefined")?g(a,t,r,o):(a=(e+" "+k.join(s+" ")+s).split(" "),c(a,t,n))}var y=[],b=[],w={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){b.push({name:e,fn:t,options:n})},addAsyncTest:function(e){b.push({name:null,fn:e})}},x=function(){};x.prototype=w,x=new x;var C=t.documentElement,_="svg"===C.nodeName.toLowerCase(),S="Moz O ms Webkit",E=w._config.usePrefixes?S.split(" "):[];w._cssomPrefixes=E;var T=function(t){var i,r=L.length,o=e.CSSRule;if("undefined"==typeof o)return n;if(!t)return!1;if(t=t.replace(/^@/,""),i=t.replace(/-/g,"_").toUpperCase()+"_RULE",i in o)return"@"+t;for(var s=0;r>s;s++){var a=L[s],l=a.toUpperCase()+"_"+i;if(l in o)return"@-"+a.toLowerCase()+"-"+t}return!1};w.atRule=T;var k=w._config.usePrefixes?S.toLowerCase().split(" "):[];w._domPrefixes=k;var A={elem:l("modernizr")};x._q.push(function(){delete A.elem});var I={style:A.elem.style};x._q.unshift(function(){delete I.style}),w.testAllProps=v;var D=w.prefixed=function(e,t,n){return 0===e.indexOf("@")?T(e):(-1!=e.indexOf("-")&&(e=s(e)),t?v(e,t,n):v(e,"pfx"))};x.addTest("objectfit",!!D("objectFit"),{aliases:["object-fit"]});var z=w.testStyles=p,L=w._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];w._prefixes=L,x.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var i=["@media (",L.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");z(i,function(e){n=9===e.offsetTop})}return n}),r(),o(y),delete w.addTest,delete w.addAsyncTest;for(var P=0;P<x._q.length;P++)x._q[P]();e.Modernizr=x}(window,document),/*!
 * log.js
 */
/*! log.js 0.1.5 */
function(){var e,t,n,i,r,o,s,a,l,u,c,d,f,h,p;window.console&&window.console.log&&(u=function(){var e;return e=[],c(arguments).forEach(function(t){return"string"==typeof t?e=e.concat(h(t)):e.push(t)}),p.apply(window,e)},p=function(){return console.log.apply(console,c(arguments))},c=function(e){return Array.prototype.slice.call(e)},n=[{regex:/\*([^\*]+)\*/,replacer:function(e,t){return"%c"+t+"%c"},styles:function(){return["font-style: italic",""]}},{regex:/\_([^\_]+)\_/,replacer:function(e,t){return"%c"+t+"%c"},styles:function(){return["font-weight: bold",""]}},{regex:/\`([^\`]+)\`/,replacer:function(e,t){return"%c"+t+"%c"},styles:function(){return["background: rgb(255, 255, 219); padding: 1px 5px; border: 1px solid rgba(0, 0, 0, 0.1)",""]}},{regex:/\[c\=(?:\"|\')?((?:(?!(?:\"|\')\]).)*)(?:\"|\')?\]((?:(?!\[c\]).)*)\[c\]/,replacer:function(e,t,n){return"%c"+n+"%c"},styles:function(e){return[e[1],""]}}],r=function(e){var t;return t=!1,n.forEach(function(n){return n.regex.test(e)?t=!0:void 0}),t},i=function(e){var t;return t=[],n.forEach(function(n){var i;return i=e.match(n.regex),i?t.push({format:n,match:i}):void 0}),t.sort(function(e,t){return e.match.index-t.match.index})},h=function(e){var t,n,o;for(o=[];r(e);)n=i(e),t=n[0],e=e.replace(t.format.regex,t.format.replacer),o=o.concat(t.format.styles(t.match));return[e].concat(o)},l=function(){return/Safari/.test(navigator.userAgent)&&/Apple Computer/.test(navigator.vendor)},a=function(){return/OPR/.test(navigator.userAgent)&&/Opera/.test(navigator.vendor)},o=function(){return/Firefox/.test(navigator.userAgent)},s=function(){return/MSIE/.test(navigator.userAgent)},f=function(){var e;return e=navigator.userAgent.match(/AppleWebKit\/(\d+)\.(\d+)(\.|\+|\s)/),!!e&&537.38<=parseInt(e[1],10)+parseInt(e[2],10)/100},d=function(){var e;return e=navigator.userAgent.match(/OPR\/(\d+)\./),!!e&&15<=parseInt(e[1],10)},t=function(){return window.console.firebug||window.console.exception},e=s()||o()&&!t()||a()&&!d()||l()&&!f()?p:u,e.l=p,"function"==typeof define&&define.amd?define(e):"undefined"!=typeof exports?module.exports=e:window.log=e)}.call(this),/*!
 * jquery-2.2.3.min.js
 */
/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(e,t){"use strict";function n(e,t,n){var i,r=(t=t||se).createElement("script");if(r.text=e,n)for(i in we)n[i]&&(r[i]=n[i]);t.head.appendChild(r).parentNode.removeChild(r)}function i(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?fe[he.call(e)]||"object":typeof e}function r(e){var t=!!e&&"length"in e&&e.length,n=i(e);return!ye(e)&&!be(e)&&("array"===n||0===t||"number"==typeof t&&t>0&&t-1 in e)}function o(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}function s(e,t,n){return ye(t)?xe.grep(e,function(e,i){return!!t.call(e,i,e)!==n}):t.nodeType?xe.grep(e,function(e){return e===t!==n}):"string"!=typeof t?xe.grep(e,function(e){return de.call(t,e)>-1!==n}):xe.filter(t,e,n)}function a(e,t){for(;(e=e[t])&&1!==e.nodeType;);return e}function l(e){var t={};return xe.each(e.match(Le)||[],function(e,n){t[n]=!0}),t}function u(e){return e}function c(e){throw e}function d(e,t,n,i){var r;try{e&&ye(r=e.promise)?r.call(e).done(t).fail(n):e&&ye(r=e.then)?r.call(e,t,n):t.apply(void 0,[e].slice(i))}catch(e){n.apply(void 0,[e])}}function f(){se.removeEventListener("DOMContentLoaded",f),e.removeEventListener("load",f),xe.ready()}function h(e,t){return t.toUpperCase()}function p(e){return e.replace(Oe,"ms-").replace(Me,h)}function m(){this.expando=xe.expando+m.uid++}function g(e){return"true"===e||"false"!==e&&("null"===e?null:e===+e+""?+e:He.test(e)?JSON.parse(e):e)}function v(e,t,n){var i;if(void 0===n&&1===e.nodeType)if(i="data-"+t.replace(Re,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(i))){try{n=g(n)}catch(e){}Be.set(e,t,n)}else n=void 0;return n}function y(e,t,n,i){var r,o,s=20,a=i?function(){return i.cur()}:function(){return xe.css(e,t,"")},l=a(),u=n&&n[3]||(xe.cssNumber[t]?"":"px"),c=(xe.cssNumber[t]||"px"!==u&&+l)&&$e.exec(xe.css(e,t));if(c&&c[3]!==u){for(l/=2,u=u||c[3],c=+l||1;s--;)xe.style(e,t,c+u),(1-o)*(1-(o=a()/l||.5))<=0&&(s=0),c/=o;c*=2,xe.style(e,t,c+u),n=n||[]}return n&&(c=+c||+l||0,r=n[1]?c+(n[1]+1)*n[2]:+n[2],i&&(i.unit=u,i.start=c,i.end=r)),r}function b(e){var t,n=e.ownerDocument,i=e.nodeName,r=Ye[i];return r||(t=n.body.appendChild(n.createElement(i)),r=xe.css(t,"display"),t.parentNode.removeChild(t),"none"===r&&(r="block"),Ye[i]=r,r)}function w(e,t){for(var n,i,r=[],o=0,s=e.length;o<s;o++)(i=e[o]).style&&(n=i.style.display,t?("none"===n&&(r[o]=qe.get(i,"display")||null,r[o]||(i.style.display="")),""===i.style.display&&Ve(i)&&(r[o]=b(i))):"none"!==n&&(r[o]="none",qe.set(i,"display",n)));for(o=0;o<s;o++)null!=r[o]&&(e[o].style.display=r[o]);return e}function x(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&o(e,t)?xe.merge([e],n):n}function C(e,t){for(var n=0,i=e.length;n<i;n++)qe.set(e[n],"globalEval",!t||qe.get(t[n],"globalEval"))}function _(e,t,n,r,o){for(var s,a,l,u,c,d,f=t.createDocumentFragment(),h=[],p=0,m=e.length;p<m;p++)if((s=e[p])||0===s)if("object"===i(s))xe.merge(h,s.nodeType?[s]:s);else if(Ke.test(s)){for(a=a||f.appendChild(t.createElement("div")),l=(Ge.exec(s)||["",""])[1].toLowerCase(),u=Ze[l]||Ze._default,a.innerHTML=u[1]+xe.htmlPrefilter(s)+u[2],d=u[0];d--;)a=a.lastChild;xe.merge(h,a.childNodes),(a=f.firstChild).textContent=""}else h.push(t.createTextNode(s));for(f.textContent="",p=0;s=h[p++];)if(r&&xe.inArray(s,r)>-1)o&&o.push(s);else if(c=xe.contains(s.ownerDocument,s),a=x(f.appendChild(s),"script"),c&&C(a),n)for(d=0;s=a[d++];)Je.test(s.type||"")&&n.push(s);return f}function S(){return!0}function E(){return!1}function T(){try{return se.activeElement}catch(e){}}function k(e,t,n,i,r,o){var s,a;if("object"==typeof t){"string"!=typeof n&&(i=i||n,n=void 0);for(a in t)k(e,a,n,i,t[a],o);return e}if(null==i&&null==r?(r=n,i=n=void 0):null==r&&("string"==typeof n?(r=i,i=void 0):(r=i,i=n,n=void 0)),!1===r)r=E;else if(!r)return e;return 1===o&&(s=r,(r=function(e){return xe().off(e),s.apply(this,arguments)}).guid=s.guid||(s.guid=xe.guid++)),e.each(function(){xe.event.add(this,t,r,i,n)})}function A(e,t){return o(e,"table")&&o(11!==t.nodeType?t:t.firstChild,"tr")?xe(e).children("tbody")[0]||e:e}function I(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function D(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function z(e,t){var n,i,r,o,s,a,l,u;if(1===t.nodeType){if(qe.hasData(e)&&(o=qe.access(e),s=qe.set(t,o),u=o.events)){delete s.handle,s.events={};for(r in u)for(n=0,i=u[r].length;n<i;n++)xe.event.add(t,r,u[r][n])}Be.hasData(e)&&(a=Be.access(e),l=xe.extend({},a),Be.set(t,l))}}function L(e,t){var n=t.nodeName.toLowerCase();"input"===n&&Xe.test(e.type)?t.checked=e.checked:"input"!==n&&"textarea"!==n||(t.defaultValue=e.defaultValue)}function P(e,t,i,r){t=ue.apply([],t);var o,s,a,l,u,c,d=0,f=e.length,h=f-1,p=t[0],m=ye(p);if(m||f>1&&"string"==typeof p&&!ve.checkClone&&st.test(p))return e.each(function(n){var o=e.eq(n);m&&(t[0]=p.call(this,n,o.html())),P(o,t,i,r)});if(f&&(o=_(t,e[0].ownerDocument,!1,e,r),s=o.firstChild,1===o.childNodes.length&&(o=s),s||r)){for(l=(a=xe.map(x(o,"script"),I)).length;d<f;d++)u=o,d!==h&&(u=xe.clone(u,!0,!0),l&&xe.merge(a,x(u,"script"))),i.call(e[d],u,d);if(l)for(c=a[a.length-1].ownerDocument,xe.map(a,D),d=0;d<l;d++)u=a[d],Je.test(u.type||"")&&!qe.access(u,"globalEval")&&xe.contains(c,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?xe._evalUrl&&xe._evalUrl(u.src):n(u.textContent.replace(at,""),c,u))}return e}function j(e,t,n){for(var i,r=t?xe.filter(t,e):e,o=0;null!=(i=r[o]);o++)n||1!==i.nodeType||xe.cleanData(x(i)),i.parentNode&&(n&&xe.contains(i.ownerDocument,i)&&C(x(i,"script")),i.parentNode.removeChild(i));return e}function N(e,t,n){var i,r,o,s,a=e.style;return(n=n||ut(e))&&(""!==(s=n.getPropertyValue(t)||n[t])||xe.contains(e.ownerDocument,e)||(s=xe.style(e,t)),!ve.pixelBoxStyles()&&lt.test(s)&&ct.test(t)&&(i=a.width,r=a.minWidth,o=a.maxWidth,a.minWidth=a.maxWidth=a.width=s,s=n.width,a.width=i,a.minWidth=r,a.maxWidth=o)),void 0!==s?s+"":s}function O(e,t){return{get:function(){return e()?void delete this.get:(this.get=t).apply(this,arguments)}}}function M(e){if(e in gt)return e;for(var t=e[0].toUpperCase()+e.slice(1),n=mt.length;n--;)if((e=mt[n]+t)in gt)return e}function F(e){var t=xe.cssProps[e];return t||(t=xe.cssProps[e]=M(e)||e),t}function q(e,t,n){var i=$e.exec(t);return i?Math.max(0,i[2]-(n||0))+(i[3]||"px"):t}function B(e,t,n,i,r,o){var s="width"===t?1:0,a=0,l=0;if(n===(i?"border":"content"))return 0;for(;s<4;s+=2)"margin"===n&&(l+=xe.css(e,n+Ue[s],!0,r)),i?("content"===n&&(l-=xe.css(e,"padding"+Ue[s],!0,r)),"margin"!==n&&(l-=xe.css(e,"border"+Ue[s]+"Width",!0,r))):(l+=xe.css(e,"padding"+Ue[s],!0,r),"padding"!==n?l+=xe.css(e,"border"+Ue[s]+"Width",!0,r):a+=xe.css(e,"border"+Ue[s]+"Width",!0,r));return!i&&o>=0&&(l+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-l-a-.5))),l}function H(e,t,n){var i=ut(e),r=N(e,t,i),o="border-box"===xe.css(e,"boxSizing",!1,i),s=o;if(lt.test(r)){if(!n)return r;r="auto"}return s=s&&(ve.boxSizingReliable()||r===e.style[t]),("auto"===r||!parseFloat(r)&&"inline"===xe.css(e,"display",!1,i))&&(r=e["offset"+t[0].toUpperCase()+t.slice(1)],s=!0),(r=parseFloat(r)||0)+B(e,t,n||(o?"border":"content"),s,i,r)+"px"}function R(e,t,n,i,r){return new R.prototype.init(e,t,n,i,r)}function W(){yt&&(!1===se.hidden&&e.requestAnimationFrame?e.requestAnimationFrame(W):e.setTimeout(W,xe.fx.interval),xe.fx.tick())}function $(){return e.setTimeout(function(){vt=void 0}),vt=Date.now()}function U(e,t){var n,i=0,r={height:e};for(t=t?1:0;i<4;i+=2-t)r["margin"+(n=Ue[i])]=r["padding"+n]=e;return t&&(r.opacity=r.width=e),r}function V(e,t,n){for(var i,r=(X.tweeners[t]||[]).concat(X.tweeners["*"]),o=0,s=r.length;o<s;o++)if(i=r[o].call(n,t,e))return i}function Q(e,t,n){var i,r,o,s,a,l,u,c,d="width"in t||"height"in t,f=this,h={},p=e.style,m=e.nodeType&&Ve(e),g=qe.get(e,"fxshow");n.queue||(null==(s=xe._queueHooks(e,"fx")).unqueued&&(s.unqueued=0,a=s.empty.fire,s.empty.fire=function(){s.unqueued||a()}),s.unqueued++,f.always(function(){f.always(function(){s.unqueued--,xe.queue(e,"fx").length||s.empty.fire()})}));for(i in t)if(r=t[i],bt.test(r)){if(delete t[i],o=o||"toggle"===r,r===(m?"hide":"show")){if("show"!==r||!g||void 0===g[i])continue;m=!0}h[i]=g&&g[i]||xe.style(e,i)}if((l=!xe.isEmptyObject(t))||!xe.isEmptyObject(h)){d&&1===e.nodeType&&(n.overflow=[p.overflow,p.overflowX,p.overflowY],null==(u=g&&g.display)&&(u=qe.get(e,"display")),"none"===(c=xe.css(e,"display"))&&(u?c=u:(w([e],!0),u=e.style.display||u,c=xe.css(e,"display"),w([e]))),("inline"===c||"inline-block"===c&&null!=u)&&"none"===xe.css(e,"float")&&(l||(f.done(function(){p.display=u}),null==u&&(c=p.display,u="none"===c?"":c)),p.display="inline-block")),n.overflow&&(p.overflow="hidden",f.always(function(){p.overflow=n.overflow[0],p.overflowX=n.overflow[1],p.overflowY=n.overflow[2]})),l=!1;for(i in h)l||(g?"hidden"in g&&(m=g.hidden):g=qe.access(e,"fxshow",{display:u}),o&&(g.hidden=!m),m&&w([e],!0),f.done(function(){m||w([e]),qe.remove(e,"fxshow");for(i in h)xe.style(e,i,h[i])})),l=V(m?g[i]:0,i,f),i in g||(g[i]=l.start,m&&(l.end=l.start,l.start=0))}}function Y(e,t){var n,i,r,o,s;for(n in e)if(i=p(n),r=t[i],o=e[n],Array.isArray(o)&&(r=o[1],o=e[n]=o[0]),n!==i&&(e[i]=o,delete e[n]),(s=xe.cssHooks[i])&&"expand"in s){o=s.expand(o),delete e[i];for(n in o)n in e||(e[n]=o[n],t[n]=r)}else t[i]=r}function X(e,t,n){var i,r,o=0,s=X.prefilters.length,a=xe.Deferred().always(function(){delete l.elem}),l=function(){if(r)return!1;for(var t=vt||$(),n=Math.max(0,u.startTime+u.duration-t),i=1-(n/u.duration||0),o=0,s=u.tweens.length;o<s;o++)u.tweens[o].run(i);return a.notifyWith(e,[u,i,n]),i<1&&s?n:(s||a.notifyWith(e,[u,1,0]),a.resolveWith(e,[u]),!1)},u=a.promise({elem:e,props:xe.extend({},t),opts:xe.extend(!0,{specialEasing:{},easing:xe.easing._default},n),originalProperties:t,originalOptions:n,startTime:vt||$(),duration:n.duration,tweens:[],createTween:function(t,n){var i=xe.Tween(e,u.opts,t,n,u.opts.specialEasing[t]||u.opts.easing);return u.tweens.push(i),i},stop:function(t){var n=0,i=t?u.tweens.length:0;if(r)return this;for(r=!0;n<i;n++)u.tweens[n].run(1);return t?(a.notifyWith(e,[u,1,0]),a.resolveWith(e,[u,t])):a.rejectWith(e,[u,t]),this}}),c=u.props;for(Y(c,u.opts.specialEasing);o<s;o++)if(i=X.prefilters[o].call(u,e,c,u.opts))return ye(i.stop)&&(xe._queueHooks(u.elem,u.opts.queue).stop=i.stop.bind(i)),i;return xe.map(c,V,u),ye(u.opts.start)&&u.opts.start.call(e,u),u.progress(u.opts.progress).done(u.opts.done,u.opts.complete).fail(u.opts.fail).always(u.opts.always),xe.fx.timer(xe.extend(l,{elem:e,anim:u,queue:u.opts.queue})),u}function G(e){return(e.match(Le)||[]).join(" ")}function J(e){return e.getAttribute&&e.getAttribute("class")||""}function Z(e){return Array.isArray(e)?e:"string"==typeof e?e.match(Le)||[]:[]}function K(e,t,n,r){var o;if(Array.isArray(t))xe.each(t,function(t,i){n||zt.test(e)?r(e,i):K(e+"["+("object"==typeof i&&null!=i?t:"")+"]",i,n,r)});else if(n||"object"!==i(t))r(e,t);else for(o in t)K(e+"["+o+"]",t[o],n,r)}function ee(e){return function(t,n){"string"!=typeof t&&(n=t,t="*");var i,r=0,o=t.toLowerCase().match(Le)||[];if(ye(n))for(;i=o[r++];)"+"===i[0]?(i=i.slice(1)||"*",(e[i]=e[i]||[]).unshift(n)):(e[i]=e[i]||[]).push(n)}}function te(e,t,n,i){function r(a){var l;return o[a]=!0,xe.each(e[a]||[],function(e,a){var u=a(t,n,i);return"string"!=typeof u||s||o[u]?s?!(l=u):void 0:(t.dataTypes.unshift(u),r(u),!1)}),l}var o={},s=e===Wt;return r(t.dataTypes[0])||!o["*"]&&r("*")}function ne(e,t){var n,i,r=xe.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((r[n]?e:i||(i={}))[n]=t[n]);return i&&xe.extend(!0,e,i),e}function ie(e,t,n){for(var i,r,o,s,a=e.contents,l=e.dataTypes;"*"===l[0];)l.shift(),void 0===i&&(i=e.mimeType||t.getResponseHeader("Content-Type"));if(i)for(r in a)if(a[r]&&a[r].test(i)){l.unshift(r);break}if(l[0]in n)o=l[0];else{for(r in n){if(!l[0]||e.converters[r+" "+l[0]]){o=r;break}s||(s=r)}o=o||s}if(o)return o!==l[0]&&l.unshift(o),n[o]}function re(e,t,n,i){var r,o,s,a,l,u={},c=e.dataTypes.slice();if(c[1])for(s in e.converters)u[s.toLowerCase()]=e.converters[s];for(o=c.shift();o;)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!l&&i&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),l=o,o=c.shift())if("*"===o)o=l;else if("*"!==l&&l!==o){if(!(s=u[l+" "+o]||u["* "+o]))for(r in u)if((a=r.split(" "))[1]===o&&(s=u[l+" "+a[0]]||u["* "+a[0]])){!0===s?s=u[r]:!0!==u[r]&&(o=a[0],c.unshift(a[1]));break}if(!0!==s)if(s&&e.throws)t=s(t);else try{t=s(t)}catch(e){return{state:"parsererror",error:s?e:"No conversion from "+l+" to "+o}}}return{state:"success",data:t}}var oe=[],se=e.document,ae=Object.getPrototypeOf,le=oe.slice,ue=oe.concat,ce=oe.push,de=oe.indexOf,fe={},he=fe.toString,pe=fe.hasOwnProperty,me=pe.toString,ge=me.call(Object),ve={},ye=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType},be=function(e){return null!=e&&e===e.window},we={type:!0,src:!0,noModule:!0},xe=function(e,t){return new xe.fn.init(e,t)},Ce=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;xe.fn=xe.prototype={jquery:"3.3.1",constructor:xe,length:0,toArray:function(){return le.call(this)},get:function(e){return null==e?le.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=xe.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return xe.each(this,e)},map:function(e){return this.pushStack(xe.map(this,function(t,n){return e.call(t,n,t)}))},slice:function(){return this.pushStack(le.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(n>=0&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:ce,sort:oe.sort,splice:oe.splice},xe.extend=xe.fn.extend=function(){var e,t,n,i,r,o,s=arguments[0]||{},a=1,l=arguments.length,u=!1;for("boolean"==typeof s&&(u=s,s=arguments[a]||{},a++),"object"==typeof s||ye(s)||(s={}),a===l&&(s=this,a--);a<l;a++)if(null!=(e=arguments[a]))for(t in e)n=s[t],s!==(i=e[t])&&(u&&i&&(xe.isPlainObject(i)||(r=Array.isArray(i)))?(r?(r=!1,o=n&&Array.isArray(n)?n:[]):o=n&&xe.isPlainObject(n)?n:{},s[t]=xe.extend(u,o,i)):void 0!==i&&(s[t]=i));return s},xe.extend({expando:"jQuery"+("3.3.1"+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==he.call(e)||(t=ae(e))&&("function"!=typeof(n=pe.call(t,"constructor")&&t.constructor)||me.call(n)!==ge))},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e){n(e)},each:function(e,t){var n,i=0;if(r(e))for(n=e.length;i<n&&!1!==t.call(e[i],i,e[i]);i++);else for(i in e)if(!1===t.call(e[i],i,e[i]))break;return e},trim:function(e){return null==e?"":(e+"").replace(Ce,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(r(Object(e))?xe.merge(n,"string"==typeof e?[e]:e):ce.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:de.call(t,e,n)},merge:function(e,t){for(var n=+t.length,i=0,r=e.length;i<n;i++)e[r++]=t[i];return e.length=r,e},grep:function(e,t,n){for(var i,r=[],o=0,s=e.length,a=!n;o<s;o++)(i=!t(e[o],o))!==a&&r.push(e[o]);return r},map:function(e,t,n){var i,o,s=0,a=[];if(r(e))for(i=e.length;s<i;s++)null!=(o=t(e[s],s,n))&&a.push(o);else for(s in e)null!=(o=t(e[s],s,n))&&a.push(o);return ue.apply([],a)},guid:1,support:ve}),"function"==typeof Symbol&&(xe.fn[Symbol.iterator]=oe[Symbol.iterator]),xe.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){fe["[object "+t+"]"]=t.toLowerCase()});var _e=function(e){function t(e,t,n,i){var r,o,s,a,l,u,c,f=t&&t.ownerDocument,p=t?t.nodeType:9;if(n=n||[],"string"!=typeof e||!e||1!==p&&9!==p&&11!==p)return n;if(!i&&((t?t.ownerDocument||t:H)!==P&&L(t),t=t||P,N)){if(11!==p&&(l=ve.exec(e)))if(r=l[1]){if(9===p){if(!(s=t.getElementById(r)))return n;if(s.id===r)return n.push(s),n}else if(f&&(s=f.getElementById(r))&&q(t,s)&&s.id===r)return n.push(s),n}else{if(l[2])return Z.apply(n,t.getElementsByTagName(e)),n;if((r=l[3])&&C.getElementsByClassName&&t.getElementsByClassName)return Z.apply(n,t.getElementsByClassName(r)),n}if(C.qsa&&!V[e+" "]&&(!O||!O.test(e))){if(1!==p)f=t,c=e;else if("object"!==t.nodeName.toLowerCase()){for((a=t.getAttribute("id"))?a=a.replace(xe,Ce):t.setAttribute("id",a=B),o=(u=T(e)).length;o--;)u[o]="#"+a+" "+h(u[o]);c=u.join(","),f=ye.test(e)&&d(t.parentNode)||t}if(c)try{return Z.apply(n,f.querySelectorAll(c)),n}catch(e){}finally{a===B&&t.removeAttribute("id")}}}return A(e.replace(ae,"$1"),t,n,i)}function n(){function e(n,i){return t.push(n+" ")>_.cacheLength&&delete e[t.shift()],e[n+" "]=i}var t=[];return e}function i(e){return e[B]=!0,e}function r(e){var t=P.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function o(e,t){for(var n=e.split("|"),i=n.length;i--;)_.attrHandle[n[i]]=t}function s(e,t){var n=t&&e,i=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(i)return i;if(n)for(;n=n.nextSibling;)if(n===t)return-1;return e?1:-1}function a(e){return function(t){return"input"===t.nodeName.toLowerCase()&&t.type===e}}function l(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function u(e){return function(t){return"form"in t?t.parentNode&&!1===t.disabled?"label"in t?"label"in t.parentNode?t.parentNode.disabled===e:t.disabled===e:t.isDisabled===e||t.isDisabled!==!e&&Se(t)===e:t.disabled===e:"label"in t&&t.disabled===e}}function c(e){return i(function(t){return t=+t,i(function(n,i){for(var r,o=e([],n.length,t),s=o.length;s--;)n[r=o[s]]&&(n[r]=!(i[r]=n[r]))})})}function d(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function f(){}function h(e){for(var t=0,n=e.length,i="";t<n;t++)i+=e[t].value;return i}function p(e,t,n){var i=t.dir,r=t.next,o=r||i,s=n&&"parentNode"===o,a=W++;return t.first?function(t,n,r){for(;t=t[i];)if(1===t.nodeType||s)return e(t,n,r);return!1}:function(t,n,l){var u,c,d,f=[R,a];if(l){for(;t=t[i];)if((1===t.nodeType||s)&&e(t,n,l))return!0}else for(;t=t[i];)if(1===t.nodeType||s)if(d=t[B]||(t[B]={}),c=d[t.uniqueID]||(d[t.uniqueID]={}),r&&r===t.nodeName.toLowerCase())t=t[i]||t;else{if((u=c[o])&&u[0]===R&&u[1]===a)return f[2]=u[2];if(c[o]=f,f[2]=e(t,n,l))return!0}return!1}}function m(e){return e.length>1?function(t,n,i){for(var r=e.length;r--;)if(!e[r](t,n,i))return!1;return!0}:e[0]}function g(e,n,i){for(var r=0,o=n.length;r<o;r++)t(e,n[r],i);return i}function v(e,t,n,i,r){for(var o,s=[],a=0,l=e.length,u=null!=t;a<l;a++)(o=e[a])&&(n&&!n(o,i,r)||(s.push(o),u&&t.push(a)));return s}function y(e,t,n,r,o,s){return r&&!r[B]&&(r=y(r)),o&&!o[B]&&(o=y(o,s)),i(function(i,s,a,l){var u,c,d,f=[],h=[],p=s.length,m=i||g(t||"*",a.nodeType?[a]:a,[]),y=!e||!i&&t?m:v(m,f,e,a,l),b=n?o||(i?e:p||r)?[]:s:y;if(n&&n(y,b,a,l),r)for(u=v(b,h),r(u,[],a,l),c=u.length;c--;)(d=u[c])&&(b[h[c]]=!(y[h[c]]=d));if(i){if(o||e){if(o){for(u=[],c=b.length;c--;)(d=b[c])&&u.push(y[c]=d);o(null,b=[],u,l)}for(c=b.length;c--;)(d=b[c])&&(u=o?ee(i,d):f[c])>-1&&(i[u]=!(s[u]=d))}}else b=v(b===s?b.splice(p,b.length):b),o?o(null,s,b,l):Z.apply(s,b)})}function b(e){for(var t,n,i,r=e.length,o=_.relative[e[0].type],s=o||_.relative[" "],a=o?1:0,l=p(function(e){return e===t},s,!0),u=p(function(e){return ee(t,e)>-1},s,!0),c=[function(e,n,i){var r=!o&&(i||n!==I)||((t=n).nodeType?l(e,n,i):u(e,n,i));return t=null,r}];a<r;a++)if(n=_.relative[e[a].type])c=[p(m(c),n)];else{if((n=_.filter[e[a].type].apply(null,e[a].matches))[B]){for(i=++a;i<r&&!_.relative[e[i].type];i++);return y(a>1&&m(c),a>1&&h(e.slice(0,a-1).concat({value:" "===e[a-2].type?"*":""})).replace(ae,"$1"),n,a<i&&b(e.slice(a,i)),i<r&&b(e=e.slice(i)),i<r&&h(e))}c.push(n)}return m(c)}function w(e,n){var r=n.length>0,o=e.length>0,s=function(i,s,a,l,u){var c,d,f,h=0,p="0",m=i&&[],g=[],y=I,b=i||o&&_.find.TAG("*",u),w=R+=null==y?1:Math.random()||.1,x=b.length;for(u&&(I=s===P||s||u);p!==x&&null!=(c=b[p]);p++){if(o&&c){for(d=0,s||c.ownerDocument===P||(L(c),a=!N);f=e[d++];)if(f(c,s||P,a)){l.push(c);break}u&&(R=w)}r&&((c=!f&&c)&&h--,i&&m.push(c))}if(h+=p,r&&p!==h){for(d=0;f=n[d++];)f(m,g,s,a);if(i){if(h>0)for(;p--;)m[p]||g[p]||(g[p]=G.call(l));g=v(g)}Z.apply(l,g),u&&!i&&g.length>0&&h+n.length>1&&t.uniqueSort(l)}return u&&(R=w,I=y),m};return r?i(s):s}var x,C,_,S,E,T,k,A,I,D,z,L,P,j,N,O,M,F,q,B="sizzle"+1*new Date,H=e.document,R=0,W=0,$=n(),U=n(),V=n(),Q=function(e,t){return e===t&&(z=!0),0},Y={}.hasOwnProperty,X=[],G=X.pop,J=X.push,Z=X.push,K=X.slice,ee=function(e,t){for(var n=0,i=e.length;n<i;n++)if(e[n]===t)return n;return-1},te="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",ne="[\\x20\\t\\r\\n\\f]",ie="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",re="\\["+ne+"*("+ie+")(?:"+ne+"*([*^$|!~]?=)"+ne+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+ie+"))|)"+ne+"*\\]",oe=":("+ie+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+re+")*)|.*)\\)|)",se=new RegExp(ne+"+","g"),ae=new RegExp("^"+ne+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ne+"+$","g"),le=new RegExp("^"+ne+"*,"+ne+"*"),ue=new RegExp("^"+ne+"*([>+~]|"+ne+")"+ne+"*"),ce=new RegExp("="+ne+"*([^\\]'\"]*?)"+ne+"*\\]","g"),de=new RegExp(oe),fe=new RegExp("^"+ie+"$"),he={ID:new RegExp("^#("+ie+")"),CLASS:new RegExp("^\\.("+ie+")"),TAG:new RegExp("^("+ie+"|[*])"),ATTR:new RegExp("^"+re),PSEUDO:new RegExp("^"+oe),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ne+"*(even|odd|(([+-]|)(\\d*)n|)"+ne+"*(?:([+-]|)"+ne+"*(\\d+)|))"+ne+"*\\)|)","i"),bool:new RegExp("^(?:"+te+")$","i"),needsContext:new RegExp("^"+ne+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ne+"*((?:-\\d)?\\d*)"+ne+"*\\)|)(?=[^-]|$)","i")},pe=/^(?:input|select|textarea|button)$/i,me=/^h\d$/i,ge=/^[^{]+\{\s*\[native \w/,ve=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ye=/[+~]/,be=new RegExp("\\\\([\\da-f]{1,6}"+ne+"?|("+ne+")|.)","ig"),we=function(e,t,n){var i="0x"+t-65536;return i!==i||n?t:i<0?String.fromCharCode(i+65536):String.fromCharCode(i>>10|55296,1023&i|56320)},xe=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,Ce=function(e,t){return t?"\0"===e?"�":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},_e=function(){L()},Se=p(function(e){return!0===e.disabled&&("form"in e||"label"in e)},{dir:"parentNode",next:"legend"});try{Z.apply(X=K.call(H.childNodes),H.childNodes),X[H.childNodes.length].nodeType}catch(e){Z={apply:X.length?function(e,t){J.apply(e,K.call(t))}:function(e,t){for(var n=e.length,i=0;e[n++]=t[i++];);e.length=n-1}}}C=t.support={},E=t.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return!!t&&"HTML"!==t.nodeName},L=t.setDocument=function(e){var t,n,i=e?e.ownerDocument||e:H;return i!==P&&9===i.nodeType&&i.documentElement?(P=i,j=P.documentElement,N=!E(P),H!==P&&(n=P.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",_e,!1):n.attachEvent&&n.attachEvent("onunload",_e)),C.attributes=r(function(e){return e.className="i",!e.getAttribute("className")}),C.getElementsByTagName=r(function(e){return e.appendChild(P.createComment("")),!e.getElementsByTagName("*").length}),C.getElementsByClassName=ge.test(P.getElementsByClassName),C.getById=r(function(e){return j.appendChild(e).id=B,!P.getElementsByName||!P.getElementsByName(B).length}),C.getById?(_.filter.ID=function(e){var t=e.replace(be,we);return function(e){return e.getAttribute("id")===t}},_.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&N){var n=t.getElementById(e);return n?[n]:[]}}):(_.filter.ID=function(e){var t=e.replace(be,we);return function(e){var n="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return n&&n.value===t}},_.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&N){var n,i,r,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];for(r=t.getElementsByName(e),i=0;o=r[i++];)if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),_.find.TAG=C.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):C.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,i=[],r=0,o=t.getElementsByTagName(e);if("*"===e){for(;n=o[r++];)1===n.nodeType&&i.push(n);return i}return o},_.find.CLASS=C.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&N)return t.getElementsByClassName(e)},M=[],O=[],(C.qsa=ge.test(P.querySelectorAll))&&(r(function(e){j.appendChild(e).innerHTML="<a id='"+B+"'></a><select id='"+B+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&O.push("[*^$]="+ne+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||O.push("\\["+ne+"*(?:value|"+te+")"),e.querySelectorAll("[id~="+B+"-]").length||O.push("~="),e.querySelectorAll(":checked").length||O.push(":checked"),e.querySelectorAll("a#"+B+"+*").length||O.push(".#.+[+~]")}),r(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=P.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&O.push("name"+ne+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&O.push(":enabled",":disabled"),j.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&O.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),O.push(",.*:")})),(C.matchesSelector=ge.test(F=j.matches||j.webkitMatchesSelector||j.mozMatchesSelector||j.oMatchesSelector||j.msMatchesSelector))&&r(function(e){C.disconnectedMatch=F.call(e,"*"),F.call(e,"[s!='']:x"),M.push("!=",oe)}),O=O.length&&new RegExp(O.join("|")),M=M.length&&new RegExp(M.join("|")),t=ge.test(j.compareDocumentPosition),q=t||ge.test(j.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,i=t&&t.parentNode;return e===i||!(!i||1!==i.nodeType||!(n.contains?n.contains(i):e.compareDocumentPosition&&16&e.compareDocumentPosition(i)))}:function(e,t){if(t)for(;t=t.parentNode;)if(t===e)return!0;return!1},Q=t?function(e,t){if(e===t)return z=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)===(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!C.sortDetached&&t.compareDocumentPosition(e)===n?e===P||e.ownerDocument===H&&q(H,e)?-1:t===P||t.ownerDocument===H&&q(H,t)?1:D?ee(D,e)-ee(D,t):0:4&n?-1:1)}:function(e,t){if(e===t)return z=!0,0;var n,i=0,r=e.parentNode,o=t.parentNode,a=[e],l=[t];if(!r||!o)return e===P?-1:t===P?1:r?-1:o?1:D?ee(D,e)-ee(D,t):0;if(r===o)return s(e,t);for(n=e;n=n.parentNode;)a.unshift(n);for(n=t;n=n.parentNode;)l.unshift(n);for(;a[i]===l[i];)i++;return i?s(a[i],l[i]):a[i]===H?-1:l[i]===H?1:0},P):P},t.matches=function(e,n){return t(e,null,null,n)},t.matchesSelector=function(e,n){if((e.ownerDocument||e)!==P&&L(e),n=n.replace(ce,"='$1']"),C.matchesSelector&&N&&!V[n+" "]&&(!M||!M.test(n))&&(!O||!O.test(n)))try{var i=F.call(e,n);if(i||C.disconnectedMatch||e.document&&11!==e.document.nodeType)return i}catch(e){}return t(n,P,null,[e]).length>0},t.contains=function(e,t){return(e.ownerDocument||e)!==P&&L(e),q(e,t)},t.attr=function(e,t){(e.ownerDocument||e)!==P&&L(e);var n=_.attrHandle[t.toLowerCase()],i=n&&Y.call(_.attrHandle,t.toLowerCase())?n(e,t,!N):void 0;return void 0!==i?i:C.attributes||!N?e.getAttribute(t):(i=e.getAttributeNode(t))&&i.specified?i.value:null},t.escape=function(e){return(e+"").replace(xe,Ce)},t.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},t.uniqueSort=function(e){var t,n=[],i=0,r=0;if(z=!C.detectDuplicates,D=!C.sortStable&&e.slice(0),e.sort(Q),z){for(;t=e[r++];)t===e[r]&&(i=n.push(r));for(;i--;)e.splice(n[i],1)}return D=null,e},S=t.getText=function(e){var t,n="",i=0,r=e.nodeType;if(r){if(1===r||9===r||11===r){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=S(e)}else if(3===r||4===r)return e.nodeValue}else for(;t=e[i++];)n+=S(t);return n},(_=t.selectors={cacheLength:50,createPseudo:i,match:he,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(be,we),e[3]=(e[3]||e[4]||e[5]||"").replace(be,we),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||t.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&t.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return he.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&de.test(n)&&(t=T(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(be,we).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=$[e+" "];return t||(t=new RegExp("(^|"+ne+")"+e+"("+ne+"|$)"))&&$(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(e,n,i){return function(r){var o=t.attr(r,e);return null==o?"!="===n:!n||(o+="","="===n?o===i:"!="===n?o!==i:"^="===n?i&&0===o.indexOf(i):"*="===n?i&&o.indexOf(i)>-1:"$="===n?i&&o.slice(-i.length)===i:"~="===n?(" "+o.replace(se," ")+" ").indexOf(i)>-1:"|="===n&&(o===i||o.slice(0,i.length+1)===i+"-"))}},CHILD:function(e,t,n,i,r){var o="nth"!==e.slice(0,3),s="last"!==e.slice(-4),a="of-type"===t;return 1===i&&0===r?function(e){return!!e.parentNode}:function(t,n,l){var u,c,d,f,h,p,m=o!==s?"nextSibling":"previousSibling",g=t.parentNode,v=a&&t.nodeName.toLowerCase(),y=!l&&!a,b=!1;if(g){if(o){for(;m;){for(f=t;f=f[m];)if(a?f.nodeName.toLowerCase()===v:1===f.nodeType)return!1;p=m="only"===e&&!p&&"nextSibling"}return!0}if(p=[s?g.firstChild:g.lastChild],s&&y){for(b=(h=(u=(c=(d=(f=g)[B]||(f[B]={}))[f.uniqueID]||(d[f.uniqueID]={}))[e]||[])[0]===R&&u[1])&&u[2],f=h&&g.childNodes[h];f=++h&&f&&f[m]||(b=h=0)||p.pop();)if(1===f.nodeType&&++b&&f===t){c[e]=[R,h,b];break}}else if(y&&(b=h=(u=(c=(d=(f=t)[B]||(f[B]={}))[f.uniqueID]||(d[f.uniqueID]={}))[e]||[])[0]===R&&u[1]),!1===b)for(;(f=++h&&f&&f[m]||(b=h=0)||p.pop())&&((a?f.nodeName.toLowerCase()!==v:1!==f.nodeType)||!++b||(y&&((c=(d=f[B]||(f[B]={}))[f.uniqueID]||(d[f.uniqueID]={}))[e]=[R,b]),f!==t)););return(b-=r)===i||b%i==0&&b/i>=0}}},PSEUDO:function(e,n){var r,o=_.pseudos[e]||_.setFilters[e.toLowerCase()]||t.error("unsupported pseudo: "+e);return o[B]?o(n):o.length>1?(r=[e,e,"",n],_.setFilters.hasOwnProperty(e.toLowerCase())?i(function(e,t){for(var i,r=o(e,n),s=r.length;s--;)e[i=ee(e,r[s])]=!(t[i]=r[s])}):function(e){return o(e,0,r)}):o}},pseudos:{not:i(function(e){var t=[],n=[],r=k(e.replace(ae,"$1"));return r[B]?i(function(e,t,n,i){for(var o,s=r(e,null,i,[]),a=e.length;a--;)(o=s[a])&&(e[a]=!(t[a]=o))}):function(e,i,o){return t[0]=e,r(t,null,o,n),t[0]=null,!n.pop()}}),has:i(function(e){return function(n){return t(e,n).length>0}}),contains:i(function(e){return e=e.replace(be,we),function(t){return(t.textContent||t.innerText||S(t)).indexOf(e)>-1}}),lang:i(function(e){return fe.test(e||"")||t.error("unsupported lang: "+e),e=e.replace(be,we).toLowerCase(),function(t){var n;do if(n=N?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang"))return(n=n.toLowerCase())===e||0===n.indexOf(e+"-");while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===j},focus:function(e){return e===P.activeElement&&(!P.hasFocus||P.hasFocus())&&!!(e.type||e.href||~e.tabIndex);
},enabled:u(!1),disabled:u(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!_.pseudos.empty(e)},header:function(e){return me.test(e.nodeName)},input:function(e){return pe.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:c(function(){return[0]}),last:c(function(e,t){return[t-1]}),eq:c(function(e,t,n){return[n<0?n+t:n]}),even:c(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:c(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:c(function(e,t,n){for(var i=n<0?n+t:n;--i>=0;)e.push(i);return e}),gt:c(function(e,t,n){for(var i=n<0?n+t:n;++i<t;)e.push(i);return e})}}).pseudos.nth=_.pseudos.eq;for(x in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})_.pseudos[x]=a(x);for(x in{submit:!0,reset:!0})_.pseudos[x]=l(x);return f.prototype=_.filters=_.pseudos,_.setFilters=new f,T=t.tokenize=function(e,n){var i,r,o,s,a,l,u,c=U[e+" "];if(c)return n?0:c.slice(0);for(a=e,l=[],u=_.preFilter;a;){i&&!(r=le.exec(a))||(r&&(a=a.slice(r[0].length)||a),l.push(o=[])),i=!1,(r=ue.exec(a))&&(i=r.shift(),o.push({value:i,type:r[0].replace(ae," ")}),a=a.slice(i.length));for(s in _.filter)!(r=he[s].exec(a))||u[s]&&!(r=u[s](r))||(i=r.shift(),o.push({value:i,type:s,matches:r}),a=a.slice(i.length));if(!i)break}return n?a.length:a?t.error(e):U(e,l).slice(0)},k=t.compile=function(e,t){var n,i=[],r=[],o=V[e+" "];if(!o){for(t||(t=T(e)),n=t.length;n--;)(o=b(t[n]))[B]?i.push(o):r.push(o);(o=V(e,w(r,i))).selector=e}return o},A=t.select=function(e,t,n,i){var r,o,s,a,l,u="function"==typeof e&&e,c=!i&&T(e=u.selector||e);if(n=n||[],1===c.length){if((o=c[0]=c[0].slice(0)).length>2&&"ID"===(s=o[0]).type&&9===t.nodeType&&N&&_.relative[o[1].type]){if(!(t=(_.find.ID(s.matches[0].replace(be,we),t)||[])[0]))return n;u&&(t=t.parentNode),e=e.slice(o.shift().value.length)}for(r=he.needsContext.test(e)?0:o.length;r--&&(s=o[r],!_.relative[a=s.type]);)if((l=_.find[a])&&(i=l(s.matches[0].replace(be,we),ye.test(o[0].type)&&d(t.parentNode)||t))){if(o.splice(r,1),!(e=i.length&&h(o)))return Z.apply(n,i),n;break}}return(u||k(e,c))(i,t,!N,n,!t||ye.test(e)&&d(t.parentNode)||t),n},C.sortStable=B.split("").sort(Q).join("")===B,C.detectDuplicates=!!z,L(),C.sortDetached=r(function(e){return 1&e.compareDocumentPosition(P.createElement("fieldset"))}),r(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||o("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),C.attributes&&r(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||o("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),r(function(e){return null==e.getAttribute("disabled")})||o(te,function(e,t,n){var i;if(!n)return!0===e[t]?t.toLowerCase():(i=e.getAttributeNode(t))&&i.specified?i.value:null}),t}(e);xe.find=_e,xe.expr=_e.selectors,xe.expr[":"]=xe.expr.pseudos,xe.uniqueSort=xe.unique=_e.uniqueSort,xe.text=_e.getText,xe.isXMLDoc=_e.isXML,xe.contains=_e.contains,xe.escapeSelector=_e.escape;var Se=function(e,t,n){for(var i=[],r=void 0!==n;(e=e[t])&&9!==e.nodeType;)if(1===e.nodeType){if(r&&xe(e).is(n))break;i.push(e)}return i},Ee=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},Te=xe.expr.match.needsContext,ke=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;xe.filter=function(e,t,n){var i=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===i.nodeType?xe.find.matchesSelector(i,e)?[i]:[]:xe.find.matches(e,xe.grep(t,function(e){return 1===e.nodeType}))},xe.fn.extend({find:function(e){var t,n,i=this.length,r=this;if("string"!=typeof e)return this.pushStack(xe(e).filter(function(){for(t=0;t<i;t++)if(xe.contains(r[t],this))return!0}));for(n=this.pushStack([]),t=0;t<i;t++)xe.find(e,r[t],n);return i>1?xe.uniqueSort(n):n},filter:function(e){return this.pushStack(s(this,e||[],!1))},not:function(e){return this.pushStack(s(this,e||[],!0))},is:function(e){return!!s(this,"string"==typeof e&&Te.test(e)?xe(e):e||[],!1).length}});var Ae,Ie=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(xe.fn.init=function(e,t,n){var i,r;if(!e)return this;if(n=n||Ae,"string"==typeof e){if(!(i="<"===e[0]&&">"===e[e.length-1]&&e.length>=3?[null,e,null]:Ie.exec(e))||!i[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(i[1]){if(t=t instanceof xe?t[0]:t,xe.merge(this,xe.parseHTML(i[1],t&&t.nodeType?t.ownerDocument||t:se,!0)),ke.test(i[1])&&xe.isPlainObject(t))for(i in t)ye(this[i])?this[i](t[i]):this.attr(i,t[i]);return this}return(r=se.getElementById(i[2]))&&(this[0]=r,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):ye(e)?void 0!==n.ready?n.ready(e):e(xe):xe.makeArray(e,this)}).prototype=xe.fn,Ae=xe(se);var De=/^(?:parents|prev(?:Until|All))/,ze={children:!0,contents:!0,next:!0,prev:!0};xe.fn.extend({has:function(e){var t=xe(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(xe.contains(this,t[e]))return!0})},closest:function(e,t){var n,i=0,r=this.length,o=[],s="string"!=typeof e&&xe(e);if(!Te.test(e))for(;i<r;i++)for(n=this[i];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(s?s.index(n)>-1:1===n.nodeType&&xe.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(o.length>1?xe.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?de.call(xe(e),this[0]):de.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(xe.uniqueSort(xe.merge(this.get(),xe(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),xe.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return Se(e,"parentNode")},parentsUntil:function(e,t,n){return Se(e,"parentNode",n)},next:function(e){return a(e,"nextSibling")},prev:function(e){return a(e,"previousSibling")},nextAll:function(e){return Se(e,"nextSibling")},prevAll:function(e){return Se(e,"previousSibling")},nextUntil:function(e,t,n){return Se(e,"nextSibling",n)},prevUntil:function(e,t,n){return Se(e,"previousSibling",n)},siblings:function(e){return Ee((e.parentNode||{}).firstChild,e)},children:function(e){return Ee(e.firstChild)},contents:function(e){return o(e,"iframe")?e.contentDocument:(o(e,"template")&&(e=e.content||e),xe.merge([],e.childNodes))}},function(e,t){xe.fn[e]=function(n,i){var r=xe.map(this,t,n);return"Until"!==e.slice(-5)&&(i=n),i&&"string"==typeof i&&(r=xe.filter(i,r)),this.length>1&&(ze[e]||xe.uniqueSort(r),De.test(e)&&r.reverse()),this.pushStack(r)}});var Le=/[^\x20\t\r\n\f]+/g;xe.Callbacks=function(e){e="string"==typeof e?l(e):xe.extend({},e);var t,n,r,o,s=[],a=[],u=-1,c=function(){for(o=o||e.once,r=t=!0;a.length;u=-1)for(n=a.shift();++u<s.length;)!1===s[u].apply(n[0],n[1])&&e.stopOnFalse&&(u=s.length,n=!1);e.memory||(n=!1),t=!1,o&&(s=n?[]:"")},d={add:function(){return s&&(n&&!t&&(u=s.length-1,a.push(n)),function t(n){xe.each(n,function(n,r){ye(r)?e.unique&&d.has(r)||s.push(r):r&&r.length&&"string"!==i(r)&&t(r)})}(arguments),n&&!t&&c()),this},remove:function(){return xe.each(arguments,function(e,t){for(var n;(n=xe.inArray(t,s,n))>-1;)s.splice(n,1),n<=u&&u--}),this},has:function(e){return e?xe.inArray(e,s)>-1:s.length>0},empty:function(){return s&&(s=[]),this},disable:function(){return o=a=[],s=n="",this},disabled:function(){return!s},lock:function(){return o=a=[],n||t||(s=n=""),this},locked:function(){return!!o},fireWith:function(e,n){return o||(n=[e,(n=n||[]).slice?n.slice():n],a.push(n),t||c()),this},fire:function(){return d.fireWith(this,arguments),this},fired:function(){return!!r}};return d},xe.extend({Deferred:function(t){var n=[["notify","progress",xe.Callbacks("memory"),xe.Callbacks("memory"),2],["resolve","done",xe.Callbacks("once memory"),xe.Callbacks("once memory"),0,"resolved"],["reject","fail",xe.Callbacks("once memory"),xe.Callbacks("once memory"),1,"rejected"]],i="pending",r={state:function(){return i},always:function(){return o.done(arguments).fail(arguments),this},catch:function(e){return r.then(null,e)},pipe:function(){var e=arguments;return xe.Deferred(function(t){xe.each(n,function(n,i){var r=ye(e[i[4]])&&e[i[4]];o[i[1]](function(){var e=r&&r.apply(this,arguments);e&&ye(e.promise)?e.promise().progress(t.notify).done(t.resolve).fail(t.reject):t[i[0]+"With"](this,r?[e]:arguments)})}),e=null}).promise()},then:function(t,i,r){function o(t,n,i,r){return function(){var a=this,l=arguments,d=function(){var e,d;if(!(t<s)){if((e=i.apply(a,l))===n.promise())throw new TypeError("Thenable self-resolution");d=e&&("object"==typeof e||"function"==typeof e)&&e.then,ye(d)?r?d.call(e,o(s,n,u,r),o(s,n,c,r)):(s++,d.call(e,o(s,n,u,r),o(s,n,c,r),o(s,n,u,n.notifyWith))):(i!==u&&(a=void 0,l=[e]),(r||n.resolveWith)(a,l))}},f=r?d:function(){try{d()}catch(e){xe.Deferred.exceptionHook&&xe.Deferred.exceptionHook(e,f.stackTrace),t+1>=s&&(i!==c&&(a=void 0,l=[e]),n.rejectWith(a,l))}};t?f():(xe.Deferred.getStackHook&&(f.stackTrace=xe.Deferred.getStackHook()),e.setTimeout(f))}}var s=0;return xe.Deferred(function(e){n[0][3].add(o(0,e,ye(r)?r:u,e.notifyWith)),n[1][3].add(o(0,e,ye(t)?t:u)),n[2][3].add(o(0,e,ye(i)?i:c))}).promise()},promise:function(e){return null!=e?xe.extend(e,r):r}},o={};return xe.each(n,function(e,t){var s=t[2],a=t[5];r[t[1]]=s.add,a&&s.add(function(){i=a},n[3-e][2].disable,n[3-e][3].disable,n[0][2].lock,n[0][3].lock),s.add(t[3].fire),o[t[0]]=function(){return o[t[0]+"With"](this===o?void 0:this,arguments),this},o[t[0]+"With"]=s.fireWith}),r.promise(o),t&&t.call(o,o),o},when:function(e){var t=arguments.length,n=t,i=Array(n),r=le.call(arguments),o=xe.Deferred(),s=function(e){return function(n){i[e]=this,r[e]=arguments.length>1?le.call(arguments):n,--t||o.resolveWith(i,r)}};if(t<=1&&(d(e,o.done(s(n)).resolve,o.reject,!t),"pending"===o.state()||ye(r[n]&&r[n].then)))return o.then();for(;n--;)d(r[n],s(n),o.reject);return o.promise()}});var Pe=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;xe.Deferred.exceptionHook=function(t,n){e.console&&e.console.warn&&t&&Pe.test(t.name)&&e.console.warn("jQuery.Deferred exception: "+t.message,t.stack,n)},xe.readyException=function(t){e.setTimeout(function(){throw t})};var je=xe.Deferred();xe.fn.ready=function(e){return je.then(e).catch(function(e){xe.readyException(e)}),this},xe.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--xe.readyWait:xe.isReady)||(xe.isReady=!0,!0!==e&&--xe.readyWait>0||je.resolveWith(se,[xe]))}}),xe.ready.then=je.then,"complete"===se.readyState||"loading"!==se.readyState&&!se.documentElement.doScroll?e.setTimeout(xe.ready):(se.addEventListener("DOMContentLoaded",f),e.addEventListener("load",f));var Ne=function(e,t,n,r,o,s,a){var l=0,u=e.length,c=null==n;if("object"===i(n)){o=!0;for(l in n)Ne(e,t,l,n[l],!0,s,a)}else if(void 0!==r&&(o=!0,ye(r)||(a=!0),c&&(a?(t.call(e,r),t=null):(c=t,t=function(e,t,n){return c.call(xe(e),n)})),t))for(;l<u;l++)t(e[l],n,a?r:r.call(e[l],l,t(e[l],n)));return o?e:c?t.call(e):u?t(e[0],n):s},Oe=/^-ms-/,Me=/-([a-z])/g,Fe=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};m.uid=1,m.prototype={cache:function(e){var t=e[this.expando];return t||(t={},Fe(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var i,r=this.cache(e);if("string"==typeof t)r[p(t)]=n;else for(i in t)r[p(i)]=t[i];return r},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][p(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,i=e[this.expando];if(void 0!==i){if(void 0!==t){n=(t=Array.isArray(t)?t.map(p):(t=p(t))in i?[t]:t.match(Le)||[]).length;for(;n--;)delete i[t[n]]}(void 0===t||xe.isEmptyObject(i))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!xe.isEmptyObject(t)}};var qe=new m,Be=new m,He=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Re=/[A-Z]/g;xe.extend({hasData:function(e){return Be.hasData(e)||qe.hasData(e)},data:function(e,t,n){return Be.access(e,t,n)},removeData:function(e,t){Be.remove(e,t)},_data:function(e,t,n){return qe.access(e,t,n)},_removeData:function(e,t){qe.remove(e,t)}}),xe.fn.extend({data:function(e,t){var n,i,r,o=this[0],s=o&&o.attributes;if(void 0===e){if(this.length&&(r=Be.get(o),1===o.nodeType&&!qe.get(o,"hasDataAttrs"))){for(n=s.length;n--;)s[n]&&0===(i=s[n].name).indexOf("data-")&&(i=p(i.slice(5)),v(o,i,r[i]));qe.set(o,"hasDataAttrs",!0)}return r}return"object"==typeof e?this.each(function(){Be.set(this,e)}):Ne(this,function(t){var n;if(o&&void 0===t){if(void 0!==(n=Be.get(o,e)))return n;if(void 0!==(n=v(o,e)))return n}else this.each(function(){Be.set(this,e,t)})},null,t,arguments.length>1,null,!0)},removeData:function(e){return this.each(function(){Be.remove(this,e)})}}),xe.extend({queue:function(e,t,n){var i;if(e)return t=(t||"fx")+"queue",i=qe.get(e,t),n&&(!i||Array.isArray(n)?i=qe.access(e,t,xe.makeArray(n)):i.push(n)),i||[]},dequeue:function(e,t){t=t||"fx";var n=xe.queue(e,t),i=n.length,r=n.shift(),o=xe._queueHooks(e,t),s=function(){xe.dequeue(e,t)};"inprogress"===r&&(r=n.shift(),i--),r&&("fx"===t&&n.unshift("inprogress"),delete o.stop,r.call(e,s,o)),!i&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return qe.get(e,n)||qe.access(e,n,{empty:xe.Callbacks("once memory").add(function(){qe.remove(e,[t+"queue",n])})})}}),xe.fn.extend({queue:function(e,t){var n=2;return"string"!=typeof e&&(t=e,e="fx",n--),arguments.length<n?xe.queue(this[0],e):void 0===t?this:this.each(function(){var n=xe.queue(this,e,t);xe._queueHooks(this,e),"fx"===e&&"inprogress"!==n[0]&&xe.dequeue(this,e)})},dequeue:function(e){return this.each(function(){xe.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,i=1,r=xe.Deferred(),o=this,s=this.length,a=function(){--i||r.resolveWith(o,[o])};for("string"!=typeof e&&(t=e,e=void 0),e=e||"fx";s--;)(n=qe.get(o[s],e+"queueHooks"))&&n.empty&&(i++,n.empty.add(a));return a(),r.promise(t)}});var We=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,$e=new RegExp("^(?:([+-])=|)("+We+")([a-z%]*)$","i"),Ue=["Top","Right","Bottom","Left"],Ve=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&xe.contains(e.ownerDocument,e)&&"none"===xe.css(e,"display")},Qe=function(e,t,n,i){var r,o,s={};for(o in t)s[o]=e.style[o],e.style[o]=t[o];r=n.apply(e,i||[]);for(o in t)e.style[o]=s[o];return r},Ye={};xe.fn.extend({show:function(){return w(this,!0)},hide:function(){return w(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){Ve(this)?xe(this).show():xe(this).hide()})}});var Xe=/^(?:checkbox|radio)$/i,Ge=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,Je=/^$|^module$|\/(?:java|ecma)script/i,Ze={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};Ze.optgroup=Ze.option,Ze.tbody=Ze.tfoot=Ze.colgroup=Ze.caption=Ze.thead,Ze.th=Ze.td;var Ke=/<|&#?\w+;/;!function(){var e=se.createDocumentFragment().appendChild(se.createElement("div")),t=se.createElement("input");t.setAttribute("type","radio"),t.setAttribute("checked","checked"),t.setAttribute("name","t"),e.appendChild(t),ve.checkClone=e.cloneNode(!0).cloneNode(!0).lastChild.checked,e.innerHTML="<textarea>x</textarea>",ve.noCloneChecked=!!e.cloneNode(!0).lastChild.defaultValue}();var et=se.documentElement,tt=/^key/,nt=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,it=/^([^.]*)(?:\.(.+)|)/;xe.event={global:{},add:function(e,t,n,i,r){var o,s,a,l,u,c,d,f,h,p,m,g=qe.get(e);if(g)for(n.handler&&(n=(o=n).handler,r=o.selector),r&&xe.find.matchesSelector(et,r),n.guid||(n.guid=xe.guid++),(l=g.events)||(l=g.events={}),(s=g.handle)||(s=g.handle=function(t){return"undefined"!=typeof xe&&xe.event.triggered!==t.type?xe.event.dispatch.apply(e,arguments):void 0}),u=(t=(t||"").match(Le)||[""]).length;u--;)h=m=(a=it.exec(t[u])||[])[1],p=(a[2]||"").split(".").sort(),h&&(d=xe.event.special[h]||{},h=(r?d.delegateType:d.bindType)||h,d=xe.event.special[h]||{},c=xe.extend({type:h,origType:m,data:i,handler:n,guid:n.guid,selector:r,needsContext:r&&xe.expr.match.needsContext.test(r),namespace:p.join(".")},o),(f=l[h])||((f=l[h]=[]).delegateCount=0,d.setup&&!1!==d.setup.call(e,i,p,s)||e.addEventListener&&e.addEventListener(h,s)),d.add&&(d.add.call(e,c),c.handler.guid||(c.handler.guid=n.guid)),r?f.splice(f.delegateCount++,0,c):f.push(c),xe.event.global[h]=!0)},remove:function(e,t,n,i,r){var o,s,a,l,u,c,d,f,h,p,m,g=qe.hasData(e)&&qe.get(e);if(g&&(l=g.events)){for(u=(t=(t||"").match(Le)||[""]).length;u--;)if(a=it.exec(t[u])||[],h=m=a[1],p=(a[2]||"").split(".").sort(),h){for(d=xe.event.special[h]||{},f=l[h=(i?d.delegateType:d.bindType)||h]||[],a=a[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),s=o=f.length;o--;)c=f[o],!r&&m!==c.origType||n&&n.guid!==c.guid||a&&!a.test(c.namespace)||i&&i!==c.selector&&("**"!==i||!c.selector)||(f.splice(o,1),c.selector&&f.delegateCount--,d.remove&&d.remove.call(e,c));s&&!f.length&&(d.teardown&&!1!==d.teardown.call(e,p,g.handle)||xe.removeEvent(e,h,g.handle),delete l[h])}else for(h in l)xe.event.remove(e,h+t[u],n,i,!0);xe.isEmptyObject(l)&&qe.remove(e,"handle events")}},dispatch:function(e){var t,n,i,r,o,s,a=xe.event.fix(e),l=new Array(arguments.length),u=(qe.get(this,"events")||{})[a.type]||[],c=xe.event.special[a.type]||{};for(l[0]=a,t=1;t<arguments.length;t++)l[t]=arguments[t];if(a.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,a)){for(s=xe.event.handlers.call(this,a,u),t=0;(r=s[t++])&&!a.isPropagationStopped();)for(a.currentTarget=r.elem,n=0;(o=r.handlers[n++])&&!a.isImmediatePropagationStopped();)a.rnamespace&&!a.rnamespace.test(o.namespace)||(a.handleObj=o,a.data=o.data,void 0!==(i=((xe.event.special[o.origType]||{}).handle||o.handler).apply(r.elem,l))&&!1===(a.result=i)&&(a.preventDefault(),a.stopPropagation()));return c.postDispatch&&c.postDispatch.call(this,a),a.result}},handlers:function(e,t){var n,i,r,o,s,a=[],l=t.delegateCount,u=e.target;if(l&&u.nodeType&&!("click"===e.type&&e.button>=1))for(;u!==this;u=u.parentNode||this)if(1===u.nodeType&&("click"!==e.type||!0!==u.disabled)){for(o=[],s={},n=0;n<l;n++)void 0===s[r=(i=t[n]).selector+" "]&&(s[r]=i.needsContext?xe(r,this).index(u)>-1:xe.find(r,this,null,[u]).length),s[r]&&o.push(i);o.length&&a.push({elem:u,handlers:o})}return u=this,l<t.length&&a.push({elem:u,handlers:t.slice(l)}),a},addProp:function(e,t){Object.defineProperty(xe.Event.prototype,e,{enumerable:!0,configurable:!0,get:ye(t)?function(){if(this.originalEvent)return t(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[e]},set:function(t){Object.defineProperty(this,e,{enumerable:!0,configurable:!0,writable:!0,value:t})}})},fix:function(e){return e[xe.expando]?e:new xe.Event(e)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==T()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===T()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&o(this,"input"))return this.click(),!1},_default:function(e){return o(e.target,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},xe.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},xe.Event=function(e,t){return this instanceof xe.Event?(e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?S:E,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&xe.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[xe.expando]=!0,void 0):new xe.Event(e,t)},xe.Event.prototype={constructor:xe.Event,isDefaultPrevented:E,isPropagationStopped:E,isImmediatePropagationStopped:E,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=S,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=S,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=S,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},xe.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(e){var t=e.button;return null==e.which&&tt.test(e.type)?null!=e.charCode?e.charCode:e.keyCode:!e.which&&void 0!==t&&nt.test(e.type)?1&t?1:2&t?3:4&t?2:0:e.which}},xe.event.addProp),xe.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,t){xe.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,i=this,r=e.relatedTarget,o=e.handleObj;return r&&(r===i||xe.contains(i,r))||(e.type=o.origType,n=o.handler.apply(this,arguments),e.type=t),n}}}),xe.fn.extend({on:function(e,t,n,i){return k(this,e,t,n,i)},one:function(e,t,n,i){return k(this,e,t,n,i,1)},off:function(e,t,n){var i,r;if(e&&e.preventDefault&&e.handleObj)return i=e.handleObj,xe(e.delegateTarget).off(i.namespace?i.origType+"."+i.namespace:i.origType,i.selector,i.handler),this;if("object"==typeof e){for(r in e)this.off(r,t,e[r]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=E),this.each(function(){xe.event.remove(this,e,n,t)})}});var rt=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,ot=/<script|<style|<link/i,st=/checked\s*(?:[^=]|=\s*.checked.)/i,at=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;xe.extend({htmlPrefilter:function(e){return e.replace(rt,"<$1></$2>")},clone:function(e,t,n){var i,r,o,s,a=e.cloneNode(!0),l=xe.contains(e.ownerDocument,e);if(!(ve.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||xe.isXMLDoc(e)))for(s=x(a),i=0,r=(o=x(e)).length;i<r;i++)L(o[i],s[i]);if(t)if(n)for(o=o||x(e),s=s||x(a),i=0,r=o.length;i<r;i++)z(o[i],s[i]);else z(e,a);return(s=x(a,"script")).length>0&&C(s,!l&&x(e,"script")),a},cleanData:function(e){for(var t,n,i,r=xe.event.special,o=0;void 0!==(n=e[o]);o++)if(Fe(n)){if(t=n[qe.expando]){if(t.events)for(i in t.events)r[i]?xe.event.remove(n,i):xe.removeEvent(n,i,t.handle);n[qe.expando]=void 0}n[Be.expando]&&(n[Be.expando]=void 0)}}}),xe.fn.extend({detach:function(e){return j(this,e,!0)},remove:function(e){return j(this,e)},text:function(e){return Ne(this,function(e){return void 0===e?xe.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return P(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||A(this,e).appendChild(e)})},prepend:function(){return P(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=A(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return P(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return P(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(xe.cleanData(x(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return xe.clone(this,e,t)})},html:function(e){return Ne(this,function(e){var t=this[0]||{},n=0,i=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!ot.test(e)&&!Ze[(Ge.exec(e)||["",""])[1].toLowerCase()]){e=xe.htmlPrefilter(e);try{for(;n<i;n++)1===(t=this[n]||{}).nodeType&&(xe.cleanData(x(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var e=[];return P(this,arguments,function(t){var n=this.parentNode;xe.inArray(this,e)<0&&(xe.cleanData(x(this)),n&&n.replaceChild(t,this))},e)}}),xe.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){xe.fn[e]=function(e){for(var n,i=[],r=xe(e),o=r.length-1,s=0;s<=o;s++)n=s===o?this:this.clone(!0),xe(r[s])[t](n),ce.apply(i,n.get());return this.pushStack(i)}});var lt=new RegExp("^("+We+")(?!px)[a-z%]+$","i"),ut=function(t){var n=t.ownerDocument.defaultView;return n&&n.opener||(n=e),n.getComputedStyle(t)},ct=new RegExp(Ue.join("|"),"i");!function(){function t(){if(u){l.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",u.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",et.appendChild(l).appendChild(u);var t=e.getComputedStyle(u);i="1%"!==t.top,a=12===n(t.marginLeft),u.style.right="60%",s=36===n(t.right),r=36===n(t.width),u.style.position="absolute",o=36===u.offsetWidth||"absolute",et.removeChild(l),u=null}}function n(e){return Math.round(parseFloat(e))}var i,r,o,s,a,l=se.createElement("div"),u=se.createElement("div");u.style&&(u.style.backgroundClip="content-box",u.cloneNode(!0).style.backgroundClip="",ve.clearCloneStyle="content-box"===u.style.backgroundClip,xe.extend(ve,{boxSizingReliable:function(){return t(),r},pixelBoxStyles:function(){return t(),s},pixelPosition:function(){return t(),i},reliableMarginLeft:function(){return t(),a},scrollboxSize:function(){return t(),o}}))}();var dt=/^(none|table(?!-c[ea]).+)/,ft=/^--/,ht={position:"absolute",visibility:"hidden",display:"block"},pt={letterSpacing:"0",fontWeight:"400"},mt=["Webkit","Moz","ms"],gt=se.createElement("div").style;xe.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=N(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,i){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var r,o,s,a=p(t),l=ft.test(t),u=e.style;if(l||(t=F(a)),s=xe.cssHooks[t]||xe.cssHooks[a],void 0===n)return s&&"get"in s&&void 0!==(r=s.get(e,!1,i))?r:u[t];"string"==(o=typeof n)&&(r=$e.exec(n))&&r[1]&&(n=y(e,t,r),o="number"),null!=n&&n===n&&("number"===o&&(n+=r&&r[3]||(xe.cssNumber[a]?"":"px")),ve.clearCloneStyle||""!==n||0!==t.indexOf("background")||(u[t]="inherit"),s&&"set"in s&&void 0===(n=s.set(e,n,i))||(l?u.setProperty(t,n):u[t]=n))}},css:function(e,t,n,i){var r,o,s,a=p(t);return ft.test(t)||(t=F(a)),(s=xe.cssHooks[t]||xe.cssHooks[a])&&"get"in s&&(r=s.get(e,!0,n)),void 0===r&&(r=N(e,t,i)),"normal"===r&&t in pt&&(r=pt[t]),""===n||n?(o=parseFloat(r),!0===n||isFinite(o)?o||0:r):r}}),xe.each(["height","width"],function(e,t){xe.cssHooks[t]={get:function(e,n,i){if(n)return!dt.test(xe.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?H(e,t,i):Qe(e,ht,function(){return H(e,t,i)})},set:function(e,n,i){var r,o=ut(e),s="border-box"===xe.css(e,"boxSizing",!1,o),a=i&&B(e,t,i,s,o);return s&&ve.scrollboxSize()===o.position&&(a-=Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-parseFloat(o[t])-B(e,t,"border",!1,o)-.5)),a&&(r=$e.exec(n))&&"px"!==(r[3]||"px")&&(e.style[t]=n,n=xe.css(e,t)),q(e,n,a)}}}),xe.cssHooks.marginLeft=O(ve.reliableMarginLeft,function(e,t){if(t)return(parseFloat(N(e,"marginLeft"))||e.getBoundingClientRect().left-Qe(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),xe.each({margin:"",padding:"",border:"Width"},function(e,t){xe.cssHooks[e+t]={expand:function(n){for(var i=0,r={},o="string"==typeof n?n.split(" "):[n];i<4;i++)r[e+Ue[i]+t]=o[i]||o[i-2]||o[0];return r}},"margin"!==e&&(xe.cssHooks[e+t].set=q)}),xe.fn.extend({css:function(e,t){return Ne(this,function(e,t,n){var i,r,o={},s=0;if(Array.isArray(t)){for(i=ut(e),r=t.length;s<r;s++)o[t[s]]=xe.css(e,t[s],!1,i);return o}return void 0!==n?xe.style(e,t,n):xe.css(e,t)},e,t,arguments.length>1)}}),xe.Tween=R,R.prototype={constructor:R,init:function(e,t,n,i,r,o){this.elem=e,this.prop=n,this.easing=r||xe.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=i,this.unit=o||(xe.cssNumber[n]?"":"px")},cur:function(){var e=R.propHooks[this.prop];return e&&e.get?e.get(this):R.propHooks._default.get(this)},run:function(e){var t,n=R.propHooks[this.prop];return this.options.duration?this.pos=t=xe.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):R.propHooks._default.set(this),this}},R.prototype.init.prototype=R.prototype,R.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=xe.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){xe.fx.step[e.prop]?xe.fx.step[e.prop](e):1!==e.elem.nodeType||null==e.elem.style[xe.cssProps[e.prop]]&&!xe.cssHooks[e.prop]?e.elem[e.prop]=e.now:xe.style(e.elem,e.prop,e.now+e.unit)}}},R.propHooks.scrollTop=R.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},xe.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},xe.fx=R.prototype.init,xe.fx.step={};var vt,yt,bt=/^(?:toggle|show|hide)$/,wt=/queueHooks$/;xe.Animation=xe.extend(X,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return y(n.elem,e,$e.exec(t),n),n}]},tweener:function(e,t){ye(e)?(t=e,e=["*"]):e=e.match(Le);for(var n,i=0,r=e.length;i<r;i++)n=e[i],X.tweeners[n]=X.tweeners[n]||[],X.tweeners[n].unshift(t)},prefilters:[Q],prefilter:function(e,t){t?X.prefilters.unshift(e):X.prefilters.push(e)}}),xe.speed=function(e,t,n){var i=e&&"object"==typeof e?xe.extend({},e):{complete:n||!n&&t||ye(e)&&e,duration:e,easing:n&&t||t&&!ye(t)&&t};return xe.fx.off?i.duration=0:"number"!=typeof i.duration&&(i.duration in xe.fx.speeds?i.duration=xe.fx.speeds[i.duration]:i.duration=xe.fx.speeds._default),null!=i.queue&&!0!==i.queue||(i.queue="fx"),i.old=i.complete,i.complete=function(){ye(i.old)&&i.old.call(this),i.queue&&xe.dequeue(this,i.queue)},i},xe.fn.extend({fadeTo:function(e,t,n,i){return this.filter(Ve).css("opacity",0).show().end().animate({opacity:t},e,n,i)},animate:function(e,t,n,i){var r=xe.isEmptyObject(e),o=xe.speed(t,n,i),s=function(){var t=X(this,xe.extend({},e),o);(r||qe.get(this,"finish"))&&t.stop(!0)};return s.finish=s,r||!1===o.queue?this.each(s):this.queue(o.queue,s)},stop:function(e,t,n){var i=function(e){var t=e.stop;delete e.stop,t(n)};return"string"!=typeof e&&(n=t,t=e,e=void 0),t&&!1!==e&&this.queue(e||"fx",[]),this.each(function(){var t=!0,r=null!=e&&e+"queueHooks",o=xe.timers,s=qe.get(this);if(r)s[r]&&s[r].stop&&i(s[r]);else for(r in s)s[r]&&s[r].stop&&wt.test(r)&&i(s[r]);for(r=o.length;r--;)o[r].elem!==this||null!=e&&o[r].queue!==e||(o[r].anim.stop(n),t=!1,o.splice(r,1));!t&&n||xe.dequeue(this,e)})},finish:function(e){return!1!==e&&(e=e||"fx"),this.each(function(){
var t,n=qe.get(this),i=n[e+"queue"],r=n[e+"queueHooks"],o=xe.timers,s=i?i.length:0;for(n.finish=!0,xe.queue(this,e,[]),r&&r.stop&&r.stop.call(this,!0),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;t<s;t++)i[t]&&i[t].finish&&i[t].finish.call(this);delete n.finish})}}),xe.each(["toggle","show","hide"],function(e,t){var n=xe.fn[t];xe.fn[t]=function(e,i,r){return null==e||"boolean"==typeof e?n.apply(this,arguments):this.animate(U(t,!0),e,i,r)}}),xe.each({slideDown:U("show"),slideUp:U("hide"),slideToggle:U("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){xe.fn[e]=function(e,n,i){return this.animate(t,e,n,i)}}),xe.timers=[],xe.fx.tick=function(){var e,t=0,n=xe.timers;for(vt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||xe.fx.stop(),vt=void 0},xe.fx.timer=function(e){xe.timers.push(e),xe.fx.start()},xe.fx.interval=13,xe.fx.start=function(){yt||(yt=!0,W())},xe.fx.stop=function(){yt=null},xe.fx.speeds={slow:600,fast:200,_default:400},xe.fn.delay=function(t,n){return t=xe.fx?xe.fx.speeds[t]||t:t,n=n||"fx",this.queue(n,function(n,i){var r=e.setTimeout(n,t);i.stop=function(){e.clearTimeout(r)}})},function(){var e=se.createElement("input"),t=se.createElement("select").appendChild(se.createElement("option"));e.type="checkbox",ve.checkOn=""!==e.value,ve.optSelected=t.selected,(e=se.createElement("input")).value="t",e.type="radio",ve.radioValue="t"===e.value}();var xt,Ct=xe.expr.attrHandle;xe.fn.extend({attr:function(e,t){return Ne(this,xe.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){xe.removeAttr(this,e)})}}),xe.extend({attr:function(e,t,n){var i,r,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?xe.prop(e,t,n):(1===o&&xe.isXMLDoc(e)||(r=xe.attrHooks[t.toLowerCase()]||(xe.expr.match.bool.test(t)?xt:void 0)),void 0!==n?null===n?void xe.removeAttr(e,t):r&&"set"in r&&void 0!==(i=r.set(e,n,t))?i:(e.setAttribute(t,n+""),n):r&&"get"in r&&null!==(i=r.get(e,t))?i:null==(i=xe.find.attr(e,t))?void 0:i)},attrHooks:{type:{set:function(e,t){if(!ve.radioValue&&"radio"===t&&o(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,i=0,r=t&&t.match(Le);if(r&&1===e.nodeType)for(;n=r[i++];)e.removeAttribute(n)}}),xt={set:function(e,t,n){return!1===t?xe.removeAttr(e,n):e.setAttribute(n,n),n}},xe.each(xe.expr.match.bool.source.match(/\w+/g),function(e,t){var n=Ct[t]||xe.find.attr;Ct[t]=function(e,t,i){var r,o,s=t.toLowerCase();return i||(o=Ct[s],Ct[s]=r,r=null!=n(e,t,i)?s:null,Ct[s]=o),r}});var _t=/^(?:input|select|textarea|button)$/i,St=/^(?:a|area)$/i;xe.fn.extend({prop:function(e,t){return Ne(this,xe.prop,e,t,arguments.length>1)},removeProp:function(e){return this.each(function(){delete this[xe.propFix[e]||e]})}}),xe.extend({prop:function(e,t,n){var i,r,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&xe.isXMLDoc(e)||(t=xe.propFix[t]||t,r=xe.propHooks[t]),void 0!==n?r&&"set"in r&&void 0!==(i=r.set(e,n,t))?i:e[t]=n:r&&"get"in r&&null!==(i=r.get(e,t))?i:e[t]},propHooks:{tabIndex:{get:function(e){var t=xe.find.attr(e,"tabindex");return t?parseInt(t,10):_t.test(e.nodeName)||St.test(e.nodeName)&&e.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),ve.optSelected||(xe.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),xe.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){xe.propFix[this.toLowerCase()]=this}),xe.fn.extend({addClass:function(e){var t,n,i,r,o,s,a,l=0;if(ye(e))return this.each(function(t){xe(this).addClass(e.call(this,t,J(this)))});if((t=Z(e)).length)for(;n=this[l++];)if(r=J(n),i=1===n.nodeType&&" "+G(r)+" "){for(s=0;o=t[s++];)i.indexOf(" "+o+" ")<0&&(i+=o+" ");r!==(a=G(i))&&n.setAttribute("class",a)}return this},removeClass:function(e){var t,n,i,r,o,s,a,l=0;if(ye(e))return this.each(function(t){xe(this).removeClass(e.call(this,t,J(this)))});if(!arguments.length)return this.attr("class","");if((t=Z(e)).length)for(;n=this[l++];)if(r=J(n),i=1===n.nodeType&&" "+G(r)+" "){for(s=0;o=t[s++];)for(;i.indexOf(" "+o+" ")>-1;)i=i.replace(" "+o+" "," ");r!==(a=G(i))&&n.setAttribute("class",a)}return this},toggleClass:function(e,t){var n=typeof e,i="string"===n||Array.isArray(e);return"boolean"==typeof t&&i?t?this.addClass(e):this.removeClass(e):ye(e)?this.each(function(n){xe(this).toggleClass(e.call(this,n,J(this),t),t)}):this.each(function(){var t,r,o,s;if(i)for(r=0,o=xe(this),s=Z(e);t=s[r++];)o.hasClass(t)?o.removeClass(t):o.addClass(t);else void 0!==e&&"boolean"!==n||((t=J(this))&&qe.set(this,"__className__",t),this.setAttribute&&this.setAttribute("class",t||!1===e?"":qe.get(this,"__className__")||""))})},hasClass:function(e){var t,n,i=0;for(t=" "+e+" ";n=this[i++];)if(1===n.nodeType&&(" "+G(J(n))+" ").indexOf(t)>-1)return!0;return!1}});var Et=/\r/g;xe.fn.extend({val:function(e){var t,n,i,r=this[0];return arguments.length?(i=ye(e),this.each(function(n){var r;1===this.nodeType&&(null==(r=i?e.call(this,n,xe(this).val()):e)?r="":"number"==typeof r?r+="":Array.isArray(r)&&(r=xe.map(r,function(e){return null==e?"":e+""})),(t=xe.valHooks[this.type]||xe.valHooks[this.nodeName.toLowerCase()])&&"set"in t&&void 0!==t.set(this,r,"value")||(this.value=r))})):r?(t=xe.valHooks[r.type]||xe.valHooks[r.nodeName.toLowerCase()])&&"get"in t&&void 0!==(n=t.get(r,"value"))?n:"string"==typeof(n=r.value)?n.replace(Et,""):null==n?"":n:void 0}}),xe.extend({valHooks:{option:{get:function(e){var t=xe.find.attr(e,"value");return null!=t?t:G(xe.text(e))}},select:{get:function(e){var t,n,i,r=e.options,s=e.selectedIndex,a="select-one"===e.type,l=a?null:[],u=a?s+1:r.length;for(i=s<0?u:a?s:0;i<u;i++)if(((n=r[i]).selected||i===s)&&!n.disabled&&(!n.parentNode.disabled||!o(n.parentNode,"optgroup"))){if(t=xe(n).val(),a)return t;l.push(t)}return l},set:function(e,t){for(var n,i,r=e.options,o=xe.makeArray(t),s=r.length;s--;)((i=r[s]).selected=xe.inArray(xe.valHooks.option.get(i),o)>-1)&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),xe.each(["radio","checkbox"],function(){xe.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=xe.inArray(xe(e).val(),t)>-1}},ve.checkOn||(xe.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),ve.focusin="onfocusin"in e;var Tt=/^(?:focusinfocus|focusoutblur)$/,kt=function(e){e.stopPropagation()};xe.extend(xe.event,{trigger:function(t,n,i,r){var o,s,a,l,u,c,d,f,h=[i||se],p=pe.call(t,"type")?t.type:t,m=pe.call(t,"namespace")?t.namespace.split("."):[];if(s=f=a=i=i||se,3!==i.nodeType&&8!==i.nodeType&&!Tt.test(p+xe.event.triggered)&&(p.indexOf(".")>-1&&(p=(m=p.split(".")).shift(),m.sort()),u=p.indexOf(":")<0&&"on"+p,t=t[xe.expando]?t:new xe.Event(p,"object"==typeof t&&t),t.isTrigger=r?2:3,t.namespace=m.join("."),t.rnamespace=t.namespace?new RegExp("(^|\\.)"+m.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,t.result=void 0,t.target||(t.target=i),n=null==n?[t]:xe.makeArray(n,[t]),d=xe.event.special[p]||{},r||!d.trigger||!1!==d.trigger.apply(i,n))){if(!r&&!d.noBubble&&!be(i)){for(l=d.delegateType||p,Tt.test(l+p)||(s=s.parentNode);s;s=s.parentNode)h.push(s),a=s;a===(i.ownerDocument||se)&&h.push(a.defaultView||a.parentWindow||e)}for(o=0;(s=h[o++])&&!t.isPropagationStopped();)f=s,t.type=o>1?l:d.bindType||p,(c=(qe.get(s,"events")||{})[t.type]&&qe.get(s,"handle"))&&c.apply(s,n),(c=u&&s[u])&&c.apply&&Fe(s)&&(t.result=c.apply(s,n),!1===t.result&&t.preventDefault());return t.type=p,r||t.isDefaultPrevented()||d._default&&!1!==d._default.apply(h.pop(),n)||!Fe(i)||u&&ye(i[p])&&!be(i)&&((a=i[u])&&(i[u]=null),xe.event.triggered=p,t.isPropagationStopped()&&f.addEventListener(p,kt),i[p](),t.isPropagationStopped()&&f.removeEventListener(p,kt),xe.event.triggered=void 0,a&&(i[u]=a)),t.result}},simulate:function(e,t,n){var i=xe.extend(new xe.Event,n,{type:e,isSimulated:!0});xe.event.trigger(i,null,t)}}),xe.fn.extend({trigger:function(e,t){return this.each(function(){xe.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return xe.event.trigger(e,t,n,!0)}}),ve.focusin||xe.each({focus:"focusin",blur:"focusout"},function(e,t){var n=function(e){xe.event.simulate(t,e.target,xe.event.fix(e))};xe.event.special[t]={setup:function(){var i=this.ownerDocument||this,r=qe.access(i,t);r||i.addEventListener(e,n,!0),qe.access(i,t,(r||0)+1)},teardown:function(){var i=this.ownerDocument||this,r=qe.access(i,t)-1;r?qe.access(i,t,r):(i.removeEventListener(e,n,!0),qe.remove(i,t))}}});var At=e.location,It=Date.now(),Dt=/\?/;xe.parseXML=function(t){var n;if(!t||"string"!=typeof t)return null;try{n=(new e.DOMParser).parseFromString(t,"text/xml")}catch(e){n=void 0}return n&&!n.getElementsByTagName("parsererror").length||xe.error("Invalid XML: "+t),n};var zt=/\[\]$/,Lt=/\r?\n/g,Pt=/^(?:submit|button|image|reset|file)$/i,jt=/^(?:input|select|textarea|keygen)/i;xe.param=function(e,t){var n,i=[],r=function(e,t){var n=ye(t)?t():t;i[i.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(Array.isArray(e)||e.jquery&&!xe.isPlainObject(e))xe.each(e,function(){r(this.name,this.value)});else for(n in e)K(n,e[n],t,r);return i.join("&")},xe.fn.extend({serialize:function(){return xe.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=xe.prop(this,"elements");return e?xe.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!xe(this).is(":disabled")&&jt.test(this.nodeName)&&!Pt.test(e)&&(this.checked||!Xe.test(e))}).map(function(e,t){var n=xe(this).val();return null==n?null:Array.isArray(n)?xe.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Nt=/%20/g,Ot=/#.*$/,Mt=/([?&])_=[^&]*/,Ft=/^(.*?):[ \t]*([^\r\n]*)$/gm,qt=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Bt=/^(?:GET|HEAD)$/,Ht=/^\/\//,Rt={},Wt={},$t="*/".concat("*"),Ut=se.createElement("a");Ut.href=At.href,xe.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:At.href,type:"GET",isLocal:qt.test(At.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":$t,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":xe.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?ne(ne(e,xe.ajaxSettings),t):ne(xe.ajaxSettings,e)},ajaxPrefilter:ee(Rt),ajaxTransport:ee(Wt),ajax:function(t,n){function i(t,n,i,a){var u,f,h,w,x,C=n;c||(c=!0,l&&e.clearTimeout(l),r=void 0,s=a||"",_.readyState=t>0?4:0,u=t>=200&&t<300||304===t,i&&(w=ie(p,_,i)),w=re(p,w,_,u),u?(p.ifModified&&((x=_.getResponseHeader("Last-Modified"))&&(xe.lastModified[o]=x),(x=_.getResponseHeader("etag"))&&(xe.etag[o]=x)),204===t||"HEAD"===p.type?C="nocontent":304===t?C="notmodified":(C=w.state,f=w.data,u=!(h=w.error))):(h=C,!t&&C||(C="error",t<0&&(t=0))),_.status=t,_.statusText=(n||C)+"",u?v.resolveWith(m,[f,C,_]):v.rejectWith(m,[_,C,h]),_.statusCode(b),b=void 0,d&&g.trigger(u?"ajaxSuccess":"ajaxError",[_,p,u?f:h]),y.fireWith(m,[_,C]),d&&(g.trigger("ajaxComplete",[_,p]),--xe.active||xe.event.trigger("ajaxStop")))}"object"==typeof t&&(n=t,t=void 0),n=n||{};var r,o,s,a,l,u,c,d,f,h,p=xe.ajaxSetup({},n),m=p.context||p,g=p.context&&(m.nodeType||m.jquery)?xe(m):xe.event,v=xe.Deferred(),y=xe.Callbacks("once memory"),b=p.statusCode||{},w={},x={},C="canceled",_={readyState:0,getResponseHeader:function(e){var t;if(c){if(!a)for(a={};t=Ft.exec(s);)a[t[1].toLowerCase()]=t[2];t=a[e.toLowerCase()]}return null==t?null:t},getAllResponseHeaders:function(){return c?s:null},setRequestHeader:function(e,t){return null==c&&(e=x[e.toLowerCase()]=x[e.toLowerCase()]||e,w[e]=t),this},overrideMimeType:function(e){return null==c&&(p.mimeType=e),this},statusCode:function(e){var t;if(e)if(c)_.always(e[_.status]);else for(t in e)b[t]=[b[t],e[t]];return this},abort:function(e){var t=e||C;return r&&r.abort(t),i(0,t),this}};if(v.promise(_),p.url=((t||p.url||At.href)+"").replace(Ht,At.protocol+"//"),p.type=n.method||n.type||p.method||p.type,p.dataTypes=(p.dataType||"*").toLowerCase().match(Le)||[""],null==p.crossDomain){u=se.createElement("a");try{u.href=p.url,u.href=u.href,p.crossDomain=Ut.protocol+"//"+Ut.host!=u.protocol+"//"+u.host}catch(e){p.crossDomain=!0}}if(p.data&&p.processData&&"string"!=typeof p.data&&(p.data=xe.param(p.data,p.traditional)),te(Rt,p,n,_),c)return _;(d=xe.event&&p.global)&&0==xe.active++&&xe.event.trigger("ajaxStart"),p.type=p.type.toUpperCase(),p.hasContent=!Bt.test(p.type),o=p.url.replace(Ot,""),p.hasContent?p.data&&p.processData&&0===(p.contentType||"").indexOf("application/x-www-form-urlencoded")&&(p.data=p.data.replace(Nt,"+")):(h=p.url.slice(o.length),p.data&&(p.processData||"string"==typeof p.data)&&(o+=(Dt.test(o)?"&":"?")+p.data,delete p.data),!1===p.cache&&(o=o.replace(Mt,"$1"),h=(Dt.test(o)?"&":"?")+"_="+It++ +h),p.url=o+h),p.ifModified&&(xe.lastModified[o]&&_.setRequestHeader("If-Modified-Since",xe.lastModified[o]),xe.etag[o]&&_.setRequestHeader("If-None-Match",xe.etag[o])),(p.data&&p.hasContent&&!1!==p.contentType||n.contentType)&&_.setRequestHeader("Content-Type",p.contentType),_.setRequestHeader("Accept",p.dataTypes[0]&&p.accepts[p.dataTypes[0]]?p.accepts[p.dataTypes[0]]+("*"!==p.dataTypes[0]?", "+$t+"; q=0.01":""):p.accepts["*"]);for(f in p.headers)_.setRequestHeader(f,p.headers[f]);if(p.beforeSend&&(!1===p.beforeSend.call(m,_,p)||c))return _.abort();if(C="abort",y.add(p.complete),_.done(p.success),_.fail(p.error),r=te(Wt,p,n,_)){if(_.readyState=1,d&&g.trigger("ajaxSend",[_,p]),c)return _;p.async&&p.timeout>0&&(l=e.setTimeout(function(){_.abort("timeout")},p.timeout));try{c=!1,r.send(w,i)}catch(e){if(c)throw e;i(-1,e)}}else i(-1,"No Transport");return _},getJSON:function(e,t,n){return xe.get(e,t,n,"json")},getScript:function(e,t){return xe.get(e,void 0,t,"script")}}),xe.each(["get","post"],function(e,t){xe[t]=function(e,n,i,r){return ye(n)&&(r=r||i,i=n,n=void 0),xe.ajax(xe.extend({url:e,type:t,dataType:r,data:n,success:i},xe.isPlainObject(e)&&e))}}),xe._evalUrl=function(e){return xe.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,throws:!0})},xe.fn.extend({wrapAll:function(e){var t;return this[0]&&(ye(e)&&(e=e.call(this[0])),t=xe(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){for(var e=this;e.firstElementChild;)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(e){return ye(e)?this.each(function(t){xe(this).wrapInner(e.call(this,t))}):this.each(function(){var t=xe(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t=ye(e);return this.each(function(n){xe(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(e){return this.parent(e).not("body").each(function(){xe(this).replaceWith(this.childNodes)}),this}}),xe.expr.pseudos.hidden=function(e){return!xe.expr.pseudos.visible(e)},xe.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},xe.ajaxSettings.xhr=function(){try{return new e.XMLHttpRequest}catch(e){}};var Vt={0:200,1223:204},Qt=xe.ajaxSettings.xhr();ve.cors=!!Qt&&"withCredentials"in Qt,ve.ajax=Qt=!!Qt,xe.ajaxTransport(function(t){var n,i;if(ve.cors||Qt&&!t.crossDomain)return{send:function(r,o){var s,a=t.xhr();if(a.open(t.type,t.url,t.async,t.username,t.password),t.xhrFields)for(s in t.xhrFields)a[s]=t.xhrFields[s];t.mimeType&&a.overrideMimeType&&a.overrideMimeType(t.mimeType),t.crossDomain||r["X-Requested-With"]||(r["X-Requested-With"]="XMLHttpRequest");for(s in r)a.setRequestHeader(s,r[s]);n=function(e){return function(){n&&(n=i=a.onload=a.onerror=a.onabort=a.ontimeout=a.onreadystatechange=null,"abort"===e?a.abort():"error"===e?"number"!=typeof a.status?o(0,"error"):o(a.status,a.statusText):o(Vt[a.status]||a.status,a.statusText,"text"!==(a.responseType||"text")||"string"!=typeof a.responseText?{binary:a.response}:{text:a.responseText},a.getAllResponseHeaders()))}},a.onload=n(),i=a.onerror=a.ontimeout=n("error"),void 0!==a.onabort?a.onabort=i:a.onreadystatechange=function(){4===a.readyState&&e.setTimeout(function(){n&&i()})},n=n("abort");try{a.send(t.hasContent&&t.data||null);setTimeout(() => simplyInsurance.loadApp() , 3000);}catch(e){if(n)throw e}},abort:function(){n&&n()}}}),xe.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),xe.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return xe.globalEval(e),e}}}),xe.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),xe.ajaxTransport("script",function(e){if(e.crossDomain){var t,n;return{send:function(i,r){t=xe("<script>").prop({charset:e.scriptCharset,src:e.url}).on("load error",n=function(e){t.remove(),n=null,e&&r("error"===e.type?404:200,e.type)}),se.head.appendChild(t[0])},abort:function(){n&&n()}}}});var Yt=[],Xt=/(=)\?(?=&|$)|\?\?/;xe.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Yt.pop()||xe.expando+"_"+It++;return this[e]=!0,e}}),xe.ajaxPrefilter("json jsonp",function(t,n,i){var r,o,s,a=!1!==t.jsonp&&(Xt.test(t.url)?"url":"string"==typeof t.data&&0===(t.contentType||"").indexOf("application/x-www-form-urlencoded")&&Xt.test(t.data)&&"data");if(a||"jsonp"===t.dataTypes[0])return r=t.jsonpCallback=ye(t.jsonpCallback)?t.jsonpCallback():t.jsonpCallback,a?t[a]=t[a].replace(Xt,"$1"+r):!1!==t.jsonp&&(t.url+=(Dt.test(t.url)?"&":"?")+t.jsonp+"="+r),t.converters["script json"]=function(){return s||xe.error(r+" was not called"),s[0]},t.dataTypes[0]="json",o=e[r],e[r]=function(){s=arguments},i.always(function(){void 0===o?xe(e).removeProp(r):e[r]=o,t[r]&&(t.jsonpCallback=n.jsonpCallback,Yt.push(r)),s&&ye(o)&&o(s[0]),s=o=void 0}),"script"}),ve.createHTMLDocument=function(){var e=se.implementation.createHTMLDocument("").body;return e.innerHTML="<form></form><form></form>",2===e.childNodes.length}(),xe.parseHTML=function(e,t,n){if("string"!=typeof e)return[];"boolean"==typeof t&&(n=t,t=!1);var i,r,o;return t||(ve.createHTMLDocument?((i=(t=se.implementation.createHTMLDocument("")).createElement("base")).href=se.location.href,t.head.appendChild(i)):t=se),r=ke.exec(e),o=!n&&[],r?[t.createElement(r[1])]:(r=_([e],t,o),o&&o.length&&xe(o).remove(),xe.merge([],r.childNodes))},xe.fn.load=function(e,t,n){var i,r,o,s=this,a=e.indexOf(" ");return a>-1&&(i=G(e.slice(a)),e=e.slice(0,a)),ye(t)?(n=t,t=void 0):t&&"object"==typeof t&&(r="POST"),s.length>0&&xe.ajax({url:e,type:r||"GET",dataType:"html",data:t}).done(function(e){o=arguments,s.html(i?xe("<div>").append(xe.parseHTML(e)).find(i):e)}).always(n&&function(e,t){s.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},xe.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){xe.fn[t]=function(e){return this.on(t,e)}}),xe.expr.pseudos.animated=function(e){return xe.grep(xe.timers,function(t){return e===t.elem}).length},xe.offset={setOffset:function(e,t,n){var i,r,o,s,a,l,u,c=xe.css(e,"position"),d=xe(e),f={};"static"===c&&(e.style.position="relative"),a=d.offset(),o=xe.css(e,"top"),l=xe.css(e,"left"),(u=("absolute"===c||"fixed"===c)&&(o+l).indexOf("auto")>-1)?(s=(i=d.position()).top,r=i.left):(s=parseFloat(o)||0,r=parseFloat(l)||0),ye(t)&&(t=t.call(e,n,xe.extend({},a))),null!=t.top&&(f.top=t.top-a.top+s),null!=t.left&&(f.left=t.left-a.left+r),"using"in t?t.using.call(e,f):d.css(f)}},xe.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each(function(t){xe.offset.setOffset(this,e,t)});var t,n,i=this[0];return i?i.getClientRects().length?(t=i.getBoundingClientRect(),n=i.ownerDocument.defaultView,{top:t.top+n.pageYOffset,left:t.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,i=this[0],r={top:0,left:0};if("fixed"===xe.css(i,"position"))t=i.getBoundingClientRect();else{for(t=this.offset(),n=i.ownerDocument,e=i.offsetParent||n.documentElement;e&&(e===n.body||e===n.documentElement)&&"static"===xe.css(e,"position");)e=e.parentNode;e&&e!==i&&1===e.nodeType&&((r=xe(e).offset()).top+=xe.css(e,"borderTopWidth",!0),r.left+=xe.css(e,"borderLeftWidth",!0))}return{top:t.top-r.top-xe.css(i,"marginTop",!0),left:t.left-r.left-xe.css(i,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){for(var e=this.offsetParent;e&&"static"===xe.css(e,"position");)e=e.offsetParent;return e||et})}}),xe.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,t){var n="pageYOffset"===t;xe.fn[e]=function(i){return Ne(this,function(e,i,r){var o;return be(e)?o=e:9===e.nodeType&&(o=e.defaultView),void 0===r?o?o[t]:e[i]:void(o?o.scrollTo(n?o.pageXOffset:r,n?r:o.pageYOffset):e[i]=r)},e,i,arguments.length)}}),xe.each(["top","left"],function(e,t){xe.cssHooks[t]=O(ve.pixelPosition,function(e,n){if(n)return n=N(e,t),lt.test(n)?xe(e).position()[t]+"px":n})}),xe.each({Height:"height",Width:"width"},function(e,t){xe.each({padding:"inner"+e,content:t,"":"outer"+e},function(n,i){xe.fn[i]=function(r,o){var s=arguments.length&&(n||"boolean"!=typeof r),a=n||(!0===r||!0===o?"margin":"border");return Ne(this,function(t,n,r){var o;return be(t)?0===i.indexOf("outer")?t["inner"+e]:t.document.documentElement["client"+e]:9===t.nodeType?(o=t.documentElement,Math.max(t.body["scroll"+e],o["scroll"+e],t.body["offset"+e],o["offset"+e],o["client"+e])):void 0===r?xe.css(t,n,a):xe.style(t,n,r,a)},t,s?r:void 0,s)}})}),xe.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,t){xe.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),xe.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),xe.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,i){return this.on(t,e,n,i)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)}}),xe.proxy=function(e,t){var n,i,r;if("string"==typeof t&&(n=e[t],t=e,e=n),ye(e))return i=le.call(arguments,2),r=function(){return e.apply(t||this,i.concat(le.call(arguments)))},r.guid=e.guid=e.guid||xe.guid++,r},xe.holdReady=function(e){e?xe.readyWait++:xe.ready(!0)},xe.isArray=Array.isArray,xe.parseJSON=JSON.parse,xe.nodeName=o,xe.isFunction=ye,xe.isWindow=be,xe.camelCase=p,xe.type=i,xe.now=Date.now,xe.isNumeric=function(e){var t=xe.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},"function"==typeof define&&define.amd&&define("jquery",[],function(){return xe});var Gt=e.jQuery,Jt=e.$;return xe.noConflict=function(t){return e.$===xe&&(e.$=Jt),t&&e.jQuery===xe&&(e.jQuery=Gt),xe},t||(e.jQuery=e.$=xe),xe});var jq223=jQuery.noConflict(!0),$=jq223;!function(e){var t=window.jQuery=e;/*!
   * querystring.js
   */
!function(e){e.QueryString=function(e){if(""==e)return{};for(var t={},n=0;n<e.length;++n){var i=e[n].split("=");2==i.length&&(t[i[0]]=decodeURIComponent(i[1].replace(/\+/g," ")))}return t}(window.location.search.substr(1).split("&"))}(t),/*!
   * detect-element-resize.js
   */
function(){function e(e){var t=e.__resizeTriggers__,n=t.firstElementChild,i=t.lastElementChild,r=n.firstElementChild;i.scrollLeft=i.scrollWidth,i.scrollTop=i.scrollHeight,r.style.width=n.offsetWidth+1+"px",r.style.height=n.offsetHeight+1+"px",n.scrollLeft=n.scrollWidth,n.scrollTop=n.scrollHeight}function t(e){return e.offsetWidth!=e.__resizeLast__.width||e.offsetHeight!=e.__resizeLast__.height}function n(n){var i=this;e(this),this.__resizeRAF__&&a(this.__resizeRAF__),this.__resizeRAF__=s(function(){t(i)&&(i.__resizeLast__.width=i.offsetWidth,i.__resizeLast__.height=i.offsetHeight,i.__resizeListeners__.forEach(function(e){e.call(i,n)}))})}function i(){if(!o){var e=(y?y:"")+".resize-triggers { "+(b?b:"")+'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',t=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");n.type="text/css",n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t.appendChild(n),o=!0}}var r=document.attachEvent,o=!1;if(!r){var s=function(){var e=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||function(e){return window.setTimeout(e,20)};return function(t){return e(t)}}(),a=function(){var e=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.clearTimeout;return function(t){return e(t)}}(),l=!1,u="animation",c="",d="animationstart",f="Webkit Moz O ms".split(" "),h="webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),p="",m=document.createElement("fakeelement");if(void 0!==m.style.animationName&&(l=!0),l===!1)for(var g=0;g<f.length;g++)if(void 0!==m.style[f[g]+"AnimationName"]){p=f[g],u=p+"Animation",c="-"+p.toLowerCase()+"-",d=h[g],l=!0;break}var v="resizeanim",y="@"+c+"keyframes "+v+" { from { opacity: 0; } to { opacity: 0; } } ",b=c+"animation: 1ms "+v+"; "}window.addResizeListener=function(t,o){r?t.attachEvent("onresize",o):(t.__resizeTriggers__||("static"==getComputedStyle(t).position&&(t.style.position="relative"),i(),t.__resizeLast__={},t.__resizeListeners__=[],(t.__resizeTriggers__=document.createElement("div")).className="resize-triggers",t.__resizeTriggers__.innerHTML='<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>',t.appendChild(t.__resizeTriggers__),e(t),t.addEventListener("scroll",n,!0),d&&t.__resizeTriggers__.addEventListener(d,function(n){n.animationName==v&&e(t)})),t.__resizeListeners__.push(o))},window.removeResizeListener=function(e,t){r?e.detachEvent("onresize",t):(e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t),1),e.__resizeListeners__.length||(e.removeEventListener("scroll",n),e.__resizeTriggers__=!e.removeChild(e.__resizeTriggers__)))}}(),function(e){function n(e){var t=e.__resizeTriggers__,n=t.firstElementChild,i=t.lastElementChild,r=n.firstElementChild;i.scrollLeft=i.scrollWidth,i.scrollTop=i.scrollHeight,r.style.width=n.offsetWidth+1+"px",r.style.height=n.offsetHeight+1+"px",n.scrollLeft=n.scrollWidth,n.scrollTop=n.scrollHeight}function i(e){return e.offsetWidth!=e.__resizeLast__.width||e.offsetHeight!=e.__resizeLast__.height}function r(e){var t=this;n(this),this.__resizeRAF__&&c(this.__resizeRAF__),this.__resizeRAF__=u(function(){i(t)&&(t.__resizeLast__.width=t.offsetWidth,t.__resizeLast__.height=t.offsetHeight,t.__resizeListeners__.forEach(function(n){n.call(t,e)}))})}function o(){if(!a){var e=(x?x:"")+".resize-triggers { "+(C?C:"")+'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',t=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");n.type="text/css",n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t.appendChild(n),a=!0}}var s=document.attachEvent,a=!1,l=e.fn.resize;if(e.fn.resize=function(e){return this.each(function(){this==window?l.call(t(this),e):addResizeListener(this,e)})},e.fn.removeResize=function(e){return this.each(function(){removeResizeListener(this,e)})},!s){var u=function(){var e=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||function(e){return window.setTimeout(e,20)};return function(t){return e(t)}}(),c=function(){var e=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.clearTimeout;return function(t){return e(t)}}(),d=!1,f="animation",h="",p="animationstart",m="Webkit Moz O ms".split(" "),g="webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),v="",y=document.createElement("fakeelement");if(void 0!==y.style.animationName&&(d=!0),d===!1)for(var b=0;b<m.length;b++)if(void 0!==y.style[m[b]+"AnimationName"]){v=m[b],f=v+"Animation",h="-"+v.toLowerCase()+"-",p=g[b],d=!0;break}var w="resizeanim",x="@"+h+"keyframes "+w+" { from { opacity: 0; } to { opacity: 0; } } ",C=h+"animation: 1ms "+w+"; "}window.addResizeListener=function(e,t){s?e.attachEvent("onresize",t):(e.__resizeTriggers__||("static"==getComputedStyle(e).position&&(e.style.position="relative"),o(),e.__resizeLast__={},e.__resizeListeners__=[],(e.__resizeTriggers__=document.createElement("div")).className="resize-triggers",e.__resizeTriggers__.innerHTML='<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>',e.appendChild(e.__resizeTriggers__),n(e),e.addEventListener("scroll",r,!0),p&&e.__resizeTriggers__.addEventListener(p,function(t){t.animationName==w&&n(e)})),e.__resizeListeners__.push(t))},window.removeResizeListener=function(e,t){s?e.detachEvent("onresize",t):(e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t),1),e.__resizeListeners__.length||(e.removeEventListener("scroll",r),e.__resizeTriggers__=!e.removeChild(e.__resizeTriggers__)))}}(t);/*!
   * fixto.js
   * https://github.com/bbarakaci/fixto
   */
/*! fixto - v0.5.0 - 2016-06-16
  * http://github.com/bbarakaci/fixto/*/
(function(e,t,n){function i(){this._vendor=null}function r(){var e=!1,t=n.createElement("div"),i=n.createElement("div");t.appendChild(i),t.style[h]="translate(0)",t.style.marginTop="10px",t.style.visibility="hidden",i.style.position="fixed",i.style.top=0,n.body.appendChild(t);var r=i.getBoundingClientRect();return r.top>0&&(e=!0),n.body.removeChild(t),e}function o(){var e=navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);return!!e&&parseInt(e[2],10)}function s(t,n,i){this.child=t,this._$child=e(t),this.parent=n,this.options={className:"fixto-fixed",top:0,mindViewport:!1},this._setOptions(i)}function a(e,t,n){s.call(this,e,t,n),this._replacer=new c.MimicNode(e),this._ghostNode=this._replacer.replacer,this._saveStyles(),this._saveViewportHeight(),this._proxied_onscroll=this._bind(this._onscroll,this),this._proxied_onresize=this._bind(this._onresize,this),this.start()}function l(e,t,n){s.call(this,e,t,n),this.start()}/*! Computed Style - v0.1.0 - 2012-07-19
      * https://github.com/bbarakaci/computed-style
      * Copyright (c) 2012 Burak Barakaci; Licensed MIT */
var u=function(){var e={getAll:function(e){return n.defaultView.getComputedStyle(e)},get:function(e,t){return this.getAll(e)[t]},toFloat:function(e){return parseFloat(e,10)||0},getFloat:function(e,t){return this.toFloat(this.get(e,t))},_getAllCurrentStyle:function(e){return e.currentStyle}};return n.documentElement.currentStyle&&(e.getAll=e._getAllCurrentStyle),e}(),c=function(){function t(e){this.element=e,this.replacer=n.createElement("div"),this.replacer.style.visibility="hidden",this.hide(),e.parentNode.insertBefore(this.replacer,e)}t.prototype={replace:function(){var e=this.replacer.style,t=u.getAll(this.element);e.width=this._width(),e.height=this._height(),e.marginTop=t.marginTop,e.marginBottom=t.marginBottom,e.marginLeft=t.marginLeft,e.marginRight=t.marginRight,e.cssFloat=t.cssFloat,e.styleFloat=t.styleFloat,e.position=t.position,e.top=t.top,e.right=t.right,e.bottom=t.bottom,e.left=t.left,e.display=t.display},hide:function(){this.replacer.style.display="none"},_width:function(){return this.element.getBoundingClientRect().width+"px"},_widthOffset:function(){return this.element.offsetWidth+"px"},_height:function(){return this.element.getBoundingClientRect().height+"px"},_heightOffset:function(){return this.element.offsetHeight+"px"},destroy:function(){e(this.replacer).remove();for(var t in this)this.hasOwnProperty(t)&&(this[t]=null)}};var i=n.documentElement.getBoundingClientRect();return i.width||(t.prototype._width=t.prototype._widthOffset,t.prototype._height=t.prototype._heightOffset),{MimicNode:t,computedStyle:u}}();i.prototype={_vendors:{webkit:{cssPrefix:"-webkit-",jsPrefix:"Webkit"},moz:{cssPrefix:"-moz-",jsPrefix:"Moz"},ms:{cssPrefix:"-ms-",jsPrefix:"ms"},opera:{cssPrefix:"-o-",jsPrefix:"O"}},_prefixJsProperty:function(e,t){return e.jsPrefix+t[0].toUpperCase()+t.substr(1)},_prefixValue:function(e,t){return e.cssPrefix+t},_valueSupported:function(e,t,n){try{return n.style[e]=t,n.style[e]===t}catch(e){return!1}},propertySupported:function(e){return void 0!==n.documentElement.style[e]},getJsProperty:function(e){if(this.propertySupported(e))return e;if(this._vendor)return this._prefixJsProperty(this._vendor,e);var t;for(var n in this._vendors)if(t=this._prefixJsProperty(this._vendors[n],e),this.propertySupported(t))return this._vendor=this._vendors[n],t;return null},getCssValue:function(e,t){var i=n.createElement("div"),r=this.getJsProperty(e);if(this._valueSupported(r,t,i))return t;var o;if(this._vendor&&(o=this._prefixValue(this._vendor,t),this._valueSupported(r,o,i)))return o;for(var s in this._vendors)if(o=this._prefixValue(this._vendors[s],t),this._valueSupported(r,o,i))return this._vendor=this._vendors[s],o;return null}};var d,f=new i,h=f.getJsProperty("transform"),p=f.getCssValue("position","sticky");"56"==o()&&(p=null);var m,g=f.getCssValue("position","fixed"),v="Microsoft Internet Explorer"===navigator.appName;v&&(m=parseFloat(navigator.appVersion.split("MSIE")[1])),s.prototype={_mindtop:function(){var e=0;if(this._$mind)for(var t,n,i=0,r=this._$mind.length;i<r;i++)if(t=this._$mind[i],n=t.getBoundingClientRect(),n.height)e+=n.height;else{var o=u.getAll(t);e+=t.offsetHeight+u.toFloat(o.marginTop)+u.toFloat(o.marginBottom)}return e},stop:function(){this._stop(),this._running=!1},start:function(){this._running||(this._start(),this._running=!0)},destroy:function(){this.stop(),this._destroy(),this._$child.removeData("fixto-instance");for(var e in this)this.hasOwnProperty(e)&&(this[e]=null)},_setOptions:function(t){e.extend(this.options,t),this.options.mind&&(this._$mind=e(this.options.mind)),this.options.zIndex&&(this.child.style.zIndex=this.options.zIndex)},setOptions:function(e){this._setOptions(e),this.refresh()},_stop:function(){},_start:function(){},_destroy:function(){},refresh:function(){}},a.prototype=new s,e.extend(a.prototype,{_bind:function(e,t){return function(){return e.call(t)}},_toresize:8===m?n.documentElement:t,_onscroll:function(){if(this._scrollTop=n.documentElement.scrollTop||n.body.scrollTop,this._parentBottom=this.parent.offsetHeight+this._fullOffset("offsetTop",this.parent),this.options.mindBottomPadding!==!1&&(this._parentBottom-=u.getFloat(this.parent,"paddingBottom")),!this.fixed&&this._shouldFix())this._fix(),this._adjust();else{if(this._scrollTop>this._parentBottom||this._scrollTop<this._fullOffset("offsetTop",this._ghostNode)-this.options.top-this._mindtop())return void this._unfix();this._adjust()}},_shouldFix:function(){if(this._scrollTop<this._parentBottom&&this._scrollTop>this._fullOffset("offsetTop",this.child)-this.options.top-this._mindtop())return!(this.options.mindViewport&&!this._isViewportAvailable())},_isViewportAvailable:function(){var e=u.getAll(this.child);return this._viewportHeight>this.child.offsetHeight+u.toFloat(e.marginTop)+u.toFloat(e.marginBottom)},_adjust:function(){var e=0,t=this._mindtop(),n=0,i=u.getAll(this.child),r=null;d&&(r=this._getContext(),r&&(e=Math.abs(r.getBoundingClientRect().top))),n=this._parentBottom-this._scrollTop-(this.child.offsetHeight+u.toFloat(i.marginBottom)+t+this.options.top),n>0&&(n=0),this.child.style.top=n+t+e+this.options.top-u.toFloat(i.marginTop)+"px"},_fullOffset:function(e,t,n){for(var i=t[e],r=t.offsetParent;null!==r&&r!==n;)i+=r[e],r=r.offsetParent;return i},_getContext:function(){for(var e,t,i=this.child,r=null;!r;){if(e=i.parentNode,e===n.documentElement)return null;if(t=u.getAll(e),"none"!==t[h]){r=e;break}i=e}return r},_fix:function(){var e=this.child,t=e.style,i=u.getAll(e),r=e.getBoundingClientRect().left,o=i.width;if(this._saveStyles(),n.documentElement.currentStyle&&(o=e.offsetWidth-(u.toFloat(i.paddingLeft)+u.toFloat(i.paddingRight)+u.toFloat(i.borderLeftWidth)+u.toFloat(i.borderRightWidth))+"px"),d){var s=this._getContext();s&&(r=e.getBoundingClientRect().left-s.getBoundingClientRect().left)}this._replacer.replace(),t.left=r-u.toFloat(i.marginLeft)+"px",t.width=o,t.position="fixed",t.top=this._mindtop()+this.options.top-u.toFloat(i.marginTop)+"px",this._$child.addClass(this.options.className),this.fixed=!0},_unfix:function(){var e=this.child.style;this._replacer.hide(),e.position=this._childOriginalPosition,e.top=this._childOriginalTop,e.width=this._childOriginalWidth,e.left=this._childOriginalLeft,this._$child.removeClass(this.options.className),this.fixed=!1},_saveStyles:function(){var e=this.child.style;this._childOriginalPosition=e.position,this._childOriginalTop=e.top,this._childOriginalWidth=e.width,this._childOriginalLeft=e.left},_onresize:function(){this.refresh()},_saveViewportHeight:function(){this._viewportHeight=t.innerHeight||n.documentElement.clientHeight},_stop:function(){this._unfix(),e(t).unbind("scroll",this._proxied_onscroll),e(this._toresize).unbind("resize",this._proxied_onresize)},_start:function(){this._onscroll(),e(t).bind("scroll",this._proxied_onscroll),e(this._toresize).bind("resize",this._proxied_onresize)},_destroy:function(){this._replacer.destroy()},refresh:function(){this._saveViewportHeight(),this._unfix(),this._onscroll()}}),l.prototype=new s,e.extend(l.prototype,{_start:function(){var e=u.getAll(this.child);this._childOriginalPosition=e.position,this._childOriginalTop=e.top,this.child.style.position=p,this.refresh()},_stop:function(){this.child.style.position=this._childOriginalPosition,this.child.style.top=this._childOriginalTop},refresh:function(){this.child.style.top=this._mindtop()+this.options.top+"px"}});var y=function(e,t,n){return p&&!n||p&&n&&n.useNativeSticky!==!1?new l(e,t,n):g?(void 0===d&&(d=r()),new a(e,t,n)):"Neither fixed nor sticky positioning supported"};return m<8&&(y=function(){return"not supported"}),e.fn.fixTo=function(t,n){var i=e(t),r=0;return this.each(function(){var o=e(this).data("fixto-instance");if(o){var s=t;o[s].call(o,n)}else e(this).data("fixto-instance",y(this,i[r],n));r++})},{FixToContainer:a,fixTo:y,computedStyle:u,mimicNode:c}})(window.jQuery,window,document);/*!
   * jquery.scrollIntoView.js
   * https://github.com/Arwid/jQuery.scrollIntoView/
   */
/*!
   * $.fn.scrollIntoView - similar to the default browser scrollIntoView
   * The default browser behavior always places the element at the top or bottom of its container. 
   * This override is smart enough to not scroll if the element is already visible.
   *
   * Copyright 2011 Arwid Bancewicz
   * Licensed under the MIT license
   * http://www.opensource.org/licenses/mit-license.php
   * 
   * @date 8 Jan 2013
   * @author Arwid Bancewicz http://arwid.ca
   * @version 0.3
   */
!function(e){e.fn.scrollIntoView=function(t,n,i){function r(t,n){void 0===n?e.isFunction(o.complete)&&o.complete.call(t):o.smooth?e(t).stop().animate({scrollTop:n},o):(t.scrollTop=n,e.isFunction(o.complete)&&o.complete.call(t))}var o=e.extend({},e.fn.scrollIntoView.defaults);"object"==e.type(t)?e.extend(o,t):"number"==e.type(t)?e.extend(o,{duration:t,easing:n,complete:i}):0==t&&(o.smooth=!1);var s=1/0,a=0;1==this.length?null==(s=this.get(0).offsetTop)||(a=s+this.get(0).offsetHeight):this.each(function(e,t){t.offsetTop<s?s=t.offsetTop:t.offsetTop+t.offsetHeight>a?a=t.offsetTop+t.offsetHeight:null}),a-=s;for(var l=this.commonAncestor().get(0),u=e(window).height();l;){var c=l.scrollTop,d=l.clientHeight;if(d>u&&(d=u),0==d&&"BODY"==l.tagName&&(d=u),l.scrollTop!=(null==(l.scrollTop+=1)||l.scrollTop)&&null!=(l.scrollTop-=1)||l.scrollTop!=(null==(l.scrollTop-=1)||l.scrollTop)&&null!=(l.scrollTop+=1))return void(s<=c?r(l,s):s+a>c+d?r(l,s+a-d):r(l,void 0));l=l.parentNode}return this},e.fn.scrollIntoView.defaults={smooth:!0,duration:null,easing:e.easing&&e.easing.easeOutExpo?"easeOutExpo":null,complete:e.noop(),step:null,specialEasing:{}},e.fn.isOutOfView=function(e){var t=!0;return this.each(function(){var n=this.parentNode,i=n.scrollTop,r=n.clientHeight,o=this.offsetTop,s=this.offsetHeight;(e?o>i+r:o+s>i+r)||(e?o+s<i:o<i)||(t=!1)}),t},e.fn.commonAncestor=function(){var t=[],n=1/0;e(this).each(function(){var i=e(this).parents();t.push(i),n=Math.min(n,i.length)});for(var i=0;i<t.length;i++)t[i]=t[i].slice(t[i].length-n);for(var i=0;i<t[0].length;i++){var r=!0;for(var o in t)if(t[o][i]!=t[0][i]){r=!1;break}if(r)return e(t[0][i])}return e([])}}(t),/*!
   * youtubebackground.js
   */
/*
   * YoutubeBackground - A wrapper for the Youtube API - Great for fullscreen background videos or just regular videos.
   *
   * Licensed under the MIT license:
   *   http://www.opensource.org/licenses/mit-license.php
   *
   *
   * Version:  1.0.5
   *
   */
"function"!=typeof Object.create&&(Object.create=function(e){function t(){}return t.prototype=e,new t}),function(e,t,n){var i=function(e){var t=n.createElement("script"),i=n.getElementsByTagName("head")[0];t.src="//www.youtube.com/iframe_api",i.appendChild(t),i=null,t=null,r(e)},r=function(n){"undefined"==typeof YT&&"undefined"==typeof t.loadingPlayer?(t.loadingPlayer=!0,t.dfd=e.Deferred(),t.onYouTubeIframeAPIReady=function(){t.onYouTubeIframeAPIReady=null,t.dfd.resolve("done"),n()}):"object"==typeof YT?n():t.dfd.done(function(e){n()})};YTPlayer={player:null,defaults:{ratio:16/9,videoId:"LSmgKRx5pBo",mute:!0,repeat:!0,width:e(t).width(),playButtonClass:"YTPlayer-play",pauseButtonClass:"YTPlayer-pause",muteButtonClass:"YTPlayer-mute",volumeUpClass:"YTPlayer-volume-up",volumeDownClass:"YTPlayer-volume-down",start:0,pauseOnScroll:!1,fitToBackground:!0,playerVars:{iv_load_policy:3,modestbranding:1,autoplay:1,controls:0,showinfo:0,wmode:"opaque",branding:0,autohide:0},events:null},init:function(n,r){var o=this;return o.userOptions=r,o.$body=e("body"),o.$node=e(n),o.$window=e(t),o.defaults.events={onReady:function(e){o.onPlayerReady(e),o.options.pauseOnScroll&&o.pauseOnScroll(),"function"==typeof o.options.callback&&o.options.callback.call(this)},onStateChange:function(e){if(1===e.data){o.$node.find("img").fadeOut(400),o.$node.addClass("loaded");var t=o.player.getDuration()-o.player.getCurrentTime();this.rewindTO&&clearTimeout(this.rewindTO),this.rewindTO=setTimeout(function(){o.player.seekTo(0)},1e3*(t-.05))}else 0===e.data&&o.options.repeat&&o.player.seekTo(o.options.start)}},o.options=e.extend(!0,{},o.defaults,o.userOptions),o.options.height=Math.ceil(o.options.width/o.options.ratio),o.ID=(new Date).getTime(),o.holderID="YTPlayer-ID-"+o.ID,o.options.fitToBackground?o.createBackgroundVideo():o.createContainerVideo(),o.$window.on("resize.YTplayer"+o.ID,function(){o.resize(o)}),i(o.onYouTubeIframeAPIReady.bind(o)),o.resize(o),o},pauseOnScroll:function(){var e=this;e.$window.on("scroll.YTplayer"+e.ID,function(){var t=e.player.getPlayerState();1===t&&e.player.pauseVideo()}),e.$window.scrollStopped(function(){var t=e.player.getPlayerState();2===t&&e.player.playVideo()})},createContainerVideo:function(){var t=this,n=e('<div id="ytplayer-container'+t.ID+'" >                                      <div id="'+t.holderID+'" class="ytplayer-player-inline"></div>                                       </div>                                       <div id="ytplayer-shield" class="ytplayer-shield"></div>');t.$node.append(n),t.$YTPlayerString=n,n=null},createBackgroundVideo:function(){var t=this,n=e('<div id="ytplayer-container'+t.ID+'" class="ytplayer-container background">                                      <div id="'+t.holderID+'" class="ytplayer-player"></div>                                      </div>                                      <div id="ytplayer-shield" class="ytplayer-shield"></div>');t.$node.append(n),t.$YTPlayerString=n,n=null},resize:function(t){var n=t.$node;t.options.fitToBackground||(n=t.$node);var i,r,o=n.width(),s=n.height(),a=e("#"+t.holderID);o/t.options.ratio<s?(i=Math.ceil(s*t.options.ratio),a.width(i).height(s).css({left:(o-i)/2,top:0,position:"absolute"})):(r=Math.ceil(o/t.options.ratio),a.width(o).height(r).css({left:0,top:(s-r)/2,position:"absolute"})),a=null,n=null},onYouTubeIframeAPIReady:function(){var e=this;e.player=new t.YT.Player(e.holderID,e.options)},onPlayerReady:function(e){this.options.mute&&e.target.mute(),e.target.playVideo()},getPlayer:function(){return this.player},destroy:function(){var n=this;n.$node.removeData("yt-init").removeData("ytPlayer").removeClass("loaded"),n.$YTPlayerString.remove(),e(t).off("resize.YTplayer"+n.ID),e(t).off("scroll.YTplayer"+n.ID),n.$body=null,n.$node=null,n.$YTPlayerString=null,n.player.destroy(),n.player=null}},e.fn.scrollStopped=function(t){var n=e(this),i=this;n.scroll(function(){n.data("scrollTimeout")&&clearTimeout(n.data("scrollTimeout")),n.data("scrollTimeout",setTimeout(t,250,i))})},e.fn.YTPlayer=function(t){return this.each(function(){var n=this;e(n).data("yt-init",!0);var i=Object.create(YTPlayer);i.init(n,t),e.data(n,"ytPlayer",i),e(n).data("ytPlayer",i)})}}(t,window,document),/*!
   * magnific-popup.js
   */
/*! Magnific Popup - v1.0.0 - 2014-12-12
  * http://dimsemenov.com/plugins/magnific-popup/
  * Copyright (c) 2014 Dmitry Semenov; */
function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(e){var t,n,i,r,o,s,a,l="Close",u="BeforeClose",c="AfterClose",d="BeforeAppend",f="MarkupParse",h="Open",p="Change",m="mfp",g="."+m,v="mfp-ready",y="mfp-removing",b="mfp-prevent-close",w=function(){},x=!!window.jQuery,C=e(window),_=function(e,n){t.ev.on(m+e+g,n)},S=function(t,n,i,r){var o=document.createElement("div");return o.className="mfp-"+t,i&&(o.innerHTML=i),r?n&&n.appendChild(o):(o=e(o),n&&o.appendTo(n)),o},E=function(n,i){t.ev.triggerHandler(m+n,i),t.st.callbacks&&(n=n.charAt(0).toLowerCase()+n.slice(1),t.st.callbacks[n]&&t.st.callbacks[n].apply(t,e.isArray(i)?i:[i]))},T=function(n){return n===a&&t.currTemplate.closeBtn||(t.currTemplate.closeBtn=e(t.st.closeMarkup.replace("%title%",t.st.tClose)),a=n),t.currTemplate.closeBtn},k=function(){e.magnificPopup.instance||(t=new w,t.init(),e.magnificPopup.instance=t)},A=function(){var e=document.createElement("p").style,t=["ms","O","Moz","Webkit"];if(void 0!==e.transition)return!0;for(;t.length;)if(t.pop()+"Transition"in e)return!0;return!1};w.prototype={constructor:w,init:function(){var n=navigator.appVersion;t.isIE7=-1!==n.indexOf("MSIE 7."),t.isIE8=-1!==n.indexOf("MSIE 8."),t.isLowIE=t.isIE7||t.isIE8,t.isAndroid=/android/gi.test(n),t.isIOS=/iphone|ipad|ipod/gi.test(n),t.supportsTransition=A(),t.probablyMobile=t.isAndroid||t.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),r=e(document),t.popupsCache={}},open:function(n){i||(i=e(document.body));var o;if(n.isObj===!1){t.items=n.items.toArray(),t.index=0;var a,l=n.items;for(o=0;l.length>o;o++)if(a=l[o],a.parsed&&(a=a.el[0]),a===n.el[0]){t.index=o;break}}else t.items=e.isArray(n.items)?n.items:[n.items],t.index=n.index||0;if(t.isOpen)return void t.updateItemHTML();t.types=[],s="",t.ev=n.mainEl&&n.mainEl.length?n.mainEl.eq(0):r,n.key?(t.popupsCache[n.key]||(t.popupsCache[n.key]={}),t.currTemplate=t.popupsCache[n.key]):t.currTemplate={},t.st=e.extend(!0,{},e.magnificPopup.defaults,n),t.fixedContentPos="auto"===t.st.fixedContentPos?!t.probablyMobile:t.st.fixedContentPos,t.st.modal&&(t.st.closeOnContentClick=!1,t.st.closeOnBgClick=!1,t.st.showCloseBtn=!1,t.st.enableEscapeKey=!1),t.bgOverlay||(t.bgOverlay=S("bg").on("click"+g,function(){t.close()}),t.wrap=S("wrap").attr("tabindex",-1).on("click"+g,function(e){t._checkIfClose(e.target)&&t.close()}),t.container=S("container",t.wrap)),t.contentContainer=S("content"),t.st.preloader&&(t.preloader=S("preloader",t.container,t.st.tLoading));var u=e.magnificPopup.modules;for(o=0;u.length>o;o++){var c=u[o];c=c.charAt(0).toUpperCase()+c.slice(1),t["init"+c].call(t)}E("BeforeOpen"),t.st.showCloseBtn&&(t.st.closeBtnInside?(_(f,function(e,t,n,i){n.close_replaceWith=T(i.type)}),s+=" mfp-close-btn-in"):t.wrap.append(T())),t.st.alignTop&&(s+=" mfp-align-top"),t.fixedContentPos?t.wrap.css({overflow:t.st.overflowY,overflowX:"hidden",overflowY:t.st.overflowY}):t.wrap.css({top:C.scrollTop(),position:"absolute"}),(t.st.fixedBgPos===!1||"auto"===t.st.fixedBgPos&&!t.fixedContentPos)&&t.bgOverlay.css({height:r.height(),position:"absolute"}),t.st.enableEscapeKey&&r.on("keyup"+g,function(e){27===e.keyCode&&t.close()}),C.on("resize"+g,function(){t.updateSize()}),t.st.closeOnContentClick||(s+=" mfp-auto-cursor"),s&&t.wrap.addClass(s);var d=t.wH=C.height(),p={};if(t.fixedContentPos&&t._hasScrollBar(d)){var m=t._getScrollbarSize();m&&(p.marginRight=m)}t.fixedContentPos&&(t.isIE7?e("body, html").css("overflow","hidden"):p.overflow="hidden");var y=t.st.mainClass;return t.isIE7&&(y+=" mfp-ie7"),y&&t._addClassToMFP(y),t.updateItemHTML(),E("BuildControls"),e("html").css(p),t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo||i),t._lastFocusedEl=document.activeElement,setTimeout(function(){t.content?(t._addClassToMFP(v),t._setFocus()):t.bgOverlay.addClass(v),r.on("focusin"+g,t._onFocusIn)},16),t.isOpen=!0,t.updateSize(d),E(h),n},close:function(){t.isOpen&&(E(u),t.isOpen=!1,t.st.removalDelay&&!t.isLowIE&&t.supportsTransition?(t._addClassToMFP(y),setTimeout(function(){t._close()},t.st.removalDelay)):t._close())},_close:function(){E(l);var n=y+" "+v+" ";if(t.bgOverlay.detach(),t.wrap.detach(),t.container.empty(),t.st.mainClass&&(n+=t.st.mainClass+" "),t._removeClassFromMFP(n),t.fixedContentPos){var i={marginRight:""};t.isIE7?e("body, html").css("overflow",""):i.overflow="",e("html").css(i)}r.off("keyup"+g+" focusin"+g),t.ev.off(g),t.wrap.attr("class","mfp-wrap").removeAttr("style"),t.bgOverlay.attr("class","mfp-bg"),t.container.attr("class","mfp-container"),!t.st.showCloseBtn||t.st.closeBtnInside&&t.currTemplate[t.currItem.type]!==!0||t.currTemplate.closeBtn&&t.currTemplate.closeBtn.detach(),t._lastFocusedEl&&e(t._lastFocusedEl).focus(),t.currItem=null,t.content=null,t.currTemplate=null,t.prevHeight=0,E(c)},updateSize:function(e){if(t.isIOS){var n=document.documentElement.clientWidth/window.innerWidth,i=window.innerHeight*n;t.wrap.css("height",i),t.wH=i}else t.wH=e||C.height();t.fixedContentPos||t.wrap.css("height",t.wH),E("Resize")},updateItemHTML:function(){var n=t.items[t.index];t.contentContainer.detach(),t.content&&t.content.detach(),n.parsed||(n=t.parseEl(t.index));var i=n.type;if(E("BeforeChange",[t.currItem?t.currItem.type:"",i]),t.currItem=n,!t.currTemplate[i]){var r=!!t.st[i]&&t.st[i].markup;E("FirstMarkupParse",r),t.currTemplate[i]=!r||e(r)}o&&o!==n.type&&t.container.removeClass("mfp-"+o+"-holder");var s=t["get"+i.charAt(0).toUpperCase()+i.slice(1)](n,t.currTemplate[i]);t.appendContent(s,i),n.preloaded=!0,E(p,n),o=n.type,t.container.prepend(t.contentContainer),E("AfterChange")},appendContent:function(e,n){t.content=e,e?t.st.showCloseBtn&&t.st.closeBtnInside&&t.currTemplate[n]===!0?t.content.find(".mfp-close").length||t.content.append(T()):t.content=e:t.content="",E(d),t.container.addClass("mfp-"+n+"-holder"),t.contentContainer.append(t.content)},parseEl:function(n){var i,r=t.items[n];if(r.tagName?r={el:e(r)}:(i=r.type,r={data:r,src:r.src}),r.el){for(var o=t.types,s=0;o.length>s;s++)if(r.el.hasClass("mfp-"+o[s])){i=o[s];break}r.src=r.el.attr("data-mfp-src"),r.src||(r.src=r.el.attr("href"))}return r.type=i||t.st.type||"inline",r.index=n,r.parsed=!0,t.items[n]=r,E("ElementParse",r),t.items[n]},addGroup:function(e,n){var i=function(i){i.mfpEl=this,t._openClick(i,e,n)};n||(n={});var r="click.magnificPopup";n.mainEl=e,n.items?(n.isObj=!0,e.off(r).on(r,i)):(n.isObj=!1,n.delegate?e.off(r).on(r,n.delegate,i):(n.items=e,e.off(r).on(r,i)))},_openClick:function(n,i,r){var o=void 0!==r.midClick?r.midClick:e.magnificPopup.defaults.midClick;if(o||2!==n.which&&!n.ctrlKey&&!n.metaKey){var s=void 0!==r.disableOn?r.disableOn:e.magnificPopup.defaults.disableOn;if(s)if(e.isFunction(s)){if(!s.call(t))return!0}else if(s>C.width())return!0;n.type&&(n.preventDefault(),t.isOpen&&n.stopPropagation()),r.el=e(n.mfpEl),r.delegate&&(r.items=i.find(r.delegate)),t.open(r)}},updateStatus:function(e,i){if(t.preloader){n!==e&&t.container.removeClass("mfp-s-"+n),i||"loading"!==e||(i=t.st.tLoading);var r={status:e,text:i};E("UpdateStatus",r),e=r.status,i=r.text,t.preloader.html(i),t.preloader.find("a").on("click",function(e){e.stopImmediatePropagation()}),t.container.addClass("mfp-s-"+e),n=e}},_checkIfClose:function(n){if(!e(n).hasClass(b)){var i=t.st.closeOnContentClick,r=t.st.closeOnBgClick;if(i&&r)return!0;if(!t.content||e(n).hasClass("mfp-close")||t.preloader&&n===t.preloader[0])return!0;if(n===t.content[0]||e.contains(t.content[0],n)){if(i)return!0}else if(r&&e.contains(document,n))return!0;return!1}},_addClassToMFP:function(e){t.bgOverlay.addClass(e),t.wrap.addClass(e)},_removeClassFromMFP:function(e){this.bgOverlay.removeClass(e),t.wrap.removeClass(e)},_hasScrollBar:function(e){return(t.isIE7?r.height():document.body.scrollHeight)>(e||C.height())},_setFocus:function(){(t.st.focus?t.content.find(t.st.focus).eq(0):t.wrap).focus()},_onFocusIn:function(n){return n.target===t.wrap[0]||e.contains(t.wrap[0],n.target)?void 0:(t._setFocus(),!1)},_parseMarkup:function(t,n,i){var r;i.data&&(n=e.extend(i.data,n)),E(f,[t,n,i]),e.each(n,function(e,n){if(void 0===n||n===!1)return!0;if(r=e.split("_"),r.length>1){var i=t.find(g+"-"+r[0]);if(i.length>0){var o=r[1];"replaceWith"===o?i[0]!==n[0]&&i.replaceWith(n):"img"===o?i.is("img")?i.attr("src",n):i.replaceWith('<img src="'+n+'" class="'+i.attr("class")+'" />'):i.attr(r[1],n)}}else t.find(g+"-"+e).html(n)})},_getScrollbarSize:function(){if(void 0===t.scrollbarSize){var e=document.createElement("div");e.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(e),t.scrollbarSize=e.offsetWidth-e.clientWidth,document.body.removeChild(e)}return t.scrollbarSize}},e.magnificPopup={instance:null,proto:w.prototype,modules:[],open:function(t,n){return k(),t=t?e.extend(!0,{},t):{},t.isObj=!0,t.index=n||0,this.instance.open(t)},close:function(){return e.magnificPopup.instance&&e.magnificPopup.instance.close()},registerModule:function(t,n){n.options&&(e.magnificPopup.defaults[t]=n.options),e.extend(this.proto,n.proto),this.modules.push(t)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&times;</button>',tClose:"Close (Esc)",tLoading:"Loading..."}},e.fn.magnificPopup=function(n){k();var i=e(this);if("string"==typeof n)if("open"===n){var r,o=x?i.data("magnificPopup"):i[0].magnificPopup,s=parseInt(arguments[1],10)||0;o.items?r=o.items[s]:(r=i,o.delegate&&(r=r.find(o.delegate)),r=r.eq(s)),t._openClick({mfpEl:r},i,o)}else t.isOpen&&t[n].apply(t,Array.prototype.slice.call(arguments,1));else n=e.extend(!0,{},n),x?i.data("magnificPopup",n):i[0].magnificPopup=n,t.addGroup(i,n);return i};var I,D,z,L="inline",P=function(){z&&(D.after(z.addClass(I)).detach(),z=null)};e.magnificPopup.registerModule(L,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){t.types.push(L),_(l+"."+L,function(){P()})},getInline:function(n,i){if(P(),n.src){var r=t.st.inline,o=e(n.src);if(o.length){var s=o[0].parentNode;s&&s.tagName&&(D||(I=r.hiddenClass,D=S(I),I="mfp-"+I),z=o.after(D).detach().removeClass(I)),t.updateStatus("ready")}else t.updateStatus("error",r.tNotFound),o=e("<div>");return n.inlineElement=o,o}return t.updateStatus("ready"),t._parseMarkup(i,{},n),i}}});var j,N="ajax",O=function(){j&&i.removeClass(j)},M=function(){O(),t.req&&t.req.abort()};e.magnificPopup.registerModule(N,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){t.types.push(N),j=t.st.ajax.cursor,_(l+"."+N,M),_("BeforeChange."+N,M)},getAjax:function(n){j&&i.addClass(j),t.updateStatus("loading");var r=e.extend({url:n.src,success:function(i,r,o){var s={data:i,xhr:o};E("ParseAjax",s),t.appendContent(e(s.data),N),n.finished=!0,O(),t._setFocus(),setTimeout(function(){t.wrap.addClass(v)},16),t.updateStatus("ready"),E("AjaxContentAdded")},error:function(){O(),n.finished=n.loadError=!0,t.updateStatus("error",t.st.ajax.tError.replace("%url%",n.src))}},t.st.ajax.settings);return t.req=e.ajax(r),""}}});var F,q=function(n){if(n.data&&void 0!==n.data.title)return n.data.title;var i=t.st.image.titleSrc;if(i){if(e.isFunction(i))return i.call(t,n);if(n.el)return n.el.attr(i)||""}return""};e.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var e=t.st.image,n=".image";t.types.push("image"),_(h+n,function(){"image"===t.currItem.type&&e.cursor&&i.addClass(e.cursor)}),_(l+n,function(){e.cursor&&i.removeClass(e.cursor),C.off("resize"+g)}),_("Resize"+n,t.resizeImage),t.isLowIE&&_("AfterChange",t.resizeImage)},resizeImage:function(){var e=t.currItem;if(e&&e.img&&t.st.image.verticalFit){var n=0;t.isLowIE&&(n=parseInt(e.img.css("padding-top"),10)+parseInt(e.img.css("padding-bottom"),10)),e.img.css("max-height",t.wH-n)}},_onImageHasSize:function(e){e.img&&(e.hasSize=!0,F&&clearInterval(F),e.isCheckingImgSize=!1,E("ImageHasSize",e),e.imgHidden&&(t.content&&t.content.removeClass("mfp-loading"),e.imgHidden=!1))},findImageSize:function(e){var n=0,i=e.img[0],r=function(o){F&&clearInterval(F),F=setInterval(function(){return i.naturalWidth>0?void t._onImageHasSize(e):(n>200&&clearInterval(F),n++,void(3===n?r(10):40===n?r(50):100===n&&r(500)))},o)};r(1)},getImage:function(n,i){var r=0,o=function(){n&&(n.img[0].complete?(n.img.off(".mfploader"),n===t.currItem&&(t._onImageHasSize(n),t.updateStatus("ready")),n.hasSize=!0,n.loaded=!0,E("ImageLoadComplete")):(r++,200>r?setTimeout(o,100):s()))},s=function(){n&&(n.img.off(".mfploader"),n===t.currItem&&(t._onImageHasSize(n),t.updateStatus("error",a.tError.replace("%url%",n.src))),n.hasSize=!0,n.loaded=!0,n.loadError=!0)},a=t.st.image,l=i.find(".mfp-img");if(l.length){var u=document.createElement("img");u.className="mfp-img",n.el&&n.el.find("img").length&&(u.alt=n.el.find("img").attr("alt")),n.img=e(u).on("load.mfploader",o).on("error.mfploader",s),u.src=n.src,l.is("img")&&(n.img=n.img.clone()),u=n.img[0],u.naturalWidth>0?n.hasSize=!0:u.width||(n.hasSize=!1)}return t._parseMarkup(i,{title:q(n),img_replaceWith:n.img},n),t.resizeImage(),n.hasSize?(F&&clearInterval(F),n.loadError?(i.addClass("mfp-loading"),t.updateStatus("error",a.tError.replace("%url%",n.src))):(i.removeClass("mfp-loading"),t.updateStatus("ready")),i):(t.updateStatus("loading"),n.loading=!0,n.hasSize||(n.imgHidden=!0,i.addClass("mfp-loading"),t.findImageSize(n)),i)}}});var B,H=function(){return void 0===B&&(B=void 0!==document.createElement("p").style.MozTransform),B};e.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(e){return e.is("img")?e:e.find("img")}},proto:{initZoom:function(){var e,n=t.st.zoom,i=".zoom";if(n.enabled&&t.supportsTransition){var r,o,s=n.duration,a=function(e){var t=e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),i="all "+n.duration/1e3+"s "+n.easing,r={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},o="transition";return r["-webkit-"+o]=r["-moz-"+o]=r["-o-"+o]=r[o]=i,t.css(r),t},c=function(){t.content.css("visibility","visible")};_("BuildControls"+i,function(){if(t._allowZoom()){if(clearTimeout(r),t.content.css("visibility","hidden"),e=t._getItemToZoom(),!e)return void c();o=a(e),o.css(t._getOffset()),t.wrap.append(o),r=setTimeout(function(){o.css(t._getOffset(!0)),r=setTimeout(function(){c(),setTimeout(function(){o.remove(),e=o=null,E("ZoomAnimationEnded")},16)},s)},16)}}),_(u+i,function(){if(t._allowZoom()){if(clearTimeout(r),t.st.removalDelay=s,!e){if(e=t._getItemToZoom(),!e)return;o=a(e)}o.css(t._getOffset(!0)),t.wrap.append(o),t.content.css("visibility","hidden"),setTimeout(function(){o.css(t._getOffset())},16)}}),_(l+i,function(){t._allowZoom()&&(c(),o&&o.remove(),e=null)})}},_allowZoom:function(){return"image"===t.currItem.type},_getItemToZoom:function(){return!!t.currItem.hasSize&&t.currItem.img},_getOffset:function(n){var i;i=n?t.currItem.img:t.st.zoom.opener(t.currItem.el||t.currItem);var r=i.offset(),o=parseInt(i.css("padding-top"),10),s=parseInt(i.css("padding-bottom"),10);r.top-=e(window).scrollTop()-o;var a={width:i.width(),height:(x?i.innerHeight():i[0].offsetHeight)-s-o};return H()?a["-moz-transform"]=a.transform="translate("+r.left+"px,"+r.top+"px)":(a.left=r.left,a.top=r.top),a}}});var R="iframe",W="//about:blank",$=function(e){if(t.currTemplate[R]){var n=t.currTemplate[R].find("iframe");n.length&&(e||(n[0].src=W),t.isIE8&&n.css("display",e?"block":"none"))}};e.magnificPopup.registerModule(R,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){t.types.push(R),_("BeforeChange",function(e,t,n){t!==n&&(t===R?$():n===R&&$(!0))}),_(l+"."+R,function(){$()})},getIframe:function(n,i){var r=n.src,o=t.st.iframe;e.each(o.patterns,function(){return r.indexOf(this.index)>-1?(this.id&&(r="string"==typeof this.id?r.substr(r.lastIndexOf(this.id)+this.id.length,r.length):this.id.call(this,r)),r=this.src.replace("%id%",r),!1):void 0});var s={};return o.srcAction&&(s[o.srcAction]=r),t._parseMarkup(i,s,n),t.updateStatus("ready"),i}}});var U=function(e){var n=t.items.length;return e>n-1?e-n:0>e?n+e:e},V=function(e,t,n){return e.replace(/%curr%/gi,t+1).replace(/%total%/gi,n)};e.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var n=t.st.gallery,i=".mfp-gallery",o=Boolean(e.fn.mfpFastClick);return t.direction=!0,!(!n||!n.enabled)&&(s+=" mfp-gallery",_(h+i,function(){n.navigateByImgClick&&t.wrap.on("click"+i,".mfp-img",function(){return t.items.length>1?(t.next(),!1):void 0}),r.on("keydown"+i,function(e){37===e.keyCode?t.prev():39===e.keyCode&&t.next()})}),_("UpdateStatus"+i,function(e,n){n.text&&(n.text=V(n.text,t.currItem.index,t.items.length))}),_(f+i,function(e,i,r,o){var s=t.items.length;r.counter=s>1?V(n.tCounter,o.index,s):""}),_("BuildControls"+i,function(){if(t.items.length>1&&n.arrows&&!t.arrowLeft){var i=n.arrowMarkup,r=t.arrowLeft=e(i.replace(/%title%/gi,n.tPrev).replace(/%dir%/gi,"left")).addClass(b),s=t.arrowRight=e(i.replace(/%title%/gi,n.tNext).replace(/%dir%/gi,"right")).addClass(b),a=o?"mfpFastClick":"click";r[a](function(){t.prev()}),s[a](function(){t.next()}),t.isIE7&&(S("b",r[0],!1,!0),S("a",r[0],!1,!0),S("b",s[0],!1,!0),S("a",s[0],!1,!0)),t.container.append(r.add(s))}}),_(p+i,function(){t._preloadTimeout&&clearTimeout(t._preloadTimeout),t._preloadTimeout=setTimeout(function(){t.preloadNearbyImages(),t._preloadTimeout=null},16)}),void _(l+i,function(){r.off(i),t.wrap.off("click"+i),t.arrowLeft&&o&&t.arrowLeft.add(t.arrowRight).destroyMfpFastClick(),t.arrowRight=t.arrowLeft=null}))},next:function(){t.direction=!0,t.index=U(t.index+1),t.updateItemHTML()},prev:function(){t.direction=!1,t.index=U(t.index-1),t.updateItemHTML()},goTo:function(e){t.direction=e>=t.index,t.index=e,t.updateItemHTML()},preloadNearbyImages:function(){var e,n=t.st.gallery.preload,i=Math.min(n[0],t.items.length),r=Math.min(n[1],t.items.length);for(e=1;(t.direction?r:i)>=e;e++)t._preloadItem(t.index+e);for(e=1;(t.direction?i:r)>=e;e++)t._preloadItem(t.index-e)},_preloadItem:function(n){if(n=U(n),!t.items[n].preloaded){var i=t.items[n];i.parsed||(i=t.parseEl(n)),E("LazyLoad",i),"image"===i.type&&(i.img=e('<img class="mfp-img" />').on("load.mfploader",function(){i.hasSize=!0}).on("error.mfploader",function(){i.hasSize=!0,i.loadError=!0,E("LazyLoadError",i)}).attr("src",i.src)),i.preloaded=!0}}}});var Q="retina";e.magnificPopup.registerModule(Q,{options:{replaceSrc:function(e){return e.src.replace(/\.\w+$/,function(e){return"@2x"+e})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var e=t.st.retina,n=e.ratio;n=isNaN(n)?n():n,n>1&&(_("ImageHasSize."+Q,function(e,t){t.img.css({"max-width":t.img[0].naturalWidth/n,width:"100%"})}),_("ElementParse."+Q,function(t,i){i.src=e.replaceSrc(i,n)}))}}}}),function(){var t=1e3,n="ontouchstart"in window,i=function(){C.off("touchmove"+o+" touchend"+o)},r="mfpFastClick",o="."+r;e.fn.mfpFastClick=function(r){return e(this).each(function(){var s,a=e(this);if(n){var l,u,c,d,f,h;a.on("touchstart"+o,function(e){d=!1,h=1,f=e.originalEvent?e.originalEvent.touches[0]:e.touches[0],u=f.clientX,c=f.clientY,C.on("touchmove"+o,function(e){f=e.originalEvent?e.originalEvent.touches:e.touches,h=f.length,f=f[0],(Math.abs(f.clientX-u)>10||Math.abs(f.clientY-c)>10)&&(d=!0,i())}).on("touchend"+o,function(e){i(),d||h>1||(s=!0,e.preventDefault(),clearTimeout(l),l=setTimeout(function(){s=!1},t),r())})})}a.on("click"+o,function(){s||r()})})},e.fn.destroyMfpFastClick=function(){e(this).off("touchstart"+o+" click"+o),n&&C.off("touchmove"+o+" touchend"+o)}}(),k()}),/*!
   * jquery.easing.js
   */
/*
   * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
   *
   * Uses the built in easing capabilities added In jQuery 1.1
   * to offer multiple easing options
   *
   * TERMS OF USE - jQuery Easing
   *
   * Open source under the BSD License.
   *
   * Copyright 2008 George McGinley Smith
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without modification,
   * are permitted provided that the following conditions are met:
   *
   * Redistributions of source code must retain the above copyright notice, this list of
   * conditions and the following disclaimer.
   * Redistributions in binary form must reproduce the above copyright notice, this list
   * of conditions and the following disclaimer in the documentation and/or other materials
   * provided with the distribution.
   *
   * Neither the name of the author nor the names of contributors may be used to endorse
   * or promote products derived from this software without specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
   * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
   * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
   * GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
   * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
   * OF THE POSSIBILITY OF SUCH DAMAGE.
   *
  */
e.easing.jswing=e.easing.swing,e.extend(e.easing,{def:"easeOutQuad",swing:function(t,n,i,r,o){return e.easing[e.easing.def](t,n,i,r,o)},easeInQuad:function(e,t,n,i,r){return i*(t/=r)*t+n},easeOutQuad:function(e,t,n,i,r){return-i*(t/=r)*(t-2)+n},easeInOutQuad:function(e,t,n,i,r){return(t/=r/2)<1?i/2*t*t+n:-i/2*(--t*(t-2)-1)+n},easeInCubic:function(e,t,n,i,r){return i*(t/=r)*t*t+n},easeOutCubic:function(e,t,n,i,r){return i*((t=t/r-1)*t*t+1)+n},easeInOutCubic:function(e,t,n,i,r){return(t/=r/2)<1?i/2*t*t*t+n:i/2*((t-=2)*t*t+2)+n},easeInQuart:function(e,t,n,i,r){return i*(t/=r)*t*t*t+n},easeOutQuart:function(e,t,n,i,r){return-i*((t=t/r-1)*t*t*t-1)+n},easeInOutQuart:function(e,t,n,i,r){return(t/=r/2)<1?i/2*t*t*t*t+n:-i/2*((t-=2)*t*t*t-2)+n},easeInQuint:function(e,t,n,i,r){return i*(t/=r)*t*t*t*t+n},easeOutQuint:function(e,t,n,i,r){return i*((t=t/r-1)*t*t*t*t+1)+n},easeInOutQuint:function(e,t,n,i,r){return(t/=r/2)<1?i/2*t*t*t*t*t+n:i/2*((t-=2)*t*t*t*t+2)+n},easeInSine:function(e,t,n,i,r){return-i*Math.cos(t/r*(Math.PI/2))+i+n},easeOutSine:function(e,t,n,i,r){return i*Math.sin(t/r*(Math.PI/2))+n},easeInOutSine:function(e,t,n,i,r){return-i/2*(Math.cos(Math.PI*t/r)-1)+n},easeInExpo:function(e,t,n,i,r){return 0==t?n:i*Math.pow(2,10*(t/r-1))+n},easeOutExpo:function(e,t,n,i,r){return t==r?n+i:i*(-Math.pow(2,-10*t/r)+1)+n},easeInOutExpo:function(e,t,n,i,r){return 0==t?n:t==r?n+i:(t/=r/2)<1?i/2*Math.pow(2,10*(t-1))+n:i/2*(-Math.pow(2,-10*--t)+2)+n},easeInCirc:function(e,t,n,i,r){return-i*(Math.sqrt(1-(t/=r)*t)-1)+n},easeOutCirc:function(e,t,n,i,r){return i*Math.sqrt(1-(t=t/r-1)*t)+n},easeInOutCirc:function(e,t,n,i,r){return(t/=r/2)<1?-i/2*(Math.sqrt(1-t*t)-1)+n:i/2*(Math.sqrt(1-(t-=2)*t)+1)+n},easeInElastic:function(e,t,n,i,r){var o=1.70158,s=0,a=i;if(0==t)return n;if(1==(t/=r))return n+i;if(s||(s=.3*r),a<Math.abs(i)){a=i;var o=s/4}else var o=s/(2*Math.PI)*Math.asin(i/a);return-(a*Math.pow(2,10*(t-=1))*Math.sin((t*r-o)*(2*Math.PI)/s))+n},easeOutElastic:function(e,t,n,i,r){var o=1.70158,s=0,a=i;if(0==t)return n;if(1==(t/=r))return n+i;if(s||(s=.3*r),a<Math.abs(i)){a=i;var o=s/4}else var o=s/(2*Math.PI)*Math.asin(i/a);return a*Math.pow(2,-10*t)*Math.sin((t*r-o)*(2*Math.PI)/s)+i+n},easeInOutElastic:function(e,t,n,i,r){var o=1.70158,s=0,a=i;if(0==t)return n;if(2==(t/=r/2))return n+i;if(s||(s=r*(.3*1.5)),a<Math.abs(i)){a=i;var o=s/4}else var o=s/(2*Math.PI)*Math.asin(i/a);return t<1?-.5*(a*Math.pow(2,10*(t-=1))*Math.sin((t*r-o)*(2*Math.PI)/s))+n:a*Math.pow(2,-10*(t-=1))*Math.sin((t*r-o)*(2*Math.PI)/s)*.5+i+n},easeInBack:function(e,t,n,i,r,o){return void 0==o&&(o=1.70158),i*(t/=r)*t*((o+1)*t-o)+n},easeOutBack:function(e,t,n,i,r,o){return void 0==o&&(o=1.70158),i*((t=t/r-1)*t*((o+1)*t+o)+1)+n},easeInOutBack:function(e,t,n,i,r,o){return void 0==o&&(o=1.70158),(t/=r/2)<1?i/2*(t*t*(((o*=1.525)+1)*t-o))+n:i/2*((t-=2)*t*(((o*=1.525)+1)*t+o)+2)+n},easeInBounce:function(t,n,i,r,o){return r-e.easing.easeOutBounce(t,o-n,0,r,o)+i},easeOutBounce:function(e,t,n,i,r){return(t/=r)<1/2.75?i*(7.5625*t*t)+n:t<2/2.75?i*(7.5625*(t-=1.5/2.75)*t+.75)+n:t<2.5/2.75?i*(7.5625*(t-=2.25/2.75)*t+.9375)+n:i*(7.5625*(t-=2.625/2.75)*t+.984375)+n},easeInOutBounce:function(t,n,i,r,o){return n<o/2?.5*e.easing.easeInBounce(t,2*n,0,r,o)+i:.5*e.easing.easeOutBounce(t,2*n-o,0,r,o)+.5*r+i}}),/*
   *
   * TERMS OF USE - EASING EQUATIONS
   *
   * Open source under the BSD License.
   *
   * Copyright 2001 Robert Penner
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without modification,
   * are permitted provided that the following conditions are met:
   *
   * Redistributions of source code must retain the above copyright notice, this list of
   * conditions and the following disclaimer.
   * Redistributions in binary form must reproduce the above copyright notice, this list
   * of conditions and the following disclaimer in the documentation and/or other materials
   * provided with the distribution.
   *
   * Neither the name of the author nor the names of contributors may be used to endorse
   * or promote products derived from this software without specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
   * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
   * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
   * GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
   * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
   * OF THE POSSIBILITY OF SUCH DAMAGE.
   *
   */
/*!
   * flickity.js
   */
/*!
   * Flickity PACKAGED v2.1.2
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * or Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2018 Metafizzy
   */
/**
   * Bridget makes jQuery widgets
   * v2.0.1
   * MIT license
   */
function(e,t){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(n){return t(e,n)}):"object"==typeof module&&module.exports?module.exports=t(e,require("jquery")):e.jQueryBridget=t(e,e.jQuery)}(window,function(e,t){"use strict";function n(n,o,a){function l(e,t,i){var r,o="$()."+n+'("'+t+'")';return e.each(function(e,l){var u=a.data(l,n);if(!u)return void s(n+" not initialized. Cannot call methods, i.e. "+o);var c=u[t];if(!c||"_"==t.charAt(0))return void s(o+" is not a valid method");var d=c.apply(u,i);r=void 0===r?d:r}),void 0!==r?r:e}function u(e,t){e.each(function(e,i){var r=a.data(i,n);r?(r.option(t),r._init()):(r=new o(i,t),a.data(i,n,r))})}a=a||t||e.jQuery,a&&(o.prototype.option||(o.prototype.option=function(e){a.isPlainObject(e)&&(this.options=a.extend(!0,this.options,e))}),a.fn[n]=function(e){if("string"==typeof e){var t=r.call(arguments,1);return l(this,e,t)}return u(this,e),this},i(a))}function i(e){!e||e&&e.bridget||(e.bridget=n)}var r=Array.prototype.slice,o=e.console,s="undefined"==typeof o?function(){}:function(e){o.error(e)};return i(t||e.jQuery),n}),/**
   * EvEmitter v1.1.0
   * Lil' event emitter
   * MIT License
   */
function(e,t){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",t):"object"==typeof module&&module.exports?module.exports=t():e.EvEmitter=t()}("undefined"!=typeof window?window:this,function(){function e(){}var t=e.prototype;return t.on=function(e,t){if(e&&t){var n=this._events=this._events||{},i=n[e]=n[e]||[];return i.indexOf(t)==-1&&i.push(t),this}},t.once=function(e,t){if(e&&t){this.on(e,t);var n=this._onceEvents=this._onceEvents||{},i=n[e]=n[e]||{};return i[t]=!0,this}},t.off=function(e,t){var n=this._events&&this._events[e];if(n&&n.length){var i=n.indexOf(t);return i!=-1&&n.splice(i,1),this}},t.emitEvent=function(e,t){var n=this._events&&this._events[e];if(n&&n.length){n=n.slice(0),t=t||[];for(var i=this._onceEvents&&this._onceEvents[e],r=0;r<n.length;r++){var o=n[r],s=i&&i[o];s&&(this.off(e,o),delete i[o]),o.apply(this,t)}return this}},t.allOff=function(){delete this._events,delete this._onceEvents},e}),/*!
   * getSize v2.0.3
   * measure size of elements
   * MIT license
   */
function(e,t){"function"==typeof define&&define.amd?define("get-size/get-size",t):"object"==typeof module&&module.exports?module.exports=t():e.getSize=t()}(window,function(){"use strict";function e(e){var t=parseFloat(e),n=e.indexOf("%")==-1&&!isNaN(t);return n&&t}function t(){}function n(){for(var e={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},t=0;t<u;t++){var n=l[t];e[n]=0}return e}function i(e){var t=getComputedStyle(e);return t||a("Style returned "+t+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),t}function r(){if(!c){c=!0;var t=document.createElement("div");t.style.width="200px",t.style.padding="1px 2px 3px 4px",t.style.borderStyle="solid",t.style.borderWidth="1px 2px 3px 4px",t.style.boxSizing="border-box";var n=document.body||document.documentElement;n.appendChild(t);var r=i(t);s=200==Math.round(e(r.width)),o.isBoxSizeOuter=s,n.removeChild(t)}}function o(t){if(r(),"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var o=i(t);if("none"==o.display)return n();var a={};a.width=t.offsetWidth,a.height=t.offsetHeight;for(var c=a.isBorderBox="border-box"==o.boxSizing,d=0;d<u;d++){var f=l[d],h=o[f],p=parseFloat(h);a[f]=isNaN(p)?0:p}var m=a.paddingLeft+a.paddingRight,g=a.paddingTop+a.paddingBottom,v=a.marginLeft+a.marginRight,y=a.marginTop+a.marginBottom,b=a.borderLeftWidth+a.borderRightWidth,w=a.borderTopWidth+a.borderBottomWidth,x=c&&s,C=e(o.width);C!==!1&&(a.width=C+(x?0:m+b));var _=e(o.height);return _!==!1&&(a.height=_+(x?0:g+w)),a.innerWidth=a.width-(m+b),a.innerHeight=a.height-(g+w),a.outerWidth=a.width+v,a.outerHeight=a.height+y,a}}var s,a="undefined"==typeof console?t:function(e){console.error(e)},l=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],u=l.length,c=!1;return o}),/**
   * matchesSelector v2.0.2
   * matchesSelector( element, '.selector' )
   * MIT license
   */
function(e,t){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",t):"object"==typeof module&&module.exports?module.exports=t():e.matchesSelector=t()}(window,function(){"use strict";var e=function(){var e=window.Element.prototype;if(e.matches)return"matches";if(e.matchesSelector)return"matchesSelector";for(var t=["webkit","moz","ms","o"],n=0;n<t.length;n++){var i=t[n],r=i+"MatchesSelector";if(e[r])return r}}();return function(t,n){return t[e](n)}}),/**
   * Fizzy UI utils v2.0.7
   * MIT license
   */
function(e,t){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(n){return t(e,n)}):"object"==typeof module&&module.exports?module.exports=t(e,require("desandro-matches-selector")):e.fizzyUIUtils=t(e,e.matchesSelector)}(window,function(e,t){var n={};n.extend=function(e,t){for(var n in t)e[n]=t[n];return e},n.modulo=function(e,t){return(e%t+t)%t};var i=Array.prototype.slice;n.makeArray=function(e){if(Array.isArray(e))return e;if(null===e||void 0===e)return[];var t="object"==typeof e&&"number"==typeof e.length;return t?i.call(e):[e]},n.removeFrom=function(e,t){var n=e.indexOf(t);n!=-1&&e.splice(n,1)},n.getParent=function(e,n){for(;e.parentNode&&e!=document.body;)if(e=e.parentNode,t(e,n))return e},n.getQueryElement=function(e){return"string"==typeof e?document.querySelector(e):e},n.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},n.filterFindElements=function(e,i){e=n.makeArray(e);var r=[];return e.forEach(function(e){if(e instanceof HTMLElement){if(!i)return void r.push(e);t(e,i)&&r.push(e);for(var n=e.querySelectorAll(i),o=0;o<n.length;o++)r.push(n[o])}}),r},n.debounceMethod=function(e,t,n){n=n||100;var i=e.prototype[t],r=t+"Timeout";e.prototype[t]=function(){var e=this[r];clearTimeout(e);var t=arguments,o=this;this[r]=setTimeout(function(){i.apply(o,t),delete o[r]},n)}},n.docReady=function(e){var t=document.readyState;"complete"==t||"interactive"==t?setTimeout(e):document.addEventListener("DOMContentLoaded",e)},n.toDashed=function(e){return e.replace(/(.)([A-Z])/g,function(e,t,n){return t+"-"+n}).toLowerCase()};var r=e.console;return n.htmlInit=function(t,i){n.docReady(function(){var o=n.toDashed(i),s="data-"+o,a=document.querySelectorAll("["+s+"]"),l=document.querySelectorAll(".js-"+o),u=n.makeArray(a).concat(n.makeArray(l)),c=s+"-options",d=e.jQuery;u.forEach(function(e){var n,o=e.getAttribute(s)||e.getAttribute(c);try{n=o&&JSON.parse(o)}catch(t){return void(r&&r.error("Error parsing "+s+" on "+e.className+": "+t))}var a=new t(e,n);d&&d.data(e,i,a)})})},n}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/cell",["get-size/get-size"],function(n){return t(e,n)}):"object"==typeof module&&module.exports?module.exports=t(e,require("get-size")):(e.Flickity=e.Flickity||{},e.Flickity.Cell=t(e,e.getSize))}(window,function(e,t){function n(e,t){this.element=e,this.parent=t,this.create()}var i=n.prototype;return i.create=function(){this.element.style.position="absolute",this.element.setAttribute("aria-selected","false"),this.x=0,this.shift=0},i.destroy=function(){this.element.style.position="";var e=this.parent.originSide;this.element.removeAttribute("aria-selected"),this.element.style[e]=""},i.getSize=function(){this.size=t(this.element)},i.setPosition=function(e){this.x=e,this.updateTarget(),this.renderPosition(e)},i.updateTarget=i.setDefaultTarget=function(){var e="left"==this.parent.originSide?"marginLeft":"marginRight";this.target=this.x+this.size[e]+this.size.width*this.parent.cellAlign},i.renderPosition=function(e){var t=this.parent.originSide;this.element.style[t]=this.parent.getPositionValue(e)},i.wrapShift=function(e){this.shift=e,this.renderPosition(this.x+this.parent.slideableWidth*e)},i.remove=function(){this.element.parentNode.removeChild(this.element)},n}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/slide",t):"object"==typeof module&&module.exports?module.exports=t():(e.Flickity=e.Flickity||{},e.Flickity.Slide=t())}(window,function(){"use strict";function e(e){this.parent=e,this.isOriginLeft="left"==e.originSide,this.cells=[],this.outerWidth=0,this.height=0}var t=e.prototype;return t.addCell=function(e){if(this.cells.push(e),this.outerWidth+=e.size.outerWidth,this.height=Math.max(e.size.outerHeight,this.height),1==this.cells.length){this.x=e.x;var t=this.isOriginLeft?"marginLeft":"marginRight";this.firstMargin=e.size[t]}},t.updateTarget=function(){var e=this.isOriginLeft?"marginRight":"marginLeft",t=this.getLastCell(),n=t?t.size[e]:0,i=this.outerWidth-(this.firstMargin+n);this.target=this.x+this.firstMargin+i*this.parent.cellAlign},t.getLastCell=function(){return this.cells[this.cells.length-1]},t.select=function(){this.changeSelected(!0)},t.unselect=function(){this.changeSelected(!1)},t.changeSelected=function(e){var t=e?"add":"remove";this.cells.forEach(function(n){n.element.classList[t]("is-selected"),n.element.setAttribute("aria-selected",e.toString())})},t.getCellElements=function(){return this.cells.map(function(e){return e.element})},e}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/animate",["fizzy-ui-utils/utils"],function(n){return t(e,n)}):"object"==typeof module&&module.exports?module.exports=t(e,require("fizzy-ui-utils")):(e.Flickity=e.Flickity||{},e.Flickity.animatePrototype=t(e,e.fizzyUIUtils))}(window,function(e,t){var n={};return n.startAnimation=function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},n.animate=function(){this.applyDragForce(),this.applySelectedAttraction();var e=this.x;if(this.integratePhysics(),this.positionSlider(),this.settle(e),this.isAnimating){var t=this;requestAnimationFrame(function(){t.animate()})}},n.positionSlider=function(){var e=this.x;this.options.wrapAround&&this.cells.length>1&&(e=t.modulo(e,this.slideableWidth),e-=this.slideableWidth,this.shiftWrapCells(e)),e+=this.cursorPosition,e=this.options.rightToLeft?-e:e;var n=this.getPositionValue(e);this.slider.style.transform=this.isAnimating?"translate3d("+n+",0,0)":"translateX("+n+")";var i=this.slides[0];if(i){var r=-this.x-i.target,o=r/this.slidesWidth;this.dispatchEvent("scroll",null,[o,r])}},n.positionSliderAtSelected=function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,this.positionSlider())},n.getPositionValue=function(e){return this.options.percentPosition?.01*Math.round(e/this.size.innerWidth*1e4)+"%":Math.round(e)+"px"},n.settle=function(e){this.isPointerDown||Math.round(100*this.x)!=Math.round(100*e)||this.restingFrames++,this.restingFrames>2&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent("settle",null,[this.selectedIndex]))},n.shiftWrapCells=function(e){var t=this.cursorPosition+e;this._shiftCells(this.beforeShiftCells,t,-1);var n=this.size.innerWidth-(e+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,n,1)},n._shiftCells=function(e,t,n){for(var i=0;i<e.length;i++){var r=e[i],o=t>0?n:0;r.wrapShift(o),t-=r.size.outerWidth}},n._unshiftCells=function(e){if(e&&e.length)for(var t=0;t<e.length;t++)e[t].wrapShift(0)},n.integratePhysics=function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},n.applyForce=function(e){this.velocity+=e},n.getFrictionFactor=function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},n.getRestingPosition=function(){return this.x+this.velocity/(1-this.getFrictionFactor())},n.applyDragForce=function(){if(this.isDraggable&&this.isPointerDown){var e=this.dragX-this.x,t=e-this.velocity;this.applyForce(t)}},n.applySelectedAttraction=function(){var e=this.isDraggable&&this.isPointerDown;if(!e&&!this.isFreeScrolling&&this.slides.length){var t=this.selectedSlide.target*-1-this.x,n=t*this.options.selectedAttraction;this.applyForce(n)}},n}),function(e,t){if("function"==typeof define&&define.amd)define("flickity/js/flickity",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./cell","./slide","./animate"],function(n,i,r,o,s,a){return t(e,n,i,r,o,s,a)});else if("object"==typeof module&&module.exports)module.exports=t(e,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./cell"),require("./slide"),require("./animate"));else{var n=e.Flickity;e.Flickity=t(e,e.EvEmitter,e.getSize,e.fizzyUIUtils,n.Cell,n.Slide,n.animatePrototype)}}(window,function(e,t,n,i,r,o,s){function a(e,t){for(e=i.makeArray(e);e.length;)t.appendChild(e.shift())}function l(e,t){var n=i.getQueryElement(e);if(!n)return void(d&&d.error("Bad element for Flickity: "+(n||e)));if(this.element=n,this.element.flickityGUID){var r=h[this.element.flickityGUID];return r.option(t),r}u&&(this.$element=u(this.element)),this.options=i.extend({},this.constructor.defaults),this.option(t),this._create()}var u=e.jQuery,c=e.getComputedStyle,d=e.console,f=0,h={};l.defaults={accessibility:!0,cellAlign:"center",freeScrollFriction:.075,friction:.28,namespaceJQueryEvents:!0,percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0},l.createMethods=[];var p=l.prototype;i.extend(p,t.prototype),p._create=function(){var t=this.guid=++f;this.element.flickityGUID=t,h[t]=this,this.selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.originSide=this.options.rightToLeft?"right":"left",this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),(this.options.resize||this.options.watchCSS)&&e.addEventListener("resize",this);for(var n in this.options.on){var i=this.options.on[n];this.on(n,i)}l.createMethods.forEach(function(e){this[e]()},this),this.options.watchCSS?this.watchCSS():this.activate()},p.option=function(e){i.extend(this.options,e)},p.activate=function(){if(!this.isActive){this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize();var e=this._filterFindCellElements(this.element.children);a(e,this.slider),this.viewport.appendChild(this.slider),this.element.appendChild(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener("keydown",this)),this.emitEvent("activate");var t,n=this.options.initialIndex;t=this.isInitActivated?this.selectedIndex:void 0!==n&&this.cells[n]?n:0,this.select(t,!1,!0),this.isInitActivated=!0,this.dispatchEvent("ready")}},p._createSlider=function(){var e=document.createElement("div");e.className="flickity-slider",e.style[this.originSide]=0,this.slider=e},p._filterFindCellElements=function(e){return i.filterFindElements(e,this.options.cellSelector)},p.reloadCells=function(){this.cells=this._makeCells(this.slider.children),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize()},p._makeCells=function(e){var t=this._filterFindCellElements(e),n=t.map(function(e){return new r(e,this)},this);return n},p.getLastCell=function(){return this.cells[this.cells.length-1]},p.getLastSlide=function(){return this.slides[this.slides.length-1]},p.positionCells=function(){this._sizeCells(this.cells),this._positionCells(0)},p._positionCells=function(e){e=e||0,this.maxCellHeight=e?this.maxCellHeight||0:0;var t=0;if(e>0){var n=this.cells[e-1];t=n.x+n.size.outerWidth}for(var i=this.cells.length,r=e;r<i;r++){var o=this.cells[r];o.setPosition(t),t+=o.size.outerWidth,this.maxCellHeight=Math.max(o.size.outerHeight,this.maxCellHeight)}this.slideableWidth=t,this.updateSlides(),this._containSlides(),this.slidesWidth=i?this.getLastSlide().target-this.slides[0].target:0},p._sizeCells=function(e){e.forEach(function(e){e.getSize()})},p.updateSlides=function(){if(this.slides=[],this.cells.length){var e=new o(this);this.slides.push(e);var t="left"==this.originSide,n=t?"marginRight":"marginLeft",i=this._getCanCellFit();this.cells.forEach(function(t,r){if(!e.cells.length)return void e.addCell(t);var s=e.outerWidth-e.firstMargin+(t.size.outerWidth-t.size[n]);i.call(this,r,s)?e.addCell(t):(e.updateTarget(),e=new o(this),this.slides.push(e),e.addCell(t))},this),e.updateTarget(),this.updateSelectedSlide()}},p._getCanCellFit=function(){var e=this.options.groupCells;if(!e)return function(){return!1};if("number"==typeof e){var t=parseInt(e,10);return function(e){return e%t!==0}}var n="string"==typeof e&&e.match(/^(\d+)%$/),i=n?parseInt(n[1],10)/100:1;return function(e,t){return t<=(this.size.innerWidth+1)*i}},p._init=p.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},p.getSize=function(){this.size=n(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};var m={center:{left:.5,right:.5},left:{left:0,right:1},right:{right:0,left:1}};return p.setCellAlign=function(){var e=m[this.options.cellAlign];this.cellAlign=e?e[this.originSide]:this.options.cellAlign},p.setGallerySize=function(){if(this.options.setGallerySize){var e=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=e+"px"}},p._getWrapShiftCells=function(){if(this.options.wrapAround){this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);var e=this.cursorPosition,t=this.cells.length-1;this.beforeShiftCells=this._getGapCells(e,t,-1),e=this.size.innerWidth-this.cursorPosition,this.afterShiftCells=this._getGapCells(e,0,1)}},p._getGapCells=function(e,t,n){for(var i=[];e>0;){var r=this.cells[t];if(!r)break;i.push(r),t+=n,e-=r.size.outerWidth}return i},p._containSlides=function(){if(this.options.contain&&!this.options.wrapAround&&this.cells.length){var e=this.options.rightToLeft,t=e?"marginRight":"marginLeft",n=e?"marginLeft":"marginRight",i=this.slideableWidth-this.getLastCell().size[n],r=i<this.size.innerWidth,o=this.cursorPosition+this.cells[0].size[t],s=i-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach(function(e){r?e.target=i*this.cellAlign:(e.target=Math.max(e.target,o),e.target=Math.min(e.target,s))},this)}},p.dispatchEvent=function(e,t,n){var i=t?[t].concat(n):n;if(this.emitEvent(e,i),u&&this.$element){e+=this.options.namespaceJQueryEvents?".flickity":"";var r=e;if(t){var o=u.Event(t);o.type=e,r=o}this.$element.trigger(r,n)}},p.select=function(e,t,n){if(this.isActive&&(e=parseInt(e,10),this._wrapSelect(e),(this.options.wrapAround||t)&&(e=i.modulo(e,this.slides.length)),this.slides[e])){var r=this.selectedIndex;this.selectedIndex=e,this.updateSelectedSlide(),n?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent("select",null,[e]),e!=r&&this.dispatchEvent("change",null,[e]),this.dispatchEvent("cellSelect")}},p._wrapSelect=function(e){var t=this.slides.length,n=this.options.wrapAround&&t>1;if(!n)return e;var r=i.modulo(e,t),o=Math.abs(r-this.selectedIndex),s=Math.abs(r+t-this.selectedIndex),a=Math.abs(r-t-this.selectedIndex);!this.isDragSelect&&s<o?e+=t:!this.isDragSelect&&a<o&&(e-=t),e<0?this.x-=this.slideableWidth:e>=t&&(this.x+=this.slideableWidth)},p.previous=function(e,t){this.select(this.selectedIndex-1,e,t)},p.next=function(e,t){this.select(this.selectedIndex+1,e,t)},p.updateSelectedSlide=function(){var e=this.slides[this.selectedIndex];e&&(this.unselectSelectedSlide(),this.selectedSlide=e,e.select(),this.selectedCells=e.cells,this.selectedElements=e.getCellElements(),this.selectedCell=e.cells[0],this.selectedElement=this.selectedElements[0])},p.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},p.selectCell=function(e,t,n){var i=this.queryCell(e);if(i){var r=this.getCellSlideIndex(i);this.select(r,t,n)}},p.getCellSlideIndex=function(e){for(var t=0;t<this.slides.length;t++){var n=this.slides[t],i=n.cells.indexOf(e);if(i!=-1)return t}},p.getCell=function(e){for(var t=0;t<this.cells.length;t++){var n=this.cells[t];if(n.element==e)return n}},p.getCells=function(e){e=i.makeArray(e);var t=[];return e.forEach(function(e){var n=this.getCell(e);n&&t.push(n)},this),t},p.getCellElements=function(){return this.cells.map(function(e){return e.element})},p.getParentCell=function(e){var t=this.getCell(e);return t?t:(e=i.getParent(e,".flickity-slider > *"),this.getCell(e))},p.getAdjacentCellElements=function(e,t){if(!e)return this.selectedSlide.getCellElements();t=void 0===t?this.selectedIndex:t;var n=this.slides.length;if(1+2*e>=n)return this.getCellElements();for(var r=[],o=t-e;o<=t+e;o++){var s=this.options.wrapAround?i.modulo(o,n):o,a=this.slides[s];a&&(r=r.concat(a.getCellElements()))}return r},p.queryCell=function(e){return"number"==typeof e?this.cells[e]:("string"==typeof e&&(e=this.element.querySelector(e)),this.getCell(e))},p.uiChange=function(){this.emitEvent("uiChange")},p.childUIPointerDown=function(e){this.emitEvent("childUIPointerDown",[e])},p.onresize=function(){this.watchCSS(),this.resize()},i.debounceMethod(l,"onresize",150),p.resize=function(){if(this.isActive){this.getSize(),this.options.wrapAround&&(this.x=i.modulo(this.x,this.slideableWidth)),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");var e=this.selectedElements&&this.selectedElements[0];this.selectCell(e,!1,!0)}},p.watchCSS=function(){var e=this.options.watchCSS;if(e){var t=c(this.element,":after").content;t.indexOf("flickity")!=-1?this.activate():this.deactivate()}},p.onkeydown=function(e){var t=document.activeElement&&document.activeElement!=this.element;if(this.options.accessibility&&!t){var n=l.keyboardHandlers[e.keyCode];n&&n.call(this)}},l.keyboardHandlers={37:function(){var e=this.options.rightToLeft?"next":"previous";this.uiChange(),this[e]()},39:function(){var e=this.options.rightToLeft?"previous":"next";this.uiChange(),this[e]()}},p.focus=function(){var t=e.pageYOffset;this.element.focus({preventScroll:!0}),e.pageYOffset!=t&&e.scrollTo(e.pageXOffset,t)},p.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.unselectSelectedSlide(),this.cells.forEach(function(e){e.destroy()}),this.element.removeChild(this.viewport),a(this.slider.children,this.element),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),this.isActive=!1,this.emitEvent("deactivate"))},p.destroy=function(){this.deactivate(),e.removeEventListener("resize",this),this.emitEvent("destroy"),u&&this.$element&&u.removeData(this.element,"flickity"),delete this.element.flickityGUID,delete h[this.guid]},i.extend(p,s),l.data=function(e){e=i.getQueryElement(e);var t=e&&e.flickityGUID;return t&&h[t]},i.htmlInit(l,"flickity"),u&&u.bridget&&u.bridget("flickity",l),l.setJQuery=function(e){u=e},l.Cell=r,l}),/*!
   * Unipointer v2.3.0
   * base class for doing one thing with pointer event
   * MIT license
   */
function(e,t){"function"==typeof define&&define.amd?define("unipointer/unipointer",["ev-emitter/ev-emitter"],function(n){return t(e,n)}):"object"==typeof module&&module.exports?module.exports=t(e,require("ev-emitter")):e.Unipointer=t(e,e.EvEmitter)}(window,function(e,t){function n(){}function i(){}var r=i.prototype=Object.create(t.prototype);r.bindStartEvent=function(e){this._bindStartEvent(e,!0)},r.unbindStartEvent=function(e){this._bindStartEvent(e,!1)},r._bindStartEvent=function(t,n){n=void 0===n||n;var i=n?"addEventListener":"removeEventListener",r="mousedown";e.PointerEvent?r="pointerdown":"ontouchstart"in e&&(r="touchstart"),t[i](r,this)},r.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},r.getTouch=function(e){for(var t=0;t<e.length;t++){var n=e[t];if(n.identifier==this.pointerIdentifier)return n}},r.onmousedown=function(e){var t=e.button;t&&0!==t&&1!==t||this._pointerDown(e,e)},r.ontouchstart=function(e){this._pointerDown(e,e.changedTouches[0])},r.onpointerdown=function(e){this._pointerDown(e,e)},r._pointerDown=function(e,t){e.button||this.isPointerDown||(this.isPointerDown=!0,this.pointerIdentifier=void 0!==t.pointerId?t.pointerId:t.identifier,this.pointerDown(e,t))},r.pointerDown=function(e,t){this._bindPostStartEvents(e),this.emitEvent("pointerDown",[e,t])};var o={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};return r._bindPostStartEvents=function(t){if(t){var n=o[t.type];n.forEach(function(t){e.addEventListener(t,this)},this),this._boundPointerEvents=n}},r._unbindPostStartEvents=function(){this._boundPointerEvents&&(this._boundPointerEvents.forEach(function(t){e.removeEventListener(t,this)},this),delete this._boundPointerEvents)},r.onmousemove=function(e){this._pointerMove(e,e)},r.onpointermove=function(e){e.pointerId==this.pointerIdentifier&&this._pointerMove(e,e)},r.ontouchmove=function(e){var t=this.getTouch(e.changedTouches);t&&this._pointerMove(e,t)},r._pointerMove=function(e,t){this.pointerMove(e,t)},r.pointerMove=function(e,t){this.emitEvent("pointerMove",[e,t])},r.onmouseup=function(e){this._pointerUp(e,e)},r.onpointerup=function(e){e.pointerId==this.pointerIdentifier&&this._pointerUp(e,e)},r.ontouchend=function(e){var t=this.getTouch(e.changedTouches);t&&this._pointerUp(e,t)},r._pointerUp=function(e,t){this._pointerDone(),this.pointerUp(e,t)},r.pointerUp=function(e,t){this.emitEvent("pointerUp",[e,t])},r._pointerDone=function(){this._pointerReset(),this._unbindPostStartEvents(),this.pointerDone()},r._pointerReset=function(){this.isPointerDown=!1,delete this.pointerIdentifier},r.pointerDone=n,r.onpointercancel=function(e){e.pointerId==this.pointerIdentifier&&this._pointerCancel(e,e)},r.ontouchcancel=function(e){var t=this.getTouch(e.changedTouches);t&&this._pointerCancel(e,t)},r._pointerCancel=function(e,t){this._pointerDone(),this.pointerCancel(e,t)},r.pointerCancel=function(e,t){this.emitEvent("pointerCancel",[e,t])},i.getPointerPoint=function(e){return{x:e.pageX,y:e.pageY}},i}),/*!
   * Unidragger v2.3.0
   * Draggable base class
   * MIT license
   */
function(e,t){"function"==typeof define&&define.amd?define("unidragger/unidragger",["unipointer/unipointer"],function(n){return t(e,n)}):"object"==typeof module&&module.exports?module.exports=t(e,require("unipointer")):e.Unidragger=t(e,e.Unipointer)}(window,function(e,t){function n(){}var i=n.prototype=Object.create(t.prototype);i.bindHandles=function(){this._bindHandles(!0)},i.unbindHandles=function(){this._bindHandles(!1)},i._bindHandles=function(t){t=void 0===t||t;for(var n=t?"addEventListener":"removeEventListener",i=(t?this._touchActionValue:"",0);i<this.handles.length;i++){var r=this.handles[i];this._bindStartEvent(r,t),r[n]("click",this),e.PointerEvent}},i._touchActionValue="none",i.pointerDown=function(e,t){var n=this.okayPointerDown(e);n&&(this.pointerDownPointer=t,e.preventDefault(),this.pointerDownBlur(),this._bindPostStartEvents(e),this.emitEvent("pointerDown",[e,t]))};var r={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},o={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};return i.okayPointerDown=function(e){var t=r[e.target.nodeName],n=o[e.target.type],i=!t||n;return i||this._pointerReset(),i},i.pointerDownBlur=function(){var e=document.activeElement,t=e&&e.blur&&e!=document.body;t&&e.blur()},i.pointerMove=function(e,t){var n=this._dragPointerMove(e,t);this.emitEvent("pointerMove",[e,t,n]),this._dragMove(e,t,n)},i._dragPointerMove=function(e,t){var n={x:t.pageX-this.pointerDownPointer.pageX,y:t.pageY-this.pointerDownPointer.pageY};return!this.isDragging&&this.hasDragStarted(n)&&this._dragStart(e,t),n},i.hasDragStarted=function(e){return Math.abs(e.x)>3||Math.abs(e.y)>3},i.pointerUp=function(e,t){this.emitEvent("pointerUp",[e,t]),this._dragPointerUp(e,t)},i._dragPointerUp=function(e,t){this.isDragging?this._dragEnd(e,t):this._staticClick(e,t)},i._dragStart=function(e,t){this.isDragging=!0,this.isPreventingClicks=!0,this.dragStart(e,t)},i.dragStart=function(e,t){this.emitEvent("dragStart",[e,t])},i._dragMove=function(e,t,n){this.isDragging&&this.dragMove(e,t,n)},i.dragMove=function(e,t,n){e.preventDefault(),this.emitEvent("dragMove",[e,t,n])},i._dragEnd=function(e,t){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(e,t)},i.dragEnd=function(e,t){this.emitEvent("dragEnd",[e,t])},i.onclick=function(e){this.isPreventingClicks&&e.preventDefault()},i._staticClick=function(e,t){this.isIgnoringMouseUp&&"mouseup"==e.type||(this.staticClick(e,t),"mouseup"!=e.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},i.staticClick=function(e,t){this.emitEvent("staticClick",[e,t])},n.getPointerPoint=t.getPointerPoint,n}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/drag",["./flickity","unidragger/unidragger","fizzy-ui-utils/utils"],function(n,i,r){return t(e,n,i,r)}):"object"==typeof module&&module.exports?module.exports=t(e,require("./flickity"),require("unidragger"),require("fizzy-ui-utils")):e.Flickity=t(e,e.Flickity,e.Unidragger,e.fizzyUIUtils)}(window,function(e,t,n,i){function r(){return{x:e.pageXOffset,y:e.pageYOffset}}i.extend(t.defaults,{draggable:">1",dragThreshold:3}),t.createMethods.push("_createDrag");var o=t.prototype;i.extend(o,n.prototype),o._touchActionValue="pan-y";var s="createTouch"in document,a=!1;o._createDrag=function(){this.on("activate",this.onActivateDrag),this.on("uiChange",this._uiChangeDrag),this.on("childUIPointerDown",this._childUIPointerDownDrag),this.on("deactivate",this.onDeactivateDrag),this.on("cellChange",this.updateDraggable),s&&!a&&(e.addEventListener("touchmove",function(){}),a=!0)},o.onActivateDrag=function(){this.handles=[this.viewport],this.bindHandles(),this.updateDraggable()},o.onDeactivateDrag=function(){this.unbindHandles(),this.element.classList.remove("is-draggable")},o.updateDraggable=function(){">1"==this.options.draggable?this.isDraggable=this.slides.length>1:this.isDraggable=this.options.draggable,this.isDraggable?this.element.classList.add("is-draggable"):this.element.classList.remove("is-draggable")},o.bindDrag=function(){this.options.draggable=!0,this.updateDraggable()},o.unbindDrag=function(){this.options.draggable=!1,this.updateDraggable()},o._uiChangeDrag=function(){delete this.isFreeScrolling},o._childUIPointerDownDrag=function(e){e.preventDefault(),this.pointerDownFocus(e)},o.pointerDown=function(t,n){if(!this.isDraggable)return void this._pointerDownDefault(t,n);var i=this.okayPointerDown(t);i&&(this._pointerDownPreventDefault(t),this.pointerDownFocus(t),document.activeElement!=this.element&&this.pointerDownBlur(),this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),this.pointerDownScroll=r(),e.addEventListener("scroll",this),this._pointerDownDefault(t,n))},o._pointerDownDefault=function(e,t){this.pointerDownPointer=t,this._bindPostStartEvents(e),this.dispatchEvent("pointerDown",e,[t])};var l={INPUT:!0,TEXTAREA:!0,SELECT:!0};return o.pointerDownFocus=function(e){var t=l[e.target.nodeName];t||this.focus()},o._pointerDownPreventDefault=function(e){var t="touchstart"==e.type,n="touch"==e.pointerType,i=l[e.target.nodeName];t||n||i||e.preventDefault()},o.hasDragStarted=function(e){return Math.abs(e.x)>this.options.dragThreshold},o.pointerUp=function(e,t){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down"),this.dispatchEvent("pointerUp",e,[t]),this._dragPointerUp(e,t)},o.pointerDone=function(){e.removeEventListener("scroll",this),delete this.pointerDownScroll},o.dragStart=function(t,n){this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),e.removeEventListener("scroll",this),this.dispatchEvent("dragStart",t,[n]))},o.pointerMove=function(e,t){var n=this._dragPointerMove(e,t);this.dispatchEvent("pointerMove",e,[t,n]),this._dragMove(e,t,n)},o.dragMove=function(e,t,n){if(this.isDraggable){e.preventDefault(),this.previousDragX=this.dragX;var i=this.options.rightToLeft?-1:1;this.options.wrapAround&&(n.x=n.x%this.slideableWidth);var r=this.dragStartPosition+n.x*i;if(!this.options.wrapAround&&this.slides.length){var o=Math.max(-this.slides[0].target,this.dragStartPosition);r=r>o?.5*(r+o):r;var s=Math.min(-this.getLastSlide().target,this.dragStartPosition);r=r<s?.5*(r+s):r}this.dragX=r,this.dragMoveTime=new Date,this.dispatchEvent("dragMove",e,[t,n])}},o.dragEnd=function(e,t){if(this.isDraggable){this.options.freeScroll&&(this.isFreeScrolling=!0);var n=this.dragEndRestingSelect();if(this.options.freeScroll&&!this.options.wrapAround){var i=this.getRestingPosition();this.isFreeScrolling=-i>this.slides[0].target&&-i<this.getLastSlide().target}else this.options.freeScroll||n!=this.selectedIndex||(n+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.options.wrapAround,this.select(n),delete this.isDragSelect,this.dispatchEvent("dragEnd",e,[t])}},o.dragEndRestingSelect=function(){var e=this.getRestingPosition(),t=Math.abs(this.getSlideDistance(-e,this.selectedIndex)),n=this._getClosestResting(e,t,1),i=this._getClosestResting(e,t,-1),r=n.distance<i.distance?n.index:i.index;return r},o._getClosestResting=function(e,t,n){for(var i=this.selectedIndex,r=1/0,o=this.options.contain&&!this.options.wrapAround?function(e,t){return e<=t}:function(e,t){return e<t};o(t,r)&&(i+=n,r=t,t=this.getSlideDistance(-e,i),null!==t);)t=Math.abs(t);return{distance:r,index:i-n}},o.getSlideDistance=function(e,t){var n=this.slides.length,r=this.options.wrapAround&&n>1,o=r?i.modulo(t,n):t,s=this.slides[o];if(!s)return null;var a=r?this.slideableWidth*Math.floor(t/n):0;return e-(s.target+a)},o.dragEndBoostSelect=function(){if(void 0===this.previousDragX||!this.dragMoveTime||new Date-this.dragMoveTime>100)return 0;var e=this.getSlideDistance(-this.dragX,this.selectedIndex),t=this.previousDragX-this.dragX;return e>0&&t>0?1:e<0&&t<0?-1:0},o.staticClick=function(e,t){var n=this.getParentCell(e.target),i=n&&n.element,r=n&&this.cells.indexOf(n);this.dispatchEvent("staticClick",e,[t,i,r])},o.onscroll=function(){var e=r(),t=this.pointerDownScroll.x-e.x,n=this.pointerDownScroll.y-e.y;(Math.abs(t)>3||Math.abs(n)>3)&&this._pointerDone()},t}),/*!
   * Tap listener v2.0.0
   * listens to taps
   * MIT license
   */
function(e,t){"function"==typeof define&&define.amd?define("tap-listener/tap-listener",["unipointer/unipointer"],function(n){return t(e,n)}):"object"==typeof module&&module.exports?module.exports=t(e,require("unipointer")):e.TapListener=t(e,e.Unipointer)}(window,function(e,t){function n(e){this.bindTap(e)}var i=n.prototype=Object.create(t.prototype);return i.bindTap=function(e){e&&(this.unbindTap(),this.tapElement=e,this._bindStartEvent(e,!0))},i.unbindTap=function(){this.tapElement&&(this._bindStartEvent(this.tapElement,!0),delete this.tapElement)},i.pointerUp=function(n,i){if(!this.isIgnoringMouseUp||"mouseup"!=n.type){var r=t.getPointerPoint(i),o=this.tapElement.getBoundingClientRect(),s=e.pageXOffset,a=e.pageYOffset,l=r.x>=o.left+s&&r.x<=o.right+s&&r.y>=o.top+a&&r.y<=o.bottom+a;if(l&&this.emitEvent("tap",[n,i]),"mouseup"!=n.type){this.isIgnoringMouseUp=!0;var u=this;setTimeout(function(){delete u.isIgnoringMouseUp},400)}}},i.destroy=function(){this.pointerDone(),this.unbindTap()},n}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/prev-next-button",["./flickity","tap-listener/tap-listener","fizzy-ui-utils/utils"],function(n,i,r){return t(e,n,i,r)}):"object"==typeof module&&module.exports?module.exports=t(e,require("./flickity"),require("tap-listener"),require("fizzy-ui-utils")):t(e,e.Flickity,e.TapListener,e.fizzyUIUtils)}(window,function(e,t,n,i){"use strict";function r(e,t){this.direction=e,this.parent=t,this._create()}function o(e){return"string"==typeof e?e:"M "+e.x0+",50 L "+e.x1+","+(e.y1+50)+" L "+e.x2+","+(e.y2+50)+" L "+e.x3+",50  L "+e.x2+","+(50-e.y2)+" L "+e.x1+","+(50-e.y1)+" Z"}var s="http://www.w3.org/2000/svg";r.prototype=Object.create(n.prototype),r.prototype._create=function(){this.isEnabled=!0,this.isPrevious=this.direction==-1;var e=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==e;var t=this.element=document.createElement("button");t.className="flickity-button flickity-prev-next-button",t.className+=this.isPrevious?" previous":" next",t.setAttribute("type","button"),this.disable(),t.setAttribute("aria-label",this.isPrevious?"Previous":"Next");var n=this.createSVG();t.appendChild(n),this.on("tap",this.onTap),this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},r.prototype.activate=function(){this.bindTap(this.element),this.element.addEventListener("click",this),this.parent.element.appendChild(this.element)},r.prototype.deactivate=function(){this.parent.element.removeChild(this.element),n.prototype.destroy.call(this),this.element.removeEventListener("click",this)},r.prototype.createSVG=function(){var e=document.createElementNS(s,"svg");e.setAttribute("class","flickity-button-icon"),e.setAttribute("viewBox","0 0 100 100");var t=document.createElementNS(s,"path"),n=o(this.parent.options.arrowShape);return t.setAttribute("d",n),t.setAttribute("class","arrow"),this.isLeft||t.setAttribute("transform","translate(100, 100) rotate(180) "),e.appendChild(t),e},r.prototype.onTap=function(){if(this.isEnabled){this.parent.uiChange();var e=this.isPrevious?"previous":"next";this.parent[e]()}},r.prototype.handleEvent=i.handleEvent,r.prototype.onclick=function(e){var t=document.activeElement;t&&t==this.element&&this.onTap(e,e)},r.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},r.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},r.prototype.update=function(){var e=this.parent.slides;if(this.parent.options.wrapAround&&e.length>1)return void this.enable();var t=e.length?e.length-1:0,n=this.isPrevious?0:t,i=this.parent.selectedIndex==n?"disable":"enable";this[i]()},r.prototype.destroy=function(){this.deactivate()},i.extend(t.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),t.createMethods.push("_createPrevNextButtons");var a=t.prototype;return a._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new r((-1),this),this.nextButton=new r(1,this),this.on("activate",this.activatePrevNextButtons))},a.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},a.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},t.PrevNextButton=r,t}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/page-dots",["./flickity","tap-listener/tap-listener","fizzy-ui-utils/utils"],function(n,i,r){return t(e,n,i,r)}):"object"==typeof module&&module.exports?module.exports=t(e,require("./flickity"),require("tap-listener"),require("fizzy-ui-utils")):t(e,e.Flickity,e.TapListener,e.fizzyUIUtils)}(window,function(e,t,n,i){function r(e){this.parent=e,this._create()}r.prototype=new n,r.prototype._create=function(){this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",this.dots=[],this.on("tap",this.onTap),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},r.prototype.activate=function(){this.setDots(),this.bindTap(this.holder),this.parent.element.appendChild(this.holder)},r.prototype.deactivate=function(){this.parent.element.removeChild(this.holder),n.prototype.destroy.call(this)},r.prototype.setDots=function(){var e=this.parent.slides.length-this.dots.length;e>0?this.addDots(e):e<0&&this.removeDots(-e)},r.prototype.addDots=function(e){for(var t=document.createDocumentFragment(),n=[],i=this.dots.length,r=i+e,o=i;o<r;o++){var s=document.createElement("li");s.className="dot",s.setAttribute("aria-label","Page dot "+(o+1)),t.appendChild(s),n.push(s)}this.holder.appendChild(t),this.dots=this.dots.concat(n)},r.prototype.removeDots=function(e){var t=this.dots.splice(this.dots.length-e,e);t.forEach(function(e){this.holder.removeChild(e)},this)},r.prototype.updateSelected=function(){this.selectedDot&&(this.selectedDot.className="dot",this.selectedDot.removeAttribute("aria-current")),this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected",this.selectedDot.setAttribute("aria-current","step"))},r.prototype.onTap=function(e){var t=e.target;if("LI"==t.nodeName){this.parent.uiChange();var n=this.dots.indexOf(t);this.parent.select(n)}},r.prototype.destroy=function(){this.deactivate()},t.PageDots=r,i.extend(t.defaults,{pageDots:!0}),t.createMethods.push("_createPageDots");var o=t.prototype;return o._createPageDots=function(){this.options.pageDots&&(this.pageDots=new r(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},o.activatePageDots=function(){this.pageDots.activate()},o.updateSelectedPageDots=function(){this.pageDots.updateSelected()},o.updatePageDots=function(){this.pageDots.setDots()},o.deactivatePageDots=function(){this.pageDots.deactivate()},t.PageDots=r,t}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/player",["ev-emitter/ev-emitter","fizzy-ui-utils/utils","./flickity"],function(e,n,i){return t(e,n,i)}):"object"==typeof module&&module.exports?module.exports=t(require("ev-emitter"),require("fizzy-ui-utils"),require("./flickity")):t(e.EvEmitter,e.fizzyUIUtils,e.Flickity)}(window,function(e,t,n){function i(e){this.parent=e,this.state="stopped",this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}i.prototype=Object.create(e.prototype),i.prototype.play=function(){if("playing"!=this.state){var e=document.hidden;if(e)return void document.addEventListener("visibilitychange",this.onVisibilityPlay);this.state="playing",document.addEventListener("visibilitychange",this.onVisibilityChange),this.tick()}},i.prototype.tick=function(){if("playing"==this.state){var e=this.parent.options.autoPlay;e="number"==typeof e?e:3e3;var t=this;this.clear(),this.timeout=setTimeout(function(){t.parent.next(!0),t.tick()},e)}},i.prototype.stop=function(){this.state="stopped",this.clear(),document.removeEventListener("visibilitychange",this.onVisibilityChange)},i.prototype.clear=function(){clearTimeout(this.timeout)},i.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},i.prototype.unpause=function(){"paused"==this.state&&this.play()},i.prototype.visibilityChange=function(){var e=document.hidden;this[e?"pause":"unpause"]()},i.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},t.extend(n.defaults,{pauseAutoPlayOnHover:!0}),n.createMethods.push("_createPlayer");var r=n.prototype;return r._createPlayer=function(){this.player=new i(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},r.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},r.playPlayer=function(){this.player.play()},r.stopPlayer=function(){this.player.stop()},r.pausePlayer=function(){this.player.pause()},r.unpausePlayer=function(){this.player.unpause()},r.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},r.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},r.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},n.Player=i,n}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/add-remove-cell",["./flickity","fizzy-ui-utils/utils"],function(n,i){return t(e,n,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("./flickity"),require("fizzy-ui-utils")):t(e,e.Flickity,e.fizzyUIUtils)}(window,function(e,t,n){function i(e){var t=document.createDocumentFragment();return e.forEach(function(e){t.appendChild(e.element)}),t}var r=t.prototype;return r.insert=function(e,t){var n=this._makeCells(e);if(n&&n.length){var r=this.cells.length;t=void 0===t?r:t;var o=i(n),s=t==r;if(s)this.slider.appendChild(o);else{var a=this.cells[t].element;this.slider.insertBefore(o,a)}if(0===t)this.cells=n.concat(this.cells);else if(s)this.cells=this.cells.concat(n);else{var l=this.cells.splice(t,r-t);this.cells=this.cells.concat(n).concat(l)}this._sizeCells(n),this.cellChange(t,!0)}},r.append=function(e){this.insert(e,this.cells.length)},r.prepend=function(e){this.insert(e,0)},r.remove=function(e){var t=this.getCells(e);if(t&&t.length){var i=this.cells.length-1;t.forEach(function(e){e.remove();var t=this.cells.indexOf(e);i=Math.min(t,i),n.removeFrom(this.cells,e)},this),this.cellChange(i,!0)}},r.cellSizeChange=function(e){var t=this.getCell(e);if(t){t.getSize();var n=this.cells.indexOf(t);this.cellChange(n)}},r.cellChange=function(e,t){var n=this.selectedElement;this._positionCells(e),this._getWrapShiftCells(),this.setGallerySize();var i=this.getCell(n);i&&(this.selectedIndex=this.getCellSlideIndex(i)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[e]),this.select(this.selectedIndex),t&&this.positionSliderAtSelected()},t}),function(e,t){"function"==typeof define&&define.amd?define("flickity/js/lazyload",["./flickity","fizzy-ui-utils/utils"],function(n,i){return t(e,n,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("./flickity"),require("fizzy-ui-utils")):t(e,e.Flickity,e.fizzyUIUtils)}(window,function(e,t,n){"use strict";function i(e){if("IMG"==e.nodeName){var t=e.getAttribute("data-flickity-lazyload"),i=e.getAttribute("data-flickity-lazyload-src"),r=e.getAttribute("data-flickity-lazyload-srcset");if(t||i||r)return[e]}var o="img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",s=e.querySelectorAll(o);return n.makeArray(s)}function r(e,t){this.img=e,this.flickity=t,this.load()}t.createMethods.push("_createLazyload");var o=t.prototype;return o._createLazyload=function(){this.on("select",this.lazyLoad)},o.lazyLoad=function(){var e=this.options.lazyLoad;if(e){var t="number"==typeof e?e:0,n=this.getAdjacentCellElements(t),o=[];n.forEach(function(e){var t=i(e);o=o.concat(t)}),o.forEach(function(e){new r(e,this)},this)}},r.prototype.handleEvent=n.handleEvent,r.prototype.load=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this);var e=this.img.getAttribute("data-flickity-lazyload")||this.img.getAttribute("data-flickity-lazyload-src"),t=this.img.getAttribute("data-flickity-lazyload-srcset");this.img.src=e,t&&this.img.setAttribute("srcset",t),this.img.removeAttribute("data-flickity-lazyload"),this.img.removeAttribute("data-flickity-lazyload-src"),this.img.removeAttribute("data-flickity-lazyload-srcset")},r.prototype.onload=function(e){this.complete(e,"flickity-lazyloaded")},r.prototype.onerror=function(e){this.complete(e,"flickity-lazyerror")},r.prototype.complete=function(e,t){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this);var n=this.flickity.getParentCell(this.img),i=n&&n.element;this.flickity.cellSizeChange(i),this.img.classList.add(t),this.flickity.dispatchEvent("lazyLoad",e,i)},t.LazyLoader=r,t}),/*!
   * Flickity v2.1.2
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * or Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2018 Metafizzy
   */
function(e,t){"function"==typeof define&&define.amd?define("flickity/js/index",["./flickity","./drag","./prev-next-button","./page-dots","./player","./add-remove-cell","./lazyload"],t):"object"==typeof module&&module.exports&&(module.exports=t(require("./flickity"),require("./drag"),require("./prev-next-button"),require("./page-dots"),require("./player"),require("./add-remove-cell"),require("./lazyload")))}(window,function(e){return e}),/*!
   * Flickity asNavFor v2.0.1
   * enable asNavFor for Flickity
   */
function(e,t){"function"==typeof define&&define.amd?define("flickity-as-nav-for/as-nav-for",["flickity/js/index","fizzy-ui-utils/utils"],t):"object"==typeof module&&module.exports?module.exports=t(require("flickity"),require("fizzy-ui-utils")):e.Flickity=t(e.Flickity,e.fizzyUIUtils)}(window,function(e,t){function n(e,t,n){return(t-e)*n+e}e.createMethods.push("_createAsNavFor");var i=e.prototype;return i._createAsNavFor=function(){this.on("activate",this.activateAsNavFor),this.on("deactivate",this.deactivateAsNavFor),this.on("destroy",this.destroyAsNavFor);var e=this.options.asNavFor;if(e){var t=this;setTimeout(function(){t.setNavCompanion(e)})}},i.setNavCompanion=function(n){n=t.getQueryElement(n);var i=e.data(n);if(i&&i!=this){this.navCompanion=i;var r=this;this.onNavCompanionSelect=function(){r.navCompanionSelect()},i.on("select",this.onNavCompanionSelect),this.on("staticClick",this.onNavStaticClick),this.navCompanionSelect(!0)}},i.navCompanionSelect=function(e){if(this.navCompanion){var t=this.navCompanion.selectedCells[0],i=this.navCompanion.cells.indexOf(t),r=i+this.navCompanion.selectedCells.length-1,o=Math.floor(n(i,r,this.navCompanion.cellAlign));if(this.selectCell(o,!1,e),this.removeNavSelectedElements(),!(o>=this.cells.length)){var s=this.cells.slice(i,r+1);this.navSelectedElements=s.map(function(e){return e.element}),this.changeNavSelectedClass("add")}}},i.changeNavSelectedClass=function(e){this.navSelectedElements.forEach(function(t){t.classList[e]("is-nav-selected")})},i.activateAsNavFor=function(){this.navCompanionSelect(!0)},i.removeNavSelectedElements=function(){this.navSelectedElements&&(this.changeNavSelectedClass("remove"),delete this.navSelectedElements)},i.onNavStaticClick=function(e,t,n,i){"number"==typeof i&&this.navCompanion.selectCell(i)},i.deactivateAsNavFor=function(){this.removeNavSelectedElements()},i.destroyAsNavFor=function(){this.navCompanion&&(this.navCompanion.off("select",this.onNavCompanionSelect),this.off("staticClick",this.onNavStaticClick),delete this.navCompanion)},e}),/*!
   * imagesLoaded v4.1.4
   * JavaScript is all like "You images are done yet or what?"
   * MIT License
   */
function(e,t){"use strict";"function"==typeof define&&define.amd?define("imagesloaded/imagesloaded",["ev-emitter/ev-emitter"],function(n){return t(e,n)}):"object"==typeof module&&module.exports?module.exports=t(e,require("ev-emitter")):e.imagesLoaded=t(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){function n(e,t){for(var n in t)e[n]=t[n];return e}function i(e){if(Array.isArray(e))return e;var t="object"==typeof e&&"number"==typeof e.length;return t?u.call(e):[e]}function r(e,t,o){if(!(this instanceof r))return new r(e,t,o);var s=e;return"string"==typeof e&&(s=document.querySelectorAll(e)),s?(this.elements=i(s),this.options=n({},this.options),"function"==typeof t?o=t:n(this.options,t),o&&this.on("always",o),this.getImages(),a&&(this.jqDeferred=new a.Deferred),void setTimeout(this.check.bind(this))):void l.error("Bad element for imagesLoaded "+(s||e))}function o(e){this.img=e}function s(e,t){this.url=e,this.element=t,this.img=new Image}var a=e.jQuery,l=e.console,u=Array.prototype.slice;r.prototype=Object.create(t.prototype),r.prototype.options={},r.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},r.prototype.addElementImages=function(e){"IMG"==e.nodeName&&this.addImage(e),this.options.background===!0&&this.addElementBackgroundImages(e);var t=e.nodeType;if(t&&c[t]){for(var n=e.querySelectorAll("img"),i=0;i<n.length;i++){var r=n[i];this.addImage(r)}if("string"==typeof this.options.background){var o=e.querySelectorAll(this.options.background);for(i=0;i<o.length;i++){var s=o[i];this.addElementBackgroundImages(s)}}}};var c={1:!0,9:!0,11:!0};return r.prototype.addElementBackgroundImages=function(e){var t=getComputedStyle(e);if(t)for(var n=/url\((['"])?(.*?)\1\)/gi,i=n.exec(t.backgroundImage);null!==i;){var r=i&&i[2];r&&this.addBackground(r,e),i=n.exec(t.backgroundImage)}},r.prototype.addImage=function(e){var t=new o(e);this.images.push(t)},r.prototype.addBackground=function(e,t){var n=new s(e,t);this.images.push(n)},r.prototype.check=function(){function e(e,n,i){setTimeout(function(){t.progress(e,n,i)})}var t=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(t){t.once("progress",e),t.check()}):void this.complete()},r.prototype.progress=function(e,t,n){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded,this.emitEvent("progress",[this,e,t]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,e),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&l&&l.log("progress: "+n,e,t)},r.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(e,[this]),this.emitEvent("always",[this]),this.jqDeferred){var t=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[t](this)}},o.prototype=Object.create(t.prototype),o.prototype.check=function(){var e=this.getIsImageComplete();return e?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},o.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},o.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.img,t])},o.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},o.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},o.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},o.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(o.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var e=this.getIsImageComplete();e&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.element,t])},r.makeJQueryPlugin=function(t){t=t||e.jQuery,t&&(a=t,a.fn.imagesLoaded=function(e,t){var n=new r(this,e,t);return n.jqDeferred.promise(a(this))})},r.makeJQueryPlugin(),r}),/*!
   * Flickity imagesLoaded v2.0.0
   * enables imagesLoaded option for Flickity
   */
function(e,t){"function"==typeof define&&define.amd?define(["flickity/js/index","imagesloaded/imagesloaded"],function(n,i){return t(e,n,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("flickity"),require("imagesloaded")):e.Flickity=t(e,e.Flickity,e.imagesLoaded)}(window,function(e,t,n){"use strict";t.createMethods.push("_createImagesLoaded");var i=t.prototype;return i._createImagesLoaded=function(){this.on("activate",this.imagesLoaded)},i.imagesLoaded=function(){function e(e,n){var i=t.getParentCell(n.img);t.cellSizeChange(i&&i.element),t.options.freeScroll||t.positionSliderAtSelected()}if(this.options.imagesLoaded){var t=this;n(this.slider).on("progress",e)}},t}),/*!
   * flickity.fullscreen.js
   */
/*!
   * Flickity fullscreen v1.1.0
   * Enable fullscreen view for Flickity
   */
function(e,t){"function"==typeof define&&define.amd?define(["flickity/js/index"],t):"object"==typeof module&&module.exports?module.exports=t(require("flickity")):t(e.Flickity)}(window,function(e){"use strict";function t(e,t){this.name=e,this.createButton(),this.createIcon(),this.onClick=function(){t[e+"Fullscreen"]()},this.clickHandler=this.onClick.bind(this)}function n(e){return e[0].toUpperCase()+e.slice(1)}e.createMethods.push("_createFullscreen");var i=e.prototype;i._createFullscreen=function(){this.isFullscreen=!1,this.options.fullscreen&&(this.viewFullscreenButton=new t("view",this),this.exitFullscreenButton=new t("exit",this),this.on("activate",this._changeFullscreenActive),this.on("deactivate",this._changeFullscreenActive))},i._changeFullscreenActive=function(){var e=this.isActive?"appendChild":"removeChild";this.element[e](this.viewFullscreenButton.element),this.element[e](this.exitFullscreenButton.element);var t=this.isActive?"activate":"deactivate";this.viewFullscreenButton[t](),this.exitFullscreenButton[t]()},i.viewFullscreen=function(){this._changeFullscreen(!0),this.focus()},i.exitFullscreen=function(){this._changeFullscreen(!1)},i._changeFullscreen=function(e){if(this.isFullscreen!=e){this.isFullscreen=e;var t=e?"add":"remove";document.documentElement.classList[t]("is-flickity-fullscreen"),this.element.classList[t]("is-fullscreen"),this.resize(),this.isFullscreen&&this.reposition(),this.dispatchEvent("fullscreenChange",null,[e])}},i.toggleFullscreen=function(){this._changeFullscreen(!this.isFullscreen)};var r=i.setGallerySize;i.setGallerySize=function(){this.options.setGallerySize&&(this.isFullscreen?this.viewport.style.height="":r.call(this))},e.keyboardHandlers[27]=function(){this.exitFullscreen()},t.prototype.createButton=function(){var e=this.element=document.createElement("button");e.className="flickity-button flickity-fullscreen-button flickity-fullscreen-button-"+this.name;var t=n(this.name+" full-screen");e.setAttribute("aria-label",t),e.title=t};var o="http://www.w3.org/2000/svg",s={view:"M209,131.74269 L209,153.699805 C209,158.22846 205.2875,161.933723 200.75,161.933723 L162.25,161.933723 L162.25,200.358674 C162.25,204.887329 158.5375,208.592593 154,208.592593 L132,208.592593 C127.4625,208.592593 123.75,204.887329 123.75,200.358674 L123.75,161.933723 L85.25,161.933723 C80.7125,161.933723 77,158.22846 77,153.699805 L77,131.74269 C77,127.214035 80.7125,123.508772 85.25,123.508772 L123.75,123.508772 L123.75,85.0838207 C123.75,80.5551657 127.4625,76.8499025 132,76.8499025 L154,76.8499025 C158.5375,76.8499025 162.25,80.5551657 162.25,85.0838207 L162.25,123.508772 L200.75,123.508772 C205.2875,123.508772 209,127.214035 209,131.74269 Z M347.1875,327.092398 L327.73125,346.510721 C321.26875,352.960624 310.81875,352.960624 304.425,346.510721 L235.8125,278.100585 C232.71875,275.012865 231,270.82729 231,266.435867 L231,255.251462 C206.73125,274.189474 176.20625,285.442495 143,285.442495 C64.00625,285.442495 0,221.561014 0,142.721248 C0,63.8814815 64.00625,0 143,0 C221.99375,0 286,63.8814815 286,142.721248 C286,175.862768 274.725,206.328265 255.75,230.549708 L266.95625,230.549708 C271.35625,230.549708 275.55,232.265107 278.64375,235.352827 L347.1875,303.762963 C353.58125,310.212865 353.58125,320.642495 347.1875,327.092398 Z M236.5,142.721248 C236.5,91.1220273 194.7,49.4035088 143,49.4035088 C91.3,49.4035088 49.5,91.1220273 49.5,142.721248 C49.5,194.320468 91.3,236.038986 143,236.038986 C194.7,236.038986 236.5,194.320468 236.5,142.721248 Z",exit:"M242.72,176 L342.79,75.93 C355.07,63.65 355.07,43.74 342.79,31.45 L320.55,9.21 C308.27,-3.07 288.36,-3.07 276.07,9.21 L176,109.28 L75.93,9.21 C63.65,-3.07 43.74,-3.07 31.45,9.21 L9.21,31.45 C-3.07,43.73 -3.07,63.64 9.21,75.93 L109.28,176 L9.21,276.07 C-3.07,288.35 -3.07,308.26 9.21,320.55 L31.45,342.79 C43.73,355.07 63.65,355.07 75.93,342.79 L176,242.72 L276.07,342.79 C288.35,355.07 308.27,355.07 320.55,342.79 L342.79,320.55 C355.07,308.27 355.07,288.36 342.79,276.07 L242.72,176 Z"};return t.prototype.createIcon=function(){var e=document.createElementNS(o,"svg");e.setAttribute("class","flickity-button-icon"),e.setAttribute("viewBox","0 0 352 352");var t=document.createElementNS(o,"path"),n=s[this.name];t.setAttribute("d",n),e.appendChild(t),this.element.appendChild(e)},t.prototype.activate=function(){this.element.addEventListener("click",this.clickHandler)},t.prototype.deactivate=function(){this.element.removeEventListener("click",this.clickHandler)},e.FullscreenButton=t,e}),/*!
   * jquery-cookie.js
   */
/*!
   * jQuery Cookie Plugin v1.4.1
   * https://github.com/carhartl/jquery-cookie
   *
   * Copyright 2006, 2014 Klaus Hartl
   * Released under the MIT license
   */
function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(t)}(function(e){function t(e){return a.raw?e:encodeURIComponent(e)}function n(e){return a.raw?e:decodeURIComponent(e)}function i(e){return t(a.json?JSON.stringify(e):String(e))}function r(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(s," ")),a.json?JSON.parse(e):e}catch(e){}}function o(t,n){var i=a.raw?t:r(t);return e.isFunction(n)?n(i):i}var s=/\+/g,a=e.cookie=function(r,s,l){if(arguments.length>1&&!e.isFunction(s)){if(l=e.extend({},a.defaults,l),"number"==typeof l.expires){var u=l.expires,c=l.expires=new Date;c.setMilliseconds(c.getMilliseconds()+864e5*u)}return document.cookie=[t(r),"=",i(s),l.expires?"; expires="+l.expires.toUTCString():"",l.path?"; path="+l.path:"",l.domain?"; domain="+l.domain:"",l.secure?"; secure":""].join("")}for(var d=r?void 0:{},f=document.cookie?document.cookie.split("; "):[],h=0,p=f.length;h<p;h++){var m=f[h].split("="),g=n(m.shift()),v=m.join("=");if(r===g){d=o(v,s);break}r||void 0===(v=o(v))||(d[g]=v)}return d};a.defaults={},e.removeCookie=function(t,n){return e.cookie(t,"",e.extend({},n,{expires:-1})),!e.cookie(t)}}),function(e){"use strict";e.fn.fitVids=function(t){var n={customSelector:null,ignore:null};if(!document.getElementById("fit-vids-style")){var i=document.head||document.getElementsByTagName("head")[0],r=".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}",o=document.createElement("div");o.innerHTML='<p>x</p><style id="fit-vids-style">'+r+"</style>",i.appendChild(o.childNodes[1])}return t&&e.extend(n,t),this.each(function(){var t=['iframe[src*="player.vimeo.com"]','iframe[src*="youtube.com"]','iframe[src*="youtube-nocookie.com"]','iframe[src*="kickstarter.com"][src*="video.html"]','iframe[src*="wistia.com"]','iframe[src*="wistia.net"]',"object","embed"];n.customSelector&&t.push(n.customSelector);var i=".fitvidsignore";n.ignore&&(i=i+", "+n.ignore);var r=e(this).find(t.join(","));r=r.not("object object"),r=r.not(i),r.each(function(t){var n=e(this);if(!(n.parents(i).length>0||"embed"===this.tagName.toLowerCase()&&n.parent("object").length||n.parent(".fluid-width-video-wrapper").length)){n.css("height")||n.css("width")||!isNaN(n.attr("height"))&&!isNaN(n.attr("width"))||(n.attr("height",9),n.attr("width",16));var r="object"===this.tagName.toLowerCase()||n.attr("height")&&!isNaN(parseInt(n.attr("height"),10))?parseInt(n.attr("height"),10):n.height(),o=isNaN(parseInt(n.attr("width"),10))?n.width():parseInt(n.attr("width"),10),s=r/o;if(!n.attr("id")){var a="fitvid"+t;n.attr("id",a)}n.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top",100*s+"%"),n.removeAttr("height").removeAttr("width")}})})}}(window.jQuery||window.Zepto),/*!
   * rivets-cart.js
   */
function(){var e,n,i,r,o,s,a=function(e,t){return function(){return e.apply(t,arguments)}};n=function(){function e(){this.update=a(this.update,this)}return e.prototype.update=function(e){var t,n,i;for(n in e)i=e[n],"items"!==n&&(this[n]=i);return this.items=function(){var n,i,o,s;for(o=e.items,s=[],n=0,i=o.length;n<i;n++)t=o[n],s.push(new r(t));return s}()},e}(),r=function(){function e(e){this.propertyArray=a(this.propertyArray,this),this.update=a(this.update,this),this.update(e)}return e.prototype.update=function(e){var t,n;for(t in e)n=e[t],"properties"!==t&&(this[t]=n);return this.properties=i.Utils.extend({},e.properties)},e.prototype.propertyArray=function(){var e,t,n,i;n=this.properties,i=[];for(e in n)t=n[e],i.push({name:e,value:t});return i},e}(),i={settings:{debug:!1,dataAPI:!0,requestBodyClass:null,rivetsModels:{},currency:null,moneyFormat:null,moneyWithCurrencyFormat:null,weightUnit:"g",weightPrecision:0},cart:new n},i.init=function(e,n){return null==n&&(n={}),i.configure(n),i.Utils.log("Initialising CartJS."),i.cart.update(e),i.settings.dataAPI&&(i.Utils.log('"dataAPI" setting is true, initialising Data API.'),i.Data.init()),i.settings.requestBodyClass&&(i.Utils.log('"requestBodyClass" set, adding event listeners.'),t(document).on("cart.requestStarted",function(){return t("body").addClass(i.settings.requestBodyClass)}),t(document).on("cart.requestComplete",function(){return t("body").removeClass(i.settings.requestBodyClass)})),i.Rivets.init(),t(document).trigger("cart.ready",[i.cart])},i.configure=function(e){return null==e&&(e={}),i.Utils.extend(i.settings,e)},null==window.console&&(window.console={},window.console.log=function(){}),i.Utils={log:function(){return i.Utils.console(console.log,arguments)},error:function(){return i.Utils.console(console.error,arguments)},console:function(e,t){if(i.settings.debug&&"undefined"!=typeof console&&null!==console)return t=Array.prototype.slice.call(t),t.unshift("[CartJS]:"),e.apply(console,t)},wrapKeys:function(e,t,n){var i,r,o;null==t&&(t="properties"),o={};for(i in e)r=e[i],o[""+t+"["+i+"]"]=null!=n?n:r;return o},unwrapKeys:function(e,t,n){var i,r,o,s;null==t&&(t="properties"),r={};for(i in e)s=e[i],o=i.replace(""+t+"[","").replace("]",""),r[o]=null!=n?n:s;return r},extend:function(e,t){var n,i;for(n in t)i=t[n],e[n]=i;return e},clone:function(e){var t,n;if(null==e||"object"!=typeof e)return e;n=new e.constructor;for(t in e)n[t]=clone(e[t]);return n},isArray:Array.isArray||function(e){return"[object Array]"==={}.toString.call(e)},ensureArray:function(e){return i.Utils.isArray(e)?e:null!=e?[e]:[]},formatMoney:function(e,t,n,r){var o,s;return null==r&&(r=""),r||(r=i.settings.currency),null!=window.Currency&&r!==i.settings.currency&&(e=Currency.convert(e,i.settings.currency,r),null!=(null!=(o=window.Currency)?o.moneyFormats:void 0)&&r in window.Currency.moneyFormats&&(t=window.Currency.moneyFormats[r][n])),null!=(null!=(s=window.Shopify)?s.formatMoney:void 0)?Shopify.formatMoney(e,t):e},getSizedImageUrl:function(e,t){var n,i;return null!=(null!=(n=window.Shopify)&&null!=(i=n.Image)?i.getSizedImageUrl:void 0)?e?Shopify.Image.getSizedImageUrl(e,t):Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif",t).replace("-_","-"):e?e:"https://cdn.shopify.com/s/images/admin/no-image-large.gif"}},s=[],o=!1,i.Queue={add:function(e,n,r){var a;if(null==r&&(r={}),a={url:e,data:n,type:r.type||"POST",dataType:r.dataType||"json",success:i.Utils.ensureArray(r.success),error:i.Utils.ensureArray(r.error),complete:i.Utils.ensureArray(r.complete)},r.updateCart&&a.success.push(i.cart.update),s.push(a),!o)return t(document).trigger("cart.requestStarted",[i.cart]),i.Queue.process()},process:function(){var e;return s.length?(o=!0,e=s.shift(),e.complete=i.Queue.process,t.ajax(e)):(o=!1,void t(document).trigger("cart.requestComplete",[i.cart]))}},i.Core={getCart:function(e){return null==e&&(e={}),e.type="GET",e.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_url+".js",{},e)},addItem:function(e,t,n,r){var o;return null==t&&(t=1),null==n&&(n={}),null==r&&(r={}),o=i.Utils.wrapKeys(n),o.id=e,o.quantity=t,i.Queue.add(StyleHatch.routes.cart_add_url+".js",o,r),i.Core.getCart()},updateItem:function(e,t,n,r){var o;return null==n&&(n={}),null==r&&(r={}),o=i.Utils.wrapKeys(n),o.line=e,null!=t&&(o.quantity=t),r.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_change_url+".js",o,r)},removeItem:function(e,t){return null==t&&(t={}),i.Core.updateItem(e,0,{},t)},updateItemById:function(e,t,n,r){var o;return null==n&&(n={}),null==r&&(r={}),o=i.Utils.wrapKeys(n),o.id=e,null!=t&&(o.quantity=t),r.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_change_url+".js",o,r)},updateItemQuantitiesById:function(e,t){return null==e&&(e={}),null==t&&(t={}),t.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_url+"/update.js",{updates:e},t)},removeItemById:function(e,t){var n;return null==t&&(t={}),n={id:e,quantity:0},t.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_change_url+".js",n,t)},clear:function(e){return null==e&&(e={}),e.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_clear_url+".js",{},e)},getAttribute:function(e,t){return e in i.cart.attributes?i.cart.attributes[e]:t},setAttribute:function(e,t,n){var r;return null==n&&(n={}),r={},r[e]=t,i.Core.setAttributes(r,n)},getAttributes:function(){return i.cart.attributes},setAttributes:function(e,t){return null==e&&(e={}),null==t&&(t={}),t.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_url+"/update.js",i.Utils.wrapKeys(e,"attributes"),t)},clearAttributes:function(e){return null==e&&(e={}),e.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_url+"/update.js",i.Utils.wrapKeys(i.Core.getAttributes(),"attributes",""),e)},getNote:function(){return i.cart.note},setNote:function(e,t){return null==t&&(t={}),t.updateCart=!0,i.Queue.add(StyleHatch.routes.cart_url+"/update.js",{note:e},t)}},e=null,i.Data={init:function(){return e=t(document),i.Data.setEventListeners("on"),i.Data.render(null,i.cart)},destroy:function(){return i.Data.setEventListeners("off")},setEventListeners:function(t){return e[t]("click","[data-cart-add]",i.Data.add),e[t]("click","[data-cart-remove]",i.Data.remove),e[t]("click","[data-cart-remove-id]",i.Data.removeById),e[t]("click","[data-cart-update]",i.Data.update),e[t]("click","[data-cart-update-id]",i.Data.updateById),e[t]("click","[data-cart-clear]",i.Data.clear),e[t]("change","[data-cart-toggle]",i.Data.toggle),e[t]("change","[data-cart-toggle-attribute]",i.Data.toggleAttribute),e[t]("submit","[data-cart-submit]",i.Data.submit),e[t]("cart.requestComplete",i.Data.render)},add:function(e){var n;return e.preventDefault(),n=t(this),i.Core.addItem(n.attr("data-cart-add"),n.attr("data-cart-quantity"))},remove:function(e){var n;return e.preventDefault(),n=t(this),i.Core.removeItem(n.attr("data-cart-remove"))},removeById:function(e){var n;return e.preventDefault(),n=t(this),i.Core.removeItemById(n.attr("data-cart-remove-id"))},update:function(e){var n;return e.preventDefault(),n=t(this),i.Core.updateItem(n.attr("data-cart-update"),n.attr("data-cart-quantity"))},updateById:function(e){var n;return e.preventDefault(),n=t(this),i.Core.updateItemById(n.attr("data-cart-update-id"),n.attr("data-cart-quantity"))},clear:function(e){return e.preventDefault(),i.Core.clear()},toggle:function(e){var n,r;return n=t(this),r=n.attr("data-cart-toggle"),n.is(":checked")?i.Core.addItem(r):i.Core.removeItemById(r)},toggleAttribute:function(e){var n,r;return n=t(this),r=n.attr("data-cart-toggle-attribute"),i.Core.setAttribute(r,n.is(":checked")?"Yes":"")},submit:function(e){var n,r,o,s;return e.preventDefault(),n=t(this).serializeArray(),r=void 0,s=void 0,o={},t.each(n,function(e,t){return"id"===t.name?r=t.value:"quantity"===t.name?s=t.value:t.name.match(/^properties\[\w+\]$/)?o[t.name]=t.value:void 0}),i.Core.addItem(r,s,i.Utils.unwrapKeys(o))},render:function(e,n){var r;return r={item_count:n.item_count,total_price:n.total_price,total_price_money:i.Utils.formatMoney(n.total_price,i.settings.moneyFormat,"money_format",null!=("undefined"!=typeof Currency&&null!==Currency?Currency.currentCurrency:void 0)?Currency.currentCurrency:void 0),total_price_money_with_currency:i.Utils.formatMoney(n.total_price,i.settings.moneyWithCurrencyFormat,"money_with_currency_format",null!=("undefined"!=typeof Currency&&null!==Currency?Currency.currentCurrency:void 0)?Currency.currentCurrency:void 0)},t("[data-cart-render]").each(function(){var e;return e=t(this),e.html(r[e.attr("data-cart-render")])})}},"rivets"in window?(i.Rivets={model:null,boundViews:[],init:function(){return i.Rivets.bindViews()},destroy:function(){return i.Rivets.unbindViews()},bindViews:function(){return i.Utils.log("Rivets.js is present, binding views."),i.Rivets.unbindViews(),i.Rivets.model=i.Utils.extend({cart:i.cart},i.settings.rivetsModels),null!=window.Currency&&(i.Rivets.model.Currency=window.Currency),t("[data-cart-view]").each(function(){var e;return e=rivets.bind(t(this),i.Rivets.model),i.Rivets.boundViews.push(e)})},unbindViews:function(){var e,t,n,r;for(r=i.Rivets.boundViews,t=0,n=r.length;t<n;t++)e=r[t],e.unbind();return i.Rivets.boundViews=[]}},rivets.formatters.eq=function(e,t){return e===t},rivets.formatters.includes=function(e,t){return e.indexOf(t)>=0},rivets.formatters.match=function(e,t,n){return e.match(new RegExp(t,n))},rivets.formatters.lt=function(e,t){return e<t},rivets.formatters.gt=function(e,t){return e>t},rivets.formatters.not=function(e){return!e},rivets.formatters.empty=function(e){return!e.length},rivets.formatters.plus=function(e,t){return parseInt(e)+parseInt(t)},rivets.formatters.minus=function(e,t){return parseInt(e)-parseInt(t)},rivets.formatters.times=function(e,t){return e*t},rivets.formatters.divided_by=function(e,t){return e/t},rivets.formatters.modulo=function(e,t){return e%t},rivets.formatters.prepend=function(e,t){return t+e},rivets.formatters.append=function(e,t){return e+t},rivets.formatters.slice=function(e,t,n){return e.slice(t,n)},rivets.formatters.pluralize=function(e,t,n){return null==n&&(n=t+"s"),i.Utils.isArray(e)&&(e=e.length),1===e?t:n},rivets.formatters.array_element=function(e,t){return e[t]},rivets.formatters.array_first=function(e){return e[0]},rivets.formatters.array_last=function(e){return e[e.length-1]},rivets.formatters.money=function(e,t){return i.Utils.formatMoney(e,i.settings.moneyFormat,"money_format",t)},rivets.formatters.money_with_currency=function(e,t){return i.Utils.formatMoney(e,i.settings.moneyWithCurrencyFormat,"money_with_currency_format",t)},rivets.formatters.weight=function(e){switch(i.settings.weightUnit){case"kg":return(e/1e3).toFixed(i.settings.weightPrecision);case"oz":return(.035274*e).toFixed(i.settings.weightPrecision);case"lb":return(.00220462*e).toFixed(i.settings.weightPrecision);default:return e.toFixed(i.settings.weightPrecision)}},rivets.formatters.weight_with_unit=function(e){return rivets.formatters.weight(e)+i.settings.weightUnit},rivets.formatters.product_image_size=function(e,t){return i.Utils.getSizedImageUrl(e,t)},rivets.formatters.moneyWithCurrency=rivets.formatters.money_with_currency,rivets.formatters.weightWithUnit=rivets.formatters.weight_with_unit,rivets.formatters.productImageSize=rivets.formatters.product_image_size):i.Rivets={init:function(){},destroy:function(){}},i.factory=function(e){return e.init=i.init,e.configure=i.configure,e.cart=i.cart,e.settings=i.settings,e.getCart=i.Core.getCart,e.addItem=i.Core.addItem,e.updateItem=i.Core.updateItem,e.updateItemById=i.Core.updateItemById,e.updateItemQuantitiesById=i.Core.updateItemQuantitiesById,e.removeItem=i.Core.removeItem,e.removeItemById=i.Core.removeItemById,e.clear=i.Core.clear,e.getAttribute=i.Core.getAttribute,e.setAttribute=i.Core.setAttribute,e.getAttributes=i.Core.getAttributes,e.setAttributes=i.Core.setAttributes,e.clearAttributes=i.Core.clearAttributes,e.getNote=i.Core.getNote,e.setNote=i.Core.setNote,e.render=i.Data.render},"object"==typeof exports?i.factory(exports):"function"==typeof define&&define.amd?define(["exports"],function(e){return i.factory(this.CartJS=e),e}):i.factory(this.CartJS={})}.call(this),/*!
   * easyzoom.js
   */
/*!
   * @name        EasyZoom
   * @author      Matt Hinchliffe <>
   * @modified    Wednesday, November 4th, 2015
   * @version     2.3.1
   */
!function(e){"use strict";function t(t,n){this.$target=e(t),this.opts=e.extend({},l,n,this.$target.data()),void 0===this.isOpen&&this._init()}var n,i,r,o,s,a,l={loadingNotice:"Loading image",errorNotice:"The image could not be loaded",errorDuration:2500,preventClicks:!0,onShow:e.noop,onHide:e.noop,onMove:e.noop};t.prototype._init=function(){this.$link=this.$target.find("a"),this.$image=this.$target.find("img"),this.$flyout=e('<div class="easyzoom-flyout" />'),this.$notice=e('<div class="easyzoom-notice" />'),this.$target.on({"mousemove.easyzoom touchmove.easyzoom":e.proxy(this._onMove,this),"mouseleave.easyzoom touchend.easyzoom":e.proxy(this._onLeave,this),"mouseenter.easyzoom touchstart.easyzoom":e.proxy(this._onEnter,this)}),this.opts.preventClicks&&this.$target.on("click.easyzoom",function(e){e.preventDefault()})},t.prototype.show=function(e,t){var s,a,l,u,c=this;return this.isReady?(this.$target.append(this.$flyout),s=this.$target.width(),a=this.$target.height(),l=this.$flyout.width(),u=this.$flyout.height(),n=this.$zoom.width()-l,i=this.$zoom.height()-u,r=n/s,o=i/a,this.isOpen=!0,this.opts.onShow.call(this),void(e&&this._move(e))):this._loadImage(this.$link.attr("href"),function(){(c.isMouseOver||!t)&&c.show(e)})},t.prototype._onEnter=function(e){var t=e.originalEvent.touches;this.isMouseOver=!0,t&&1!=t.length||(e.preventDefault(),this.show(e,!0))},t.prototype._onMove=function(e){this.isOpen&&(e.preventDefault(),this._move(e))},t.prototype._onLeave=function(){this.isMouseOver=!1,this.isOpen&&this.hide()},t.prototype._onLoad=function(e){e.currentTarget.width&&(this.isReady=!0,this.$notice.detach(),this.$flyout.html(this.$zoom),this.$target.removeClass("is-loading").addClass("is-ready"),e.data.call&&e.data())},t.prototype._onError=function(){var e=this;this.$notice.text(this.opts.errorNotice),this.$target.removeClass("is-loading").addClass("is-error"),this.detachNotice=setTimeout(function(){e.$notice.detach(),e.detachNotice=null},this.opts.errorDuration)},t.prototype._loadImage=function(t,n){var i=new Image;this.$target.addClass("is-loading").append(this.$notice.text(this.opts.loadingNotice)),this.$zoom=e(i).on("error",e.proxy(this._onError,this)).on("load",n,e.proxy(this._onLoad,this)),i.style.position="absolute",i.src=t},t.prototype._move=function(e){if(0===e.type.indexOf("touch")){var t=e.touches||e.originalEvent.touches;s=t[0].pageX,a=t[0].pageY}else s=e.pageX||s,a=e.pageY||a;var l=this.$target.offset(),u=a-l.top,c=s-l.left,d=Math.ceil(u*o),f=Math.ceil(c*r);if(0>f||0>d||f>n||d>i)this.hide();else{var h=-1*d,p=-1*f;this.$zoom.css({top:h,left:p}),this.opts.onMove.call(this,h,p)}},t.prototype.hide=function(){this.isOpen&&(this.$flyout.detach(),this.isOpen=!1,this.opts.onHide.call(this))},t.prototype.swap=function(t,n,i){this.hide(),this.isReady=!1,this.detachNotice&&clearTimeout(this.detachNotice),this.$notice.parent().length&&this.$notice.detach(),this.$target.removeClass("is-loading is-ready is-error"),this.$image.attr({src:t,srcset:e.isArray(i)?i.join():i}),this.$link.attr("href",n)},t.prototype.teardown=function(){this.hide(),this.$target.off(".easyzoom").removeClass("is-loading is-ready is-error"),this.detachNotice&&clearTimeout(this.detachNotice),delete this.$link,delete this.$zoom,delete this.$image,delete this.$notice,delete this.$flyout,delete this.isOpen,delete this.isReady},e.fn.easyZoom=function(n){return this.each(function(){var i=e.data(this,"easyZoom");i?void 0===i.isOpen&&i._init():e.data(this,"easyZoom",new t(this,n))})},"function"==typeof define&&define.amd?define(function(){return t}):"undefined"!=typeof module&&module.exports&&(module.exports=t)}(t),/*!
   * jquery.remove-data-attribute.js
   */
e.fn.extend({removeDataAttributes:function(){var t,n=e(this),i=[],r=n.get(0).attributes,o=r.length;for(t=0;t<o;t++)"data-"===r[t].name.substring(0,5)&&i.push(r[t].name);e.each(i,function(e,t){n.removeAttr(t)})}})}(jq223);var getQueryString=function(e,t){var n=t?t:window.location.href,i=new RegExp("[?&]"+e+"=([^&#]*)","i"),r=i.exec(n);return r?r[1]:null};/*!
 * store.js
 */
/*
https://github.com/marcuswestin/store.js/
The MIT License (MIT)
Copyright (c) 2010-2016 Marcus Westin */
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var t;t="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,t.store=e()}}(function(){return function e(t,n,i){function r(s,a){if(!n[s]){if(!t[s]){var l="function"==typeof require&&require;if(!a&&l)return l(s,!0);if(o)return o(s,!0);var u=new Error("Cannot find module '"+s+"'");throw u.code="MODULE_NOT_FOUND",u}var c=n[s]={exports:{}};t[s][0].call(c.exports,function(e){var n=t[s][1][e];return r(n?n:e)},c,c.exports,e,t,n,i)}return n[s].exports}for(var o="function"==typeof require&&require,s=0;s<i.length;s++)r(i[s]);return r}({1:[function(e,t,n){(function(e){"use strict";t.exports=function(){function t(){try{return s in r&&r[s]}catch(e){return!1}}var n,i={},r="undefined"!=typeof window?window:e,o=r.document,s="localStorage",a="script";if(i.disabled=!1,i.version="1.3.20",i.set=function(e,t){},i.get=function(e,t){},i.has=function(e){return void 0!==i.get(e)},i.remove=function(e){},i.clear=function(){},i.transact=function(e,t,n){null==n&&(n=t,t=null),null==t&&(t={});var r=i.get(e,t);n(r),i.set(e,r)},i.getAll=function(){},i.forEach=function(){},i.serialize=function(e){return JSON.stringify(e)},i.deserialize=function(e){if("string"==typeof e)try{return JSON.parse(e)}catch(t){return e||void 0}},t())n=r[s],i.set=function(e,t){return void 0===t?i.remove(e):(n.setItem(e,i.serialize(t)),t)},i.get=function(e,t){var r=i.deserialize(n.getItem(e));return void 0===r?t:r},i.remove=function(e){n.removeItem(e)},i.clear=function(){n.clear()},i.getAll=function(){var e={};return i.forEach(function(t,n){e[t]=n}),e},i.forEach=function(e){for(var t=0;t<n.length;t++){var r=n.key(t);e(r,i.get(r))}};else if(o&&o.documentElement.addBehavior){var l,u;try{u=new ActiveXObject("htmlfile"),u.open(),u.write("<"+a+">document.w=window</"+a+'><iframe src="/favicon.ico"></iframe>'),u.close(),l=u.w.frames[0].document,n=l.createElement("div")}catch(e){n=o.createElement("div"),l=o.body}var c=function(e){return function(){var t=Array.prototype.slice.call(arguments,0);t.unshift(n),l.appendChild(n),n.addBehavior("#default#userData"),n.load(s);var r=e.apply(i,t);return l.removeChild(n),r}},d=new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]","g"),f=function(e){return e.replace(/^d/,"___$&").replace(d,"___")};i.set=c(function(e,t,n){return t=f(t),void 0===n?i.remove(t):(e.setAttribute(t,i.serialize(n)),e.save(s),n)}),i.get=c(function(e,t,n){t=f(t);var r=i.deserialize(e.getAttribute(t));return void 0===r?n:r}),i.remove=c(function(e,t){t=f(t),e.removeAttribute(t),e.save(s)}),i.clear=c(function(e){var t=e.XMLDocument.documentElement.attributes;e.load(s);for(var n=t.length-1;n>=0;n--)e.removeAttribute(t[n].name);e.save(s)}),i.getAll=function(e){var t={};return i.forEach(function(e,n){t[e]=n}),t},i.forEach=c(function(e,t){for(var n,r=e.XMLDocument.documentElement.attributes,o=0;n=r[o];++o)t(n.name,i.deserialize(e.getAttribute(n.name)))})}try{var h="__storejs__";i.set(h,h),i.get(h)!=h&&(i.disabled=!0),i.remove(h)}catch(e){i.disabled=!0}return i.enabled=!i.disabled,i}()}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)});var storeWithExpiration={set:function(e,t,n){store.set(e,{val:t,exp:n,time:(new Date).getTime()})},get:function(e){var t=store.get(e);return t?(new Date).getTime()-t.time>t.exp?null:t.val:null}};
(function($) {
  'use strict';

  // StyleHatch Object
  window.StyleHatch = window.StyleHatch || {};

  /**
   * Sections
   * ---------------------------------------------------------------------------
   * Constructors, instances and events for the Shopify Theme Editor
   */
  StyleHatch.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  /**
   * Prototypes to extend sections
   */
  StyleHatch.Sections.prototype = $.extend({}, StyleHatch.Sections.prototype, {
    _createInstance: function(container, constructor) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container,
      });

      this.instances.push(instance);
    },

    _onSectionLoad: function(evt) {
      var container = $('[data-section-id]', evt.target)[0];
      if (container) {
        this._createInstance(container);
      }
    },

    _onSectionUnload: function(evt) {
      var instance = slate.utils.findInstance(
        this.instances,
        'id',
        evt.detail.sectionId
      );

      if (!instance) {
        return;
      }

      if (typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }

      this.instances = slate.utils.removeInstance(
        this.instances,
        'id',
        evt.detail.sectionId
      );
    },

    _onSelect: function(evt) {
      var instance = slate.utils.findInstance(
        this.instances,
        'id',
        evt.detail.sectionId
      );

      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }

      if ($('body').hasClass('panel-open')) {
        StyleHatch.closePanelMenu();
        $('html, body').addClass('scroll-lock');
        // Prevent theme editor issues
        setTimeout(function() {
          $('html, body').removeClass('scroll-lock');
          $('html, body').animate(
            {
              scrollTop: instance.$container.offset().top, // - fixedOffset
            },
            600
          );
        }, 400);
      }
    },

    _onDeselect: function(evt) {
      var instance = slate.utils.findInstance(
        this.instances,
        'id',
        evt.detail.sectionId
      );

      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }

      if ($('body').hasClass('panel-open')) {
        StyleHatch.closePanelMenu();
      }
    },

    _onReorder: function(evt) {
      var instance = slate.utils.findInstance(
        this.instances,
        'id',
        evt.detail.sectionId
      );

      if (instance && typeof instance.onReorder === 'function') {
        instance.onReorder(evt);
      }
    },

    _onBlockSelect: function(evt) {
      var instance = slate.utils.findInstance(
        this.instances,
        'id',
        evt.detail.sectionId
      );

      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function(evt) {
      var instance = slate.utils.findInstance(
        this.instances,
        'id',
        evt.detail.sectionId
      );

      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },

    register: function(type, constructor) {
      this.constructors[type] = constructor;

      $('[data-section-type=' + type + ']').each(
        function(index, container) {
          this._createInstance(container, constructor);
        }.bind(this)
      );
    },
  });

  /**
   * Cache common selectors
   */
  StyleHatch.cacheSelectors = function() {
    StyleHatch.cache = {
      // General
      $body: $('body'),
      $html: $('html'),

      // Util header
      $util: $('header.util'),
      $header: $('header.site-header'),
      $siteNav: $('header.site-header ul.site-nav'),
      $featuredCollection: $('.featured-collection'),
      $instagramCollection: $('.instagram-collection'),

      $addToCartForm: $('#AddToCartForm'),
      $addToCartButton: $('#AddToCart'),
      $cartButton: $('#CartButton'),

      // Customer Pages
      $recoverPasswordLink: $('#RecoverPassword'),
      $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
      $recoverPasswordForm: $('#RecoverPasswordForm'),
      $customerLoginForm: $('#CustomerLoginForm'),
      $passwordResetSuccess: $('#ResetSuccess'),
    };
  };

  StyleHatch.init = function() {
    var doc = document.documentElement;
    doc.setAttribute('data-useragent', navigator.userAgent);

    StyleHatch.cacheSelectors();

    // Set up width levels
    StyleHatch.largeMobile = 700;

    /**
     * Set up sections
     */
    var sections = new StyleHatch.Sections();
    // Fixed theme sections
    sections.register('promos-section', StyleHatch.PromosSection);
    sections.register('header-section', StyleHatch.HeaderSection);
    sections.register('footer-section', StyleHatch.FooterSection);
    // Index sections
    sections.register('slideshow-section', StyleHatch.SlideshowSection);
    sections.register('hero-video-section', StyleHatch.HeroVideoSection);
    sections.register(
      'featured-collection-section',
      StyleHatch.FeaturedCollectionSection
    );
    sections.register(
      'simple-collection-section',
      StyleHatch.SimpleCollectionSection
    );
    sections.register('featured-text-section', StyleHatch.PageSection);
    sections.register('custom-content-section', StyleHatch.PageSection);
    sections.register('instagram-section', StyleHatch.InstagramSection);
    sections.register('featured-blog-section', StyleHatch.GenericSection);
    sections.register('map', StyleHatch.Maps);
    // Template sections
    sections.register('product-template', StyleHatch.Product);
    sections.register(
      'product-recommendations',
      StyleHatch.ProductRecommendations
    );
    sections.register('collection-template', StyleHatch.Collection);
    sections.register('collection-list-template', StyleHatch.Collection);
    sections.register('list-collections-template', StyleHatch.ListCollections);
    sections.register('blog-template', StyleHatch.BlogArticle);
    sections.register('article-template', StyleHatch.BlogArticle);
    sections.register('password-template', StyleHatch.Password);
    sections.register('cart-template', StyleHatch.Cart);

    if (StyleHatch.currencyConverter) {
      StyleHatch.CurrencyConverter.init();
    }

    StyleHatch.AjaxCart.init();
    StyleHatch.loginForms();
    StyleHatch.videoLayout();
    StyleHatch.initTemplates();

    // Flickity iOS 13 fix
    var touchingCarousel = false,
        touchStartCoords;
    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('[data-flickity-options]')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY,
      };
    });
    document.body.addEventListener(
      'touchmove',
      function(e) {
        if (!(touchingCarousel && e.cancelable)) {
          return;
        }

        var moveVector = {
          x: e.touches[0].pageX - touchStartCoords.x,
          y: e.touches[0].pageY - touchStartCoords.y,
        };
        if (Math.abs(moveVector.x) > 5) e.preventDefault();
      },
      {
        passive: false,
      }
    );
  };

  /**
   * Section - Modules
   * ---------------------------------------------------------------------------
   * Set up core functionality for fixed global (all template) modules
   */

  /**
   * Promos - header
   */
  StyleHatch.PromosSection = (function() {
    function PromosSection(container) {
      var $container = (this.$container = $(container));
      var id = $container.attr('data-section-id');
      StyleHatch.Promos.init();
    }

    return PromosSection;
  })();
  StyleHatch.PromosSection.prototype = $.extend(
    {},
    StyleHatch.PromosSection.prototype,
    {
      onUnload: function() {
        StyleHatch.Promos.unload();
      },
      onBlockSelect: function(evt) {
        StyleHatch.Promos.blockSelect(evt);
      },
      onBlockDeselect: function(evt) {
        StyleHatch.Promos.blockDeselect(evt);
      },
    }
  );
  // Promos Class
  StyleHatch.Promos = (function() {
    var selectors = {
      body: 'body',
      page: '#page',
      promos: '#shopify-section-promos',
      promoBar: 'header.promo-bar',
      bottomContainer: '.promo-bar-container.bottom',
      popup: '.promo-popup',
    };

    var config = {};
    config = {
      scrollLock: false,
      fixToZIndex: 992,
      hideTimers: [],
      slideSpeed: 400,
    };

    var cache = {};

    function init() {
      cacheSelectors();

      config.scrollLock = cache.$promos.find('>*:first').data('scroll-lock');

      initPromoBars();
      initPopups();

      StyleHatch.Header.rebuildFixTo();
    }

    function cacheSelectors() {
      cache = {
        $body: $(selectors.body),
        $promos: $(selectors.promos),
        $promosContainer: $(selectors.promos).find('>*:first'),
        $promoBar: $(selectors.promoBar),
        $bottomContainer: $(selectors.bottomContainer),
        $popup: $(selectors.popup),
      };
    }

    // Core functions
    /*
     * Promo bar
     * Announcement bar
     */
    function initPromoBars() {
      if (cache.$promoBar.length) {
        // Loop through each
        cache.$promoBar.each(function() {
          var $promoBar = $(this);
          var hideDelay = $promoBar.data('hide-delay');
          var barPlacement = $promoBar.data('bar-placement');

          // Check for errors
          var $errors = $promoBar.find('div.errors');
          if ($errors.length) {
            $errors.prependTo($promoBar);
          }

          // Create and group together bottom bars
          if (barPlacement == 'bottom') {
            if (!cache.$bottomContainer.length) {
              cache.$promosContainer.append(
                '<div class="promo-bar-container bottom"></div>'
              );
              cache.$bottomContainer = $(selectors.bottomContainer);
            }
            $promoBar.appendTo(cache.$bottomContainer);

            // Calculate height and offset bottom padding
            cache.$bottomContainer.resize(function() {
              var bottomHeight = $(this).height() + 'px';
              cache.$body.css({
                'margin-bottom': bottomHeight,
              });
            });
          }

          if ($promoBar.hasClass('signup-bar')) {
            $promoBar.showPopup();
          }

          // Hide the bar after ms delay (hideDelay)
          if (hideDelay !== 'no-delay') {
            config.hideTimers.push(
              setTimeout(function() {
                if (!$promoBar.data('pause-hide')) {
                  $promoBar.promoSlideUp();
                }
              }, hideDelay)
            );
          }
        });

        destroyFixTo();
        fixTo();
      }
    }
    function destroyFixTo() {
      if (cache.$promos.data('fixtoInstance')) {
        cache.$promos.fixTo('destroy');
      }
    }
    function refreshFixTo() {
      if (cache.$promos.data('fixtoInstance')) {
        cache.$promos.fixTo('refresh');
      }
    }
    function fixTo() {
      if (config.scrollLock) {
        cache.$promos.fixTo(selectors.page, {
          zIndex: config.fixToZIndex,
        });
      }
    }

    /*
     * Popup
     */
    function initPopups() {
      if (cache.$popup.length) {
        // Loop through each
        cache.$popup.each(function() {
          var $popup = $(this);
          var popupEnable = true,
              showDelay = $popup.data('show-delay'),
              homepageLimit = $popup.data('homepage-limit'),
              visitorLimit = $popup.data('visitor-limit'),
              isVisitor = $popup.data('visitor'),
              showFor = $popup.data('show-for');

          // Disable popup if "only enable for visitor" and customer
          if (visitorLimit == true && isVisitor == false) {
            popupEnable = false;
          }

          var $errors = $popup.find('.errors');
          if ($errors.length) {
            showDelay = 0;
          }

          var popupTimeout = setTimeout(function() {
            var windowWidth = $(window).width();
            switch (showFor) {
              case 'mobile':
                if (windowWidth <= StyleHatch.largeMobile) {
                  $popup.showPopup();
                }
                break;
              case 'desktop':
                if (windowWidth > StyleHatch.largeMobile) {
                  $popup.showPopup();
                }
                break;
              case 'both':
                $popup.showPopup();
                break;
            }
          }, showDelay);
        });
      }
    }

    // Prototypes
    /*
     * Popups
     * - showPopup
     * - hidePopup
     */
    $.fn.extend({
      showPopup: function(force) {
        var $popup = $(this);
        var popupEnable = true,
            showDelay = $popup.data('show-delay'),
            showAgainDelay = $popup.data('show-again-delay'),
            homepageLimit = $popup.data('homepage-limit'),
            visitorLimit = $popup.data('visitor-limit'),
            isVisitor = $popup.data('visitor'),
            showFor = $popup.data('show-for'),
            type = $popup.data('type'),
            id = $popup.data('id');

        // Disable popup if "only enable for visitor" and customer
        if (visitorLimit == true && isVisitor == false) {
          popupEnable = false;
        }

        // Check to see if the cookie exists
        var cookieName = 'popup-' + id;
        if ($.cookie(cookieName)) {
          popupEnable = false;
        }

        // Check for homepage limit
        if (homepageLimit && !cache.$body.hasClass('template-index')) {
          popupEnable = false;
        }

        if (window.self !== window.top && type == 'popup') {
          popupEnable = false;
        }

        // Always show signup-bar popup if inside the editor
        if (force) {
          popupEnable = true;
        }

        // Check for errors to show the popup anyways
        var $errors = $popup.find('.errors');
        var formTags = getQueryString('contact%5Btags%5D');

        if ($errors.length && formTags.includes('popup')) {
          popupEnable = true;
          $popup.find('input#email').addClass('errors');
        }

        if ($errors.length && formTags.includes('signup-bar')) {
          popupEnable = true;
        }

        // Remove target=_blank on touch
        if (Modernizr.touchevents) {
          $popup.find('form').removeAttr('target');
        }

        if (popupEnable) {
          if (type == 'popup') {
            $.magnificPopup.open({
              items: {
                src: $popup,
                type: 'inline',
                showCloseBtn: false,
              },
              mainClass: 'mfp-slideup',
              removalDelay: 300,
              callbacks: {
                close: function() {
                  $.cookie(cookieName, 'shown', {
                    expires: showAgainDelay,
                    path: StyleHatch.routes.root_url,
                  });
                },
              },
            });
          }

          if (type == 'signup-bar') {
            if (force) {
              $popup.addClass('visible force');
            } else {
              $popup.addClass('visible');
            }
          }

          var $close = $popup.find('.icon-text');
          $close.on('click', function(e) {
            $popup.hidePopup();
            e.preventDefault();
          });

          // On click subscribe button
          var $form = $popup.find('form');
          $form.on('submit', function(e) {
            if (e.target.checkValidity()) {
              $popup.hidePopup();
              $(this).submit();
            } else {
              return false;
            }
          });
        }
      },
      hidePopup: function() {
        var $promos = $('#shopify-section-promos');
        var $popup = $(this);
        var type = $popup.data('type'),
            id = $popup.data('id');

        if (type == 'popup') {
          $.magnificPopup.close();
        }

        if (type == 'signup-bar') {
          var cookieName = 'popup-' + id;

          $.cookie(cookieName, 'shown', {
            expires: 60,
            path: StyleHatch.routes.root_url,
          });

          // close all signup bars
          $('.promo-bar.signup-bar').each(function(i) {
            $(this).slideUp({
              duration: 400,
              progress: function() {
                StyleHatch.refreshFixTo();
              },
              complete: function() {
                // one final refresh call
                StyleHatch.refreshFixTo();
                $(this).removeClass('visible force');
              },
            });
          });
        }
      },
      promoSlideUp: function() {
        $(this).slideUp({
          duration: config.slideSpeed,
          progress: StyleHatch.refreshFixTo,
          complete: StyleHatch.refreshFixTo,
        });
      },
      promoSlideDown: function() {
        $(this).slideDown({
          duration: config.slideSpeed,
          progress: StyleHatch.refreshFixTo,
          complete: StyleHatch.refreshFixTo,
        });
      },
      // Simulated versions for the customize theme menu
      showMockPopup: function() {
        var $promos = $('#shopify-section-promos');
        if (!$('.mock-popup-container').length) {
          $promos
          .find('>*:first')
          .append('<div class="mock-popup-container"></div>');
        }
        var $mockPopupContainer = $('.mock-popup-container');
        var $popup = $(this);
        $popup.appendTo($mockPopupContainer);

        $mockPopupContainer.show();
        $popup.show();
      },
      hideMockPopup: function() {
        var $mockPopupContainer = $('.mock-popup-container');
        var $popup = $(this);
        $mockPopupContainer.hide();
        $popup.hide();
      },
    });

    function blockSelect(evt) {
      var $block = $('#block-' + evt.detail.blockId);
      var blockType = $block.data('type');

      // close any open popup
      $.magnificPopup.close();

      // make sure each block type opens
      switch (blockType) {
        case 'announcement-bar':
          // Promo bars
          // Always show the bar when the block is selected
          $block.promoSlideDown();
          $block.attr('data-pause-hide', true);

          break;
        case 'popup':
          $block.showMockPopup();
          break;
        case 'signup-bar':
          $block.showPopup(true);
          break;
      }
      StyleHatch.Header.rebuildFixTo();
      StyleHatch.refreshFixTo();
    }
    function blockDeselect(evt) {
      var $block = $('#block-' + evt.detail.blockId);
      var blockType = $block.data('type');
      var showFor = $block.data('show-for');
      var windowWidth = $(window).width();

      // make sure each block type closes (if it should)
      switch (blockType) {
        case 'announcement-bar':
          var $promoBar = $block;
          $promoBar.attr('data-pause-hide', false);

          var hideDelay = $promoBar.data('hide-delay');
          var barPlacement = $promoBar.data('bar-placement');
          var homepageLimit = $promoBar.data('homepage-limit');

          // Instantly hide any promo bar that was open for editing only (wrong size)
          if (showFor == 'desktop' && windowWidth <= StyleHatch.largeMobile) {
            $block.promoSlideUp();
          } else if (
            showFor == 'mobile' &&
            windowWidth > StyleHatch.largeMobile
          ) {
            $block.promoSlideUp();
          }

          // Hide the bar after ms delay (hideDelay)
          if (hideDelay !== 'no-delay') {
            config.hideTimers.push(
              setTimeout(function() {
                if (!$promoBar.data('pause-hide')) {
                  $promoBar.promoSlideUp();
                }
              }, hideDelay)
            );
          }
          break;
        case 'popup':
          $block.hideMockPopup();
          break;

        case 'signup-bar':
          if (showFor == 'desktop' && windowWidth <= StyleHatch.largeMobile) {
            $block.hidePopup();
            StyleHatch.refreshFixTo();
          }
          if (showFor == 'mobile' && windowWidth > StyleHatch.largeMobile) {
            $block.hidePopup();
            StyleHatch.refreshFixTo();
          }
          break;
      }
      StyleHatch.Header.rebuildFixTo();
    }
    function unload() {
      // Clear out timers
      if (
        typeof config.hideTimers == 'undefined' ||
        !(config.hideTimers instanceof Array)
      ) {
        config.hideTimers = [];
      } else {
        for (var i = 0; i < config.hideTimers.length; i++) {
          clearTimeout(config.hideTimers[i]);
        }
        config.hideTimers.length = 0;
      }

      // Clean up fixto
      destroyFixTo();
      StyleHatch.refreshFixTo();

      // Misc
      cache.$bottomContainer.remove();
      $.magnificPopup.close();
    }

    return {
      init: init,
      unload: unload,
      blockSelect: blockSelect,
      blockDeselect: blockDeselect,
      refreshFixTo: refreshFixTo,
    };
  })();

  /**
   * Header
   */
  StyleHatch.HeaderSection = (function() {
    function HeaderSection(container) {
      var $container = (this.$container = $(container));
      var id = $container.attr('data-section-id');
      StyleHatch.Header.init();
    }

    return HeaderSection;
  })();
  StyleHatch.HeaderSection.prototype = $.extend(
    {},
    StyleHatch.HeaderSection.prototype,
    {
      onUnload: function() {
        StyleHatch.Header.unload();
      },
    }
  );
  // Header Class
  StyleHatch.Header = (function() {
    var selectors = {
      htmlBody: 'html, body',
      body: 'body',
      page: '#page',
      section: '#shopify-section-header',
      promosSection: '#shopify-section-promos',
      util: 'header.util',
      header: 'header.site-header',
      siteNav: 'header.site-header ul.site-nav',
      menuLink: '.menu-link',
      menuPanel: '#menu.panel',
      menuOverlay: '.mobile-menu-overlay',
    };

    var config = {};
    config = {
      blurTimer: {},
      blurTime: 2000,
      slideSpeed: 300,
      // Dropdowns
      dropdownActiveClass: 'dropdown-hover',
      subDropdownActiveClass: 'sub-dropdown-hover',
    };

    var cache = {};

    function init() {
      cacheSelectors();

      // Util
      initUtilHeader();
      bindUtilHeaderEvents();
      // Header
      initHeader();
      bindHeaderEvents();

      $('[data-currency-selector]').on('change', function() {
        $(this)
        .parents('form')
        .submit();
      });

      rebuildFixTo();
    }

    function cacheSelectors() {
      cache = {
        $htmlBody: $(selectors.htmlBody),
        $body: $(selectors.body),
        $page: $(selectors.page),
        $section: $(selectors.section),
        $promosSection: $(selectors.promosSection),
        $util: $(selectors.util),
        $header: $(selectors.header),
        $siteNav: $(selectors.siteNav),
        // Dropdowns
        $dropdownParent: $(selectors.siteNav).find('li.has-dropdown'),
        $defaultLink: $(selectors.siteNav).find('> li:not(.has-dropdown)'),
        $subMenuLinks: $(selectors.siteNav).find('li.has-dropdown a'),
        $subDropdownParent: $(selectors.siteNav).find('li.has-sub-dropdown'),
        // Util
        $search: $(selectors.util).find('.search-wrapper'),
        $searchLink: $(selectors.util).find('a.search'),
        $searchClose: $(selectors.util).find('form.search-bar button'),
        $searchInput: $(selectors.util).find('form.search-bar input'),
        // Panel menu
        $menuLink: $(selectors.menuLink),
        $menuPanel: $(selectors.menuPanel),
        $menuPanelDropdown: $(selectors.menuPanel).find('li.has-dropdown'),
        $menuPanelSubDropdown: $(selectors.menuPanel).find(
          'li.has-sub-dropdown'
        ),
      };
    }

    /*
     * Util header
     * ------------------------
     */
    function initUtilHeader() {
      // Add overlay
      if (!$(selectors.menuOverlay).length) {
        cache.$section.append('<div class="mobile-menu-overlay"></div>');
        cache.$menuOverlay = $(selectors.menuOverlay);
      }
    }
    /*
     * Search open/close
     */
    function openSearch() {
      cache.$search.slideDown({
        duration: config.slideSpeed,
        progress: function() {
          StyleHatch.refreshFixTo();
        },
        complete: function() {
          StyleHatch.refreshFixTo();
        },
      });
      cache.$searchInput.focus();
    }
    function closeSearch() {
      cache.$searchInput.blur();
      clearTimeout(config.blurTimer);
      cache.$search.slideUp({
        duration: config.slideSpeed,
        progress: function() {
          StyleHatch.refreshFixTo();
        },
        complete: function() {
          StyleHatch.refreshFixTo();
        },
      });
    }
    /*
     * Mobile panel open/close
     */
    function togglePanelMenu() {
      if (cache.$body.hasClass('panel-open')) {
        closePanelMenu();
      } else {
        openPanelMenu();
      }
    }
    function openPanelMenu() {
      cache.$htmlBody.addClass('panel-open');
      window.scrollTo(0, 0);
      cache.$menuPanel.attr('tabindex', '0');
      cache.$menuPanel.focus();
    }
    function closePanelMenu() {
      cache.$htmlBody.addClass('panel-open-transition');
      cache.$htmlBody.removeClass('panel-open');
      cache.$menuPanel.removeAttr('tabindex');

      setTimeout(function() {
        cache.$htmlBody.removeClass('panel-open-transition');
      }, 400);
    }
    /*
     * Events
     */
    function bindUtilHeaderEvents() {
      // Search
      cache.$searchLink.on('click.search', function(e) {
        openSearch();
        e.preventDefault();
      });
      cache.$searchClose.on('click.search', function(e) {
        closeSearch();
        e.preventDefault();
      });
      // cache.$searchInput.on('blur.search', function(e) {
      //   config.blurTimer = setTimeout(closeSearch, config.blurTime);
      //   e.preventDefault();
      // });

      // Mobile panel menu
      cache.$menuLink.on('click.panel', function(e) {
        togglePanelMenu();
        e.preventDefault();
      });
      cache.$menuOverlay.on('click.panel', function(e) {
        togglePanelMenu();
        e.preventDefault();
      });

      // Collapsible panel navigation (subnav)
      cache.$menuPanelDropdown.on('click.panelDropdown', function(e) {
        // Slide up previous one(s)
        cache.$menuPanelDropdown.find('ul.dropdown').slideUp();
        cache.$menuPanelDropdown.find('> a').attr('aria-expanded', 'false');
        cache.$menuPanelDropdown.removeClass('expanded');

        cache.$menuPanelDropdown
        .find('ul.dropdown')
        .attr('aria-hidden', 'true');
        cache.$menuPanelDropdown.find('ul.dropdown a').attr('tabindex', '-1');

        // If it's not open slide down the menu
        // and don't allow the click
        if (
          !$(this)
          .find('ul.dropdown')
          .is(':visible')
        ) {
          $(this)
          .find('> a')
          .attr('aria-expanded', 'true');
          $(this)
          .find('ul.dropdown')
          .slideDown();
          $(this)
          .find('ul.dropdown')
          .attr('aria-hidden', 'false');
          $(this)
          .find('ul.dropdown > li > a')
          .attr('tabindex', '0');
          $(this).addClass('expanded');
        }
      });

      cache.$menuPanelDropdown
      .find('> a')
      .on('click.panelDropdown', function(e) {
        if (
          !$(this)
          .closest('li')
          .hasClass('expanded')
        ) {
          e.preventDefault();
        }
      });
      cache.$menuPanelDropdown
      .find('ul.dropdown li:not(.has-sub-dropdown) a')
      .on('click.panelDropdown', function(e) {
        e.stopPropagation();
      });

      // Collapsible panel navigation (sub-subnav)
      cache.$menuPanelSubDropdown.on('click.panelDropdown', function(e) {
        e.stopPropagation();
        cache.$menuPanelSubDropdown.find('ul.sub-dropdown').slideUp();
        cache.$menuPanelDropdown.find('> a').attr('aria-expanded', 'false');
        cache.$menuPanelSubDropdown.removeClass('expanded');

        cache.$menuPanelDropdown
        .find('ul.sub-dropdown')
        .attr('aria-hidden', 'true');
        cache.$menuPanelDropdown
        .find('ul.sub-dropdown a')
        .attr('tabindex', '-1');

        // If it's not open slide down the menu
        // and don't allow the click
        if (
          !$(this)
          .find('ul.sub-dropdown')
          .is(':visible')
        ) {
          $(this)
          .find('> a')
          .attr('aria-expanded', 'true');
          $(this)
          .find('ul.sub-dropdown')
          .slideDown();
          $(this)
          .find('ul.sub-dropdown')
          .attr('aria-hidden', 'false');
          $(this)
          .find('ul.sub-dropdown > li > a')
          .attr('tabindex', '0');
          $(this).addClass('expanded');
        }
      });

      cache.$menuPanelSubDropdown
      .find('> a')
      .on('click.panelDropdown', function(e) {
        if (
          !$(this)
          .closest('li')
          .hasClass('expanded')
        ) {
          e.preventDefault();
        }
      });
      cache.$menuPanelSubDropdown
      .find('ul.sub-dropdown a')
      .on('click.panelDropdown', function(e) {
        e.stopPropagation();
      });

      // Promo resize
      cache.$promosSection.resize(StyleHatch.refreshFixTo);
    }
    function unbindUtilHeaderEvents() {
      // Search
      clearTimeout(config.blurTimer);
      cache.$searchLink.off('click.search');
      cache.$searchClose.off('click.search');
      cache.$searchInput.off('blur.search');

      // Mobile panel menu
      cache.$menuLink.off('click.panel');
      //cache.$menuOverlay.off('click.panel');

      // Collapsible panel navigation
      cache.$menuPanelDropdown.off('click.panelDropdown');
      cache.$menuPanelDropdown.find('> a').off('click.panelDropdown');
      cache.$menuPanelDropdown
      .find('ul.dropdown li:not(.has-sub-dropdown) a')
      .off('click.panelDropdown');

      cache.$menuPanelSubDropdown.off('click.panelDropdown');
      cache.$menuPanelSubDropdown.find('> a').off('click.panelDropdown');
      cache.$menuPanelSubDropdown
      .find('ul.sub-dropdown a')
      .off('click.panelDropdown');

      // Promo resize
      cache.$promosSection.removeResize(StyleHatch.refreshFixTo);
    }

    /*
     * Header
     * ------------------------
     */
    function initHeader() {
      // Adds line breaks to really long subnav text links
      cache.$subMenuLinks.each(function() {
        var $link = $(this);
        var linkText = $link.text();
        var linkTextWrapped = wordWrapper(linkText, 24, '<br/>\n');

        // Apply wrapped text
        // $link.html(linkTextWrapped);
      });

      // Prevent Safari from reopening menu when browsing back
      hideDropdown(cache.$dropdownParent);
    }
    /*
     * Dropdown open / close
     */
    function showDropdown($el) {
      // Hide previous
      hideDropdown($('.' + config.dropdownActiveClass));

      $el.addClass(config.dropdownActiveClass);

      // Accessiblity
      $el.find('> a').attr('aria-expanded', 'true');
      $el.find('ul.dropdown').attr('aria-hidden', 'false');
      $el.find('ul.dropdown > li > a').attr('tabindex', '0');

      var $dropdown = $el.find('ul.dropdown');
      if (!$dropdown.hasClass('dropdown--mega-menu')) {
        $dropdown.css({
          left: 'auto',
        });
      }
      var dropdownEnd = $dropdown.offset().left + $dropdown.outerWidth();

      // Account for page edge padding
      var pageWidth = $(window).width() - 20;

      // Without border
      var siteWidth = cache.$header.width();
      var logoOffset = cache.$header.find('.logo-nav-contain').offset().left;

      if (siteWidth + 40 > $(window).width()) {
        siteWidth = $(window).width();
        logoOffset = -20;
      }

      pageWidth = siteWidth + logoOffset + 1;

      if (dropdownEnd > pageWidth) {
        if (!$dropdown.hasClass('dropdown--mega-menu')) {
          var rightEdge = '-' + (dropdownEnd - pageWidth) + 'px';
          $dropdown.css({
            left: rightEdge,
          });
        }
      }

      setTimeout(function() {
        cache.$body.on('touchstart', function() {
          hideDropdown($el);
        });
      }, 250);
    }
    function hideDropdown($el) {
      $el.removeClass(config.dropdownActiveClass);
      cache.$body.off('touchstart');

      // Accessiblity
      $el.find('> a').attr('aria-expanded', 'false');
      $el.find('ul.dropdown').attr('aria-hidden', 'true');
      $el.find('ul.dropdown > li > a').attr('tabindex', '-1');
    }
    // Sub dropdowns
    function showSubDropdown($el) {
      hideDropdown($('.' + config.subDropdownActiveClass));

      $el.addClass(config.subDropdownActiveClass);

      // Accessiblity
      $el.find('> a').attr('aria-expanded', 'true');
      $el.find('ul.sub-dropdown').attr('aria-hidden', 'false');
      $el.find('ul.sub-dropdown > li > a').attr('tabindex', '0');

      // Check if partially in view
      //log($el.find('.sub-dropdown').offset().left, $el.find('.sub-dropdown').width());

      // Show subdropdown to the left if there isn't enough room
      var dropdownOffsetEdge =
          $el.find('.sub-dropdown').offset().left +
          $el.find('.sub-dropdown').width();
      var windowWidth = $(window).width();
      if (dropdownOffsetEdge > windowWidth) {
        $el.addClass('alternate-align');
      } else {
        $el.removeClass('alternate-align');
      }
    }
    function hideSubDropdown($el) {
      $el.removeClass(config.subDropdownActiveClass);
      $el.removeClass('alternate-align');
      // Accessiblity
      $el.find('> a').attr('aria-expanded', 'false');
      $el.find('ul.sub-dropdown').attr('aria-hidden', 'true');
      $el.find('ul.sub-dropdown > li > a').attr('tabindex', '-1');
    }
    /*
     * Events
     */
    function bindHeaderEvents() {
      // Dropdown
      cache.$dropdownParent.on(
        'mouseenter.dropdown touchstart.dropdown focusin.dropdown',
        function(e) {
          var $el = $(this);

          if (!$el.hasClass(config.dropdownActiveClass)) {
            e.preventDefault();
            showDropdown($el);
          }
        }
      );
      cache.$dropdownParent.on('mouseleave.dropdown', function() {
        hideDropdown($(this));
      });
      cache.$subMenuLinks.on('touchstart.dropdown', function(e) {
        // Prevent touchstart on body from firing instead of link
        e.stopImmediatePropagation();
      });

      // Subdropdowns
      cache.$subDropdownParent.on(
        'mouseenter.subdropdown touchstart.subdropdown focusin.subdropdown',
        function(e) {
          var $el = $(this);

          if (!$el.hasClass(config.subDropdownActiveClass)) {
            e.preventDefault();
            showSubDropdown($el);
          }
        }
      );
      cache.$subDropdownParent.on('mouseleave.subdropdown', function() {
        hideSubDropdown($(this));
      });
      cache.$subDropdownParent.on('touchstart.subdropdown', function(e) {
        // Prevent touchstart on body from firing instead of link
        e.stopImmediatePropagation();
      });

      if ($('html').hasClass('touchevents')) {
        cache.$subDropdownParent.children('a').on('click', function(e) {
          var $el = $(this);

          if (!$el.hasClass(config.subDropdownActiveClass)) {
            e.preventDefault();
            showSubDropdown($el);
          }
        });
      }

      // Focus out detect tabbing outside of dropdown or subdropdown
      cache.$subMenuLinks.on('focusout.dropdown', function(e) {
        if (e.relatedTarget == null) {
          hideDropdown($('.' + config.dropdownActiveClass));
        } else {
          if (
            $(e.target).closest('li.has-dropdown')[0] !==
            $(e.relatedTarget).closest('li.has-dropdown')[0]
          ) {
            hideDropdown($('.' + config.dropdownActiveClass));
          }
          if (
            $(e.target).closest('li.has-sub-dropdown')[0] !==
            $(e.relatedTarget).closest('li.has-sub-dropdown')[0]
          ) {
            hideSubDropdown($('.' + config.subDropdownActiveClass));
          }
        }
      });
    }
    function unbindHeaderEvents() {
      // Dropdown
      cache.$dropdownParent.off(
        'mouseenter.dropdown touchstart.dropdown focusin.dropdown'
      );
      cache.$dropdownParent.off('mouseleave.dropdown');
      cache.$subMenuLinks.off('touchstart.dropdown');

      // Subdropdowns
      cache.$subDropdownParent.off(
        'mouseenter.subdropdown touchstart.subdropdown focusin.subdropdown'
      );
      cache.$subDropdownParent.off('mouseleave.subdropdown');
      cache.$subDropdownParent.off('touchstart.subdropdown');

      // Focus out detect tabbing outside of dropdown or subdropdown
      cache.$subMenuLinks.off('focusout.dropdown');
    }

    /*
     * fixTo - Complete header
     */
    function createFixTo() {
      var $headerSection = cache.$section;
      var $promosSection = cache.$promosSection;
      var $header = cache.$header;
      var $util = cache.$util;

      // Lock the util or header to the top on scroll
      var scrollLock = $header.data('scroll-lock');
      if (scrollLock == 'util' || scrollLock == 'header') {
        var mindElements = '';
        if ($promosSection.data('fixtoInstance')) {
          mindElements = '#shopify-section-promos';
        }
        $util.fixTo('#page', {
          zIndex: 991,
          mind: mindElements,
        });
      }
      if (scrollLock == 'header') {
        var mindElements = 'header.util';
        if ($promosSection.data('fixtoInstance')) {
          mindElements = 'header.util, #shopify-section-promos';
        }
        $headerSection.fixTo('#page', {
          zIndex: 990,
          mind: mindElements,
        });
        $headerSection.resize(function() {
          if ($(this).width() <= 700) {
            $headerSection.fixTo('stop');
          } else {
            $headerSection.fixTo('start');
          }
        });
      }
    }
    function destroyFixTo() {
      // Destroy header locks
      var $fixToElements = $('header.util, #shopify-section-header').filter(
        function() {
          return $(this).data('fixtoInstance');
        }
      );
      if ($fixToElements.length) {
        $fixToElements.fixTo('destroy');
      }
    }
    function rebuildFixTo() {
      cacheSelectors();
      destroyFixTo();
      createFixTo();
    }

    function unload() {
      // Util
      closePanelMenu();
      unbindUtilHeaderEvents();
      // Header
      unbindHeaderEvents();
      destroyFixTo();
    }

    return {
      init: init,
      unload: unload,
      openSearch: openSearch,
      closeSearch: closeSearch,
      togglePanelMenu: togglePanelMenu,
      openPanelMenu: openPanelMenu,
      closePanelMenu: closePanelMenu,
      rebuildFixTo: rebuildFixTo,
    };
  })();

  /**
   * Footer
   * Global section
   */
  StyleHatch.FooterSection = (function() {
    function FooterSection(container) {
      var $container = (this.$container = $(container));
      var id = $container.attr('data-section-id');
      StyleHatch.Footer.init($container);
    }

    return FooterSection;
  })();
  StyleHatch.FooterSection.prototype = $.extend(
    {},
    StyleHatch.FooterSection.prototype,
    {
      onUnload: function(evt) {
        StyleHatch.Footer.unload(evt);
      },
    }
  );
  // Footer class
  StyleHatch.Footer = (function() {
    function init($container) {
      var $nestedMenu = $container.find('ul.nested-menu');
      $nestedMenu.initNestedMenu();
    }
    function unload(evt) {
      $nestedMenu.destroyNestedMenu();
    }

    return {
      init: init,
      unload: unload,
    };
  })();

  /**
   * Slideshow
   */
  StyleHatch.SlideshowSection = (function() {
    function SlideshowSection(container) {
      var $container = (this.$container = $(container));
      var id = $container.attr('data-section-id');
      StyleHatch.Slideshow.init($container);
    }

    return SlideshowSection;
  })();
  StyleHatch.SlideshowSection.prototype = $.extend(
    {},
    StyleHatch.SlideshowSection.prototype,
    {
      onUnload: function(evt) {
        StyleHatch.Slideshow.unload(evt);
      },
      onBlockSelect: function(evt) {
        StyleHatch.Slideshow.blockSelect(evt);
      },
      onBlockDeselect: function(evt) {
        StyleHatch.Slideshow.blockDeselect(evt);
      },
    }
  );
  // Slideshow Class
  StyleHatch.Slideshow = (function() {
    // Initialization
    function init($container) {
      var $carousel = $container.find('.slideshow-carousel');

      // Preload mobile or desktop slide images based on width
      var mobileWidth = 700;
      var $slideItem = $carousel.find('.slide__item');
      $(window).on('resize', function() {
        $slideItem.each(function(i) {
          var $responsiveImg;
          if ($(window).width() > mobileWidth) {
            $responsiveImg = $(this).find('img.slide__image-desktop');
          } else {
            $responsiveImg = $(this).find('img.slide__image-mobile');
            if ($responsiveImg.length < 1) {
              $responsiveImg = $(this).find('img.slide__image-desktop');
            }
          }

          if ($responsiveImg.hasClass('lazymanual')) {
            $responsiveImg
            .attr('src', $responsiveImg.attr('data-preload'))
            .removeAttr('data-preload');
            $responsiveImg.removeClass('lazymanual').addClass('lazyload');
          }
        });
      });

      var flickityOptions = $carousel.data('flickity-options');
      // Pass options from data attribute object
      $carousel.flickity(flickityOptions);
      $carousel
      .parent()
      .find('.flickity-page-dots.placeholder')
      .remove();

      var $responsiveImg;
      if ($(window).width() > mobileWidth) {
        $responsiveImg = $('img.slide__image-desktop', $container);
      } else {
        $responsiveImg = $('img.slide__image-mobile', $container);
        if ($responsiveImg.length < 1) {
          $responsiveImg = $('img.slide__image-desktop', $container);
        }
      }
      // Initiate the first image lazyload
      $responsiveImg
      .eq(0)
      .removeClass('lazymanual')
      .addClass('lazyload');

      // Change all image to lazyload on first slide change
      $carousel.on('change.flickity', function(event, index) {
        var $lazyManual = $('img.lazymanual', $container);
        $lazyManual.removeClass('lazymanual').addClass('lazyload');
        $carousel.off('change.flickity');
      });

      // Load YouTube videos
      var $videoSlides = $container.find('.slide__item-video');
      $videoSlides.each(function() {
        var $slideVideo = $(this).find('.slide__item-image');
        var videoId = $(this).data('video-id');
        var autoplayMobile = $(this).data('mobile-autoplay');
        var playsinline = 0;
        if (autoplayMobile) {
          playsinline = 1;
        }
        if ($(window).width() > StyleHatch.largeMobile || autoplayMobile) {
          $slideVideo.YTPlayer({
            fitToBackground: false,
            videoId: videoId,
            repeat: true,
            mute: true,
            playerVars: {
              rel: 0,
              mute: 1,
              playsinline: playsinline,
              autoplay: 1,
            },
            callback: function() {
              $(window).trigger('resize');
            },
          });
        }
      });
    }

    function blockSelect(evt) {
      var $block = $('#block-' + evt.detail.blockId);
      var $carousel = $block.closest('.slideshow-carousel');
      var slideIndex = $block.data('slide-index');
      // Pause flickity and select the current block
      $carousel.flickity('pausePlayer');
      $carousel.flickity('select', slideIndex, true, true);
      // Lazyload all images
      $carousel
      .find('img')
      .removeClass('.lazymanual')
      .addClass('lazyload');
    }
    function blockDeselect(evt) {
      var $block = $('#block-' + evt.detail.blockId);
      var $carousel = $block.closest('.slideshow-carousel');
      // Unpause player
      $carousel.flickity('unpausePlayer');
    }
    // Unload
    function unload(evt) {
      var $section = $('.slideshow-' + evt.detail.sectionId);
      var $carousel = $section.find('.slideshow-carousel');
      // Destroy flickity to be rebuilt
      $carousel.flickity('destroy');

      // Destroy YouTube
      var $slideVideo = $section.find('.slide__item-video .slide__item-image');
      // Destroy
      $slideVideo
      .removeData('yt-init')
      .removeData('ytPlayer')
      .removeClass('loaded');

      $(window).off('resize.YTplayer' + $slideVideo.ID);
      $(window).off('scroll.YTplayer' + $slideVideo.ID);

      $slideVideo.$body = null;
      $slideVideo.$node = null;
      $slideVideo.$YTPlayerString = null;
      $slideVideo.player = null;
    }

    // Public methods
    return {
      init: init,
      unload: unload,
      blockSelect: blockSelect,
      blockDeselect: blockDeselect,
    };
  })();

  /**
   * Hero Video
   */
  StyleHatch.HeroVideoSection = (function() {
    function HeroVideoSection(container) {
      var $container = (this.$container = $(container));
      var id = $container.attr('data-section-id');

      StyleHatch.HeroVideo.init($container);
    }

    return HeroVideoSection;
  })();
  StyleHatch.HeroVideoSection.prototype = $.extend(
    {},
    StyleHatch.HeroVideoSection.prototype,
    {
      onUnload: function(evt) {
        StyleHatch.HeroVideo.unload(evt);
      },
    }
  );
  // Slideshow Class
  StyleHatch.HeroVideo = (function() {
    // Initialization
    function init($container) {
      var $heroVideo = $container.find('.wrapper');
      var videoId = $container.data('video-id');
      var autoplayMobile = $container.data('mobile-autoplay');
      var playsinline = 0;
      if (autoplayMobile) {
        playsinline = 1;
      }
      $heroVideo.removeData('ytPlayer');

      $heroVideo.YTPlayer({
        fitToBackground: false,
        videoId: videoId,
        repeat: true,
        mute: true,
        playerVars: {
          rel: 0,
          mute: 1,
          playsinline: playsinline,
          autoplay: 1,
        },
      });
    }

    // Unload
    function unload(evt) {
      var $section = $('.slideshow-' + evt.detail.sectionId);
      var $heroVideo = $section.find('.wrapper');
      // Destroy
      $heroVideo
      .removeData('yt-init')
      .removeData('ytPlayer')
      .removeClass('loaded');
      $heroVideo.find('.ytplayer-container .ytplayer-shield').remove();
    }

    // Public methods
    return {
      init: init,
      unload: unload,
    };
  })();

  /**
   * Maps
   */
  StyleHatch.Maps = (function() {
    var config = {
      zoom: 14,
    };
    var apiStatus = null;
    var apiKey = null;
    var apiKeyReset = false;
    var mapsToLoad = [];

    var mapStyles = {
      standard: [],
      silver: [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
      ],
        retro: [
        {
        elementType: 'geometry',
        stylers: [
        {
        color: '#ebe3cd',
        },
      ],
    },
        {
          elementType: 'labels.text.fill',
          stylers: [
          {
          color: '#523735',
        },
        ],
  },
                     {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f1e6',
      },
    ],
  },
                     {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#c9b2a6',
      },
    ],
  },
                     {
    featureType: 'administrative.land_parcel',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#dcd2be',
      },
    ],
  },
                     {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#ae9e90',
      },
    ],
  },
                     {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dfd2ae',
      },
    ],
  },
                     {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dfd2ae',
      },
    ],
  },
                     {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#93817c',
      },
    ],
  },
                     {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#a5b076',
      },
    ],
  },
                     {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#447530',
      },
    ],
  },
                     {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f1e6',
      },
    ],
  },
                     {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#fdfcf8',
      },
    ],
  },
                     {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f8c967',
      },
    ],
  },
                     {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#e9bc62',
      },
    ],
  },
                     {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e98d58',
      },
    ],
  },
                     {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#db8555',
      },
    ],
  },
                     {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#806b63',
      },
    ],
  },
                     {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dfd2ae',
      },
    ],
  },
                     {
    featureType: 'transit.line',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#8f7d77',
      },
    ],
  },
                     {
    featureType: 'transit.line',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ebe3cd',
      },
    ],
  },
                     {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dfd2ae',
      },
    ],
  },
                     {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#b9d3c2',
      },
    ],
  },
                     {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#92998d',
      },
    ],
  },
                     ],
                     dark: [
                     {
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#212121',
                     },
                     ],
                     },
                     {
                     elementType: 'labels.icon',
                     stylers: [
                     {
                     visibility: 'off',
                     },
                     ],
                     },
                     {
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#757575',
                     },
                     ],
                     },
                     {
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#212121',
                     },
                     ],
                     },
                     {
                     featureType: 'administrative',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#757575',
                     },
                     ],
                     },
                     {
                     featureType: 'administrative.country',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#9e9e9e',
                     },
                     ],
                     },
                     {
                     featureType: 'administrative.land_parcel',
                     stylers: [
                     {
                     visibility: 'off',
                     },
                     ],
                     },
                     {
                     featureType: 'administrative.locality',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#bdbdbd',
                     },
                     ],
                     },
                     {
                     featureType: 'poi',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#757575',
                     },
                     ],
                     },
                     {
                     featureType: 'poi.park',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#181818',
                     },
                     ],
                     },
                     {
                     featureType: 'poi.park',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#616161',
                     },
                     ],
                     },
                     {
                     featureType: 'poi.park',
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#1b1b1b',
                     },
                     ],
                     },
                     {
                     featureType: 'road',
                     elementType: 'geometry.fill',
                     stylers: [
                     {
                     color: '#2c2c2c',
                     },
                     ],
                     },
                     {
                     featureType: 'road',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#8a8a8a',
                     },
                     ],
                     },
                     {
                     featureType: 'road.arterial',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#373737',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#3c3c3c',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway.controlled_access',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#4e4e4e',
                     },
                     ],
                     },
                     {
                     featureType: 'road.local',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#616161',
                     },
                     ],
                     },
                     {
                     featureType: 'transit',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#757575',
                     },
                     ],
                     },
                     {
                     featureType: 'water',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#000000',
                     },
                     ],
                     },
                     {
                     featureType: 'water',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#3d3d3d',
                     },
                     ],
                     },
                     ],
                     night: [
                     {
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#242f3e',
                     },
                     ],
                     },
                     {
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#746855',
                     },
                     ],
                     },
                     {
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#242f3e',
                     },
                     ],
                     },
                     {
                     featureType: 'administrative.locality',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#d59563',
                     },
                     ],
                     },
                     {
                     featureType: 'poi',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#d59563',
                     },
                     ],
                     },
                     {
                     featureType: 'poi.park',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#263c3f',
                     },
                     ],
                     },
                     {
                     featureType: 'poi.park',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#6b9a76',
                     },
                     ],
                     },
                     {
                     featureType: 'road',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#38414e',
                     },
                     ],
                     },
                     {
                     featureType: 'road',
                     elementType: 'geometry.stroke',
                     stylers: [
                     {
                     color: '#212a37',
                     },
                     ],
                     },
                     {
                     featureType: 'road',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#9ca5b3',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#746855',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway',
                     elementType: 'geometry.stroke',
                     stylers: [
                     {
                     color: '#1f2835',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#f3d19c',
                     },
                     ],
                     },
                     {
                     featureType: 'transit',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#2f3948',
                     },
                     ],
                     },
                     {
                     featureType: 'transit.station',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#d59563',
                     },
                     ],
                     },
                     {
                     featureType: 'water',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#17263c',
                     },
                     ],
                     },
                     {
                     featureType: 'water',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#515c6d',
                     },
                     ],
                     },
                     {
                     featureType: 'water',
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#17263c',
                     },
                     ],
                     },
                     ],
                     aubergine: [
                     {
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#1d2c4d',
                     },
                     ],
                     },
                     {
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#8ec3b9',
                     },
                     ],
                     },
                     {
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#1a3646',
                     },
                     ],
                     },
                     {
                     featureType: 'administrative.country',
                     elementType: 'geometry.stroke',
                     stylers: [
                     {
                     color: '#4b6878',
                     },
                     ],
                     },
                     {
                     featureType: 'administrative.land_parcel',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#64779e',
                     },
                     ],
                     },
                     {
                     featureType: 'administrative.province',
                     elementType: 'geometry.stroke',
                     stylers: [
                     {
                     color: '#4b6878',
                     },
                     ],
                     },
                     {
                     featureType: 'landscape.man_made',
                     elementType: 'geometry.stroke',
                     stylers: [
                     {
                     color: '#334e87',
                     },
                     ],
                     },
                     {
                     featureType: 'landscape.natural',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#023e58',
                     },
                     ],
                     },
                     {
                     featureType: 'poi',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#283d6a',
                     },
                     ],
                     },
                     {
                     featureType: 'poi',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#6f9ba5',
                     },
                     ],
                     },
                     {
                     featureType: 'poi',
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#1d2c4d',
                     },
                     ],
                     },
                     {
                     featureType: 'poi.park',
                     elementType: 'geometry.fill',
                     stylers: [
                     {
                     color: '#023e58',
                     },
                     ],
                     },
                     {
                     featureType: 'poi.park',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#3C7680',
                     },
                     ],
                     },
                     {
                     featureType: 'road',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#304a7d',
                     },
                     ],
                     },
                     {
                     featureType: 'road',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#98a5be',
                     },
                     ],
                     },
                     {
                     featureType: 'road',
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#1d2c4d',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#2c6675',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway',
                     elementType: 'geometry.stroke',
                     stylers: [
                     {
                     color: '#255763',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#b0d5ce',
                     },
                     ],
                     },
                     {
                     featureType: 'road.highway',
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#023e58',
                     },
                     ],
                     },
                     {
                     featureType: 'transit',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#98a5be',
                     },
                     ],
                     },
                     {
                     featureType: 'transit',
                     elementType: 'labels.text.stroke',
                     stylers: [
                     {
                     color: '#1d2c4d',
                     },
                     ],
                     },
                     {
                     featureType: 'transit.line',
                     elementType: 'geometry.fill',
                     stylers: [
                     {
                     color: '#283d6a',
                     },
                     ],
                     },
                     {
                     featureType: 'transit.station',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#3a4762',
                     },
                     ],
                     },
                     {
                     featureType: 'water',
                     elementType: 'geometry',
                     stylers: [
                     {
                     color: '#0e1626',
                     },
                     ],
                     },
                     {
                     featureType: 'water',
                     elementType: 'labels.text.fill',
                     stylers: [
                     {
                     color: '#4e6d70',
                     },
                     ],
                     },
                     ],
                     };

                     var errors = {
                     addressNoResults: StyleHatch.Strings.addressNoResults,
                     addressQueryLimit: StyleHatch.Strings.addressQueryLimit,
                     addressError: StyleHatch.Strings.addressError,
                     authError: StyleHatch.Strings.authError,
                     };

                     var selectors = {
                     section: '[data-section-type="maps"]',
                     map: '[data-map]',
                     mapOverlay: '[data-map-overlay]',
                     };

                     var classes = {
                     mapError: 'map-selection--load-error',
                     errorMsg: 'map-section__errors errors text-center',
                     };

                     // Global Google function for auth errors
                     window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      log('Google Maps authentication error', window.google, apiStatus);
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      StyleHatch.Strings.authError +
      '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (this.key != apiKey) {
      apiKey = this.key;
      apiStatus = null;
      apiKeyReset = true;
    }

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);
      var mapElement = this;

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined' || apiKeyReset) {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            apiKeyReset = false;
            initAllMaps(mapElement);
          });
        }
      }
    }
  }

  function initAllMaps(mapElement) {
    document.addEventListener('lazybeforeunveil', function(e) {
      if ($(e.target).attr('data-section-type')) {
        mapElement.createMap();
      }
    });

    $.each(mapsToLoad, function(index, instance) {
      if (instance.$container.hasClass('lazyloaded')) {
        mapElement.createMap();
      }
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = $.extend({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;
      var mapStyle = $map.data('map-style');

      return geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
            styles: mapStyles[mapStyle],
          };

          var map = (this.map = new google.maps.Map($map[0], mapOptions));
          var center = (this.center = map.getCenter());

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter(),
          });

          google.maps.event.addDomListener(
            window,
            'resize',
            slate.utils.debounce(function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            }, 250)
          );
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = errors.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = errors.addresQueryLimit;
            break;
          case 'REQUEST_DENIED':
            errorMessage = errors.authError;
            break;
          default:
            errorMessage = errors.addressError;
            break;
        }

        // Show errors only to merchant in the editor.
        if (Shopify.designMode) {
          $map
          .parent()
          .addClass(classes.mapError)
          .append(
            '<div class="' +
            classes.errorMsg +
            '">' +
            errorMessage +
            '</div>'
          );
        }
      });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    },
  });

  return Map;
})();

/**
   * Page Section - any section that loads pages
   */
StyleHatch.PageSection = (function() {
  function PageSection(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr('data-section-id');
    StyleHatch.Page.init($container);
  }

  return PageSection;
})();
// Featured Text Class
StyleHatch.Page = (function() {
  // Initialization
  function init($container) {
    // Apply fitVids
    $container.fitVids();
    // Possibly check for oembed data
  }

  // Unload
  function unload(evt) {
    //log('unload Page');
  }

  // Public methods
  return {
    init: init,
    unload: unload,
  };
})();

/**
   * Sections - Collection
   * ---------------------------------------------------------------------------
   * Feature collection
   */
StyleHatch.FeaturedCollectionSection = (function() {
  function FeaturedCollectionSection(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr('data-section-id');
    $container.productBox();

    if (StyleHatch.currencyConverter) {
      StyleHatch.CurrencyConverter.init();
    }
  }

  return FeaturedCollectionSection;
})();
StyleHatch.FeaturedCollectionSection.prototype = $.extend(
  {},
  StyleHatch.FeaturedCollectionSection.prototype,
  {
    onUnload: function(evt) {
      var $container = $('#section-' + evt.detail.sectionId);
      var id = $container.attr('data-section-id');
      $container.destroyProductBox();
    },
  }
);

StyleHatch.SimpleCollectionSection = (function() {
  function SimpleCollectionSection(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr('data-section-id');
    $container.productBox();

    if (StyleHatch.currencyConverter) {
      StyleHatch.CurrencyConverter.init();
    }
  }

  return SimpleCollectionSection;
})();
StyleHatch.SimpleCollectionSection.prototype = $.extend(
  {},
  StyleHatch.SimpleCollectionSection.prototype,
  {
    onUnload: function(evt) {
      var $container = $('#section-' + evt.detail.sectionId);
      var id = $container.attr('data-section-id');

      $container.destroyProductBox();
    },
  }
);

/**
   * Instagram - instagram-section
   */

StyleHatch.instagrams = {};
StyleHatch.InstagramSection = (function() {
  function InstagramSection(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr('data-section-id');
    var instagram = (this.instagram = '#Instagram-' + id);

    // Only support IE9 and above
    if ($('html').hasClass('lt-ie9')) {
      return false;
    }

    var $shotContainer = $container.find('.instagram-container');
    var $profileLink = $container.find('header a.button, footer a.button');
    var imageCount = $container.data('image-count');
    var accessToken = $container.data('instagram-access-token');
    var apiURL =
        'https://api.instagram.com/v1/users/self/media/recent/?access_token=' +
        accessToken +
        '&count=20';
    // Set how long the localStorage is valid for 12 hours
    var expireTime = 1000 * 60 * 60 * 12; // ms * s * m * 12 hours

    // Helper Text
    var addAccessToken = StyleHatch.Strings.instagramAddToken;
    var invalidAccessToken = StyleHatch.Strings.instagramInvalidToken;
    var rateLimitAccessToken = StyleHatch.Strings.instagramRateLimitToken;

    // AJAX call to load Instagram API data
    var getData = function() {
      // Check if access token exists
      if (accessToken) {
        $.ajax({
          url: apiURL,
          dataType: 'jsonp',
          timeout: 5000,
          success: function(data) {
            switch (data.meta.code) {
              case 400:
                if (Shopify.designMode) {
                  $shotContainer.attr('data-helper-text', invalidAccessToken);
                  storeWithExpiration.set(accessToken, data, expireTime);
                  $container.show();
                }
                break;
              case 429:
                if (Shopify.designMode) {
                  $shotContainer.attr(
                    'data-helper-text',
                    rateLimitAccessToken
                  );
                  $container.show();
                }
                break;
              default:
                loadImages(data);
                storeWithExpiration.set(accessToken, data, expireTime);
            }
          },
        });
      } else {
        if (Shopify.designMode) {
          // Show helper with details of adding token
          $shotContainer.attr('data-helper-text', addAccessToken);
          $container.show();
        }
      }
    };

    // Load in all the recent media in the Instagram data
    var loadImages = function(data) {
      // Check to ensure valid data
      if (data.data) {
        if (data.data.length < imageCount) {
          var dataCount = data.data.length;
          var settingsCount = imageCount;
          var lastIndex = settingsCount - (settingsCount - dataCount);
          imageCount = data.data.length;

          // Remove the extra holders
          $container.find('.box').each(function(i) {
            if (i >= lastIndex) {
              $(this).hide();
            }
          });
        }
        for (var i = 0; i < imageCount; i++) {
          var images = data.data[i].images,
              // Thumbnail
              thumbnail = images.thumbnail.url,
              thumbnailWidth = images.thumbnail.width,
              // Low Resolution
              low_resolution = images.low_resolution.url,
              low_resolutionWidth = images.low_resolution.width,
              // Standard Resolution
              standard_resolution = images.standard_resolution.url,
              standard_resolutionWidth = images.standard_resolution.width;

          var link = data.data[i].link;
          var likes = data.data[i].likes.count;
          var comments = data.data[i].comments.count;

          var caption = '';
          if (data.data[i].caption) {
            caption = data.data[i].caption.text;
          }

          var $shot = $container.find('.box-' + i);
          var $shotImageContainer = $shot.find('figure > a');
          var $shotLinks = $shot.find('figure > a, li > a');
          var $shotCaption = $shot.find('figcaption > p');
          var $shotLikes = $shot.find('a.likes span.label');
          var $shotComments = $shot.find('a.comments span.label');

          // Add image
          $shotImageContainer.html('<div class="card__image lazyload">');
          var $shotImage = $shotImageContainer.find('.card__image');
          $shotImage.attr('data-sizes', 'auto');
          $shotImage.attr(
            'data-bgset',
            thumbnail +
            ' ' +
            thumbnailWidth +
            'w, ' +
            low_resolution +
            ' ' +
            low_resolutionWidth +
            'w, ' +
            standard_resolution +
            ' ' +
            standard_resolutionWidth +
            'w'
          );

          // Set shot data
          $shotLinks.attr('href', link);
          $shotCaption.html(caption);
          $shotLikes.text(likes);
          $shotComments.text(comments);
        }
        var instagramFeed =
            'https://www.instagram.com/' + data.data[0].user.username;
        $profileLink.attr('href', instagramFeed);
        $profileLink.attr('target', '_blank');

        $container.show();
        $shotContainer.addClass('loaded');
      }
    };

    // localStorage - check to see if the api data exists and is current
    if (storeWithExpiration.get(accessToken) && !Shopify.designMode) {
      var data = storeWithExpiration.get(accessToken);
      loadImages(data);
    } else {
      getData();
    }

    StyleHatch.instagrams[instagram] = this;
    //$container.show();
  }

  return InstagramSection;
})();
StyleHatch.InstagramSection.prototype = $.extend(
  {},
  StyleHatch.InstagramSection.prototype,
  {
    onUnload: function() {
      delete StyleHatch.instagrams[this.instagram];
    },
  }
);

/**
   * GenericSection
   */
StyleHatch.GenericSection = (function() {
  function GenericSection(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr('data-section-id');

    StyleHatch.cacheSelectors();
  }

  return GenericSection;
})();

/**
   * Section - Templates
   * ---------------------------------------------------------------------------
   * Set up core functionality for template based sections
   */

// Product Class
StyleHatch.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      enableHistoryState: $container.data('enable-history-state') || false,
      enableSwatch: $container.data('enable-swatch') || false,
      imageSize: '394x',
      imageZoomSize: null,
      namespace: '.product-' + sectionId,
      sectionId: sectionId,
      zoomEnabled: false,
      lightboxEnabled: false,
      productImageLightboxData: [],
    };

    this.selectors = {
      addToCartForm: '#AddToCartForm-' + sectionId,
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productFeaturedImage: '#FeaturedImage-' + sectionId,
      productImageWrap: '.featured-container-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productPhoto: '#ProductPhoto-' + sectionId,
      productImage: '#ProductImage-' + sectionId,
      productThumbs: '#ProductThumbs-' + sectionId,
      quantityWrap: '.quantity-' + sectionId,
      quantity: '.quantity-select-' + sectionId,
      cartError: '.cart-error-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      cartButtons: '#CartButtons-' + sectionId,
      paymentButtonContainer: '#PaymentButtonContainer-' + sectionId,
      productSizeGuideLink: 'a.product-size-guide-' + sectionId,
      productSizeGuideContent: '#product-size-guide-content-' + sectionId,
    };

    this._initSlider();

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWrap).hasClass(
      'featured-zoom'
    );
    if (Modernizr.objectfit) {
      this.settings.lightboxEnabled = $(this.selectors.productImageWrap).data(
        'lightbox'
      );
    }
    $container.productBox();

    if (StyleHatch.currencyConverter) {
      StyleHatch.CurrencyConverter.init();
    }

    this._initVariants();
    this._initQuanitySelect();

    if ($(this.selectors.productSizeGuideLink).length) {
      $(this.selectors.productSizeGuideLink).magnificPopup({
        items: {
          src: $(this.selectors.productSizeGuideContent),
          type: 'inline',
        },
      });
    }

    // Product tabs
    var $tabs = $container.find('.description__tabs');
    var $tab = $tabs.find('.tab');
    var $tabTitle = $tabs.find('.tab__title');

    $tabTitle.on('click keydown', function(evt) {
      var trigger = false;
      if (evt.type === 'click') {
        trigger = true;
      }
      if (evt.type === 'keydown' && evt.key == 'Enter') {
        trigger = true;
      }

      if (trigger) {
        var $tab = $(this).closest('.tab');
        var $activeTab = $tabs.find('.tab--active');

        // Close it if open
        // Otherwise close active and open new
        if ($tab.hasClass('tab--active')) {
          $tab.removeClass('tab--active');
          $tab.find('.tab__content').slideUp(400);
        } else {
          //$activeTab.removeClass('tab--active');
          //$activeTab.find('.tab__content').slideUp(400);
          $tab.addClass('tab--active');
          $tab.find('.tab__content').slideDown(400);
        }
      }
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {
    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
        this.$container.data('enable-history-state') || false,
        enableSwatch: this.$container.data('enable-swatch'),
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };
      this.optionsMap = {};

      this.variants = new slate.Variants(options);
      if (options.enableSwatch) {
        this._linkOptionSelectors(this.productSingleObject);
        this.$container.on(
          'variantSwatchChange' + this.settings.namespace,
          this._updateSwatches.bind(this)
        );
      }

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );

      // Initial call to trigger variant change for initial load
      var currentVariant = this.variants.currentVariant;
      this.$container.trigger({
        type: 'variantChange' + this.settings.namespace,
        variant: currentVariant,
      });
    },

    _initQuanitySelect: function() {
      // Quantity Selector
      var $quantitySelect = $(this.selectors.quantity);
      $quantitySelect.each(function() {
        var $el = $(this);
        var $quantityDown = $el.find('.adjust-minus');
        var $quantityUp = $el.find('.adjust-plus');
        var $quantity = $el.find('input.quantity');

        var quantity = $quantity.val();

        $quantityDown.on('click', function(e) {
          quantity = $quantity.val();
          if (quantity > 1) {
            quantity--;
            $quantity.val(quantity);
          }
          e.preventDefault();
        });

        $quantityUp.on('click', function(e) {
          quantity = $quantity.val();
          quantity++;
          $quantity.val(quantity);

          e.preventDefault();
        });
      });
    },

    _initSlider: function() {
      var $imageSlider = this.$container.find('.product-image--slider');
      if ($imageSlider.length) {
        var sliderOptions = $imageSlider.data('flickity-options');
        var enabled = $imageSlider.data('slider-enabled');
        var zoomEnabled = $imageSlider.data('zoom');
        var lightboxEnabled = $imageSlider.data('lightbox');
        var $initial = $imageSlider.find('[data-initial-image]');
        var initialIndex = $initial
        .parent()
        .find('.product-image--cell')
        .index($initial);
        sliderOptions.initialIndex = initialIndex;
        if (!enabled) {
          sliderOptions.draggable = false;
          sliderOptions.selectedAttraction = 1;
          sliderOptions.friction = 1;
        }

        $initial.removeAttr('data-initial-image');
        $imageSlider.flickity(sliderOptions);
        $imageSlider
        .parent()
        .find('.flickity-page-dots.placeholder')
        .remove();

        if (!Modernizr.touchevents && zoomEnabled) {
          var $easyzoom = $('.product-image--cell').easyZoom();
          $imageSlider
          .on('dragStart.flickity', function(event) {
            var $zoom = $(event.currentTarget).find('.easyzoom-flyout');
            $zoom.addClass('hidden');
          })
          .on('dragEnd.flickity', function(event) {
            var $zoom = $(event.currentTarget).find('.easyzoom-flyout');
            $zoom.removeClass('hidden');
          });
        }

        $imageSlider.on('dragStart.flickity', function(event, pointer) {
          document.ontouchmove = function(e) {
            e.preventDefault();
          };
        });
        $imageSlider.on('dragEnd.flickity', function(event, pointer) {
          document.ontouchmove = function(e) {
            return true;
          };
        });
        $imageSlider.find('a').on('click', function(e) {
          e.preventDefault();
        });

        if (lightboxEnabled && Modernizr.objectfit) {
          $imageSlider.on('staticClick.flickity', function() {
            $imageSlider.flickity('toggleFullscreen');
          });
          $imageSlider.on('fullscreenChange.flickity', function(
                          event,
                           isFullscreen
                          ) {
            if (isFullscreen) {
              $imageSlider.parent().addClass('is-fullscreen');
            } else {
              $imageSlider.parent().removeClass('is-fullscreen');
            }
          });
        }
      }

      // Flickity thumb slider
      var $thumbSlider = this.$container.find('.product-thumb--slider');
      if ($thumbSlider.length) {
        var sliderOptions = $thumbSlider.data('flickity-options');
        var enabled = $thumbSlider.data('slider-enabled');

        // If the grouped thumbnails option is turned on
        if (enabled) {
          var $initial = $thumbSlider.find('[data-initial-image]');
          var initialIndex = $initial
          .parent()
          .find('.product-thumb--cell')
          .index($initial);
          sliderOptions.initialIndex = initialIndex;

          $initial.removeAttr('data-initial-image');
          $thumbSlider.flickity(sliderOptions);
          $thumbSlider.find('a').on('click', function(e) {
            e.preventDefault();
          });
          $thumbSlider.on('dragStart.flickity', function(event, pointer) {
            document.ontouchmove = function(e) {
              e.preventDefault();
            };
          });
          $thumbSlider.on('dragEnd.flickity', function(event, pointer) {
            document.ontouchmove = function(e) {
              return true;
            };
          });
        } else {
          var $initial = $thumbSlider.find('[data-initial-image]');

          $initial.addClass('is-nav-selected');
          $initial.removeAttr('data-initial-image');
          $thumbSlider.find('a').on('click', function(e) {
            var $thumb = $(this);
            var $cell = $thumb.parent();
            var id = $cell.data('image-id');
            var selector = '[data-image-id="' + id + '"]';
            $imageSlider.flickity('selectCell', selector, false, true);

            $cell
            .parent()
            .find('.' + 'is-nav-selected')
            .removeClass('is-nav-selected');
            $cell.addClass('is-nav-selected');
            e.preventDefault();
          });

          // On slide change update thumbnail
          $imageSlider.on('change.flickity', function(event, index) {
            var $slider = $(this);
            var $cell = $slider.find('.product-image--cell').eq(index);
            var imageId = $cell.data('image-id');

            $thumbSlider
            .find('.' + 'is-nav-selected')
            .removeClass('is-nav-selected');
            var $activeThumb = $thumbSlider.find(
              '[data-image-id="' + imageId + '"]'
            );
            $activeThumb.addClass('is-nav-selected');
          });
        }

        // IE fix for object-fit
        if (!Modernizr.objectfit) {
          $thumbSlider.find('.product-thumb--cell a').each(function() {
            var $container = $(this);
            var imgUrl = $container.find('img').prop('src');

            $container.css({
              'background-image': 'url(' + imgUrl + ')',
            });

            $container.addClass('fallback-object-fit');
          });
        }
      }

      // Basic non flickity thumbnails
      var $thumbs = this.$container.find('.thumbnails');
      if ($thumbs.length) {
        $thumbs.find('a').on('click', function(e) {
          var $thumb = $(this);
          var id = $thumb.data('image-id');
          var selector = '[data-image-id="' + id + '"]';
          $imageSlider.flickity('selectCell', selector, false, true);

          $thumb
          .parent()
          .parent()
          .find('.' + 'active')
          .removeClass('active');
          $thumb.addClass('active');

          e.preventDefault();
        });

        // On slide change update thumbnail
        $imageSlider.on('change.flickity', function(event, index) {
          var $slider = $(this);
          var $cell = $slider.find('.product-image--cell').eq(index);
          var imageId = $cell.data('image-id');

          $thumbs.find('.' + 'active').removeClass('active');
          var $activeThumb = $thumbs.find(
            '[data-image-id="' + imageId + '"]'
          );
          $activeThumb.addClass('active');

          var $thumbsList = $thumbs.find('[data-productthumbs]');
          if ($thumbsList.height() > $thumbs.height()) {
            if ($thumbs.data('enable-group') && $thumbs.is(':visible')) {
              setTimeout(function() {
                $activeThumb.scrollIntoView();
              }, 200);
            }
          }
        });

        // Resize thumbnail container on slider height change
        if ($thumbs.data('enable-group')) {
          $thumbs.css({
            'overflow-y': 'scroll',
            position: 'relative',
          });

          $imageSlider.resize(function() {
            $thumbs.height(
              $(this)
              .find('.flickity-viewport')
              .height()
            );
          });

          var $thumbsList = $thumbs.find('[data-productthumbs]');

          setTimeout(function() {
            if ($thumbsList.height() > $thumbs.height()) {
              $thumbs.find('a.active').scrollIntoView();
            }
          }, 200);

          $thumbs.find('li').each(function(i) {
            $(this)
            .delay(i * 100)
            .fadeTo(200, 1);
          });
        }
      }
    },

    _linkOptionSelectors: function(product) {
      // Building our mapping object
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
          // Gathering values for the 1st option group
          this.optionsMap['root'] = this.optionsMap['root'] || [];
          this.optionsMap['root'].push(variant.option1);
          this.optionsMap['root'] = $.unique(this.optionsMap['root']);
          // Gathering values for the 2nd option group
          if (product.options.length > 1) {
            var key = variant.option1;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option2);
            this.optionsMap[key] = $.unique(this.optionsMap[key]);
          }
          // Gathering values for the 3rd option group
          if (product.options.length === 3) {
            var key = variant.option1 + ' / ' + variant.option2;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option3);
            this.optionsMap[key] = $.unique(this.optionsMap[key]);
          }
        }
      }

      // Update options right away
      this._updateOptionsInSelector(0);
      if (product.options.length > 1) this._updateOptionsInSelector(1);
      if (product.options.length === 3) this._updateOptionsInSelector(2);
    },

    _updateOptionsInSelector: function(selectorIndex) {
      switch (selectorIndex) {
        case 0:
          var key = 'root';
          var selector = $(
            '.single-option-radio:eq(0)',
            this.selectors.addToCartForm
          );
          break;
        case 1:
          var key = $(
            'input:checked',
            this.selectors.addToCartForm + ' .single-option-radio:eq(0)'
          ).val();
          var selector = $(
            '.single-option-radio:eq(1)',
            this.selectors.addToCartForm
          );
          break;
        case 2:
          var key = $(
            'input:checked',
            this.selectors.addToCartForm + ' .single-option-radio:eq(0)'
          ).val();
          key +=
            ' / ' +
            $(
            'input:checked',
            this.selectors.addToCartForm + ' .single-option-radio:eq(1)'
          ).val();
          var selector = $(
            '.single-option-radio:eq(2)',
            this.selectors.addToCartForm
          );
          break;
      }

      var initialValue = $('input:checked', selector).val();
      var availableOptions = this.optionsMap[key];

      var optionIndex = selectorIndex + 1;
      $(
        '.radio-wrapper[data-option-index="' +
        optionIndex +
        '"] input.single-option-selector__radio',
        this.selectors.addToCartForm
      ).each(function() {
        if ($.inArray($(this).val(), availableOptions) !== -1) {
          $(this)
          .parent()
          .removeClass('soldout');
        } else {
          $(this)
          .parent()
          .addClass('soldout');
        }
      });

      var $optionGroup = $(
        '.radio-wrapper[data-option-index="' + optionIndex + '"]',
        this.selectors.addToCartForm
      );
      var $selectedSwatch = $optionGroup.find('input:checked').parent();

      if (
        $selectedSwatch.hasClass('soldout') &&
        $selectedSwatch.attr('data-variant-swatch-soldout') == 'true'
      ) {
        var $availableSwatch = $optionGroup
        .find('.swatch-container:not(.soldout)')
        .eq(0);
        if ($availableSwatch.length > 0) {
          $availableSwatch.find('input').trigger('click');
        }
      }
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;
      var dynamicCheckout = $(this.selectors.addToCartForm).data(
        'dynamic-checkout'
      );

      if (variant) {
        $(this.selectors.cartError).hide();
        $(this.selectors.productPrices)
        .removeClass('visibility-hidden')
        .attr('aria-hidden', 'true');

        if (variant.available) {
          $(this.selectors.addToCart)
          .removeClass('disabled')
          .prop('disabled', false);
          var addToCartText = StyleHatch.Strings.addToCart;
          if ($(this.selectors.addToCart)[0].hasAttribute('data-preorder')) {
            addToCartText = StyleHatch.Strings.preOrder;
          }
          $(this.selectors.addToCartText).text(addToCartText);
          $(this.selectors.quantityWrap).show();
          if (dynamicCheckout) {
            $(this.selectors.cartButtons).addClass('cart-buttons__enabled');
          }
          $('.dev_stockStatus').show();
        } else {
          $('.dev_stockStatus').hide();
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart)
          .addClass('disabled')
          .prop('disabled', true);
          $(this.selectors.addToCartText).text(StyleHatch.Strings.soldOut);
          $(this.selectors.quantityWrap).hide();
          if (dynamicCheckout) {
            $(this.selectors.cartButtons).removeClass(
              'cart-buttons__enabled'
            );
          }
        }
      } else {
        $(this.selectors.addToCart)
        .addClass('disabled')
        .prop('disabled', true);
        $(this.selectors.addToCartText).text(StyleHatch.Strings.soldOut);
        $(this.selectors.productPrices)
        .addClass('visibility-hidden')
        .attr('aria-hidden', 'false');
        $(this.selectors.quantityWrap).hide();
        if (dynamicCheckout) {
          $(this.selectors.cartButtons).removeClass('cart-buttons__enabled');
        }
      }
    },

    _updateSwatches: function(evt) {
      var currentVariant = evt.variant;
      var $swatch = $(evt.currentTarget).find('[type=radio]');
      var $radioWrapper = $(evt.currentTarget).find('.radio-wrapper');
      var Product = this;

      // Update options right away
      this._updateOptionsInSelector(0);
      if (Product.productSingleObject.options.length > 1)
        this._updateOptionsInSelector(1);
      if (Product.productSingleObject.options.length === 3)
        this._updateOptionsInSelector(2);

      $radioWrapper.each(function() {
        var $radioWrapper = $(this);
        var currentOption = 'option' + $radioWrapper.data('option-index');
        var $labelValue = $radioWrapper.find(
          '.single-option-radio__label--value'
        );

        if ($labelValue.length && currentVariant) {
          var value = currentVariant[currentOption];
          $labelValue.text(value);
        }
      });
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      var sizedImgUrl = theme.Images.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );
      var zoomSizedImgUrl;

      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_image.src,
          this.settings.imageZoomSize
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
        '[data-image-id="' +
        variant.featured_image.id +
        '"]'
      );

      // Slider
      var $imageSlider = this.$container.find('.product-image--slider');
      if ($imageSlider.length) {
        var selector = '[data-image-id="' + variant.featured_image.id + '"]';
        $imageSlider.flickity('selectCell', selector, false, true);
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, StyleHatch.currencyFormat)
      );

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
        .find('span.money')
        .html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            StyleHatch.currencyFormat
          )
        );
        $(this.selectors.comparePrice).css('display', 'inline');
      } else {
        $(this.selectors.comparePrice).hide();
      }

      // Apply any currency conversions
      if (StyleHatch.currencyConverter) {
        // clear out previous currency attributes
        removeDataAttributes($(this.selectors.originalPrice));
        removeDataAttributes(
          $(this.selectors.comparePrice).find('span.money')
        );
        Currency.convertAll(
          StyleHatch.shopCurrency,
          $('[name=currencies]').val()
        );
        $('.selected-currency').text(Currency.currentCurrency);
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      // destroys on close
      $.magnificPopup.close();
      if (this.settings.zoomEnabled) {
        _destroyZoom($(this.selectors.productImageWrap));
      }
      if (StyleHatch.ajaxCartEnable) {
        StyleHatch.AjaxCart.unload();
      }
      this.$container.destroyProductBox();
    },
  });

  function _enableZoom($el) {
    var $easyzoom = $el.easyZoom();
  }

  function _destroyZoom($el) {
    var easyZoomApi = $el.easyZoom().data('easyZoom');
    easyZoomApi.teardown();
  }

  return Product;
})();

StyleHatch.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    var $container = (this.$container = $(container));
    var productId = $container.data('productId');
    var limit = $container.data('limit');

    var url =
        '/recommendations/products?&section_id=product-recommendations&limit=' +
        limit +
        '&product_id=' +
        productId;
    var pageFragmentClass = ' .product-recommendations';
    $container.parent().load(url + pageFragmentClass, function() {
      $(this).productBox();

      if (StyleHatch.currencyConverter) {
        StyleHatch.CurrencyConverter.init();
      }
    });
  }

  ProductRecommendations.prototype = $.extend(
    {},
    ProductRecommendations.prototype,
    {
      onUnload: function() {
        this.$container.destroyProductBox();
      },
    }
  );

  return ProductRecommendations;
})();

// Collection (template) Class
StyleHatch.Collection = (function() {
  var constants = {
    SORT_BY: 'sort_by',
    DEFAULT_SORT: 'title-ascending',
    VIEW: 'view',
  };

  var selectors = {
    sortSelection: '#SortBy',
    defaultSort: '.sort-by__default-sort',
    viewChange: '.change-view',
    advancedFilter: '.advanced-filter a',
    filterCollection: '.mobile-aside-container > a.button.simple',
    mobileAside: '.mobile-aside-container aside',
    productBox: '.box.product .image-table',
    nestedMenu: 'ul.nested-menu',
  };

  function Collection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.$sortSelect = $(selectors.sortSelection, $container);
    this.defaultSort = this._getDefaultSortValue();

    this.$viewButton = $(selectors.viewChange);

    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this.$viewButton.on('click', this._onViewChange);

    this.$productbox = $(selectors.productBox, $container);

    this._initSidebar();
    this._initAdvancedTags();

    $container.productBox();

    if (StyleHatch.currencyConverter) {
      StyleHatch.CurrencyConverter.init();
    }
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    _onSortChange: function(evt) {
      var query = '';

      this.sort = this._getSortValue();

      if (this.sort !== this.defaultSort) {
        query = [constants.SORT_BY + '=' + this.sort];
      }

      var url = document.URL;
      var hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        document.location.href = replaceUrlParam(
          url,
          constants.SORT_BY,
          this.sort
        );
      } else {
        var search = (document.location.search = query.length
                      ? '?' + query
                      : '');
        document.location.href = this.$filterSelect.val() + search;
      }
    },
    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },
    _getDefaultSortValue: function() {
      return (
        $(selectors.defaultSort, this.$container).val() ||
        constants.DEFAULT_SORT
      );
    },
    _onViewChange: function(evt) {
      var query = '';

      var view = $(this).data('view');
      var url = document.URL;
      var hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }

      evt.preventDefault();
    },
    _initSidebar: function() {
      $(selectors.filterCollection).on('click', function(e) {
        $(selectors.mobileAside).slideToggle();
        e.preventDefault();
      });

      this.$container.find(selectors.nestedMenu).initNestedMenu();
    },
    _initAdvancedTags: function() {
      var $filters = $(selectors.advancedFilter),
          $tag,
          tagGroup,
          tagHandle,
          $activeTagInGroup;

      $filters.on('click', function(e) {
        $tag = $(this).parent();
        tagGroup = $tag.data('group');
        tagHandle = $tag.data('handle');
        $activeTagInGroup = $('.active[data-group="' + tagGroup + '"]');

        // If the tag clicked is not already active and its group contains an active tag
        // we will swap tag within the group
        if (!$tag.hasClass('active') && $activeTagInGroup.length > 0) {
          e.preventDefault();
          var newPath = window.location.pathname
          .replace($activeTagInGroup.data('handle'), tagHandle)
          .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, '');
          window.location.pathname = newPath;
        }
      });
    },
    onUnload: function() {
      this.$sortSelect.off('change');
      this.$viewButton.off('click');
      $(selectors.advancedFilter).off('click');
      this.$container.destroyProductBox();
      this.$container.find(selectors.nestedMenu).destroyNestedMenu();
    },
  });

  return Collection;
})();

// List collections (template) Class
StyleHatch.ListCollections = (function() {
  var selectors = {
    productBox: '.box .image-table',
  };

  function ListCollections(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var layout = $container.data('layout');
    var $cardImage = $container.find('.card__image');

    this.$productbox = $(selectors.productBox, $container);

    if (layout == 'preview') {
      $container.productBox();
    }

    if (StyleHatch.currencyConverter) {
      StyleHatch.CurrencyConverter.init();
    }
  }

  ListCollections.prototype = $.extend({}, ListCollections.prototype, {
    onUnload: function() {
      $container.destroyProductBox();
    },
  });

  return ListCollections;
})();

// Blog and Article (template) Class
StyleHatch.BlogArticle = (function() {
  var selectors = {
    filterCollection: '.mobile-aside-container > a.button.simple',
    mobileAside: '.mobile-aside-container aside',
    nestedMenu: 'ul.nested-menu',
  };

  function BlogArticle(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this._initSidebar();
    StyleHatch.videoLayout();
  }

  BlogArticle.prototype = $.extend({}, BlogArticle.prototype, {
    _initSidebar: function() {
      $(selectors.filterCollection).on('click', function(e) {
        $(selectors.mobileAside).slideToggle();
        e.preventDefault();
      });

      this.$container.find(selectors.nestedMenu).initNestedMenu();
    },
    onUnload: function() {
      $(selectors.filterCollection).off('click');
      this.$container.find(selectors.nestedMenu).destroyNestedMenu();
    },
  });

  return BlogArticle;
})();

// Password (template) Class
StyleHatch.Password = (function() {
  function Password(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    var $loginForm = $('#login_form');

    $('.login-popup').magnificPopup({
      type: 'inline',
      midClick: true,
      mainClass: 'mfp-fade',
      closeBtnInside: false,
      callbacks: {
        afterClose: function() {
          $('a').blur();
          $loginForm.find('.errors').remove();
        },
      },
    });

    // On MailChimp form submit
    $('#mc-embedded-subscribe-form').on('submit', function() {
      $('p.signup-message').hide();
      $('p.thanks-message').show();
      $(this)
      .find('.input-row')
      .hide();
    });

    // If error in password form
    if ($loginForm.find('.errors').length > 0) {
      $('.login-popup').magnificPopup('open');
    }
  }

  Password.prototype = $.extend({}, Password.prototype, {
    onUnload: function() {
      // destroys on close
      $.magnificPopup.close();
      $('#mc-embedded-subscribe-form').off('submit');
    },
  });

  return Password;
})();

// Cart (template) Class
StyleHatch.Cart = (function() {
  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var ajaxCart = $container.data('ajax-cart');
    StyleHatch.quantitySelect();

    if (ajaxCart) {
      // Cart.js
      CartJS.init(StyleHatch.cartData);

      // Button events for cart items
      var $cartItems = $('[data-cart-item]', $container);

      // Add events to inital cart items, new are added later
      $cartItems.each(function() {
        addCartItemEvents($(this));
      });

      function addCartItemEvents(item) {
        var $item = item;
        var id = $item.attr('data-cart-item');
        var $itemQuantity = $('[data-cart-item-quantity]', $item);
        var $itemMinus = $('[data-cart-item-quantity-minus]', $item);
        var $itemPlus = $('[data-cart-item-quantity-plus]', $item);
        var $itemRemove = $('[data-cart-item-remove]', $item);

        $itemQuantity.on('blur', function(evt) {
          evt.preventDefault();
          var quantity = $(this).val();
          var $cartItem = $(this).closest('.cart-item');
          var id = $cartItem.attr('data-cart-item');

          $('.cart-item').addClass('cart-item--pending');
          $('.cart-checkout').addClass('cart-checkout--pending');

          CartJS.updateItemById(id, quantity);
        });
        $itemQuantity.on('keypress', function(evt) {
          if (evt.which === 13) {
            evt.preventDefault();
            var quantity = $(this).val();
            var $cartItem = $(this).closest('.cart-item');
            var id = $cartItem.attr('data-cart-item');

            $('.cart-item').addClass('cart-item--pending');
            $('.cart-checkout').addClass('cart-checkout--pending');

            CartJS.updateItemById(id, quantity);
          }
        });
        $itemMinus.on('click', function(evt) {
          evt.preventDefault();
          var quantity = $itemQuantity.val();
          var $cartItem = $(this).closest('.cart-item');
          var id = $cartItem.attr('data-cart-item');

          $('.cart-item').addClass('cart-item--pending');
          $('.cart-checkout').addClass('cart-checkout--pending');

          CartJS.updateItemById(id, quantity);
          if (quantity == 0) {
            $cartItem.attr('data-cart-item', '').remove();
          }
        });
        $itemPlus.on('click', function(evt) {
          evt.preventDefault();
          var quantity = $itemQuantity.val();
          var $cartItem = $(this).closest('.cart-item');
          var id = $cartItem.attr('data-cart-item');

          $('.cart-item').addClass('cart-item--pending');
          $('.cart-checkout').addClass('cart-checkout--pending');

          CartJS.updateItemById(id, quantity)
          .fail(function(jqXHR) {
            const data = JSON.parse(jqXHR.responseText);
            showCartErrorPopup(data.message);
            $('.cart-item--pending').removeClass('cart-item--pending');
            $('.cart-checkout--pending').removeClass('cart-checkout--pending');
          });
        });
        $itemRemove.on('click', function(evt) {
          evt.preventDefault();
          var $cartItem = $(this).closest('.cart-item');
          var id = $cartItem.attr('data-cart-item');

          $('.cart-item').addClass('cart-item--pending');
          $('.cart-checkout').addClass('cart-checkout--pending');
          $cartItem.attr('data-cart-item', '').remove();
          CartJS.removeItemById(id);
        });
        
        if(typeof trigger_messages == 'function')
        {
          trigger_messages();
        }
      }

      function showCartErrorPopup(message) {
        const popup = document.getElementById("cart-error-popup");
        popup.innerHTML = `<strong>${message}</strong>`;
        popup.classList.add("show");
      
        setTimeout(() => {
          popup.classList.remove("show");
        }, 3000);
      }

      function isInsuranceOn() {
        try {
          return jQuery('input.cart-insurance-input').is(':checked');
        } catch(e) {
          return false;
        }
      }

      $(document).on('cart.requestComplete', function(event, cart) {
        StyleHatch.AjaxCart.updateCartButton(cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }

        if (!isInsuranceOn()) {
          $('.cart-item--pending').removeClass('cart-item--pending');
          $('.cart-checkout--pending').removeClass('cart-checkout--pending');
        }

        var cartItemKeys = [];
        var $previousItem = $('[data-cart-item]', $container).first();
        $.each(cart.items, function(index, cartItem) {
          var id = cartItem.key;
          var quantity = cartItem.quantity;
          var price = theme.Currency.formatMoney(
            cartItem.price,
            StyleHatch.currencyFormat
          );
          var linePrice = theme.Currency.formatMoney(
            cartItem.line_price,
            StyleHatch.currencyFormat
          );

          var $item = $('[data-cart-item="' + id + '"]');
          if ($item.length === 0) {
            var $itemTemplate = $('[data-cart-item]', $container)
            .first()
            .clone();

            // Update key
            if (index === 0) {
              var $newItem = $itemTemplate.insertAfter(
                $('.label-row', $container)
              );
            } else {
              var $newItem = $itemTemplate.insertAfter($previousItem);
            }

            // Update image
            $newItem.attr('data-cart-item', cartItem.key);
            var sizedImgUrl = theme.Images.getSizedImageUrl(
              cartItem.image,
              '394x'
            );
            $('[data-cart-item-image]', $newItem)
            .attr('src', sizedImgUrl)
            .removeAttr('class')
            .removeAttr('data-widths')
            .removeAttr('data-aspectratio')
            .removeAttr('data-sizes')
            .removeAttr('data-srcset')
            .removeAttr('sizes')
            .removeAttr('srcset');
            $('[data-cart-item-image]', $newItem)
            .parent()
            .removeAttr('class')
            .removeAttr('style');

            // Update title
            $('[data-cart-item-title]', $newItem).html(
              cartItem.product_title
            );

            // Update links
            $('[data-cart-item-href]', $newItem).attr('href', cartItem.url);

            // Update vendor
            $('[data-cart-item-vendor]', $newItem).html(cartItem.vendor);

            // Update variant title
            $('[data-cart-item-variant-title]', $newItem).html(
              cartItem.variant_title
            );

            // Update quantity
            $('[data-cart-item-quantity]', $newItem)
            .val(cartItem.quantity)
            .attr('id', 'updates_' + cartItem.key);

            $newItem
            .find('.quantity-select')
            .removeAttr('data-quantity-select-enabled');
            StyleHatch.quantitySelect();
            addCartItemEvents($newItem);

            // Update price
            // var itemPrice =
            //   '<p><span class="money" data-cart-item-final-price>' +
            //   cartItem.finalPrice +
            //   '</span></p>';
            // $('.cart-item-price', $newItem).html(itemPrice);
            // updateCartItemPrice($newItem, cartItem);
            $item = $newItem;
          }

          var $itemQuantity = $('[data-cart-item-quantity]', $item);
          $itemQuantity.val(quantity);
          // $itemPrice.removeClass('money');
          // $itemPrice.html('<span class="money">' + price + '</span>');

          // $itemLinePrice.removeClass('money');
          // $itemLinePrice.html('<span class="money">' + linePrice + '</span>');
          updateCartItemPrice($item, cartItem);

          cartItemKeys.push(id);

          $previousItem = $item;
        });

        function updateCartItemPrice($item, cartItem) {
          // Update line item price
          var finalPrice = theme.Currency.formatMoney(
            cartItem.final_price,
            StyleHatch.currencyFormat
          );
          var originalPrice = theme.Currency.formatMoney(
            cartItem.original_price,
            StyleHatch.currencyFormat
          );

          var itemPriceHTML =
              '<p><span class="money final-price" data-cart-item-final-price>' +
              finalPrice +
              '</span></p>';
          var $cartItemPrice = $('.cart-item-price', $item).html(
            itemPriceHTML
          );

          var finalLinePrice = theme.Currency.formatMoney(
            cartItem.final_line_price,
            StyleHatch.currencyFormat
          );
          var mobileLabel = $('.cart-item-total', $item).attr(
            'data-mobile-label'
          );
          $('.cart-item-total', $item).html(
            '<div class="mobile-label">' +
            mobileLabel +
            '</div>' +
            '<p><span class="money" data-cart-item-line-price>' +
            finalLinePrice +
            '</span></p>'
          );

          if (cartItem.final_price < cartItem.original_price) {
            $('.final-price', $cartItemPrice).addClass(
              'final-price-discount'
            );

            $('.cart-item-price', $item).append(
              '<p><span class="money original-price" data-cart-item-original-price>' +
              originalPrice +
              '</p>'
            );

            if (cartItem.discounts.length > 0) {
              $('.cart-item-price', $item).append(
                '<ul class="cart-item-discounts"></ul>'
              );
              var $discountsList = $('.cart-item-discounts', $item);
              $.each(cartItem.discounts, function(index, discounts) {
                var title = discounts.title;
                var amount = theme.Currency.formatMoney(
                  discounts.amount,
                  StyleHatch.currencyFormat
                );
                $discountsList.append(
                  '<li class="cart-item-discount"><span class="cart-item-discount-title">' +
                  title +
                  '</span><br><span class="cart-item-discount-amount">(-<span class="money">' +
                  amount +
                  '</span>)</span></li>'
                );
              });
            }

            var originalLinePrice = theme.Currency.formatMoney(
              cartItem.original_line_price,
              StyleHatch.currencyFormat
            );
            $('.cart-item-total', $item).append(
              '<p><span class="money original-price" data-cart-item-original-price>' +
              originalLinePrice +
              '</span></p>'
            );
          }
        }

        var $cartItems = $('[data-cart-item]', $container);

        // Remove items from display
        $cartItems.each(function(i) {
          var key = $(this).attr('data-cart-item');
          if ($.inArray(key, cartItemKeys) === -1) {
            $(this).remove();
          }
        });

        var totalPrice = theme.Currency.formatMoney(
          cart.total_price,
          StyleHatch.currencyFormat
        );
        var $subTotal = $('[data-cart-subtotal]');
        $subTotal.removeClass('money');
        $subTotal.html('<span class="money">' + totalPrice + '</span>');

        // Add in cart level discounts (cart_level_discount_applications)
        if (cart.cart_level_discount_applications.length > 0) {
          // Check if HTML structure exists
          if ($('.cart-discount').length === 0) {
            $('.cart-checkout').prepend('<ul class="cart-discount"></ul>');
          }
          var $discount = $('.cart-discount');
          $discount.show();
          $discount.empty();

          $.each(cart.cart_level_discount_applications, function(
                 index,
                  discount
                 ) {
            var amount = theme.Currency.formatMoney(
              discount.total_allocated_amount,
              StyleHatch.currencyFormat
            );
            $discount.append(
              '<li class="cart-discount--applications"><span class="cart-discount--title">' +
              discount.title +
              '</span><span class="cart-discount--amount">-<span class="money">' +
              amount +
              '</span></span></li>'
            );
          });
        } else {
          $('.cart-discount').hide();
        }
        $('.cart-discount--title').html(
          cart.cart_level_discount_applications.title
        );

        // If Currency convertor has been added
        if (StyleHatch.currencyConverter) {
          Currency.convertAll(
            StyleHatch.shopCurrency,
            jQuery('[name=currencies]').val()
          );
        }
        if(typeof trigger_messages == 'function')
        {
          trigger_messages();
        }
      });
    }

    var $termsAndConditions = $('.terms-and-conditions', $container);
    if ($termsAndConditions.length > 0) {
      $('body').on(
        'click',
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
        function() {
          if ($('#terms-and-conditions__agree').is(':checked')) {
            $(this).submit();
          } else {
            // check if notice exists...
            if ($('.terms-and-conditions__notice').length <= 0) {
              $termsAndConditions.append(
                '<div class="terms-and-conditions__notice"><p><em>' +
                StyleHatch.Strings.agreeNotice +
                '</em></p></div>'
              );
            }
            return false;
          }
        }
      );

      var $checkbox = $termsAndConditions.find('input');
      $checkbox.on('click', function() {
        $termsAndConditions.find('.terms-and-conditions__notice').remove();
      });
    }
  }

  Cart.prototype = $.extend({}, Cart.prototype, {
    onUnload: function() {},
  });

  return Cart;
})();

/**
   * Classes - complex functionality
   * ---------------------------------------------------------------------------
   * AjaxCart
   * Currency
   */

/*
   * Add product to cart without page refresh
   */
StyleHatch.AjaxCart = (function() {
  var selectors = {
    body: 'body',
    util: 'header.util',
    cartPreview: 'header.util .cart-preview',
    addToCartForm: '[data-AddToCartForm] > form',
    addToCartButton: '[data-AddToCartForm]',
    cartButton: '[data-CartButton]',
    cartCount: '#CartCount',
    cartCost: '#CartCost',
  };
  var config = {
    addURL: StyleHatch.routes.cart_add_url + '.js',
    cartURL: StyleHatch.routes.cart_url + '.js',
    clearURL: StyleHatch.routes.cart_clear_url + '.js',
  };
  var cache = {};
  function cacheSelectors() {
    cache = {
      $body: $(selectors.body),
      $util: $(selectors.util),
      $cartPreview: $(selectors.cartPreview),
      $addToCartForm: $(selectors.addToCartForm),
      $addToCartButton: $(selectors.addToCartButton),
      $cartButton: $(selectors.cartButton),
      $cartCount: $(selectors.cartCount),
      $cartCost: $(selectors.cartCost),
    };
  }

  function init() {
    cacheSelectors();
    if (StyleHatch.ajaxCartEnable) {
      bindEvents();
      loadCartData();
    }
  }

  /*** Load page cap nhat product items trong cart preview ***/
  function loadCartData() {
    // Lấy thông tin từ API giỏ hàng
    $.get(config.cartURL, function(cartData) {
        updateCartButton(cartData);
        
        // Nếu giỏ hàng không có sản phẩm
        if (cartData.items.length === 0) {
            $(".cart-preview .product-container").html('<p>Your cart is currently empty.</p>'); // Hiển thị thông báo giỏ hàng trống
            $(".cart-preview .cart-total-price").text(''); // Xóa giá tổng
            return; // Dừng xử lý nếu giỏ hàng trống
        }

        var $productContainer = $(".cart-preview .product-container");
        $productContainer.empty(); // Xóa sản phẩm cũ

        var totalPrice = 0; // Khởi tạo biến tổng giá
        var totalQuantity = 0; // Khởi tạo biến tổng số lượng sản phẩm

        cartData.items.forEach(function(item, index) {
            var itemPrice = item.price * item.quantity;
            totalPrice += itemPrice;
            totalQuantity += item.quantity; // Tính tổng số lượng sản phẩm

            // Kiểm tra nếu sản phẩm có product_id = 7270991167535
            var disableQuantityEdit = item.product_id === 7270991167535 ? "disabled" : "";

            var $productTemplate = $(`
                <div class="box product">
                    <figure>
                        <a href="${item.url}" class="product-image">
                            <img src="${item.image}" alt="${item.title}">
                        </a>
                        <figcaption>
                            <a href="${item.url}" class="product-title ${disableQuantityEdit}"><span class="product-title-cart">${item.title}</span></a>
                            <ul class="product-variant options ${item.variant_title || "hideProductVariant"}">${item.variant_title || ""}</ul>
                            <span class="product-price price money">${theme.Currency.formatMoney(
                                item.price,
                                StyleHatch.currencyFormat
                            )}</span>
                            <div class="product-quantity ${disableQuantityEdit}">
                              <div class="quantity-wrapper">
                                <button class="quantity-btn quantity-decrease" aria-label="Decrease quantity">-</button>
                                <input type="text" class="quantity-input" min="1" value="${item.quantity}" pattern="[0-9]*" data-line="${index + 1}">
                                <button class="quantity-btn quantity-increase" aria-label="Increase quantity">+</button>
                              </div>
                            </div>
                        </figcaption>
                    </figure>
                </div>
            `);
            $productContainer.append($productTemplate);
        });

        // Hiển thị giá tổng
        var formattedTotalPrice = theme.Currency.formatMoney(totalPrice, StyleHatch.currencyFormat);
        $(".cart-preview-total .total-price .money").text(formattedTotalPrice);

        // Hiển thị thông báo số lượng sản phẩm
        if (totalQuantity > 0) {
          $(".cart-preview-total .count").html(`You have <span class="item-count">${totalQuantity}</span> items in cart.`);
          $(".cart-preview").removeClass('disabledCartPreview');
        } else if (totalQuantity === 1) {
          $(".cart-preview-total .count").html(`You have <span class="item-count">${totalQuantity}</span> item in cart`);
          $(".cart-preview").removeClass('disabledCartPreview');
        } else {
          $(".cart-preview-total .count").text(``);
          $(".cart-preview").addClass('disabledCartPreview');
        }

        // Kiểm tra và hiển thị thông báo miễn phí vận chuyển
        var shippingPrice2 = parseFloat($('.shippingPriceVal').attr('data-shipping'));
        var cart_TotalPrice = parseFloat(formattedTotalPrice.split("$")[1].replace(/,/g, ""));

        if (cart_TotalPrice >= shippingPrice2) {
          $(".dev_shippingMessage").html('<span>FREE SHIPPING!*</span>');
        } else {
          $(".dev_shippingMessage").html('');
        }

        // Gắn sự kiện update số lượng
        attachQuantityUpdateEvent();

    }, "json").fail(function() {
        console.error("Failed to load cart data.");
    });
}

function clearCartPreview(cartData) {
  // Làm sạch cart preview nếu giỏ hàng trống
  $(".cart-preview-total .count").text(``);
  $(".cart-preview").addClass('disabledCartPreview');
}

function attachQuantityUpdateEvent() {
  // Xử lý nút tăng số lượng
  $(".quantity-increase").off("click").on("click", function () {
    const $input = $(this).siblings(".quantity-input");
    const currentValue = parseInt($input.val()) || 1;
    const line = $input.data("line");
    const newQuantity = currentValue + 1;

    $input.val(newQuantity); // Cập nhật giá trị trong input
    updateCartItemQuantity(line, newQuantity); // Gửi yêu cầu cập nhật
  });

  // Xử lý nút giảm số lượng
  $(".quantity-decrease").off("click").on("click", function () {
    const $input = $(this).siblings(".quantity-input");
    const currentValue = parseInt($input.val()) || 1;
    const line = $input.data("line");

    if (currentValue > 1) { // Không cho giảm về 0
      const newQuantity = currentValue - 1;
      $input.val(newQuantity); // Cập nhật giá trị trong input
      updateCartItemQuantity(line, newQuantity); // Gửi yêu cầu cập nhật
    }
  });

  // Xử lý thay đổi trực tiếp trong ô input
  $(".quantity-input").off("change").on("change", function () {
    const $input = $(this);
    const line = $input.data("line");
    const newQuantity = parseInt($input.val()) || 1;

    if (newQuantity > 0) {
      updateCartItemQuantity(line, newQuantity); // Gửi yêu cầu cập nhật
    } else {
      $input.val(1); // Đặt lại số lượng tối thiểu là 1
    }
  });
}

function updateCartItemQuantity(line, quantity) {
  var $totalPrice = $(".cart-preview .total-price .money");
  var $spinner = $(".cart-preview .total-price .spinner");

  // Hiển thị spinner và ẩn giá cũ
  $totalPrice.hide();
  $spinner.show();

  $.ajax({
    url: "/cart/change.js",
    type: "POST",
    data: { line: line, quantity: quantity },
    dataType: "json",
    success: function(cartData) {
      loadCartData(); // Tải lại dữ liệu giỏ hàng
      updateItemCountMessage(cartData);

      // Cập nhật giá mới và ẩn spinner
      var formattedTotalPrice = theme.Currency.formatMoney(
        cartData.total_price,
        StyleHatch.currencyFormat
      );
      $totalPrice.text(formattedTotalPrice).show();
      $spinner.hide();
    },
    error: function() {
      // alert("Failed to update quantity. Please try again.");

      // Ẩn spinner nếu có lỗi
      $spinner.hide();
      $totalPrice.show();
    },
  });
}

function updateItemCountMessage(cartData) {
  const itemCount = cartData.item_count;

  if (itemCount > 0) {
    $(".cart-preview-total .count").html(`You have <span class="item-count">${itemCount}</span> items in cart.`);
  } else if (itemCount === 1) {
    $(".cart-preview-total .count").html(`You have <span class="item-count">${itemCount}</span> item in cart`);
  } else {
    $(".cart-preview-total .count").text(``);
  }
}

function removeItemFromCart(line) {
  $.ajax({
    url: "/cart/change.js",
    type: "POST",
    data: { line: line, quantity: 0 },
    dataType: "json",
    success: function(cartData) {
      loadCartData(); // Tải lại dữ liệu giỏ hàng
      if (cartData.item_count === 0) {
        // Nếu giỏ hàng trống, làm sạch giỏ hàng và hiển thị thông báo
        clearCartPreview(cartData);
      }
    },
    error: function() {
      alert("Failed to remove item. Please try again.");
    },
  });
} 

function showCartSuccessPopup() {
  const popup = document.getElementById("cart-success-popup");
  
  // Hiển thị popup
  popup.classList.add("show");
  
  // Tự động ẩn sau 3 giây
  setTimeout(() => {
    popup.classList.remove("show");
  }, 3000);
}

function submitCart($form) {
  var $cartError = $form.find('.cart-error');
  var cartButtonText = $form.find('[data-AddToCartText]').html();
  var cartButtonAddedText = $form
    .find('[data-AddToCartText]')
    .attr('data-added');
  var cartButtonAddingText = $form
    .find('[data-AddToCartText]')
    .attr('data-adding');

  // Đổi trạng thái nút thành "đang thêm" và vô hiệu hóa
  $form
    .find('[data-AddToCart]')
    .addClass('added')
    .prop('disabled', true);
  $form.find('[data-AddToCartText]').html(cartButtonAddingText);

  // Hiển thị spinner
  var $spinner = $('<div class="spinner-overlay"></div>');
  $("body").append($spinner);

  $cartError.hide();

  $.post(
    config.addURL,
    $form.serialize(),
    function (data) {
      // Lấy dữ liệu sản phẩm vừa thêm
      var productData = data;

      // Gọi hàm hiển thị thông báo thành công
      if (window.innerWidth <= 768) {
        showCartSuccessPopup();
      }

      // Lấy dữ liệu giỏ hàng cập nhật
      $.get(
        config.cartURL,
        function (cartData) {
          // Cập nhật dữ liệu giỏ hàng
          loadCartData();
  
          // Hiển thị cart preview sau khi cập nhật
          setTimeout(function () {
              $(".cart-preview").addClass("open"); // Thêm class để mở preview (CSS sẽ xử lý hiệu ứng)
              
              // Tự động ẩn preview sau 3 giây (nếu cần)
              setTimeout(function () {
                  $(".cart-preview").removeClass("open");
              }, 3000);
          }, 200); // Delay để đảm bảo dữ liệu đã cập nhật hoàn toàn
  
          // Đổi lại trạng thái nút
          setTimeout(function () {
              $form
                  .find('[data-AddToCart]')
                  .removeClass('added')
                  .prop('disabled', false);
              $form.find('[data-AddToCartText]').html(cartButtonText);
  
              // Xóa spinner
              $spinner.remove();
          }, 500);
      },
      "json"
    );
    },
    "text"
  ).fail(function (data) {
    if (data && data.status) {
      var responseText = JSON.parse(data.responseText);
      $cartError.html(
        `<strong>${responseText.message}:</strong> <em>${responseText.description}</em>`
      );
      $cartError.slideDown();
    }

    // Đổi lại trạng thái nút khi lỗi
    setTimeout(function () {
      $form
        .find('[data-AddToCart]')
        .removeClass('added')
        .prop('disabled', false);
      $form.find('[data-AddToCartText]').html(cartButtonText);

      // Xóa spinner
      $spinner.remove();
    }, 500);
  });

  return false;
}

  function clearCart() {
    $.post(config.clearURL);
  }
  function updateCartButton(cartData) {
    var $cartButton = cache.$cartButton;
    var $cartCount = cache.$cartCount;
    var $cartCost = cache.$cartCost;

    var itemCount = cartData.item_count;
    var totalPrice = theme.Currency.formatMoney(
      cartData.total_price,
      StyleHatch.currencyFormat
    );

    $cartCount.text(itemCount);
    $cartCost.removeClass('money');
    $cartCost.html('<span class="money">' + totalPrice + '</span>');
    
    var shippingPrice = $('.shippingPriceVal').attr('data-shipping');
    // console.log(shippingPrice);
    var cart_TotalPrice = totalPrice.split('$')[1].replace(/,/g , '');	
    // console.log(cart_TotalPrice);
    if( parseFloat(cart_TotalPrice) >= parseFloat(shippingPrice)){     	
      $('.dev_ajaxShipping').html('<div class="dev_shippingBar"><p>This item qualifies for FREE SHIPPING!*</div>');	
      $('.dev_ajaxCartShipping').html('<div class="dev_shippingCartBar"><p>This order qualifies for FREE SHIPPING!<a href="javascript:void(0)" class="tooltip-link" data-toggle="modal" data-target="#freeShippingPopup">*</a></p></div>');	
    }else{	
      var result= (shippingPrice - cart_TotalPrice);	
      result = result.toFixed(2);	
      $('.dev_ajaxCartShipping').html('<div class="dev_shippingCartBar"><p>You are only <span class="dev_leftPrice">$' +result+'</span> away from getting FREE SHIPPING!<a href="javascript:void(0)" class="tooltip-link" data-toggle="modal" data-target="#freeShippingPopup">*</a></p></div>');	
    }

    // If Currency convertor has been added
    if (StyleHatch.currencyConverter) {
      Currency.convertAll(
        StyleHatch.shopCurrency,
        jQuery('[name=currencies]').val()
      );
    }
  }
  function showCartPreview(productData, cartData) {
    var $util = cache.$util;
    var $cartPreview = cache.$cartPreview;

    clearTimeout(cache.hideCartPreview);
    cache.$cartPreview.hide();

    // Cart Data
    var itemCount = cartData.item_count;
    var totalPrice = theme.Currency.formatMoney(
      cartData.total_price,
      StyleHatch.currencyFormat
    );

    // Recent Added Product Data
    var productData = JSON.parse(productData);
    var productTitle = productData.product_title;
    var productVariant = productData.variant_options;
    var productImage = productData.image;
    var productURL = productData.url;
    var productPrice = theme.Currency.formatMoney(
      productData.price,
      StyleHatch.currencyFormat
    );
    var productQuantity = productData.quantity;
    var productTotal = theme.Currency.formatMoney(
      productData.line_price,
      StyleHatch.currencyFormat
    );

    // Set Product Details
    var $productImage = $cartPreview.find('.product-image').empty();
    $productImage.append(
      '<img src="' + productImage + '" alt="' + productTitle + '">'
    );
    $productImage.attr('href', productURL);

    var $productTitle = $cartPreview.find('.product-title');
    $productTitle.html(productTitle);
    $productTitle.attr('href', productURL);

    var $productVarient = $cartPreview.find('.product-variant').empty();
    $.each(productVariant, function() {
      var variantStr = this;
      if (variantStr.toLowerCase().indexOf('default title') < 0) {
        $productVarient.show();
        $productVarient.append('<li>' + variantStr + '</li>');
      } else {
        $productVarient.hide();
      }
    });

    var $productPrice = $cartPreview.find('.product-price');
    $productPrice.removeClass('money');
    $productPrice.html('<span class="money">' + productPrice + '</span>');

    // Set Cart Totals
    var $itemCount = $cartPreview.find('.item-count');
    $itemCount.text(itemCount);

    if (itemCount > 1) {
      $cartPreview.find('.count.plural').show();
      $cartPreview.find('.count.singular').hide();
    } else {
      $cartPreview.find('.count.plural').hide();
      $cartPreview.find('.count.singular').show();
    }

    if (cartData.cart_level_discount_applications.length > 0) {
      var $discount = $('.cart-preview--discounts');
      $discount.show();
      $discount.empty();

      $.each(cartData.cart_level_discount_applications, function(
             index,
              discount
             ) {
        var amount = theme.Currency.formatMoney(
          discount.total_allocated_amount,
          StyleHatch.currencyFormat
        );
        $discount.append(
          '<li class="cart-discount--applications"><span class="cart-discount--title">' +
          discount.title +
          '</span><span class="cart-discount--amount">-<span class="money">' +
          amount +
          '</span></span></li>'
        );
      });
    } else {
      $('.cart-preview--discounts').hide();
    }

    var $totalPrice = $cartPreview.find('.total-price');
    $totalPrice.html('<span class="money">' + totalPrice + '</span>');
    
    var shippingPrice2 = $('.shippingPriceVal').attr('data-shipping');	
    var cart_TotalPrice = totalPrice.split('$')[1].replace(/,/g , '');	
    if(parseFloat(cart_TotalPrice) >= parseFloat(shippingPrice2 )){    	
      $('.dev_shippingMessage').html('<span>FREE SHIPPING!*</span>');	
    }

    var utilHeight = $util.height();
    $cartPreview.css({
      top: utilHeight,
    });

    // Fade in the preview
    $cartPreview.fadeIn(300);

    // Auto hide after 6000ms
    // cache.hideCartPreview = setTimeout(function() {
    //   $cartPreview.fadeOut(300);
    // }, 6000);

    $cartPreview.find('a.continue-shopping').on('click', function(e) {
      $cartPreview.fadeOut(300);
      e.preventDefault();
    });

    // If Currency convertor has been added
    if (StyleHatch.currencyConverter) {
      Currency.convertAll(
        StyleHatch.shopCurrency,
        jQuery('[name=currencies]').val()
      );
    }
    
    if(typeof trigger_messages == 'function')
        {
          trigger_messages();
        }
  }

  /*
     * Events
     */
  function bindEvents() {
    cache.$addToCartForm.each(function() {
      $(this).on('submit', function(e) {
        var $form = $(this);
        submitCart($form);
        e.preventDefault();
      });
    });
  }
  function unbindEvents() {
    cache.$addToCartForm.off('submit');
  }

  function unload() {
    unbindEvents();
    clearTimeout(cache.hideCartPreview);
    cache.$cartPreview.hide();
  }

  return {
    init: init,
    clearCart: clearCart,
    updateCartButton: updateCartButton,
    unload: unload,
  };
})();

/*
   * Currency converter
   */
StyleHatch.CurrencyConverter = (function() {
  var selectors = {
    body: 'body',
    money: 'span.money',
  };
  var config = {
    enabled: false,
  };
  var cache = {};
  function cacheSelectors() {
    cache = {
      $body: $(selectors.body),
      $money: $(selectors.money),
    };
  }

  // Initialization
  function init() {
    cacheSelectors();
    convert();
  }

  // Methods
  function convert() {
    // Get current currency based on cookie
    config.cookieCurrency = Currency.cookie.read();

    // Make sure customer account pages have proper spans
    $('span.money span.money').each(function() {
      $(this)
      .parents(selectors.money)
      .removeClass('money');
    });

    /* Saving the current price */
    cache.$money.each(function() {
      if (Currency.currentCurrency !== '') {
        $(this).attr(
          'data-currency-' + Currency.currentCurrency,
          $(this).html()
        );
      } else {
        $(this).attr(
          'data-currency-' + StyleHatch.shopCurrency,
          $(this).html()
        );
      }
    });

    // If there's no cookie.
    if (config.cookieCurrency == null) {
      if (StyleHatch.shopCurrency !== StyleHatch.defaultCurrency) {
        Currency.convertAll(
          StyleHatch.shopCurrency,
          StyleHatch.defaultCurrency
        );
      } else {
        Currency.currentCurrency = StyleHatch.defaultCurrency;
      }
    } else if (
      $('[name=currencies]').length > 0 &&
      $('[name=currencies] option[value=' + config.cookieCurrency + ']')
      .length === 0
    ) {
      // If the cookie value does not correspond to any value in the currency dropdown.
      Currency.currentCurrency = StyleHatch.shopCurrency;
      Currency.cookie.write(StyleHatch.shopCurrency);
    } else if (config.cookieCurrency === StyleHatch.shopCurrency) {
      Currency.currentCurrency = StyleHatch.shopCurrency;
    } else {
      Currency.convertAll(StyleHatch.shopCurrency, config.cookieCurrency);
    }

    // On currency change
    $('[name=currencies]')
    .val(Currency.currentCurrency)
    .change(function() {
      var newCurrency = $(this).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      $('.selected-currency').text(Currency.currentCurrency);

      // If the currency is the store currency, hide the cart disclaimer
      if ($('p.currency-at-checkout').length > 0) {
        if (Currency.currentCurrency == StyleHatch.shopCurrency) {
          $('p.currency-at-checkout').hide();
        } else {
          $('p.currency-at-checkout').show();
        }
      }
    });

    // Update selected currency
    $('[name=currencies]')
    .val(Currency.currentCurrency)
    .change();
  }

  // Public methods
  return {
    init: init,
    config: config,
    convert: convert,
  };
})();

/**
   * Slate & Theme Functionality
   * ------------------------------------------------------------------------------
   */
window.theme = window.theme || {};
window.slate = window.slate || {};

/**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
theme.Images = (function() {
  /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
     * Swaps the src of an image for another OR returns the imageURL to the callback function
     * @param image
     * @param element
     * @param callback
     */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
     * +++ Useful
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
     * +++ Useful
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */

theme.Currency = (function() {
  var moneyFormat = '$'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
   * Utility helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions for dealing with arrays and objects
   *
   * @namespace utils
   */

slate.utils = {
  /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
  defaultTo: function(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },

  /**
     * _.debounce from underscore
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     *
     * @param {*} func - Function to call
     * @param {*} wait - ms delay (250)
     * @param {*} immediate - bool
     */

  debounce: function(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
          args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
};

/**
   * Variant Selection scripts
   * ------------------------------------------------------------------------------
   *
   * Handles change events from the variant inputs in any `cart/add` forms that may
   * exist. Also updates the master select and triggers updates when the variants
   * price or image changes.
   *
   * @namespace variants
   */

slate.Variants = (function() {
  /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.enableSwatch = options.enableSwatch;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
    _getCurrentOptions: function() {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
       * Find variant based on selected values.
       *
       * @param  {array} selectedValues - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;
        var options = variant.options;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
       * Event handler for when a variant input changes.
       */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
      });

      if (!variant) {
        this._updateSwatches(variant);
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateSwatches(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      });
    },

    /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      });
    },

    /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant,
      });
    },

    _updateSwatches: function(variant) {
      this.$container.trigger({
        type: 'variantSwatchChange',
        variant: variant,
      });
    },

    /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/**
   * Global functionality
   * ---------------------------------------------------------------------------
   */

/*
   * Basic plugins to handle responsive product images
   */
$.fn.extend({
  // product grid item click events
  productBox: function() {
    var $productBox = $(this).find('.box.product figure');
    $productBox.on('click', function(e) {
      // go to product URL unless clicking on vendor link
      if (
        $(e.target).is('.vendor') ||
        $(e.target)
        .parent()
        .is('.vendor')
      ) {
        // log('is vendor');
      } else if (
        $(e.target).is('.product-swatches__li') ||
        $(e.target).closest('.product-swatches__li').length != 0
      ) {
        var $swatchList = $(e.target).closest('.product-swatches');
        var $swatchListItem = $(e.target).closest('.product-swatches__li');
        var $swatchLink = $swatchListItem.find('a');
        var variantImage = $swatchLink.data('variant-image');
        var variantImagePattern = $swatchLink.data('variant-image-pattern');
        var variantUrl = $swatchLink.data('variant-url');

        var $productCard = $swatchListItem
        .closest('.box.product')
        .find('a.product_card');
        var $productImage = $productCard.find(
          '.product_card__image:not(.alt)'
        );

        if (variantUrl !== '') {
          $productCard.attr('href', variantUrl);
        }

        if (variantImage !== '') {
          $productImage
          .attr('src', variantImage)
          .attr('data-fallback', variantImage)
          .attr('srcset', '')
          .attr('data-srcset', '')
          .attr('data-src', variantImagePattern);
        }

        $('.product-swatches__link--selected', $swatchList).removeClass(
          'product-swatches__link--selected'
        );
        $swatchLink.addClass('product-swatches__link--selected');

        e.preventDefault();
      } else {
        e.preventDefault();
        var productURL = $(this)
        .find('a')
        .attr('href');
        // Open link in new window for tabs
        if (e.shiftKey || e.ctrlKey || e.metaKey) {
          window.open(productURL, '_blank');
        } else {
          window.location = productURL;
        }
      }
    });
    // IE fix for object-fit
    if (!Modernizr.objectfit) {
      $productBox.find('.product_card__image-wrapper').each(function() {
        var $container = $(this),
            $altImg = $container.find('.product_card__image.alt'),
            imgUrl = $container.find('img').prop('src');
        $altImg.hide();
        $container.addClass('ie-fallback lazyload');
      });
    }
    var $productSwatch = $(this).find(
      '.box.product a.product-swatches__link'
    );

    // Preload product images associated with swatch on hover for faster switching
    $productSwatch.on('mouseenter', function(e) {
      StyleHatch.productSwatchPreload = StyleHatch.productSwatchPreload || [];
      var $link = $(e.target).closest('a.product-swatches__link');
      var preloadImage = $link.data('variant-image');

      if (preloadImage !== '') {
        if (StyleHatch.productSwatchPreload.indexOf(preloadImage) < 0) {
          StyleHatch.productSwatchPreload.push(preloadImage);
          var image = new Image();
          image.src = preloadImage;
        }
      }
    });
  },
  // remove product box
  destroyProductBox: function() {
    var $productBox = $(this).find('.box.product figure');
    $productBox.off('click');
  },

  // Nested menu
  initNestedMenu: function() {
    var $nestedNav = $(this);
    var $nestedLink = $nestedNav.find('a[aria-haspopup="true"]');

    var _closeCurrentChild = function($menu) {
      var $expandedItem = $menu.find('li.has-dropdown.expanded');
      if ($expandedItem.length > 0) {
        $expandedItem.removeClass('expanded');

        var $expandedItemLink = $expandedItem.find('> a');
        $expandedItemLink.attr('aria-expanded', 'false');

        var $dropdown = $expandedItem.find('> ul.dropdown');
        $dropdown.attr('aria-hidden', 'true');
        $dropdown.slideUp();

        var $dropdownLinks = $dropdown.find('a');
        $dropdownLinks.attr('tabindex', '-1');
        _closeCurrentGrandchild($menu);
      }
    };
    var _closeCurrentGrandchild = function($menu) {
      var $expandedItem = $menu.find('li.has-sub-dropdown.expanded');
      if ($expandedItem.length > 0) {
        $expandedItem.removeClass('expanded');

        var $expandedItemLink = $expandedItem.find('> a');
        $expandedItemLink.attr('aria-expanded', 'false');

        var $dropdown = $expandedItem.find('> ul.sub-dropdown');
        $dropdown.attr('aria-hidden', 'true');
        $dropdown.slideUp();

        var $dropdownLinks = $dropdown.find('a');
        $dropdownLinks.attr('tabindex', '-1');
        _closeCurrentGrandchild($menu);
      }
    };

    $nestedLink.on('click', function(e) {
      var $el = $(this);
      var $parentItem = $el.parent();
      var $dropdown = $parentItem.find('> ul');
      var $dropdownLinks = $parentItem.find('> ul > li > a');
      var $menu = $el.closest('ul.nested-menu');

      if ($el.attr('aria-expanded') !== 'true') {
        e.preventDefault();

        if ($parentItem.hasClass('has-dropdown')) {
          // child level
          _closeCurrentChild($menu);
        } else {
          // grandchild level
          _closeCurrentGrandchild($menu);
        }

        // Element changes
        $el.attr('aria-expanded', 'true');

        // Parent changes
        $parentItem.addClass('expanded');

        // Dropdown changes
        $dropdown.attr('aria-hidden', 'false');
        $dropdownLinks.attr('tabindex', '0');
        $dropdown.slideDown();
      }
    });
  },
  destroyNestedMenu: function() {
    var $nestedNav = $(this);
    var $nestedLink = $nestedNav.find('a[aria-haspopup="true"]');
    $nestedLink.off('click');
  },
});
/*
   * Refresh all fixTo elements
   * - called when elements slide in/out
   */
StyleHatch.refreshFixTo = function() {
  StyleHatch.Promos.refreshFixTo();
  var $fixToElements = $('*').filter(function() {
    return $(this).data('fixtoInstance');
  });
  // Only refresh the ones _running
  $fixToElements.each(function(i) {
    if ($(this).data('fixto-instance')._running) {
      $(this).fixTo('refresh');
    }
  });
};
// Apply fitvids
StyleHatch.videoLayout = function() {
  $('.rte').fitVids();
  var $table = $('.rte').find('table');
  $table.wrap('<div class="table-wrapper"></div>');
};
// Customer account logins
StyleHatch.loginForms = function() {
  function showRecoverPasswordForm() {
    StyleHatch.cache.$recoverPasswordForm.show();
    StyleHatch.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    StyleHatch.cache.$recoverPasswordForm.hide();
    StyleHatch.cache.$customerLoginForm.show();
  }

  StyleHatch.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
    StyleHatch.updateHash('recover');
  });

  StyleHatch.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
    StyleHatch.updateHash();
  });

  // Allow deep linking to recover password form
  if (StyleHatch.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

// Template specific initalization
StyleHatch.initTemplates = function() {
  var $body = StyleHatch.cache.$body;

  // Grab the template name from the body
  var template = $body.data('template');

  // Execute specific functionality
  switch (template) {
    case 'addresses':
      StyleHatch.initCustomerAddressTemplate();
      break;

    default:
      //log('Template: Default');
  }
};
// Customer Address Page
StyleHatch.initCustomerAddressTemplate = function() {
  if (StyleHatch.addressJSValidation) {
    var $submit = $('.customer-address input[type="submit"]');

    $submit.on('click', function(e) {
      var $form = $(this).closest('form');

      // Required fields
      var $lastName = $form.find('input[name="address[last_name]"]');
      var $address1 = $form.find('input[name="address[address1]"]');
      var $city = $form.find('input[name="address[city]"]');
      var $country = $form.find('select[name="address[country]"]');
      var $province = $form.find('select[name="address[province]"]');
      var $zip = $form.find('input[name="address[zip]"]');

      if (!$lastName.val()) {
        $lastName.addClass('required');
      }
      if (!$address1.val()) {
        $address1.addClass('required');
      }
      if (!$city.val()) {
        $city.addClass('required');
      }
      if ($country.val() == '---') {
        $country.addClass('required');
      }

      // Check to see if province is showing
      if ($province.closest('.input-row').is(':visible')) {
        if (
          !$province.val() ||
          $province.val() == '---' ||
          $province.val() == ''
        ) {
          $province.addClass('required');
        }
      }

      if (!$zip.val()) {
        $zip.addClass('required');
      }

      // Check for focus to clear required
      var $required = $form.find('input.required, select.required');
      $required.on('focus', function() {
        $(this).removeClass('required');
      });

      // If any required inputs are still here prevent submission
      if ($required.length > 0) {
        $form
        .find('div.errors')
        .parent()
        .show();
        e.preventDefault();
      } else {
        $form
        .find('div.errors')
        .parent()
        .hide();
      }
    });
  }
};
// Utilities
StyleHatch.updateHash = function(hash) {
  if (hash) {
    window.location.hash = '#' + hash;
    $('#' + hash)
    .attr('tabindex', -1)
    .focus();
  } else {
    window.location.hash = '';
  }
};
StyleHatch.getHash = function() {
  return window.location.hash;
};
// Still used by cart page
StyleHatch.quantitySelect = function() {
  // Quantity Selector
  var $quantitySelect = $(
    '.quantity-select:not([data-quantity-select-enabled])'
  );
  $quantitySelect.each(function(i) {
    var $el = $(this);
    var $quantityDown = $el.find('.adjust-minus');
    var $quantityUp = $el.find('.adjust-plus');
    var $quantity = $el.find('input.quantity');

    var quantity = $quantity.val();

    $quantity.on('click', function(e) {
      e.preventDefault();
    });

    $quantityDown.on('click', function(e) {
      quantity = $quantity.val();
      if (quantity > 0) {
        quantity--;
        $quantity.val(quantity);
      }
      e.preventDefault();
    });

    $quantityUp.on('click', function(e) {
      quantity = $quantity.val();
      quantity++;
      $quantity.val(quantity);

      e.preventDefault();
    });

    $el.attr('data-quantity-select-enabled', 'true');
  });
};
// Reset passwords (store accounts)
StyleHatch.resetPasswordSuccess = function() {
  StyleHatch.cache.$passwordResetSuccess.show();
};

/**
   * Primary Initialization
   * ---------------------------------------------------------------------------
   */
$(document).ready(function() {
  StyleHatch.init();
});
})(jq223);

/* EasySlide custom */
document.addEventListener("easyslide_inited", function(){
  if( document.querySelector('header.util') ) easyslider.fixedHeader('header.util');
});
/* EasySlide custom */